export default function (editor: any, opt: any = {}) {
    const blockManager = editor.BlockManager;
    const category = opt.category;

    blockManager.add('careerum-en-header', {
        label: 'Header',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `<div class="careerum-en-header veb30-header login-button">
        <div>
            <div class="header-en-top">
                <div class="header-en-logo">
                    <a onclick="" href="/ru-ru/club">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744110689090-f6HxF-logo.svg" alt="">
                    </a>
                </div>
                <div>
                    <nav>
                        <a onclick="" href="/ru-ru/club/gift-certificate" target="_blank">Сертификаты</a>
                        <a onclick="" href="/ru-ru/expert-consultations" target="_blank">Консультации</a>
                        <a onclick="" href="/ru-ru/success-stories" target="_blank">Результаты клиентов</a>
                        <a onclick="" href="/ru-ru/team" target="_blank">О нас</a>
                        <a onclick="" href="#login" class="login-button">Войти</a>
                    </nav>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-en-header-tablet', {
        label: 'Header (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `<div class="careerum-en-header-tablet veb30-header login-button">
        <div>
            <div class="header-en-top">
                <div class="header-en-logo">
                    <a onclick="" href="/ru-ru/club">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744110701230-gTgVM-logo.svg" alt="">
                    </a>
                </div>
                <div>
                    <nav>
                        <a onclick="" href="/ru-ru/club/gift-certificate" target="_blank">Сертификаты</a>
                        <a onclick="" href="/ru-ru/expert-consultations" target="_blank">Консультации</a>
                        <a onclick="" href="/ru-ru/success-stories" target="_blank">Результаты клиентов</a>
                        <a onclick="" href="/ru-ru/team" target="_blank">О нас</a>
                        <a onclick="" href="#login" class="login-button">Войти</a>
                    </nav>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-en-header-mobile', {
        label: 'Header (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `<div class="careerum-en-header-mobile veb30-header">
        <div>
            <div class="header-en-top">
                <div class="header-en-main">
                    <div class="header-en-logo">
                        <a onclick="" href="/ru-ru/club">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744110709561-T60ls-logo.svg" alt="">
                        </a>
                        </div>
                    <div class="header-en-burger"><span class="line line1"></span><span class="line line2"></span><span
                            class="line line3"></span></div>
                </div>
                <div class="header-en-menu">
                    <nav>
                    <a onclick="" href="/ru-ru/club/gift-certificate" target="_blank">Сертификаты</a>
                    <a onclick="" href="/ru-ru/expert-consultations" target="_blank">Консультации</a>
                    <a onclick="" href="/ru-ru/success-stories" target="_blank">Результаты клиентов</a>
                    <a onclick="" href="/ru-ru/team" target="_blank">О нас</a>
                    <a onclick="" href="#login" class="login-button">Войти</a>
                    </nav>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-club40-main', {
        label: 'Club 4 main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-main">
            <div class="careerum-container-desc">
                <div class="club40-main-header">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105236868-Y2Lsy-Vect.svg"
                        alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105245948-FJlOP-Vect.svg"
                        alt="img">
                    <h1>Поможем построить карьеру<br> по любви в любой точке мира</h1>
                    <p>Careerum — платформа карьерного развития, с помощью которой тысячи<br> профессионалов из 30+ стран
                        уже построили карьеру мечты</p>
                </div>
                <div class="club40-main-tales">
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105590285-zZI0k-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не получаю офферов</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105590285-zZI0k-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Застрял на одной должности</p>
                        </div>
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105590285-zZI0k-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Был большой перерыв в работе</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105635645-LsSKT-Fram.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Думаю о смене профессии</p>
                        </div>
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105635645-LsSKT-Fram.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Регулярно выгораю</p>
                        </div>
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105590285-zZI0k-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не могу найти работу за границей</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105635645-LsSKT-Fram.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Работаю без мотивации</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105590285-zZI0k-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не растет зарплата</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105635645-LsSKT-Fram.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Кажется, что я не на своем месте</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723105590285-zZI0k-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не понимаю, туда ли движется моя карьера</p>
                        </div>
                    </div>
                </div>
                <div class="club40-main-link careerum-flex-cc">
                    <a href="#buy" class="btn-color-main-dark-orange">Изменить карьеру с Careerum</a>
                </div>
                <div class="club40-main-bottom">
                    <div class="careerum-flex-fsfs">
                        <div>
                            <p class="club40-main-bottom-header">12 000+</p>
                            <p class="club40-main-bottom-text">профессионалов построили карьеру мечты с нами</p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">4 000+</p>
                            <p class="club40-main-bottom-text">офферов получили специалисты по всему миру с нашей помощью
                            </p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">в 1,5 раза</p>
                            <p class="club40-main-bottom-text">средний рост<br> зарплаты клиентов<br> Careerum</p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">6 лет</p>
                            <p class="club40-main-bottom-text">помогаем<br> превратить работу<br> в удовольствие</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-main-tablet', {
        label: 'Club 4 main (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-main-tablet">
            <div class="careerum-container-tablet">
                <div class="club40-main-header">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466319646-RNR9A-Vect.svg"
                        alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466319220-qzqJU-Vect.svg"
                        alt="img">
                    <h2>Поможем построить<br> карьеру по любви в любой<br> точке мира</h2>
                    <p>Careerum — платформа карьерного развития, с помощью которой<br> тысячи профессионалов из 30+ стран
                        уже построили карьеру мечты</p>
                </div>
                <div class="club40-main-tales">
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не могу найти работу</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Застрял на одной должности</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Кажется, что я не на своем месте</p>
                        </div>
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Был большой перерыв в работе</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Думаю о смене профессии</p>
                        </div>
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Регулярно выгораю</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Работаю без мотивации</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не растет зарплата</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не понимаю, туда ли движется моя карьера</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не могу найти работу за границей</p>
                        </div>
                    </div>
                </div>
                <div class="club40-main-link careerum-flex-cc">
                    <a href="#buy" class="btn-color-main-dark-orange">Изменить карьеру с Careerum</a>
                </div>
                <div class="club40-main-bottom">
                    <div class="careerum-flex-fsfs">
                        <div>
                            <p class="club40-main-bottom-header">12 000+</p>
                            <p class="club40-main-bottom-text">профессионалов построили карьеру мечты с нами</p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">4 000+</p>
                            <p class="club40-main-bottom-text">офферов получили специалисты по всему миру с нашей помощью
                            </p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">в 1,5 раза</p>
                            <p class="club40-main-bottom-text">средний рост<br> зарплаты клиентов<br> Careerum</p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">6 лет</p>
                            <p class="club40-main-bottom-text">помогаем<br> превратить работу<br> в удовольствие</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-main-mobile', {
        label: 'Club 4 main (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-main-mobile">
            <div class="careerum-container-mobile">
                <div class="club40-main-header">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723538992140-HqVEb-Vect.svg"
                        alt="img">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723538992001-jumGG-Vect.svg"
                        alt="img">
                    <h2>Поможем построить<br> карьеру по любви в любой точке мира</h2>
                    <p>Careerum — платформа карьерного развития, с помощью которой тысячи профессионалов из 30+ стран
                        уже<br> построили карьеру мечты</p>
                </div>
                <div class="club40-main-tales">
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Не могу найти работу</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Застрял на одной должности</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-light">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466510057-IeBl2-Unio.svg"
                                alt="" class="club40-main-tales-item-img-cross">
                            <p>Был большой перерыв в работе</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Кажется, что я не на своем месте</p>
                        </div>
                    </div>
                    <div class="club40-main-tales-wrapper careerum-flex-fsfs">
                        <div class="club40-main-tales-item-dark">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Регулярно выгораю</p>
                        </div>
                        <div class="club40-main-tales-item-blue">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723466509751-QKY45-Grou.svg"
                                alt="" class="club40-main-tales-item-img-smile">
                            <p>Думаю о смене профессии</p>
                        </div>
                    </div>
                </div>
                <div class="club40-main-link careerum-flex-cc">
                    <a href="#buy" class="btn-color-main-dark-orange">Изменить карьеру с Careerum</a>
                </div>
                <div class="club40-main-bottom">
                    <div class="careerum-flex-fsfs">
                        <div>
                            <p class="club40-main-bottom-header">12 000+</p>
                            <p class="club40-main-bottom-text">профессионалов построили<br> карьеру мечты с нами</p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">4 000+</p>
                            <p class="club40-main-bottom-text">офферов получили специалисты по всему миру с нашей помощью
                            </p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">в 1,5 раза</p>
                            <p class="club40-main-bottom-text">средний рост зарплаты<br> клиентов Careerum</p>
                        </div>
                        <div>
                            <p class="club40-main-bottom-header">6 лет</p>
                            <p class="club40-main-bottom-text">помогаем превратить работу<br> в удовольствие</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-main2', {
        label: 'Club 4 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-main2 main-wrapper" data-video-id="925287800">
            <div class="careerum-container-responsive careerum-flex-sbfs">
                <div class="club40-main2-left position-relative">
                    <h1>Платформа карьерного<br> развития Careerum</h1>
                    <p>Поможем построить карьеру по любви в любой точке мира: </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733899360220-tPjRo-Grou.svg" alt=""
                        class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733920456778-3k6OP-Grou.svg" alt=""
                        class="position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733932964978-uPMKS-Grou.svg" alt=""
                        class="position-absolute hidden-desc-tablet">
                    <ul>
                        <li class="careerum-flex-fsfs">
                            <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2 12.2143C4.47211 14.3245 9.96632 19.2493 14.6035 24.0792C15.6451 25.1641 17.4711 24.8039 17.933 23.3726C20.5415 15.2898 22.532 6.00656 28 1.5"
                                    stroke="#0B70FE" stroke-width="3" stroke-linecap="round" />
                            </svg>
                            <p>Получить оффер мечты</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2 12.2143C4.47211 14.3245 9.96632 19.2493 14.6035 24.0792C15.6451 25.1641 17.4711 24.8039 17.933 23.3726C20.5415 15.2898 22.532 6.00656 28 1.5"
                                    stroke="#0B70FE" stroke-width="3" stroke-linecap="round" />
                            </svg>
                            <p>Найти работу за границей</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2 12.2143C4.47211 14.3245 9.96632 19.2493 14.6035 24.0792C15.6451 25.1641 17.4711 24.8039 17.933 23.3726C20.5415 15.2898 22.532 6.00656 28 1.5"
                                    stroke="#0B70FE" stroke-width="3" stroke-linecap="round" />
                            </svg>
                            <p>Вырасти в зарплате и должности</p>
                        </li>
                        <li class="careerum-flex-fsfs">
                            <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2 12.2143C4.47211 14.3245 9.96632 19.2493 14.6035 24.0792C15.6451 25.1641 17.4711 24.8039 17.933 23.3726C20.5415 15.2898 22.532 6.00656 28 1.5"
                                    stroke="#0B70FE" stroke-width="3" stroke-linecap="round" />
                            </svg>
                            <p>Сменить сферу</p>
                        </li>
                    </ul>
                </div>
                <div class="club40-main2-right">
                    <div class="club40-main2-videowrapper position-relative">
                        <div class="club40-main2-videowrapper-frame position-absolute z-10"></div>
                        <svg width="70" height="63" viewBox="0 0 70 63" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="club40-main2-play position-absolute z-20">
                            <path
                                d="M68.2483 34.7204C67.2762 56.8698 46.1184 60.3881 35.4123 61.0219C29.7258 61.3586 5.18811 63.9441 2.13711 34.1026C-0.448426 8.81373 20.2043 4.35263 26.2295 2.98658C37.3753 0.459573 66.0873 0.626994 67.0274 28.5617"
                                stroke="white" stroke-width="2" stroke-linecap="round" />
                            <path
                                d="M27.4309 47.4754C27.8277 40.64 22.2067 26.9149 19.3467 20.9067C33.6166 22.2324 60.5889 25.4775 54.3183 27.8522C46.48 30.8206 26.935 56.0197 27.4309 47.4754Z"
                                stroke="white" stroke-width="2" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-achievements', {
        label: 'Club 4 achievements (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-achievements main-wrapper">
            <div class="careerum-container-responsive">
                <div class="club40-achievements-wrapper">
                    <div class="careerum-flex-sbfs">
                        <div>
                            <p class="club40-achievements-header">4 000+</p>
                            <p class="club40-achievements-text hidden-tablet-mobile"><span>офферов получили</span><br> наши
                                клиенты<br> по всему
                                миру </p>
                            <p class="club40-achievements-text hidden-desc">офферов получили наши
                                клиенты по всему
                                миру </p>
                        </div>
                        <div>
                            <p class="club40-achievements-header">на 50%</p>
                            <p class="club40-achievements-text hidden-tablet-mobile"><span>рост зарплаты</span><br> у наших
                                клиентов<br> в
                                среднем</p>
                            <p class="club40-achievements-text hidden-desc">рост зарплаты у наших
                                клиентов в
                                среднем</p>
                        </div>
                        <div>
                            <p class="club40-achievements-header">6 лет</p>
                            <p class="club40-achievements-text hidden-tablet-mobile"><span>выстраиваем</span><br> работающие
                                карьерные стратегии
                            </p>
                            <p class="club40-achievements-text hidden-desc">выстраиваем работающие
                                карьерные стратегии
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-about', {
        label: 'Club 4 about',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-about">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Подписка Careerum — это</h2>
                <div class="club40-about-top careerum-flex-fsfs">
                    <div>
                        <div class="club40-about-label-blue">
                            <p>Careerum — это результаты</p>
                        </div>
                        <p class="club40-about-header-white">Команда сертифицированных карьерных коучей и экспертов</p>
                        <p class="club40-about-text-white">Проработайте свой кейс со специалистами <br>с международным
                            опытом
                            и достигните цели<br>в два раза быстрее</p>
                    </div>
                    <div>
                        <div class="careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723109088799-unRFk-phot.png"
                                    alt="">
                            </div>
                            <div>
                                <p class="club40-about-coach-name">Софи Бессон</p>
                                <p class="club40-about-coach-position">Карьерный эксперт</p>
                                <p class="club40-about-coach-text">Добрый день! Оставила комментарии к резюме. Уже очень
                                    хорошо, но есть что исправить</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723109088402-yji01-phot.png"
                                    alt="">
                            </div>
                            <div>
                                <p class="club40-about-coach-name">Яна Хмельницкая</p>
                                <p class="club40-about-coach-position">Карьерный коуч</p>
                                <p class="club40-about-coach-text">Предлагаю сформулировать ваши сильные стороны и
                                    достижения, сможете опираться на них в разговоре о повышении</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-about-center careerum-flex-sbst">
                    <div>
                        <div class="club40-about-label-blue">
                            <p>Careerum — это практика</p>
                        </div>
                        <p class="club40-about-header-dark">Интенсивы и Q&A-эфиры</p>
                        <p class="club40-about-text-dark">Разберетесь в самых актуальных карьерных<br> темах: от тенденций в
                            оформлении резюме<br> до развития нетворка в любой стране</p>
                    </div>
                    <div>
                        <div class="club40-about-label-white">
                            <p>Careerum — это поддержка</p>
                        </div>
                        <p class="club40-about-header-dark">Сильное сообщество</p>
                        <p class="club40-about-text-dark">Получите доступ к сообществу профессионалов<br> из 30+ стран, где
                            вы сможете завести полезные знакомства и найти рекомендации и поддержку<br> в достижении вашей
                            цели</p>
                    </div>
                </div>
                <div class="club40-about-bottom careerum-flex-fsfs">
                    <div>
                        <div class="club40-about-label-white">
                            <p>Careerum — это знания</p>
                        </div>
                        <p class="club40-about-header-white">80+ курсов от топовых экспертов для любой карьерной цели</p>
                        <p class="club40-about-text-white">Учитесь, когда и где удобно — материалы доступны<br> 24/7 на
                            любом
                            устройстве. Получайте целевые навыки, чтобы развивать карьеру так, как нужно вам</p>
    
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110551770-KJNwC-Grou.png"
                            alt="">
                    </div>
                </div>
                <div class="club40-about-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-about-tablet', {
        label: 'Club 4 about (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-about-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Подписка Careerum — это</h2>
                <div class="club40-about-top careerum-flex-fsfs">
                    <div>
                        <p class="club40-about-header-white">Команда сертифицированных карьерных коучей и экспертов</p>
                        <p class="club40-about-text-white">Проработайте свою ситуацию со специалистами с международным
                            опытом и достигните цели в два раза быстрее</p>
                    </div>
                    <div>
                        <div>
                            <div class="careerum-flex-fsc">
                                <div class="club40-about-coach-photo">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468300463-EYtPX-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-about-coach-name">Софи Бессон</p>
                                    <p class="club40-about-coach-position">Карьерный эксперт</p>
                                </div>
                            </div>
                            <p class="club40-about-coach-text">Добрый день! Оставила комментарии к резюме. Уже очень
                                хорошо, но есть что исправить</p>
                        </div>
                        <div>
                            <div class="careerum-flex-fsc">
                                <div class="club40-about-coach-photo">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468300132-DXXeM-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-about-coach-name">Яна Хмельницкая</p>
                                    <p class="club40-about-coach-position">Карьерный коуч</p>
                                </div>
                            </div>
                            <p class="club40-about-coach-text">Предлагаю сформулировать достижения, сможете опираться в
                                обсуждении повышения</p>
                        </div>
                    </div>
                </div>
                <div class="club40-about-center careerum-flex-sbst">
                    <div>
                        <p class="club40-about-header-white">Интенсивы и Q&A-эфиры</p>
                        <p class="club40-about-text-white">Разберетесь в самых актуальных карьерных темах: от тенденций
                            в оформлении резюме до развития нетворка в любой стране</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468833142-XOfcz-Grou.svg"
                            alt="">
                    </div>
                    <div>
                        <p class="club40-about-header-dark">Сильное сообщество профессионалов<br> со всего мира</p>
                        <p class="club40-about-text-dark">Получите доступ к сообществу профессионалов из 30+ стран, где
                            вы сможете построить нетворк и найти поддержку в достижении вашей цели</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468833762-HxGov-Play.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-about-bottom careerum-flex-fsfs">
                    <div>
                        <p class="club40-about-header-white">80+ курсов от топовых экспертов для любой цели</p>
                        <p class="club40-about-text-white">Учитесь, когда и где удобно — материалы доступны 24/7 на любом
                            устройстве. Получайте целевые навыки, чтобы развивать карьеру так, как нужно вам</p>
    
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468833453-Ork8u-Grou.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-about-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Оформить подписку</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-about-mobile', {
        label: 'Club 4 about (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-about-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Подписка Careerum — это</h2>
                <div class="club40-about-top">
                    <div>
                        <p class="club40-about-header-white">Команда сертифицированных карьерных коучей и экспертов</p>
                        <p class="club40-about-text-white">Проработайте свою ситуацию со специалистами с международным
                            опытом и достигните цели в два раза быстрее</p>
                    </div>
                    <div>
                        <div>
                            <div class="careerum-flex-fsc">
                                <div class="club40-about-coach-photo">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468300463-EYtPX-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-about-coach-name">Софи Бессон</p>
                                    <p class="club40-about-coach-position">Карьерный эксперт</p>
                                </div>
                            </div>
                            <p class="club40-about-coach-text">Добрый день! Оставила комментарии к резюме. Уже очень
                                хорошо, но есть что исправить</p>
                        </div>
                        <div>
                            <div class="careerum-flex-fsc">
                                <div class="club40-about-coach-photo">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723468300132-DXXeM-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-about-coach-name">Яна Хмельницкая</p>
                                    <p class="club40-about-coach-position">Карьерный коуч</p>
                                </div>
                            </div>
                            <p class="club40-about-coach-text">Предлагаю сформулировать достижения, сможете опираться в
                                обсуждении повышения</p>
                        </div>
                    </div>
                </div>
                <div class="club40-about-center">
                    <div>
                        <p class="club40-about-header-white">Интенсивы и Q&A-эфиры</p>
                        <p class="club40-about-text-white">Разберетесь в самых актуальных карьерных темах: от тенденций
                            в оформлении резюме до развития нетворка в любой стране</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723540946071-OF6ci-Grou.svg"
                            alt="">
                    </div>
                    <div>
                        <p class="club40-about-header-dark">Сильное сообщество профессионалов со всего мира</p>
                        <p class="club40-about-text-dark">Получите доступ к сообществу профессионалов из 30+ стран, где
                            вы сможете построить нетворк и найти поддержку в достижении вашей цели</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723541019685-hHvNE-Play.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-about-bottom">
                    <div>
                        <p class="club40-about-header-white">80+ курсов от топовых<br> экспертов для любой цели</p>
                        <p class="club40-about-text-white">Учитесь, когда и где удобно — материалы доступны 24/7 на любом
                            устройстве. Получайте целевые навыки, чтобы развивать карьеру так, как нужно вам</p>
    
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723541208766-qWvqi-Grou.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-about-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-goals', {
        label: 'Club 4 goals',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-goals">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">С Careerum любая карьерная задача<br> вам по плечу</h2>
                <div class="club40-goals-tales careerum-flex-fsfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Быстро найдете работу в компании, куда всегда хотелось</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Получите оффер на своих условиях, а не тот, который дают</p>
                    </div>
                    <div class="club40-goals-tale-rotate-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Подготовитесь к интервью, чтобы общаться с рекрутерами без паники и на равных </p>
                    </div>
                </div>
                <div class="club40-goals-tales careerum-flex-fsfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Устроитесь на работу<br> за границей и не упадете в грейде </p>
                    </div>
                    <div class="club40-goals-tale-rotate-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Начнете расти в профессии<br> и регулярно получать повышение </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Перестанете выгорать,<br> начнете получать удовольствие от работы</p>
                    </div>
                </div>
                <div class="club40-goals-tales careerum-flex-fsfs">
                    <div class="club40-goals-tale-rotate-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Найдете свое место<br> в карьере, если запутались<br> и не знаете, как работать дальше </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Укрепите профессиональную самооценку и начнете<br> строить карьеру вокруг себя,<br> а не наоборот
                        </p>
                    </div>
                    <div class="club40-goals-tale-rotate-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Повысите свою конкурентоспособность<br> даже после долгого<br> перерыва в работе</p>
                    </div>
                </div>
                <div class="club40-goals-form careerum-flex-sbfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723113134344-GuPXa-Vect.svg"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723113138463-WJviy-Unio.svg"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723113144846-xYKAa-Grou.svg"
                            alt="">
                        <p>У вас другая цель? Тоже поможем</p>
                        <div>
                            <p>Оставьте заявку,</p>
                            <p>а мы погрузимся в вашу ситуацию, подберем решение, и карьерные перемены начнутся уже в этом
                                месяце</p>
                        </div>
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных<br> в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Оставить
                                    заявку</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-goals-tablet', {
        label: 'Club 4 goals (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-goals-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">С Careerum любая карьерная задача<br> вам по плечу</h2>
                <div class="club40-goals-tales careerum-flex-fsst">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Быстро найдете работу в компании, куда всегда хотелось</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Получите оффер на своих условиях, а не тот, который дают</p>
                    </div>
                    <div class="club40-goals-tale-rotate-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Подготовитесь к интервью, чтобы общаться с рекрутерами без паники и на равных </p>
                    </div>
                </div>
                <div class="club40-goals-tales careerum-flex-fsst">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Устроитесь на работу<br> за границей и не упадете в грейде </p>
                    </div>
                    <div class="club40-goals-tale-rotate-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Начнете расти<br> в профессии и регулярно получать повышение </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Перестанете выгорать,<br> начнете получать удовольствие от работы</p>
                    </div>
                </div>
                <div class="club40-goals-tales careerum-flex-fsst">
                    <div class="club40-goals-tale-rotate-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Найдете свое место<br> в карьере, если запутались и не знаете, как работать дальше </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Укрепите профессиональную самооценку и начнете строить карьеру вокруг себя,<br> а не наоборот
                        </p>
                    </div>
                    <div class="club40-goals-tale-rotate-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                            alt="">
                        <p>Повысите свою конкуренто-способность<br> даже после долгого<br> перерыва в работе</p>
                    </div>
                </div>
                <div class="club40-goals-form careerum-flex-sbfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469779584-93ZWs-Vect.svg"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469779436-0tSV3-Unio.svg"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469778866-02ZRM-Grou.svg"
                            alt="">
                        <p>У вас другая цель? Тоже поможем</p>
                        <div>
                            <p>Оставьте заявку,</p>
                            <p>а мы погрузимся в вашу ситуацию, подберем решение, и карьерные перемены начнутся уже в этом
                                месяце</p>
                        </div>
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Оставить
                                    заявку</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-goals-mobile', {
        label: 'Club 4 goals (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-goals-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">С Careerum любая карьерная задача вам по плечу</h2>
                <div class="club40-goals-tales club40-goals-tales-slider">
                    <div class="club40-goals-tale">
                        <p class="club40-goals-tale-header">Найти новую работу</p>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Подготовитесь к интервью, чтобы общаться с рекрутерами без паники</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Быстро найдете работу в компании, куда всегда хотелось, на своих условиях</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Устроитесь на работу за границей и не упадете в грейде</p>
                        </div>
                    </div>
                    <div class="club40-goals-tale">
                        <p class="club40-goals-tale-header">Вырасти в зарплате /<br> должности</p>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Укрепите профессиональную самооценку и начнете строить карьеру вокруг себя, а не наоборот</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Начнете расти и регулярно получать повышение</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Повысите конкуренто-способность даже после долгого перерыва в работе</p>
                        </div>
                    </div>
                    <div class="club40-goals-tale">
                        <p class="club40-goals-tale-header">Понять, чего хочется от карьеры</p>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Найдете свое место в карьере, если запутались и не знаете, как работать дальше </p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723469156104-t334r-Vect.svg"
                                alt="">
                            <p>Перестанете выгорать, начнете получать удовольствие от работы</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723542067084-cmkXg-Vect.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-goals-form">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723543242506-jHune-Vect.svg"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723543242175-LPPbu-Grou.svg"
                            alt="">
                        <p>У вас другая цель?<br> Тоже поможем</p>
                        <div>
                            <p>Оставьте заявку,</p>
                            <p>а мы погрузимся в вашу ситуацию, подберем решение, и карьерные перемены начнутся уже в этом
                                месяце</p>
                        </div>
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Оставить
                                    заявку</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-clients', {
        label: 'Club 4 clients',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-clients">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Наши клиенты построили карьеру<br> в ведущих компаниях мира</h2>
                <div class="club40-clients-companies careerum-flex-fsfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115122363-xyHbj-Tesl.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331031-myt4l-Amaz.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115330585-9MSlm-2560.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115333262-UAImR-Spot.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332401-FkZ64-Micr.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332749-mIfxs-Sky_.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332515-khZye-Phil.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332145-gqB7m-John.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331911-hjvbp-Goog.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115333142-EdGAC-Sony.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331641-UuXdl-Effe.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331526-uL5Yd-Disn.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332027-6Ren2-Inte.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115330911-6pK57-Airb.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331174-9BWPm-Amer.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332287-n7a8A-Lero.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331415-4gsDs-Bost.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115517876-iF9c6-Toyo.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115333370-HJSp7-Yand.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115332622-sudY9-Puma.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723115331287-VGekQ-Avit.svg"
                            alt="">
                    </div>
                    <div>
                        <p>4 000+ кейсов</p>
                    </div>
                </div>
                <div class="club40-clients-slider">
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422853-o2LIn-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Сергей Михайлов</p>
                                <p>Technical Transfer Lead, Австрия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер c релокацией в Австрию, увеличил доход в 3 раза</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116421826-n9oaA-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Александра Пинчукова</p>
                                <p>менеджер бизнес-процессов, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422118-nici9-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Сергей Бухаров</p>
                                <p>Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер от Mars с релокацией в Нидерланды</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422236-vLdYI-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Карина Пысина</p>
                                <p>бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер бизнес-аналитика, выросла в зарплате на 100%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422371-2l7A2-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Тая Штоль</p>
                                <p>UX/UI-дизайнер, Испания</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422492-aq4aa-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Евгения Вольхина</p>
                                <p>Project Manager, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в Big4 в Москве и зарплату в 3,5 раза больше, потом – оффер в Германию
                                с ростом ещё на 40%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422621-VPn05-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Олег Федоткин</p>
                                <p>Head of Department, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер на head-позицию с ростом зарплаты на 30%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422737-07i7D-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Людмила Киселёва</p>
                                <p>Recruiter ll, США</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</p>
                        </div>
                    </div>
                </div>
                <div class="club40-clients-slider-nav careerum-flex-fec">
                    <div class="club40-clients-slider-nav-prev">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_7304_21282)">
                                <g filter="url(#filter0_b_7304_21282)">
                                    <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="#FF9F00" />
                                </g>
                                <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_7304_21282" x="-18.1166" y="-18.1166" width="76.2332" height="76.2332"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in"
                                        result="effect1_backgroundBlur_7304_21282" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7304_21282"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_7304_21282">
                                    <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="club40-clients-slider-nav-next">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_7304_21286)">
                                <g filter="url(#filter0_b_7304_21286)">
                                    <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="#FF9F00" />
                                </g>
                                <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_7304_21286" x="-18.1166" y="-18.1166" width="76.2332" height="76.2332"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in"
                                        result="effect1_backgroundBlur_7304_21286" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7304_21286"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_7304_21286">
                                    <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-clients-tablet', {
        label: 'Club 4 clients (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-clients-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Наши клиенты построили карьеру<br> в ведущих компаниях мира</h2>
                <div class="club40-clients-companies careerum-flex-fsfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471017456-aQU00-Effe.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471019742-wiFVW-Toyo.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471597031-41Sbz-Vect.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471016854-KC0mT-Amaz.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471018086-kFUjz-Micr.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471019251-VE7GM-Spot.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471017945-P9kjI-John.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471746563-8Sd3H-Yand.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723472436347-BtDwx-Sky_L.webp"
                            width="52px" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471017603-hfj9T-Goog.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471019060-otJ5z-Sony.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723472605983-YIeVv-Mars.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471018378-FPG9d-Puma.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471017277-KsPCq-Disn.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471017765-3Pia8-Inte.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471018244-GkXf4-Phil.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723471017135-DO4xq-Bost.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723472803990-3lR8o-Avit.svg"
                            alt="">
                    </div>
                    <div>
                        <p>4 000+ кейсов</p>
                    </div>
                </div>
                <div class="club40-clients-slider">
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422853-o2LIn-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Сергей Михайлов</p>
                                <p>Technical Transfer Lead, Австрия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер c релокацией в Австрию, увеличил доход в 3 раза</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116421826-n9oaA-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Александра Пинчукова</p>
                                <p>менеджер, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422118-nici9-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Сергей Бухаров</p>
                                <p>Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер от Mars с релокацией в Нидерланды</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422236-vLdYI-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Карина Пысина</p>
                                <p>бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер бизнес-аналитика, выросла в зарплате на 100%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422371-2l7A2-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Тая Штоль</p>
                                <p>UX/UI-дизайнер, Испания</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422492-aq4aa-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Евгения Вольхина</p>
                                <p>Project Manager, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в Big4 в Москве и зарплату в 3,5 раза больше, потом – оффер в Германию
                                с ростом ещё на 40%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422621-VPn05-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Олег Федоткин</p>
                                <p>Head of Department, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер на head-позицию с ростом зарплаты на 30%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422737-07i7D-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Людмила Киселёва</p>
                                <p>Recruiter ll, США</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-clients-mobile', {
        label: 'Club 4 clients (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-clients-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Наши клиенты построили карьеру в ведущих компаниях</h2>
                <div class="club40-clients-companies careerum-flex-fsfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544686294-cXWs4-Vect.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685487-4vULq-Micr.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544684088-HJKiJ-Amaz.svg"
                            alt="" style="margin-top: 3px;">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685276-ErtgD-John.svg"
                            alt="" style="margin-top: 1px;">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544684694-z20V7-g10..svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544686048-B1Bzn-Spot.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723472436347-BtDwx-Sky_L.webp"
                            width="46px" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544684875-Kh6BE-Goog.svg"
                            alt="" style="margin-top: 2px;">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685014-IhhTc-Grou.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685624-XDgU1-path.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685896-mDyZM-Puma.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544684504-0d0Ri-Avit.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544686180-aw0aC-Vect.svg"
                            alt="" style="margin-top: 1px;">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685145-EgMYR-Inte.svg"
                            alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723544685756-brX6G-Phil.svg"
                            alt="">
                    </div>
                    <div>
                        <p>4 000+ кейсов</p>
                    </div>
                </div>
                <div class="club40-clients-slider">
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422853-o2LIn-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Сергей Михайлов</p>
                                <p>Technical Transfer Lead, Австрия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер c релокацией в Австрию, увеличил доход в 3 раза</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116421826-n9oaA-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Александра Пинчукова</p>
                                <p>менеджер, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422118-nici9-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Сергей Бухаров</p>
                                <p>Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер от Mars с релокацией в Нидерланды</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422236-vLdYI-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Карина Пысина</p>
                                <p>бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер бизнес-аналитика, выросла в зарплате на 100%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422371-2l7A2-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Тая Штоль</p>
                                <p>UX/UI-дизайнер, Испания</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422492-aq4aa-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Евгения Вольхина</p>
                                <p>Project Manager, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер в Big4 в Москве и зарплату в 3,5 раза больше, потом – оффер в Германию
                                с ростом ещё на 40%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422621-VPn05-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Олег Федоткин</p>
                                <p>Head of Department, Германия</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получил оффер на head-позицию с ростом зарплаты на 30%</p>
                        </div>
                    </div>
                    <div class="club40-clients-slider-item">
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422737-07i7D-Grou.png"
                                    alt="">
                            </div>
                            <div>
                                <p>Людмила Киселёва</p>
                                <p>Recruiter ll, США</p>
                            </div>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116002501-D55Pe-Righ.svg"
                                alt="">
                            <p>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-mission', {
        label: 'Club 4 mission',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-mission">
            <div class="careerum-container-desc">
                <div class="club40-mission-top careerum-flex-fsfs">
                    <div class="club40-mission-top-left">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383095-IJaUt-Circ.svg"
                                alt="">
                            <p>Преображаем карьеры с 2018 года</p>
                        </div>
                        <p>Точно знаем, как стать профессионалом<br>
                            с сильными карьерными навыками, который</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383633-2vYzb-Vect.svg"
                            alt="">
                    </div>
                    <div class="club40-mission-top-right">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383503-qQBVD-Unio.svg"
                                alt="">
                            <p>Знает, что востребовано на рынке</p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383365-pL8gq-Fram.svg"
                                alt="">
                            <p>Развивает навыки, за которые платят</p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383503-qQBVD-Unio.svg"
                                alt="">
                            <p>Заранее выстраивает стратегию повышения</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383365-pL8gq-Fram.svg"
                                alt="">
                            <p>Умеет выгодно преподносить свой опыт<br> в разных рабочих контекстах</p>
                        </div>
                        <div>
                            <p>
                                <span>Наша миссия:</span> сделать так, чтобы специалистов, осознанно управляющих своей
                                карьерой, стало как можно бо-о-о-о-ольше
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118442385-bgk8K-Grou.svg"
                                alt="">
                        </div>
                    </div>
                </div>
                <div class="club40-mission-bottom">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118616351-b8BSw-Vect.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118616229-fdPp2-Vect.svg" alt="">
                    <p>12 000+ профессионалов по всему миру<br> уже построили карьеру по своим правилам</p>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118683984-d1y11-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684271-AH5B0-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684395-sR8Vx-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684516-5Tr5C-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684634-7DOXr-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684760-uObOr-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684896-6sxpG-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118685030-I5nvh-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118685170-r30Nz-Grou.png"
                            alt="">
                    </div>
                </div>
                <div class="club40-mission-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Оформить подписку</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-mission-tablet', {
        label: 'Club 4 mission (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-mission-tablet">
            <div class="careerum-container-tablet">
                <div class="club40-mission-top">
                    <div class="club40-mission-top-left">
                        <p>Знаем, как стать профессионалом с сильными карьерными навыками</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723473791743-ewVBv-Vect.svg"
                            alt="">
                    </div>
                    <div class="club40-mission-top-right">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383503-qQBVD-Unio.svg"
                                alt="">
                            <p>Знает, что востребовано на рынке</p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383365-pL8gq-Fram.svg"
                                alt="">
                            <p>Развивает навыки, за которые платят</p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383503-qQBVD-Unio.svg"
                                alt="">
                            <p>Заранее выстраивает стратегию повышения</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118383365-pL8gq-Fram.svg"
                                alt="">
                            <p>Умеет выгодно преподносить свой опыт<br> в разных рабочих контекстах</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <p>Наша миссия:</p>
                            <p>сделать так, чтобы специалистов, осознанно управляющих своей карьерой, стало как можно больше
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723474308924-2J0Zv-Grou.svg"
                                alt="">
                        </div>
                    </div>
                </div>
                <div class="club40-mission-label careerum-flex-fsc">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723474401911-XhK0o-Circ.svg" alt="">
                    <p>Преображаем карьеры с 2018 года</p>
                </div>
                <div class="club40-mission-bottom">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118616351-b8BSw-Vect.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723474635030-6fs3R-Vect.svg" alt="">
                    <p>12 000+ профессионалов по всему миру<br> уже построили карьеру по своим правилам</p>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118683984-d1y11-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684271-AH5B0-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684395-sR8Vx-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684516-5Tr5C-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684634-7DOXr-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684760-uObOr-Grou.png"
                            alt="">
                    </div>
                </div>
                <div class="club40-mission-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Оформить подписку</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-mission-mobile', {
        label: 'Club 4 mission (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-mission-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Точно знаем, как стать профессионалом с сильными карьерными
                    навыками</h2>
                <div class="club40-mission-top">
                    <div class="club40-mission-top-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520322-rmyPK-Vect.svg"
                            alt="">
                        <p>Специалист с такими навыками</p>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520992-Wp7M7-Vect.svg"
                                alt="">
                            <p>Осознанно управляет карьерой</p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520992-Wp7M7-Vect.svg"
                                alt="">
                            <p>Получает лучшие офферы </p>
                        </div>
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520992-Wp7M7-Vect.svg"
                                alt="">
                            <p>Быстро растет в должности и зарплате</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520992-Wp7M7-Vect.svg"
                                alt="">
                            <p>Знает, за какие скилы платят, и развивает их</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520992-Wp7M7-Vect.svg"
                                alt="">
                            <p>Заранее продумывает стратегию повышения</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545520992-Wp7M7-Vect.svg"
                                alt="">
                            <p>Использует свой опыт как инструмент достижения целей</p>
                        </div>
                    </div>
                    <div class="club40-mission-top-right">
                        <div>
                            <p>Наша миссия:</p>
                            <p>сделать так, чтобы специалистов, осознанно управляющих своей карьерой, стало как можно
                                бо-о-о-о-ольше</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723545971958-ZuJE4-Grou.svg"
                                alt="">
                        </div>
                    </div>
                </div>
                <div class="club40-mission-label careerum-flex-fsc">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723474401911-XhK0o-Circ.svg" alt="">
                    <p>Преображаем карьеры с 2018 года</p>
                </div>
                <div class="club40-mission-bottom">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723546515249-YCFow-Vect.svg" alt="">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723546514877-ZE7qK-Vect.svg" alt="">
                    <p>12 000+ профессионалов по всему миру уже построили карьеру<br> по своим правилам</p>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118683984-d1y11-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684271-AH5B0-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684395-sR8Vx-Grou.png"
                            alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723118684516-5Tr5C-Grou.png"
                            alt="">
                    </div>
                </div>
                <div class="club40-mission-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Оформить подписку</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-author', {
        label: 'Club 4 author',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-author">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Ольга Лермонтова, фаундер Careerum</h2>
                <div class="club40-author-top careerum-flex-fsc">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121261660-K1WuM-Fram.png"
                            alt="">
                    </div>
                    <div>
                        <p>
                            «За 15 лет своей карьеры я прошла путь от репетитора английского языка до топ-менеджера в
                            Google,
                            Intel<br> и Microsoft.</p>
                        <p>
                            Я училась на своих ошибках, часто не знала, как правильно строить карьеру и сделать выбор,
                            который будет подходить именно мне, а не совпадать с навязанными шаблонами.</p>
                        <p>
                            Этот опыт я собрала в Careerum, чтобы другие профессионалы могли сэкономить время, избежать
                            фатальных карьерных ошибок, расти быстрее<br> и зарабатывать на том, что нравится именно им!»
                        </p>
                    </div>
                </div>
                <div class="club40-author-bottom">
                    <div class="careerum-flex-fsst">
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827701-lK3KT-User.svg"
                                alt="">
                            <p>Помогла 12 000+ клиентам из России, СНГ, Европы, Северной и Южной Америки построить карьеру
                            </p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827589-RDqmT-Grad.svg"
                                alt="">
                            <p>Сертифицированный карьерный коуч International Coaching Federation</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827589-RDqmT-Grad.svg"
                                alt="">
                            <p>Степень MBA от бизнес-школы INSEAD, учится в Гарварде</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsst">
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827344-JJ1IL-Brie.svg"
                                alt="">
                            <p>15+ лет успешной карьеры на руководящих позициях в 5 странах в tech-компаниях (Google,
                                Microsoft, Intel)</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827344-JJ1IL-Brie.svg"
                                alt="">
                            <p>Управляла бизнесом на 20+ рынках<br> Африки, Западной и Восточной Европы</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsst">
                        <div class="careerum-flex-sbfs">
                            <a class="careerum-flex-fsc" href="https://www.instagram.com/lermontova.career/"
                                target="_blank">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726038651331-fkpF5-Fram.svg"
                                    alt="">
                                <p>lermontova.career</p>
                            </a>
                            <a class="careerum-flex-fsc" href="https://www.linkedin.com/in/lermontova/" target="_blank">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726038856963-qRLBz-Fram.svg"
                                    alt="">
                                <p>lermontova</p>
                            </a>
                            <a class="careerum-flex-fsc" href="https://t.me/dreamcatchme" target="_blank">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726038866551-FX8WJ-Fram.svg"
                                    alt="">
                                <p>dreamcatchme</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="club40-author-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Оформить подписку</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-author-tablet', {
        label: 'Club 4 author (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-author-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Ольга Лермонтова, фаундер Careerum</h2>
                <div class="club40-author-top careerum-flex-fsc">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475008025-kxKl4-Fram.png"
                            alt="">
                    </div>
                    <div>
                        <p>
                            «За 15 лет своей карьеры я прошла путь<br> от репетитора английского языка до топ-<br>менеджера
                            в
                            Google,
                            Intel и Microsoft.</p>
                        <p>
                            Я училась на своих ошибках, часто не знала, как правильно строить карьеру и сделать выбор,
                            который будет подходить именно мне, а не совпадать с навязанными шаблонами.</p>
                        <p>
                            Этот опыт я собрала в Careerum, чтобы другие профессионалы могли сэкономить время, избежать
                            фатальных карьерных ошибок, расти быстрее и зарабатывать на том, что нравится именно им!»
                        </p>
                    </div>
                </div>
                <div class="club40-author-bottom">
                    <div class="careerum-flex-fsst">
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827701-lK3KT-User.svg"
                                alt="">
                            <p>Помогла 12 000+ клиентам из России, СНГ, Европы, Северной и Южной Америки построить карьеру
                            </p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827344-JJ1IL-Brie.svg"
                                alt="">
                            <p>15+ лет успешной карьеры на руководящих позициях в 5 странах в tech-компаниях (Google,
                                Microsoft, Intel)</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsst">
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827589-RDqmT-Grad.svg"
                                alt="">
                            <p>Сертифицированный карьерный коуч International Coaching Federation</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723121827589-RDqmT-Grad.svg"
                                alt="">
                            <p>Степень MBA от бизнес-школы INSEAD, учится в Гарварде</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsst">
                        <div class="careerum-flex-fsfs">
                            <a class="careerum-flex-fsc" href="https://www.instagram.com/lermontova.career/"
                                target="_blank">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726059782241-TGyZN-Fram.svg"
                                    alt="">
                                <p>lermontova.career</p>
                            </a>
                            <a class="careerum-flex-fsc" href="https://www.linkedin.com/in/lermontova/" target="_blank">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726059781876-BfLAq-Fram.svg"
                                    alt="">
                                <p>lermontova</p>
                            </a>
                            <a class="careerum-flex-fsc" href="https://t.me/dreamcatchme" target="_blank">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726059782128-2ixKy-Fram.svg"
                                    alt="">
                                <p>dreamcatchme</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="club40-author-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Оформить подписку</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-author-mobile', {
        label: 'Club 4 author (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-author-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Ольга Лермонтова, фаундер Careerum</h2>
                <div class="club40-author-top">
                    <div class="careerum-flex-cc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723546777111-Sr73P-Fram.png"
                            alt="">
                    </div>
                    <div>
                        <p>«За 15 лет карьеры я прошла путь от репетитора английского языка до топ-менеджера в Google, Intel
                            и Microsoft.</p>
                        <p>Я училась на своих ошибках, часто не знала, как правильно строить карьеру.</p>
                        <p>Весь опыт я собрала в Careerum, чтобы другие профессионалы могли сэкономить время, избежать
                            фатальных карьерных ошибок, расти быстрее и зарабатывать на том, что нравится именно им!»</p>
                    </div>
                </div>
                <div class="club40-author-bottom">
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547194995-HHAge-User.svg"
                            alt="">
                        <p>Помогла 12 000+ клиентам из России, СНГ, Европы, Северной и Южной Америки построить карьеру </p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547194808-hdZMf-Grad.svg"
                            alt="">
                        <p>Сертифицированный карьерный коуч ICF</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547194808-hdZMf-Grad.svg"
                            alt="">
                        <p>Степень MBA от бизнес-школы INSEAD, учится в Гарварде</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547194495-04rIA-Brie.svg"
                            alt="">
                        <p>15+ лет успешной карьеры на руководящих позициях в 5 странах в Google, Microsoft, Intel</p>
                    </div>
                </div>
                <div class="club40-author-bottom">
                    <a class="careerum-flex-fsc" href="https://www.instagram.com/lermontova.career/" target="_blank">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726059782241-TGyZN-Fram.svg"
                            alt="">
                        <p>lermontova.career</p>
                    </a>
                    <a class="careerum-flex-fsc" href="https://www.linkedin.com/in/lermontova/" target="_blank">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726059781876-BfLAq-Fram.svg"
                            alt="">
                        <p>lermontova</p>
                    </a>
                    <a class="careerum-flex-fsc" href="https://t.me/dreamcatchme" target="_blank">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726059782128-2ixKy-Fram.svg"
                            alt="">
                        <p>dreamcatchme</p>
                    </a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-time', {
        label: 'Club 4 time',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-time">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Сколько времени потребуется, чтобы</h2>
                <div class="club40-time-nav">
                    <ul class="club40-time-nav-wrapper careerum-flex-fsfs">
                    </ul>
                </div>
                <div class="club40-time-items">
                    <div class="club40-time-item active" data-name="Понять, чего хочется от карьеры">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123276318-o6rOi-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: иногда — всю жизнь</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Строите карьеру «как получится» и без плана</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не понимаете свои сильные стороны, сомневаетесь в себе</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Чувствуете, что в работе нужно что-то менять, но не знаете, что</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Работа перестала радовать<br> и превратилась в рутину</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не знаете, что делать дальше: с карьерой и жизнью</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Ощущаете себя на чужом месте</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330340-wzGhN-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330090-aI7Rw-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: от 4 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1–2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Определите свои «Хочу» и «Могу»</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, что мешает вам достичь карьерных целей
                                        <li>Выявите свои сильные стороны и таланты</li>
                                        <li>Определите свои ключевые ценности</li>
                                        <li>Поймете, что в работе радует, а что демотивирует</li>
                                        <li>Сформулируете свои профессиональные интересы</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Поймете свои «Надо»</p>
                                    </div>
                                    <ul>
                                        <li>Соотнесете свои таланты с запросами рынка</li>
                                        <li>Подружите свои ценности с бизнес-задачами</li>
                                        <li>Научитесь выбирать работу осознанно, а не брать, «что дают»</li>
                                        <li>Поставите долгосрочную карьерную цель с опорой на свои ценности</li>
                                        <li>Определите пути развития под свою долгосрочную цель</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">4+ месяцa</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>В зависимости от целей:</p>
                                    </div>
                                    <ul>
                                        <li>Начнете осознанный поиск работы</li>
                                        <li>Составите план развития на текущем месте</li>
                                        <li>Наладите work-life balance</li>
                                        <li>Научитесь работать без выгорания</li>
                                        <li>Укрепите профессиональную самооценку</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo careerum-flex-fsfs">
                                    <p class="club40-time-item-bottom-item-text">Распутать карьерный клубок не сложно, если
                                        рядом сертифицированные карьерные коучи и эксперты</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723125224907-7Ysdj-Unio.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover1">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723125004478-Uqcgc-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Найти работу в своей стране">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123276318-o6rOi-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: 9–12 месяцев</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Долго и безуспешно ищете работу</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Ваше резюме не читают или игнорируют</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Нервничаете на интервью и не знаете, как себя вести</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не знаете, какую зарплату запросить — адекватно</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Боитесь откликаться на «крутые» вакансии</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Получаете отказы на разных этапах и не понимаете, почему</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330340-wzGhN-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330090-aI7Rw-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: 3–6 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Создадите стратегию поиска</p>
                                    </div>
                                    <ul>
                                        <li>Определите цель поиска</li>
                                        <li>Составите стратегию и воронку поиска</li>
                                        <li>Подготовите продающее резюме</li>
                                        <li>Отправите первые отклики</li>
                                        <li>Напишете сильные сопроводительные письма</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">2-3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Выйдете на первые интервью</p>
                                    </div>
                                    <ul>
                                        <li>Проработаете LinkedIn-профиль</li>
                                        <li>Адаптируете резюме и письма под вакансии</li>
                                        <li>Подготовитесь к собеседованиям</li>
                                        <li>Получите первые приглашения на интервью</li>
                                        <li>Скорректируете стратегию поиска с экспертом</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">4–6 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Начнете получать офферы</p>
                                    </div>
                                    <ul>
                                        <li>Начнете легко проходить интервью</li>
                                        <li>Научитесь вести переговоры об условиях работы</li>
                                        <li>Начнете получать первые офферы</li>
                                        <li>Будете выбирать офферы под свою цель и стратегию</li>
                                        <li>Построите нетворк и начнете получать больше приглашений</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">6+ месяцев</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Освоитесь на новой работе</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, как пройти испытательный срок</li>
                                        <li>Сформируете план развития на новом месте</li>
                                        <li>Узнаете, как вырасти в зарплате и должности</li>
                                        <li>Разовьете софтскилы для роста</li>
                                        <li>Адаптируетесь в новой команде</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo-wide careerum-flex-sbfs">
                                    <p class="club40-time-item-bottom-item-text">Найти новую работу можно в 2 раза быстрее,
                                        когда рядом сертифицированные карьерные коучи и эксперты с международным опытом</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723126169139-JLbtf-Grou.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover3">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723126405309-EBRwq-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Найти работу в другой стране">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123276318-o6rOi-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: от 12 месяцев</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не знаете, какую странувыбрать</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не знакомы с форматом иностранных интервью</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Опасаетесь, что ваш доходстанет меньше</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, какие вакансии вам подойдут</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Боитесь конкуренции с местными кандидатами</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Получаете отказы и не понимаете, почему</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330340-wzGhN-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330090-aI7Rw-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: 3–6 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1–2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Подготовитесь к поиску</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, как устроен процесс найма за рубежом</li>
                                        <li>Определите географию, цель и стратегию поиска</li>
                                        <li>Составите резюме для выбранной страны</li>
                                        <li>Проработаете LinkedIn-профиль и сопроводительное письмо</li>
                                        <li>Начнете отправлять первые отклики</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3-5 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Выйдете на первые интервью</p>
                                    </div>
                                    <ul>
                                        <li>Научитесь проходить интервью на другом языке</li>
                                        <li>Поймете, как строить нетворк в нужной стране</li>
                                        <li>Сможете вести переговоры о зарплате и условиях</li>
                                        <li>Начнете получать первые приглашения на интервью</li>
                                        <li>Скорректируете стратегию поиска с экспертом</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">6–9 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Начнете получать офферы</p>
                                    </div>
                                    <ul>
                                        <li>Начнете проходить собеседования без стресса</li>
                                        <li>Научитесь легко общаться с иностранными рекрутерами</li>
                                        <li>Получите первые офферы и выберете из них подходящие именно под вашу цель</li>
                                        <li>Разовьете нетворк и начнете получать больше приглашений</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">9+ месяцев</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Освоитесь на новой работе</p>
                                    </div>
                                    <ul>
                                        <li>Узнаете, как успешно пройти испытательный срок</li>
                                        <li>Сформулируете план развития на новом месте</li>
                                        <li>Поймете, как вырасти в зарплате и должности</li>
                                        <li>Разовьете софтскилс для роста</li>
                                        <li>Адаптируетесь к иностранной команде</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo-wide careerum-flex-sbfs">
                                    <p class="club40-time-item-bottom-item-text">Получить оффер за границе можно быстрее и
                                        без стресса, когда рядом сертифицированные карьерные эксперты с международным опытом
                                    </p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723126555192-8CJQ6-Grou.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover4">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723126405309-EBRwq-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Вырасти в зарплате и должности">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123276318-o6rOi-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: до-о-о-о-олго</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не знаете, как вырасти в зарплате и должности</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, как аргументировать повышение</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не знаете, сколько должен получать специалист как вы</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Ждете, что вас повысят, но этого не происходит</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не представляете, как может развиваться ваша карьера</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123372961-wd5eW-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, зачем демонстрировать результаты</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330340-wzGhN-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123330090-aI7Rw-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: от 3 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Подготовите базу для роста</p>
                                    </div>
                                    <ul>
                                        <li>Определите, что мешает вам расти в карьере
                                        <li>Определите с руководителем цели, чтобы развиваться в профессии</li>
                                        <li>Составите стратегию роста с учетом ваших суперсил и задач бизнеса</li>
                                        <li>Поймете: сколько стоят ваши навыки на рынке</li>
                                        <li>Укрепите профессиональную самооценку</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Вырастите в доходе / должности</p>
                                    </div>
                                    <ul>
                                        <li>Научитесь строить коммуникации и брать стратегически важные проекты</li>
                                        <li>Поймете, как запрашивать и принимать фидбек</li>
                                        <li>Сможете заявлять о себе и демонстрировать результаты</li>
                                        <li>Научитесь вести переговоры о повышении в свою пользу</li>
                                        <li>Получите повышение в зарплате / должности</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723123375562-bETkB-Vect.svg"
                                            alt="">
                                        <p>Поставите новые рекорды</p>
                                    </div>
                                    <ul>
                                        <li>Определите дополнительные способы роста</li>
                                        <li>Составите стратегию дальнейшего повышения</li>
                                        <li>Наладите work-life balance</li>
                                        <li>Сможете работать без выгорания</li>
                                        <li>Разовьете софтскил, необходимые для роста</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo careerum-flex-fsfs">
                                    <p class="club40-time-item-bottom-item-text">Расти в карьере можно регулярно, <br>если
                                        рядом сертифицированные карьерные коучи и эксперты с международным опытом</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723125950683-T4bEF-Unio.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover2">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723125004478-Uqcgc-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-time-tablet', {
        label: 'Club 4 time (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-time-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Сколько времени потребуется, чтобы</h2>
                <div class="club40-time-nav">
                    <ul class="club40-time-nav-wrapper careerum-flex-fsfs">
                    </ul>
                </div>
                <div class="club40-time-items">
                    <div class="club40-time-item active" data-name="Понять, чего хочется от карьеры">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623488-GgpEV-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: иногда — всю жизнь</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Строите карьеру «как получится» и без плана</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете свои сильные стороны, сомневаетесь в себе</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Работа перестала радовать<br> и превратилась в рутину</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, что делать дальше: с карьерой и жизнью</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Чувствуете, что в работе нужно что-то менять, но не знаете, что</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Ощущаете себя на чужом месте</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475959505-4Gr3I-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623753-JoaXH-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: от 4 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1–2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Определите свои «Хочу» и «Могу»</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, что мешает вам достичь карьерных целей
                                        <li>Выявите свои сильные стороны и таланты</li>
                                        <li>Определите свои ключевые ценности</li>
                                        <li>Поймете, что в работе радует, а что демотивирует</li>
                                        <li>Сформулируете свои профессиональные интересы</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Поймете свои «Надо»</p>
                                    </div>
                                    <ul>
                                        <li>Соотнесете свои таланты с запросами рынка</li>
                                        <li>Подружите свои ценности с бизнес-задачами</li>
                                        <li>Научитесь выбирать работу осознанно, а не брать, «что дают»</li>
                                        <li>Поставите долгосрочную карьерную цель с опорой на свои ценности</li>
                                        <li>Определите пути развития под свою долгосрочную цель</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">4+ месяцa</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>В зависимости от целей:</p>
                                    </div>
                                    <ul>
                                        <li>Начнете осознанный поиск работы</li>
                                        <li>Составите план развития на текущем месте</li>
                                        <li>Наладите work-life balance</li>
                                        <li>Научитесь работать без выгорания</li>
                                        <li>Укрепите профессиональную самооценку</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo careerum-flex-fsfs">
                                    <p class="club40-time-item-bottom-item-text">Распутать карьерный клубок<br> не сложно,
                                        если
                                        рядом карьерные коучи и эксперты</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476494104-dIToE-Unio.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover1">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476607650-AQUXg-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Найти работу в своей стране">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623488-GgpEV-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: 9–12 месяцев</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Долго и безуспешно ищете работу</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Ваше резюме не читают или игнорируют</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Нервничаете на интервью и не знаете, как себя вести</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, какую зарплату запросить — адекватно</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Боитесь откликаться на «крутые» вакансии</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Получаете отказы на разных этапах и не понимаете, почему</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475959505-4Gr3I-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623753-JoaXH-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: 3–6 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Создадите стратегию поиска</p>
                                    </div>
                                    <ul>
                                        <li>Определите цель поиска</li>
                                        <li>Составите стратегию и воронку поиска</li>
                                        <li>Подготовите продающее резюме</li>
                                        <li>Отправите первые отклики</li>
                                        <li>Напишете сильные сопроводительные письма</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">2-3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Выйдете на первые интервью</p>
                                    </div>
                                    <ul>
                                        <li>Проработаете LinkedIn-профиль</li>
                                        <li>Адаптируете резюме и письма под вакансии</li>
                                        <li>Подготовитесь к собеседованиям</li>
                                        <li>Получите первые приглашения на интервью</li>
                                        <li>Скорректируете стратегию поиска с экспертом</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">4–6 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Начнете получать офферы</p>
                                    </div>
                                    <ul>
                                        <li>Начнете легко проходить интервью</li>
                                        <li>Научитесь вести переговоры об условиях работы</li>
                                        <li>Начнете получать первые офферы</li>
                                        <li>Будете выбирать офферы под свою цель и стратегию</li>
                                        <li>Построите нетворк и начнете получать больше приглашений</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">6+ месяцев</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Освоитесь на новой работе</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, как пройти испытательный срок</li>
                                        <li>Сформируете план развития на новом месте</li>
                                        <li>Узнаете, как вырасти в зарплате и должности</li>
                                        <li>Разовьете софтскилы для роста</li>
                                        <li>Адаптируетесь в новой команде</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo-wide">
                                    <p class="club40-time-item-bottom-item-text">Найти новую работу можно в 2 раза быстрее,
                                        когда рядом сертифицированные карьерные коучи и эксперты<br> с международным опытом
                                    </p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723477015660-EqFgL-Grou.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover3">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476976190-qRyft-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Найти работу в другой стране">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623488-GgpEV-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: от 12 месяцев</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, какую странувыбрать</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знакомы с форматом иностранных интервью</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Опасаетесь, что ваш доходстанет меньше</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, какие вакансии вам подойдут</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Боитесь конкуренции с местными кандидатами</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Получаете отказы и не понимаете, почему</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475959505-4Gr3I-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623753-JoaXH-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: 3–6 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1–2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Подготовитесь к поиску</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, как устроен процесс найма за рубежом</li>
                                        <li>Определите географию, цель и стратегию поиска</li>
                                        <li>Составите резюме для выбранной страны</li>
                                        <li>Проработаете LinkedIn-профиль и сопроводительное письмо</li>
                                        <li>Начнете отправлять первые отклики</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3-5 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Выйдете на первые интервью</p>
                                    </div>
                                    <ul>
                                        <li>Научитесь проходить интервью на другом языке</li>
                                        <li>Поймете, как строить нетворк в нужной стране</li>
                                        <li>Сможете вести переговоры о зарплате и условиях</li>
                                        <li>Начнете получать первые приглашения на интервью</li>
                                        <li>Скорректируете стратегию поиска с экспертом</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">6–9 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Начнете получать офферы</p>
                                    </div>
                                    <ul>
                                        <li>Начнете проходить собеседования без стресса</li>
                                        <li>Научитесь легко общаться с иностранными рекрутерами</li>
                                        <li>Получите первые офферы и выберете из них подходящие именно под вашу цель</li>
                                        <li>Разовьете нетворк и начнете получать больше приглашений</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">9+ месяцев</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Освоитесь на новой работе</p>
                                    </div>
                                    <ul>
                                        <li>Узнаете, как успешно пройти испытательный срок</li>
                                        <li>Сформулируете план развития на новом месте</li>
                                        <li>Поймете, как вырасти в зарплате и должности</li>
                                        <li>Разовьете софтскилс для роста</li>
                                        <li>Адаптируетесь к иностранной команде</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo-wide">
                                    <p class="club40-time-item-bottom-item-text">Получить оффер за границе можно быстрее и
                                        без стресса,<br> когда рядом сертифицированные карьерные эксперты<br> с
                                        международным опытом
                                    </p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723477015660-EqFgL-Grou.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover4">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476976190-qRyft-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Вырасти в зарплате и должности">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623488-GgpEV-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку: до-о-о-о-олго</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, как вырасти в зарплате и должности</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, как аргументировать повышение</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, сколько должен получать специалист как вы</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Ждете, что вас повысят, но этого не происходит</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не представляете, как может развиваться ваша карьера</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, зачем демонстрировать результаты</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475959505-4Gr3I-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475623753-JoaXH-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum: от 3 месяцев</p>
                            <div class="club40-time-item-bottom-items careerum-flex-fsst">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Подготовите базу для роста</p>
                                    </div>
                                    <ul>
                                        <li>Определите, что мешает вам расти в карьере
                                        <li>Определите с руководителем цели, чтобы развиваться в профессии</li>
                                        <li>Составите стратегию роста с учетом ваших суперсил и задач бизнеса</li>
                                        <li>Поймете: сколько стоят ваши навыки на рынке</li>
                                        <li>Укрепите профессиональную самооценку</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Вырастите в доходе / должности</p>
                                    </div>
                                    <ul>
                                        <li>Научитесь строить коммуникации и брать стратегически важные проекты</li>
                                        <li>Поймете, как запрашивать и принимать фидбек</li>
                                        <li>Сможете заявлять о себе и демонстрировать результаты</li>
                                        <li>Научитесь вести переговоры о повышении в свою пользу</li>
                                        <li>Получите повышение в зарплате / должности</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Поставите новые рекорды</p>
                                    </div>
                                    <ul>
                                        <li>Определите дополнительные способы роста</li>
                                        <li>Составите стратегию дальнейшего повышения</li>
                                        <li>Наладите work-life balance</li>
                                        <li>Сможете работать без выгорания</li>
                                        <li>Разовьете софтскил, необходимые для роста</li>
                                    </ul>
                                </div>
                                <div class="club40-time-item-bottom-item-photo careerum-flex-fsfs">
                                    <p class="club40-time-item-bottom-item-text">Расти в карьере можно регулярно, <br>если
                                        рядом сертифицированные карьерные коучи и эксперты с международным опытом</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476749956-7beZF-Unio.svg"
                                        alt="" class="club40-time-item-bottom-item-img-hover2">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476607650-AQUXg-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-time-mobile', {
        label: 'Club 4 time (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-time-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Сколько времени потребуется, чтобы</h2>
                <div class="club40-time-nav">
                    <ul class="club40-time-nav-wrapper careerum-flex-fsfs">
                    </ul>
                </div>
                <div class="club40-time-items">
                    <div class="club40-time-item active" data-name="Понять, чего хочется от карьеры">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678415-BM0qX-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку:<br> иногда — всю жизнь</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Строите карьеру «как получится» и без плана</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Работа перестала радовать<br> и превратилась в рутину</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете свои сильные стороны, сомневаетесь в себе</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, что делать дальше: с карьерой и жизнью</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Чувствуете, что в работе нужно что-то менять, но не знаете, что</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Ощущаете себя на чужом месте</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547709640-SXy9e-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678785-eQSTq-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum:<br> от 4 месяцев</p>
                            <div class="club40-time-item-bottom-items">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 – 2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Определите свои «Хочу» и «Могу»</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, что мешает вам достичь карьерных целей</li>
                                    </ul>
                                    <ul>
                                        <li>Выявите свои сильные стороны и таланты</li>
                                        <li>Определите свои ключевые ценности</li>
                                        <li>Поймете, что в работе радует, а что демотивирует</li>
                                        <li>Сформулируете свои профессиональные интересы</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Поймете свои «Надо»</p>
                                    </div>
                                    <ul>
                                        <li>Соотнесете свои таланты с запросами рынка</li>
                                    </ul>
                                    <ul>
    
                                        <li>Подружите свои ценности с бизнес-задачами</li>
                                        <li>Научитесь выбирать работу осознанно, а не брать, «что дают»</li>
                                        <li>Поставите долгосрочную карьерную цель с опорой на свои ценности</li>
                                        <li>Определите пути развития под свою долгосрочную цель</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">4+ месяцa</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>В зависимости от целей:</p>
                                    </div>
                                    <ul>
                                        <li>Начнете осознанный поиск работы</li>
                                    </ul>
                                    <ul>
    
                                        <li>Составите план развития на текущем месте</li>
                                        <li>Наладите work-life balance</li>
                                        <li>Научитесь работать без выгорания</li>
                                        <li>Укрепите профессиональную самооценку</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item-photo careerum-flex-fsfs">
                                    <p class="club40-time-item-bottom-item-text">Распутать карьерный клубок<br> не сложно,
                                        если
                                        рядом карьерные коучи и эксперты</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723550900705-RSDHW-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Найти работу в своей стране">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678415-BM0qX-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку:<br> 9–12 месяцев</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Долго и безуспешно ищете работу</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Ваше резюме не читают или игнорируют</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Нервничаете на интервью и не знаете, как себя вести</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, какую зарплату запросить — адекватно</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Боитесь откликаться на «крутые» вакансии</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Получаете отказы на разных этапах и не понимаете, почему</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547709640-SXy9e-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678785-eQSTq-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum:<br> 3–6 месяцев</p>
                            <div class="club40-time-item-bottom-items">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Создадите стратегию поиска</p>
                                    </div>
                                    <ul>
                                        <li>Определите цель поиска</li>
                                    </ul>
                                    <ul>
    
                                        <li>Составите стратегию и воронку поиска</li>
                                        <li>Подготовите продающее резюме</li>
                                        <li>Отправите первые отклики</li>
                                        <li>Напишете сильные сопроводительные письма</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">2-3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Выйдете на первые интервью</p>
                                    </div>
                                    <ul>
                                        <li>Проработаете LinkedIn-профиль</li>
                                    </ul>
                                    <ul>
    
                                        <li>Адаптируете резюме и письма под вакансии</li>
                                        <li>Подготовитесь к собеседованиям</li>
                                        <li>Получите первые приглашения на интервью</li>
                                        <li>Скорректируете стратегию поиска с экспертом</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">4–6 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Начнете получать офферы</p>
                                    </div>
                                    <ul>
                                        <li>Начнете легко проходить интервью</li>
                                    </ul>
                                    <ul>
    
                                        <li>Научитесь вести переговоры об условиях работы</li>
                                        <li>Начнете получать первые офферы</li>
                                        <li>Будете выбирать офферы под свою цель и стратегию</li>
                                        <li>Построите нетворк и начнете получать больше приглашений</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">6+ месяцев</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Освоитесь на новой работе</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, как пройти испытательный срок</li>
                                    </ul>
                                    <ul>
    
                                        <li>Сформируете план развития на новом месте</li>
                                        <li>Узнаете, как вырасти в зарплате и должности</li>
                                        <li>Разовьете софтскилы для роста</li>
                                        <li>Адаптируетесь в новой команде</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item-photo-wide">
                                    <p class="club40-time-item-bottom-item-text">Найти новую работу можно в 2 раза быстрее,
                                        когда рядом карьерные коучи и эксперты с международным опытом</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723550900705-RSDHW-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Найти работу в другой стране">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678415-BM0qX-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку:<br> от 12 месяцев</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, какую странувыбрать</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знакомы с форматом иностранных интервью</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Опасаетесь, что ваш доходстанет меньше</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, какие вакансии вам подойдут</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Боитесь конкуренции с местными кандидатами</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Получаете отказы и не понимаете, почему</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547709640-SXy9e-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678785-eQSTq-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum:<br> 3–6 месяцев</p>
                            <div class="club40-time-item-bottom-items">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1–2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Подготовитесь к поиску</p>
                                    </div>
                                    <ul>
                                        <li>Поймете, как устроен процесс найма за рубежом</li>
                                    </ul>
                                    <ul>
    
                                        <li>Определите географию, цель и стратегию поиска</li>
                                        <li>Составите резюме для выбранной страны</li>
                                        <li>Проработаете LinkedIn-профиль и сопроводительное письмо</li>
                                        <li>Начнете отправлять первые отклики</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3-5 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Выйдете на первые интервью</p>
                                    </div>
                                    <ul>
                                        <li>Научитесь проходить интервью на другом языке</li>
                                    </ul>
                                    <ul>
    
                                        <li>Поймете, как строить нетворк в нужной стране</li>
                                        <li>Сможете вести переговоры о зарплате и условиях</li>
                                        <li>Начнете получать первые приглашения на интервью</li>
                                        <li>Скорректируете стратегию поиска с экспертом</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">6–9 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Начнете получать офферы</p>
                                    </div>
                                    <ul>
                                        <li>Начнете проходить собеседования без стресса</li>
                                    </ul>
                                    <ul>
    
                                        <li>Научитесь легко общаться с иностранными рекрутерами</li>
                                        <li>Получите первые офферы и выберете из них подходящие именно под вашу цель</li>
                                        <li>Разовьете нетворк и начнете получать больше приглашений</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">9+ месяцев</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Освоитесь на новой работе</p>
                                    </div>
                                    <ul>
                                        <li>Узнаете, как успешно пройти испытательный срок</li>
                                    </ul>
                                    <ul>
    
                                        <li>Сформулируете план развития на новом месте</li>
                                        <li>Поймете, как вырасти в зарплате и должности</li>
                                        <li>Разовьете софтскилс для роста</li>
                                        <li>Адаптируетесь к иностранной команде</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item-photo-wide">
                                    <p class="club40-time-item-bottom-item-text">Получить оффер за границе можно быстрее и
                                        без стресса, когда рядом сертифицированные карьерные эксперты с международным опытом
                                    </p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723550900705-RSDHW-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-time-item" data-name="Вырасти в зарплате и должности">
                        <div class="club40-time-item-top">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678415-BM0qX-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">В одиночку:<br> до-о-о-о-олго</p>
                            <div class="club40-time-item-top-items careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, как вырасти в зарплате и должности</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, как аргументировать повышение</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не знаете, сколько должен получать специалист как вы</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Ждете, что вас повысят, но этого не происходит</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не представляете, как может развиваться ваша карьера</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723475709158-wvSRC-Unio.svg"
                                        alt="">
                                    <p>Не понимаете, зачем демонстрировать результаты</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-time-item-bottom">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547709640-SXy9e-Vect.svg"
                                alt="">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723547678785-eQSTq-Grou.svg"
                                alt="">
                            <p class="club40-time-item-header">С Careerum:<br> от 3 месяцев</p>
                            <div class="club40-time-item-bottom-items">
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">1 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Подготовите базу для роста</p>
                                    </div>
                                    <ul>
                                        <li>Определите, что мешает вам расти в карьере</li>
                                    </ul>
                                    <ul>
                                        <li>Определите с руководителем цели, чтобы развиваться в профессии</li>
                                        <li>Составите стратегию роста с учетом ваших суперсил и задач бизнеса</li>
                                        <li>Поймете: сколько стоят ваши навыки на рынке</li>
                                        <li>Укрепите профессиональную самооценку</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">2 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Вырастите в доходе / должности</p>
                                    </div>
                                    <ul>
                                        <li>Научитесь строить коммуникации и брать стратегически важные проекты</li>
                                    </ul>
                                    <ul>
    
                                        <li>Поймете, как запрашивать и принимать фидбек</li>
                                        <li>Сможете заявлять о себе и демонстрировать результаты</li>
                                        <li>Научитесь вести переговоры о повышении в свою пользу</li>
                                        <li>Получите повышение в зарплате / должности</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item">
                                    <p class="club40-time-item-bottom-item-label">3 месяц</p>
                                    <div class="club40-time-item-bottom-item-header careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723476189609-z6cAb-Vect.svg"
                                            alt="">
                                        <p>Поставите новые рекорды</p>
                                    </div>
                                    <ul>
                                        <li>Определите дополнительные способы роста</li>
                                    </ul>
                                    <ul>
    
                                        <li>Составите стратегию дальнейшего повышения</li>
                                        <li>Наладите work-life balance</li>
                                        <li>Сможете работать без выгорания</li>
                                        <li>Разовьете софтскил, необходимые для роста</li>
                                    </ul>
                                    <div class="club40-time-item-bottom-item-switcher careerum-flex-fsc">
                                        <p>Показать больше</p>
                                        <p>Свернуть</p>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                                stroke="black" stroke-width="1.5" stroke-miterlimit="10" />
                                            <path d="M15.375 10.875L12 14.625L8.625 10.875" stroke="black"
                                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="club40-time-item-bottom-item-photo careerum-flex-fsfs">
                                    <p class="club40-time-item-bottom-item-text">Расти в карьере можно регулярно, если рядом
                                        сертифицированные карьерные коучи и эксперты с международным опытом</p>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723550900705-RSDHW-ÑÐº.png"
                                        alt="" class="club40-time-item-bottom-item-img-coaches">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-tariffs', {
        label: 'Club 4 tariffs',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-tariffs">
            <div class="careerum-container-desc">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278008892-Gajaw-Rect.png" alt="">
                <h2 class="careerum-club40-header">Оформите подписку Careerum </h2>
                <div class="club40-tariffs-nav careerum-flex-sbfs">
                    <div class="club40-tariffs-period">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="12" class="active">12 месяцев</li>
                            <li data-period="6">6 месяцев</li>
                            <li data-period="3">3 месяца</li>
                            <li data-period="1">1 месяц</li>
                        </ul>
                    </div>
                    <div class="club40-tariffs-curr careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur" class="active">EUR</li>
                            <li data-currency="rub">RUB</li>
                        </ul>
                        <div class="club40-tariffs-notif careerum-flex-cc">
                            <div class="club40-tariffs-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="club40-tariffs-notif-content">
                                <p>Оплата в российских рублях возможна только картой российского банка. В евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-items careerum-flex-fsst">
                    <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="12 900 ₽"
                        data-price-3m-rub="9 967 ₽" data-fullprice-3m-rub="29 900 ₽" data-price-6m-rub="6 900 ₽"
                        data-fullprice-6m-rub="47 400 ₽" data-price-12m-rub="5 900 ₽" data-fullprice-12m-rub="77 880 ₽"
                        data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                        data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                        data-fullprice-12m-eur="960 €" data-offer-1m-rub="#1mr1" data-offer-3m-rub="#3mr1"
                        data-offer-6m-rub="#6mr1" data-offer-12m-rub="#12mr1" data-offer-1m-eur="#1me1"
                        data-offer-3m-eur="#3me1" data-offer-6m-eur="#6me1" data-offer-12m-eur="#12me1">
                        <p class="club40-tariffs-item-subheader">Тариф</p>
                        <p class="club40-tariffs-item-header">Самостоятельный</p>
                        <p class="club40-tariffs-item-description">Если есть время, чтобы самому проработать свой карьерный
                            запрос<br> с помощью наших программ</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723135867345-NpjXQ-Play.svg"
                                    alt="">
                                <p>18 онлайн-программ,<br> закрывающих любой карьерный запрос</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price">
                                <div>
                                    <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div>
                                    <p>/</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div>
                            <a href="#thanks-no" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="14 900 ₽"
                        data-price-3m-rub="11 633 ₽" data-fullprice-3m-rub="34 900 ₽" data-price-6m-rub="9 817 ₽"
                        data-fullprice-6m-rub="58 900 ₽" data-price-12m-rub="8 000 ₽" data-fullprice-12m-rub="96 000 ₽"
                        data-price-1m-eur="199 €" data-price-3m-eur="170 €" data-fullprice-3m-eur="510 €"
                        data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €" data-price-12m-eur="100 €"
                        data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="#1mr" data-offer-3m-rub="#3mr"
                        data-offer-6m-rub="#6mr" data-offer-12m-rub="#12mr" data-offer-1m-eur="#1me"
                        data-offer-3m-eur="#3me" data-offer-6m-eur="#6me" data-offer-12m-eur="#12me">
                        <p class="club40-tariffs-item-label">Осталось: 25 мест</p>
                        <p class="club40-tariffs-item-subheader">Тариф</p>
                        <p class="club40-tariffs-item-header">С поддержкой</p>
                        <p class="club40-tariffs-item-description">Если важна обратная связь<br> от  экспертов и куратора.
                            Получите ее<br> в групповых чатах и на Q&A-эфирах</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <p class="club40-tariffs-item-subheader">В тариф входят все опции тарифа «Самостоятельный», плюс:
                        </p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Доступ к сообществу</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Доступ ко всем онлайн-ивентам и интенсивам</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>2 Q&A-эфира в месяц с разбором ваших карьерных вопросов</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price">
                                <div>
                                    <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div>
                                    <p>/</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div>
                            <a href="#thanks-yes" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="27 900 ₽"
                        data-price-3m-rub="23 900 ₽" data-fullprice-3m-rub="71 700 ₽" data-price-6m-rub="18 317 ₽"
                        data-fullprice-6m-rub="109 900 ₽" data-price-12m-rub="16 583 ₽" data-fullprice-12m-rub="199 000 ₽"
                        data-price-1m-eur="360 €" data-price-3m-eur="310 €" data-fullprice-3m-eur="930 €"
                        data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €" data-price-12m-eur="230 €"
                        data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="#1mr" data-offer-3m-rub="#3mr"
                        data-offer-6m-rub="#6mr" data-offer-12m-rub="#12mr" data-offer-1m-eur="#1me"
                        data-offer-3m-eur="#3me" data-offer-6m-eur="#6me" data-offer-12m-eur="#12me">
                        <p class="club40-tariffs-item-label">Осталось: 25 мест</p>
                        <p class="club40-tariffs-item-subheader">Тариф</p>
                        <p class="club40-tariffs-item-header">Индивидуальный подход</p>
                        <p class="club40-tariffs-item-description">Когда надо прийти к цели быстро.<br> У вас будет
                            персональная поддержка наших карьерных экспертов</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <p class="club40-tariffs-item-subheader">В тариф входят все преимущества тарифа «С поддержкой»,
                            плюс:</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Персональная поддержка карьерного эксперта<br> и карьерного коуча в чате</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>2 видеоконсультации<br> в месяц с коучем или экспертом</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Персональный разбор вашего резюме и LinkedIn-профиля</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price">
                                <div>
                                    <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div>
                                    <p>/</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div>
                            <a href="#thanks" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom careerum-flex-sbfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278649360-d3raW-Vect.svg"
                            alt="">
                        <p class="club40-tariffs-bottom-header">Не знаете, с чего начать?</p>
                        <p class="club40-tariffs-bottom-subheader">Напишите нам — мы ответим на все вопросы<br> и поможем
                            выбрать лучшее решение под вашу задачу</p>
                        <a href="#tg" class="btn-color-main-dark-orange careerum-flex-cc">
                            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                    fill="#C8DAEA" />
                                <path
                                    d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                    fill="#A9C6D8" />
                                <path
                                    d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                    fill="white" />
                            </svg>
                            <p>Написать нам в Telegram</p>
                        </a>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278685081-7nUnx-ÑÐ¾.svg"
                            alt="">
                        <div class="careerum-flex-fsfs club40-tariffs-bottom-care">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                    alt="">
                            </div>
                            <div>
                                <p class="club40-tariffs-bottom-care-name">Анна </p>
                                <p class="club40-tariffs-bottom-care-position">Команда заботы Careerum</p>
                                <p class="club40-tariffs-bottom-care-descr">Добрый день! Построить карьеру мечты в одиночку
                                    бывает непросто. Но мы рядом и приведем вас к заветной цели 💙</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-tariffs-tablet', {
        label: 'Club 4 tariffs (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-tariffs-tablet">
            <div class="careerum-container-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723485008387-JfPF7-Rect.png" alt="">
                <h2 class="careerum-club40-header-tablet">Оформите подписку Careerum </h2>
                <div class="club40-tariffs-nav careerum-flex-sbfs">
                    <div class="club40-tariffs-period">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="12" class="active">12 месяцев</li>
                            <li data-period="6">6 месяцев</li>
                            <li data-period="3">3 месяца</li>
                            <li data-period="1">1 месяц</li>
                        </ul>
                    </div>
                </div>
                <div class="club40-tariffs-items">
                    <div class="careerum-flex-fsst">
                        <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="27 900 ₽"
                            data-price-3m-rub="23 900 ₽" data-fullprice-3m-rub="71 700 ₽" data-price-6m-rub="18 317 ₽"
                            data-fullprice-6m-rub="109 900 ₽" data-price-12m-rub="16 583 ₽"
                            data-fullprice-12m-rub="199 000 ₽" data-price-1m-eur="360 €" data-price-3m-eur="310 €"
                            data-fullprice-3m-eur="930 €" data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €"
                            data-price-12m-eur="230 €" data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="#1mr"
                            data-offer-3m-rub="#3mr" data-offer-6m-rub="#6mr" data-offer-12m-rub="#12mr"
                            data-offer-1m-eur="#1me" data-offer-3m-eur="#3me" data-offer-6m-eur="#6me"
                            data-offer-12m-eur="#12me">
                            <p class="club40-tariffs-item-label">Осталось: 25 мест</p>
                            <p class="club40-tariffs-item-subheader">Тариф</p>
                            <p class="club40-tariffs-item-header">Индивидуальный подход</p>
                            <p class="club40-tariffs-item-subheader">В тариф входят все преимущества тарифа «С поддержкой»,
                                плюс:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                        alt="">
                                    <p>Персональная поддержка карьерного эксперта и карьерного коуча в чате</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                        alt="">
                                    <p>2 видеоконсультации<br> в месяц с коучем или экспертом</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                        alt="">
                                    <p>Персональный разбор вашего резюме и LinkedIn-профиля</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a href="#payform-single" class="btn-color-main-dark-orange">Выбрать тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="14 900 ₽"
                            data-price-3m-rub="11 633 ₽" data-fullprice-3m-rub="34 900 ₽" data-price-6m-rub="9 817 ₽"
                            data-fullprice-6m-rub="58 900 ₽" data-price-12m-rub="8 000 ₽" data-fullprice-12m-rub="96 000 ₽"
                            data-price-1m-eur="199 €" data-price-3m-eur="170 €" data-fullprice-3m-eur="510 €"
                            data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €" data-price-12m-eur="100 €"
                            data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="#1mr" data-offer-3m-rub="#3mr"
                            data-offer-6m-rub="#6mr" data-offer-12m-rub="#12mr" data-offer-1m-eur="#1me"
                            data-offer-3m-eur="#3me" data-offer-6m-eur="#6me" data-offer-12m-eur="#12me">
                            <p class="club40-tariffs-item-label">Осталось: 25 мест</p>
                            <p class="club40-tariffs-item-subheader">Тариф</p>
                            <p class="club40-tariffs-item-header">С поддержкой</p>
                            <p class="club40-tariffs-item-subheader">В тариф входят все опции тарифа «Самостоятельный»,
                                плюс: </p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                        alt="">
                                    <p>Доступ к сообществу</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                        alt="">
                                    <p>Доступ ко всем онлайн-ивентам и интенсивам</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                        alt="">
                                    <p>2 Q&A-эфира в месяц с разбором ваших карьерных вопросов</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a href="#thanks-yes" class="btn-color-main-dark-orange">Выбрать тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="12 900 ₽"
                            data-price-3m-rub="9 967 ₽" data-fullprice-3m-rub="29 900 ₽" data-price-6m-rub="6 900 ₽"
                            data-fullprice-6m-rub="47 400 ₽" data-price-12m-rub="5 900 ₽" data-fullprice-12m-rub="77 880 ₽"
                            data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                            data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                            data-fullprice-12m-eur="960 €" data-offer-1m-rub="#1mr1" data-offer-3m-rub="#3mr1"
                            data-offer-6m-rub="#6mr1" data-offer-12m-rub="#12mr1" data-offer-1m-eur="#1me1"
                            data-offer-3m-eur="#3me1" data-offer-6m-eur="#6me1" data-offer-12m-eur="#12me1">
                            <p class="club40-tariffs-item-subheader">Тариф</p>
                            <p class="club40-tariffs-item-header">Самостоятельный</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723552330061-yrrgy-Play.svg"
                                        alt="">
                                    <p>18 онлайн-программ,<br> закрывающих любой карьерный запрос</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a href="#thanks-no" class="btn-color-main-dark-orange">Выбрать тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-curr">
                    <div class="club40-tariffs__swicher-block">
                        <div class="club40-tariffs__swicher-top">
                            <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="club40-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="club40-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom careerum-flex-sbfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723484897716-GBGcE-Vect.svg"
                            alt="">
                        <p class="club40-tariffs-bottom-header">Не знаете, с чего начать?</p>
                        <p class="club40-tariffs-bottom-subheader">Напишите нам — мы ответим на все вопросы и поможем
                            выбрать решение под вашу задачу</p>
                        <a href="#tg" class="btn-color-main-dark-orange careerum-flex-cc">
                            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                    fill="#C8DAEA" />
                                <path
                                    d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                    fill="#A9C6D8" />
                                <path
                                    d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                    fill="white" />
                            </svg>
                            <p>Написать нам в Telegram</p>
                        </a>
                    </div>
                    <div>
                        <div class="club40-tariffs-bottom-care">
                            <div class="careerum-flex-fsc">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-tariffs-bottom-care-name">Анна </p>
                                    <p class="club40-tariffs-bottom-care-position">Команда заботы Careerum</p>
                                </div>
                            </div>
                            <p class="club40-tariffs-bottom-care-descr">Добрый день! Построить карьеру мечты в одиночку
                                бывает непросто. Но мы рядом и приведем вас к заветной цели 💙</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-tariffs-mobile', {
        label: 'Club 4 tariffs (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-tariffs-mobile">
            <div class="careerum-container-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723551361905-BYCit-Rect.png" alt="">
                <h2 class="careerum-club40-header-mobile">Оформите подписку<br> Careerum </h2>
                <div class="club40-tariffs-nav">
                    <div class="club40-tariffs-period">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="12" class="active">Год</li>
                            <li data-period="6">Полгода</li>
                            <li data-period="3">3 месяца</li>
                            <li data-period="1">Месяц</li>
                        </ul>
                    </div>
                </div>
                <div class="club40-tariffs-curr">
                    <div class="club40-tariffs__swicher-block">
                        <div class="club40-tariffs__swicher-top">
                            <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="club40-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="club40-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-items">
                    <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="12 900 ₽"
                        data-price-3m-rub="9 967 ₽" data-fullprice-3m-rub="29 900 ₽" data-price-6m-rub="6 900 ₽"
                        data-fullprice-6m-rub="47 400 ₽" data-price-12m-rub="5 900 ₽" data-fullprice-12m-rub="77 880 ₽"
                        data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                        data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                        data-fullprice-12m-eur="960 €" data-offer-1m-rub="#1mr1" data-offer-3m-rub="#3mr1"
                        data-offer-6m-rub="#6mr1" data-offer-12m-rub="#12mr1" data-offer-1m-eur="#1me1"
                        data-offer-3m-eur="#3me1" data-offer-6m-eur="#6me1" data-offer-12m-eur="#12me1">
                        <p class="club40-tariffs-item-subheader">Тариф</p>
                        <p class="club40-tariffs-item-header">Самостоятельный</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723552330061-yrrgy-Play.svg"
                                    alt="">
                                <p>18 онлайн-программ,<br> закрывающих любой карьерный запрос</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="club40-tariffs-item-wrapper-price">
                                <div class="careerum-flex-fsfs">
                                    <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div>
                            <a href="#thanks" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="14 900 ₽"
                        data-price-3m-rub="11 633 ₽" data-fullprice-3m-rub="34 900 ₽" data-price-6m-rub="9 817 ₽"
                        data-fullprice-6m-rub="58 900 ₽" data-price-12m-rub="8 000 ₽" data-fullprice-12m-rub="96 000 ₽"
                        data-price-1m-eur="199 €" data-price-3m-eur="170 €" data-fullprice-3m-eur="510 €"
                        data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €" data-price-12m-eur="100 €"
                        data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="#1mr" data-offer-3m-rub="#3mr"
                        data-offer-6m-rub="#6mr" data-offer-12m-rub="#12mr" data-offer-1m-eur="#1me"
                        data-offer-3m-eur="#3me" data-offer-6m-eur="#6me" data-offer-12m-eur="#12me">
                        <p class="club40-tariffs-item-label">Осталось: 25 мест</p>
                        <p class="club40-tariffs-item-subheader">Тариф</p>
                        <p class="club40-tariffs-item-header">С поддержкой</p>
                        <p class="club40-tariffs-item-subheader">Все преимущества тарифа «Самостоятельный», плюс:</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                    alt="">
                                <p>Доступ к сообществу</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                    alt="">
                                <p>Доступ ко всем онлайн-ивентам и интенсивам</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                    alt="">
                                <p>2 Q&A-эфира в месяц с разбором ваших карьерных вопросов</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="club40-tariffs-item-wrapper-price">
                                <div class="careerum-flex-fsfs">
                                    <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div>
                            <a href="#thanks-yes" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div class="club40-tariffs-item careerum-flex-fsfs" data-price-1m-rub="27 900 ₽"
                        data-price-3m-rub="23 900 ₽" data-fullprice-3m-rub="71 700 ₽" data-price-6m-rub="18 317 ₽"
                        data-fullprice-6m-rub="109 900 ₽" data-price-12m-rub="16 583 ₽" data-fullprice-12m-rub="199 000 ₽"
                        data-price-1m-eur="360 €" data-price-3m-eur="310 €" data-fullprice-3m-eur="930 €"
                        data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €" data-price-12m-eur="230 €"
                        data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="#1mr" data-offer-3m-rub="#3mr"
                        data-offer-6m-rub="#6mr" data-offer-12m-rub="#12mr" data-offer-1m-eur="#1me"
                        data-offer-3m-eur="#3me" data-offer-6m-eur="#6me" data-offer-12m-eur="#12me">
                        <p class="club40-tariffs-item-label">Осталось: 25 мест</p>
                        <p class="club40-tariffs-item-subheader">Тариф</p>
                        <p class="club40-tariffs-item-header">Индивидуальный подход</p>
                        <p class="club40-tariffs-item-subheader">Все преимущества тарифа «С поддержкой», плюс:</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                    alt="">
                                <p>Персональная поддержка карьерного эксперта и карьерного коуча в чате</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                    alt="">
                                <p>2 видеоконсультации<br> в месяц с коучем или экспертом</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723483406167-XJY0e-Fram.svg"
                                    alt="">
                                <p>Персональный разбор вашего резюме и LinkedIn-профиля</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="club40-tariffs-item-wrapper-price">
                                <div class="careerum-flex-fsfs">
                                    <p class="club40-tariffs-item-price-pm">8 000 ₽</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div class="careerum-flex-fsfs">
                                    <p class="club40-tariffs-item-price-f">96 000 ₽</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div>
                            <a href="#payform-single" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub">Можно в рассрочку</p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723484897716-GBGcE-Vect.svg"
                            alt="">
                        <p class="club40-tariffs-bottom-header">Не знаете, с чего начать?</p>
                        <p class="club40-tariffs-bottom-subheader">Напишите нам — мы ответим на все вопросы и поможем
                            выбрать решение под вашу задачу</p>
                    </div>
                    <div>
                        <div class="club40-tariffs-bottom-care">
                            <div class="careerum-flex-fsc">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-tariffs-bottom-care-name">Анна </p>
                                    <p class="club40-tariffs-bottom-care-position">Команда заботы Careerum</p>
                                </div>
                            </div>
                            <p class="club40-tariffs-bottom-care-descr">Добрый день! Построить карьеру мечты в одиночку
                                бывает непросто. Но мы рядом и приведем вас к заветной цели 💙</p>
                        </div>
                        <a href="#tg" class="btn-color-main-dark-orange careerum-flex-cc">
                            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                    fill="#C8DAEA" />
                                <path
                                    d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                    fill="#A9C6D8" />
                                <path
                                    d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                    fill="white" />
                            </svg>
                            <p>Написать нам в Telegram</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-support', {
        label: 'Club 4 support',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-support">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Еще немного про подписку Careerum</h2>
                <div class="club40-support-experts">
                    <div class="club40-support-experts-top">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Экспертная поддержка</p>
                        </div>
                        <p class="club40-support-header">Помощь карьерных коучей и экспертов:<br>
                            чтобы карьерные цели достигались легко и быстро</p>
                    </div>
                    <div class="club40-support-experts-slider">
                        <div class="club40-support-experts-slider-item-about">
                            <div>
                                <div>
                                    <p class="club40-support-experts-slider-item-header">9,3/10</p>
                                    <p class="club40-support-experts-slider-item-subheader">средняя оценка коучей от
                                        клиентов Careerum</p>
                                    <p class="club40-support-experts-slider-item-header">9,5/10</p>
                                    <p class="club40-support-experts-slider-item-subheader">средняя оценка карьерных
                                        экспертов</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280806527-AkUu1-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Добринская</p>
                            <p class="club40-support-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409766-cqwPu-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Софи Бессон</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409265-9vjpf-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Надежда Община</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>9+ лет в маркетинге и консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 550+ клиентам из США, Европы и СНГ найти работу и сменить карьеру</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Airbus, Hubspot, Google, Farfetch</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Португалия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410646-Tg23o-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410772-6unNS-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Оксана Сыпченко</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет в карьерном коучинге и гос.секторе</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 100+ клиентам найти карьерный вектор, стать увереннее в себе и получить
                                        повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками ERG, DevExpress, Роснефть</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Конго</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410266-0RLoj-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410383-HztZL-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410508-UN5w7-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409625-XnYoE-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Мария Пудалова</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе
                                        и США</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409884-sm2PF-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Астра Висаева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге, финансах и инвестициях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2500+ клиентам определить карьерные вектора и найти работу в России, ЕС и США
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками OZON, EPAM, McKinsey, Nike</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410030-PrNQ2-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Марина Веденичева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410151-lWIq0-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Ирина Шутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч AFC</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ лет в коучинге и коммуникациях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1000+ клиентам получить офферы с релокацией и повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками PepsiCo, Amazon, VK, Pfizer</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="club40-support-slider-nav careerum-flex-fec">
                        <div class="club40-support-experts-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_7304_21282)">
                                    <g filter="url(#filter0_b_7304_21282)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="#FF9F00" />
                                    </g>
                                    <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_7304_21282" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_7304_21282" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7304_21282"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_7304_21282">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="club40-support-experts-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_7304_21286)">
                                    <g filter="url(#filter0_b_7304_21286)">
                                        <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="#FF9F00" />
                                    </g>
                                    <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_7304_21286" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_7304_21286" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7304_21286"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_7304_21286">
                                        <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <div class="club40-support-experts-available careerum-flex-fsc">
                        <p>Доступно на тарифах:</p>
                        <div class="careerum-flex-cc not-avail">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283080104-KyTpV-XCir.svg"
                                alt="">
                            <p>Самостоятельный</p>
                        </div>
                        <div class="careerum-flex-cc not-avail">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283080104-KyTpV-XCir.svg"
                                alt="">
                            <p>С поддержкой</p>
                        </div>
                        <div class="careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                alt="">
                            <p>Индивидуальный подход</p>
                        </div>
                    </div>
                </div>
                <div class="club40-support-info careerum-flex-sbst">
                    <div class="club40-support-mers">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Онлайн мероприятия</p>
                        </div>
                        <p class="club40-support-header">Интенсивы и Q&A-эфиры</p>
                        <p class="club40-support-content">На интенсивах глубоко погружаемся в ключевые карьерные темы и
                            помогаем каждому участнику быстро и эффективно достичь своей цели с поддержкой единомышленников
                            и экспертов.</p>
                        <p class="club40-support-content">На Q&A-эфирах вместе с карьерными экспертами и другими участниками
                            сообщества решаем актуальные карьерные вопросы.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283725047-fSheB-Fram.svg"
                            alt="">
                        <div class="club40-support-experts-available careerum-flex-fsc">
                            <p>Доступно на тарифах:</p>
                            <div class="careerum-flex-cc not-avail">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283080104-KyTpV-XCir.svg"
                                    alt="">
                                <p>Самостоятельный</p>
                            </div>
                            <div class="careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                    alt="">
                                <p>С поддержкой</p>
                            </div>
                            <div class="careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                    alt="">
                                <p>Индивидуальный подход</p>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-netw">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Нетворкинг</p>
                        </div>
                        <p class="club40-support-header">Сильное сообщество профессионалов со всего мира</p>
                        <p class="club40-support-content">Доступ в сообщество из 1000+ профессионалов из 30+ стран, где вы
                            сможете научиться строить нетворк и завести полезные знакомства, найти поддержку среди
                            участников с похожими проблемами и целями и получить советы от тех, кто уже успешно прошел
                            аналогичный путь.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723284054075-4V27u-Grou.svg"
                            alt="">
                        <div class="club40-support-experts-available careerum-flex-fsc">
                            <p>Доступно на тарифах:</p>
                            <div class="careerum-flex-cc not-avail">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283080104-KyTpV-XCir.svg"
                                    alt="">
                                <p>Самостоятельный</p>
                            </div>
                            <div class="careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                    alt="">
                                <p>С поддержкой</p>
                            </div>
                            <div class="careerum-flex-cc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                    alt="">
                                <p>Индивидуальный подход</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-support-mats">
                    <div class="club40-support-mats-top careerum-flex-sbfs">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>Образовательные материалы</p>
                            </div>
                            <p class="club40-support-header">18 программ под любую карьерную задачу, и даже самую редкую</p>
                            <ul>
                                <li>Как построить карьеру за рубежом</li>
                                <li>Как адаптироваться на новом рабочем месте</li>
                                <li>Как регулярно расти в должности и доходе</li>
                                <li>Как укрепить профессиональную самооценку</li>
                                <li>Как построить life-work balance и не выгорать</li>
                                <li>И другие темы, чтобы карьера была по любви</li>
                            </ul>
                        </div>
                        <div>
                            <div>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723284844056-jWdN3-Note.svg"
                                            alt="">
                                        <p>В Сareerum больше 80 курсов под любой запрос</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723284843668-UVBRz-Book.svg"
                                            alt="">
                                        <p>Методисты Careerum разделили их по темам и упаковали в понятные образовательные
                                            траектории</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723284844268-BBlL8-Trop.svg"
                                            alt="">
                                        <p>Вам осталось выбрать подходящую и получить знания. А если возникнут вопросы, мы
                                            обязательно поможем!</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-mats-divider"></div>
                    <div class="club40-support-mats-slider-wrapper">
                        <p class="club40-support-mats-slider-header">Учитесь по программам ведущих экспертов</p>
                        <div class="club40-support-mats-slider-items">
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285436842-nmhub-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Ольга Лермонтова</p>
                                <p class="club40-support-mats-slider-item-position">фаундер Careerum</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Занимала руководящие должности в Google и Microsoft</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Управляла бизнесом на 20+ рынках Африки и Европы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>12 000+ клиентов из РФ, СНГ, Европы, Америки </p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Италия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437123-F7q7s-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Елена Резанова</p>
                                <p class="club40-support-mats-slider-item-position">карьерный стратег</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>9+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Монако </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437246-oRSRS-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Sophie Vurpillot</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Испания</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437367-I19r8-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Анна Бабич</p>
                                <p class="club40-support-mats-slider-item-position">психолог</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Россия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437505-QfSia-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Montse Lorente</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Перу</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437627-rUPvo-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Санжар Ибрагимов</p>
                                <p class="club40-support-mats-slider-item-position">ментор</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>MBA в швейцарской бизнес-школе IMD</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в IMD International и Aalto Business School</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Финляндия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437755-4zqkR-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Наталья Токарь</p>
                                <p class="club40-support-mats-slider-item-position">эксперт по коммуникации</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и
                                            руководителей</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в бизнес-акселераторе Чикаго</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>США</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-slider-nav careerum-flex-fec">
                        <div class="club40-support-mats-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_7304_21282)">
                                    <g filter="url(#filter0_b_7304_21282)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="#FF9F00" />
                                    </g>
                                    <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_7304_21282" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_7304_21282" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7304_21282"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_7304_21282">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="club40-support-mats-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_7304_21286)">
                                    <g filter="url(#filter0_b_7304_21286)">
                                        <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="#FF9F00" />
                                    </g>
                                    <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_7304_21286" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_7304_21286" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_7304_21286"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_7304_21286">
                                        <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <div class="club40-support-experts-available careerum-flex-fsc">
                        <p>Доступно на тарифах:</p>
                        <div class="careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                alt="">
                            <p>Самостоятельный</p>
                        </div>
                        <div class="careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                alt="">
                            <p>С поддержкой</p>
                        </div>
                        <div class="careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723283079831-F19gL-Chec.svg"
                                alt="">
                            <p>Индивидуальный подход</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-support-tablet', {
        label: 'Club 4 support (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-support-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Еще немного про подписку</h2>
                <div class="club40-support-experts">
                    <div class="club40-support-experts-top careerum-flex-fsfs">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>Экспертная поддержка</p>
                            </div>
                            <p class="club40-support-header">Помощь коучей и экспертов: чтобы карьерные цели достигались
                                легко и быстро</p>
                        </div>
                        <div>
                            <div>
                                <div class="careerum-flex-fsc">
                                    <p class="club40-support-experts-slider-item-header">9,3/10</p>
                                    <p class="club40-support-experts-slider-item-subheader">средняя оценка коучей от
                                        клиентов Careerum</p>
                                </div>
                                <div class="careerum-flex-fsc">
                                    <p class="club40-support-experts-slider-item-header">9,5/10</p>
                                    <p class="club40-support-experts-slider-item-subheader">средняя оценка карьерных
                                        экспертов</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-experts-slider">
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280806527-AkUu1-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Добринская</p>
                            <p class="club40-support-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409766-cqwPu-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Софи Бессон</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409265-9vjpf-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Надежда Община</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>9+ лет в маркетинге и консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 550+ клиентам из США, Европы и СНГ найти работу и сменить карьеру</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Airbus, Hubspot, Google, Farfetch</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Португалия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410646-Tg23o-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410772-6unNS-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Оксана Сыпченко</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет в карьерном коучинге и гос.секторе</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 100+ клиентам найти карьерный вектор, стать увереннее в себе и получить
                                        повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками ERG, DevExpress, Роснефть</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Конго</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410266-0RLoj-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410383-HztZL-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410508-UN5w7-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409625-XnYoE-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Мария Пудалова</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе
                                        и США</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409884-sm2PF-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Астра Висаева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге, финансах и инвестициях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2500+ клиентам определить карьерные вектора и найти работу в России, ЕС и США
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками OZON, EPAM, McKinsey, Nike</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410030-PrNQ2-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Марина Веденичева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410151-lWIq0-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Ирина Шутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч AFC</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ лет в коучинге и коммуникациях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1000+ клиентам получить офферы с релокацией и повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками PepsiCo, Amazon, VK, Pfizer</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="club40-support-info careerum-flex-sbst">
                    <div class="club40-support-mers">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Онлайн мероприятия</p>
                        </div>
                        <p class="club40-support-header">Интенсивы и Q&A-эфиры</p>
                        <p class="club40-support-content">На интенсивах глубоко погружаемся в ключевые карьерные темы и помогаем каждому участнику достичь своей цели с поддержкой единомышленников и экспертов.</p>
                        <p class="club40-support-content">На Q&A-эфирах вместе с карьерными экспертами и другими участниками
                            сообщества решаем актуальные карьерные вопросы.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723487517601-J3a3P-Fram.svg"
                            alt="">
                    </div>
                    <div class="club40-support-netw">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Нетворкинг</p>
                        </div>
                        <p class="club40-support-header">Сильное сообщество профессионалов со всего мира</p>
                        <p class="club40-support-content">Доступ в сообщество из 1000+ профессионалов из 30+ стран, где вы сможете завести полезные знакомства, найти поддержку среди участников с похожими проблемами и целями и получить советы от тех, кто уже успешно прошел аналогичный путь.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723487518161-WYb3k-Grou.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-support-mats">
                    <div class="club40-support-mats-top careerum-flex-sbfs">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>Образовательные материалы</p>
                            </div>
                            <p class="club40-support-header">18 программ под любую карьерную задачу</p>
                            <ul>
                                <li>Построить карьеру за рубежом</li>
                                <li>Адаптироваться на новом рабочем месте</li>
                                <li>Регулярно расти в должности и доходе</li>
                                <li>Укрепить профессиональную самооценку</li>
                                <li>И другие темы, даже самые редкие</li>
                            </ul>
                        </div>
                        <div>
                            <div>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723488217563-Vnu5D-Note.svg"
                                            alt="">
                                        <p>В Сareerum больше 80 курсов<br> под любой запрос</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723488217283-YRFlS-Book.svg"
                                            alt="">
                                        <p>Методисты Careerum разделили<br> их по темам на программы и упаковали в понятные образовательные траектории</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723488217709-BpfbH-Trop.svg"
                                            alt="">
                                        <p>Вам осталось выбрать подходящую, а если возникнут вопросы — мы рядом</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-mats-divider"></div>
                    <div class="club40-support-mats-slider-wrapper">
                        <p class="club40-support-mats-slider-header">Учитесь по программам ведущих экспертов</p>
                        <div class="club40-support-mats-slider-items">
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285436842-nmhub-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Ольга Лермонтова</p>
                                <p class="club40-support-mats-slider-item-position">фаундер Careerum</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Занимала руководящие должности в Google и Microsoft</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Управляла бизнесом на 20+ рынках Африки и Европы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>12 000+ клиентов из РФ, СНГ, Европы, Америки </p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Италия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437123-F7q7s-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Елена Резанова</p>
                                <p class="club40-support-mats-slider-item-position">карьерный стратег</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>9+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Монако </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437246-oRSRS-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Sophie Vurpillot</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Испания</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437367-I19r8-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Анна Бабич</p>
                                <p class="club40-support-mats-slider-item-position">психолог</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Россия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437505-QfSia-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Montse Lorente</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Перу</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437627-rUPvo-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Санжар Ибрагимов</p>
                                <p class="club40-support-mats-slider-item-position">ментор</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>MBA в швейцарской бизнес-школе IMD</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в IMD International и Aalto Business School</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Финляндия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437755-4zqkR-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Наталья Токарь</p>
                                <p class="club40-support-mats-slider-item-position">эксперт по коммуникации</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и
                                            руководителей</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в бизнес-акселераторе Чикаго</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>США</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-support-mobile', {
        label: 'Club 4 support (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-support-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Еще немного про подписку</h2>
                <div class="club40-support-experts">
                    <div class="club40-support-experts-top">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>Экспертная поддержка</p>
                            </div>
                            <p class="club40-support-header">Помощь коучей и экспертов: чтобы карьерные цели достигались
                                легко и быстро</p>
                        </div>
                        <div>
                            <div>
                                <div class="careerum-flex-fsc">
                                    <p class="club40-support-experts-slider-item-header">9,3/10</p>
                                    <p class="club40-support-experts-slider-item-subheader">средняя оценка коучей от
                                        клиентов Careerum</p>
                                </div>
                                <div class="careerum-flex-fsc">
                                    <p class="club40-support-experts-slider-item-header">9,5/10</p>
                                    <p class="club40-support-experts-slider-item-subheader">средняя оценка карьерных
                                        экспертов</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-experts-slider">
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280806527-AkUu1-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Добринская</p>
                            <p class="club40-support-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409766-cqwPu-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Софи Бессон</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409265-9vjpf-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Надежда Община</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>9+ лет в маркетинге и консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 550+ клиентам из США, Европы и СНГ найти работу и сменить карьеру</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Airbus, Hubspot, Google, Farfetch</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Португалия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410646-Tg23o-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410772-6unNS-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Оксана Сыпченко</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет в карьерном коучинге и гос.секторе</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 100+ клиентам найти карьерный вектор, стать увереннее в себе и получить
                                        повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками ERG, DevExpress, Роснефть</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Конго</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410266-0RLoj-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410383-HztZL-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410508-UN5w7-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409625-XnYoE-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Мария Пудалова</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе
                                        и США</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409884-sm2PF-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Астра Висаева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге, финансах и инвестициях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2500+ клиентам определить карьерные вектора и найти работу в России, ЕС и США
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками OZON, EPAM, McKinsey, Nike</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410030-PrNQ2-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Марина Веденичева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с
                                        сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410151-lWIq0-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Ирина Шутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч AFC</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ лет в коучинге и коммуникациях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1000+ клиентам получить офферы с релокацией и повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками PepsiCo, Amazon, VK, Pfizer</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="club40-support-info">
                    <div class="club40-support-mers">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Онлайн мероприятия</p>
                        </div>
                        <p class="club40-support-header">Интенсивы и Q&A-эфиры</p>
                        <p class="club40-support-content">На интенсивах глубоко погружаемся в ключевые карьерные темы и
                            помогаем каждому участнику достичь своей цели с поддержкой единомышленников и экспертов.</p>
                        <p class="club40-support-content">На Q&A-эфирах вместе с карьерными экспертами и другими участниками
                            сообщества решаем актуальные карьерные вопросы.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723487517601-J3a3P-Fram.svg"
                            alt="">
                    </div>
                    <div class="club40-support-netw">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>Нетворкинг</p>
                        </div>
                        <p class="club40-support-header">Сильное сообщество профессионалов со всего мира</p>
                        <p class="club40-support-content">Доступ в сообщество из 1000+ профессионалов из 30+ стран, где вы
                            сможете завести полезные знакомства, найти поддержку среди участников с похожими проблемами и
                            целями и получить советы от тех, кто уже успешно прошел аналогичный путь.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723554465492-akoKl-Grou.svg"
                            alt="">
                    </div>
                </div>
                <div class="club40-support-mats">
                    <div class="club40-support-mats-top">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>Образовательные материалы</p>
                            </div>
                            <p class="club40-support-header">18 программ под любую карьерную задачу</p>
                            <ul>
                                <li>Построить карьеру за рубежом</li>
                                <li>Адаптироваться на новом рабочем месте</li>
                                <li>Регулярно расти в должности и доходе</li>
                                <li>Укрепить профессиональную самооценку</li>
                                <li>И другие темы, даже самые редкие</li>
                            </ul>
                        </div>
                        <div>
                            <div>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723488217563-Vnu5D-Note.svg"
                                            alt="">
                                        <p>В Сareerum больше 80 курсов<br> под любой запрос</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723488217283-YRFlS-Book.svg"
                                            alt="">
                                        <p>Методисты Careerum разделили<br> их по темам на программы и упаковали в понятные
                                            образовательные траектории</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723488217709-BpfbH-Trop.svg"
                                            alt="">
                                        <p>Вам осталось выбрать подходящую, а если возникнут вопросы — мы рядом</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-mats-divider"></div>
                    <div class="club40-support-mats-slider-wrapper">
                        <p class="club40-support-mats-slider-header">Учитесь по программам<br> ведущих экспертов</p>
                        <div class="club40-support-mats-slider-items">
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285436842-nmhub-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Ольга Лермонтова</p>
                                <p class="club40-support-mats-slider-item-position">фаундер Careerum</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Занимала руководящие должности в Google и Microsoft</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Управляла бизнесом на 20+ рынках Африки и Европы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>12 000+ клиентов из РФ, СНГ, Европы, Америки </p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Италия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437123-F7q7s-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Елена Резанова</p>
                                <p class="club40-support-mats-slider-item-position">карьерный стратег</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>9+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Монако </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437246-oRSRS-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Sophie Vurpillot</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Испания</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437367-I19r8-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Анна Бабич</p>
                                <p class="club40-support-mats-slider-item-position">психолог</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Россия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437505-QfSia-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Montse Lorente</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Перу</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437627-rUPvo-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Санжар Ибрагимов</p>
                                <p class="club40-support-mats-slider-item-position">ментор</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>MBA в швейцарской бизнес-школе IMD</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в IMD International и Aalto Business School</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Финляндия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437755-4zqkR-phot.png"
                                        alt="">
                                </div>
                                <p class="club40-support-mats-slider-item-name">Наталья Токарь</p>
                                <p class="club40-support-mats-slider-item-position">эксперт по коммуникации</p>
                                <ul>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и
                                            руководителей</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в бизнес-акселераторе Чикаго</p>
                                    </li>
                                    <li class="careerum-flex-fsfs">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>США</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('club40-support2', {
        label: 'Club 4 support2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-support club40-support2">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Careerum — это обучение карьерным навыкам, поддержка экспертов,
                    профессиональный нетворкинг</h2>
                <div class="club40-support-experts">
                    <div class="club40-support-experts-top">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>01 Образовательная платформа</p>
                        </div>
                        <p class="club40-support-header">80 курсов под любую карьерную задачу</p>
                    </div>
                    <div class="club40-support-programms-slider-items">
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Звёздный кандидат</p>
                            <p class="programms-slider-text">Эта программа — must see для всех, кто хоть раз искал работу.
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195877-jxP4N-pic..svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Real Me: как найти себя </p>
                            <p class="programms-slider-text">Вы сможете лучше узнать себя настоящего и понять, чего вы
                                хотите для своей карьеры</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195760-k2i68-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Международная карьера и релокация</p>
                            <p class="programms-slider-text">Вы узнаете всё о поиске работы в новых для вас странах, освоите
                                LinkedIn и научитесь учитывать культурный контекст</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195611-i209G-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьерная ракета</p>
                            <p class="programms-slider-text">Вы освоите базу карьерного мышления, узнаете, как расти в
                                зарплате и роли и научитесь планировать и добиваться даже самых амбициозных целей.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195276-Tuk6J-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Работать не 24/7</p>
                            <p class="programms-slider-text">Вы повысите свою продуктивность и научитесь получать результаты
                                в проектах</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905207114-JpoWG-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Самооценка и Деньги: не мешайте себе зарабатывать</p>
                            <p class="programms-slider-text">Вы преодолеете эти барьеры, присвоите свои таланты и научитесь
                                опираться на себя и свою ценность</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206995-CzHss-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Публичные выступления</p>
                            <p class="programms-slider-text">Вы прокачаете навыки самопрезентации, научитесь бороться с
                                волнением и убедительно доносить свои мысли </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206870-OTfik-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Жизнь после оффера</p>
                            <p class="programms-slider-text">Вы узнаете, как быстро освоиться на новой работе и найти
                                контакт с руководителем и коллегами. </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206754-7evbK-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Антикризис</p>
                            <p class="programms-slider-text">Вы узнаете, как оставаться ценным сотрудником даже во времена
                                сокращений</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206605-BqNcB-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьера без стресса</p>
                            <p class="programms-slider-text">Вы освоите методы предотвращения стресса и выгорания,
                                прокачаете эмоциональный интеллект и настроите свой work-life balance.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206462-v4YrG-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Секреты нетворкинга</p>
                            <p class="programms-slider-text">Вы научитесь развивать и укреплять сеть контактов, освоите
                                small talk и elevator pitch и узнаете, как сформировать личный бренд.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206300-G4EiF-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Удалёнка</p>
                            <p class="programms-slider-text">Вы разберетесь, как организовать свою удаленную работу и
                                использовать все плюсы формата себе во благо</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206162-axyQs-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Коммуникация на работе</p>
                            <p class="programms-slider-text">Вы усилите навыки экологичного общения, научитесь достигать
                                своих целей в переговорах и разрешать конфликты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206056-MnQUS-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Open Mindset</p>
                            <p class="programms-slider-text">Вы разовьете разные виды мышления и научитесь смотреть на
                                задачи, проекты и ситуации под новыми, порой непривычными, углами. </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205937-ZsoJe-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Эффективный руководитель</p>
                            <p class="programms-slider-text">Вы освоите важные навыки руководителя, изучите лайфхаки по
                                взаимодействию в кросс-функциональных командах и лучше начнете понимать своего босса.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205773-omnR0-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Новые горизонты</p>
                            <p class="programms-slider-text">Вы узнаете, как сменить сферу и что делать, если вы прямо
                                сейчас оказались в точке выбора нового профессионального пути.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205629-EdGB4-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьера и финансы</p>
                            <p class="programms-slider-text">Вы узнаете, как добиться финансовой независимости и научитесь
                                грамотно распоряжаться своими деньгами.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205499-YmnJD-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Зарубежное образование</p>
                            <p class="programms-slider-text">Вы узнаете основные особенности обучения за рубежом и детально
                                рассмотрите поступление на MBA</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205377-zl9WX-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Выход из декрета</p>
                            <p class="programms-slider-text">Вы сможете преодолеть страхи и трудности, свойственные при
                                выходе из декрета, и узнаете, как вернуться к работе в бережном, но не менее эффективном
                                режиме.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205223-dT5vR-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Мышление Boost</p>
                            <p class="programms-slider-text">Узнайте, как построить стратегию поиска работы, пройти все
                                этапы и получить оффер мечты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905204858-qg4Um-pic .svg"
                                alt="" class="position-absolute">
                        </div>
                    </div>
                    <div class="club40-support-slider-nav careerum-flex-fec">
                        <div class="club40-support-programms-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9432_18847)">
                                    <g filter="url(#filter0_b_9432_18847)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="black" />
                                    </g>
                                    <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_9432_18847" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_9432_18847" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18847"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_9432_18847">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="club40-support-programms-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9432_18851)">
                                    <g filter="url(#filter0_b_9432_18851)">
                                        <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="black" />
                                    </g>
                                    <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_9432_18851" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_9432_18851" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18851"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_9432_18851">
                                        <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <div class="club40-support-mats-slider-wrapper">
                        <p class="club40-support-mats-slider-header">Авторы курсов — ведущие карьерные эксперты и стратеги
                        </p>
                        <div class="club40-support-mats-slider-items">
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285436842-nmhub-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Ольга Лермонтова</p>
                                <p class="club40-support-mats-slider-item-position">фаундер Careerum</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Занимала руководящие должности в Google и Microsoft</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Управляла бизнесом на 20+ рынках Африки и Европы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>12 000+ клиентов из РФ, СНГ, Европы, Америки </p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Италия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437123-F7q7s-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Елена Резанова</p>
                                <p class="club40-support-mats-slider-item-position">карьерный стратег</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>9+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Монако </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437246-oRSRS-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Sophie Vurpillot</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Испания</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437367-I19r8-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Анна Бабич</p>
                                <p class="club40-support-mats-slider-item-position">психолог</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Россия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437505-QfSia-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Montse Lorente</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Перу</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437627-rUPvo-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Санжар Ибрагимов</p>
                                <p class="club40-support-mats-slider-item-position">ментор</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>MBA в швейцарской бизнес-школе IMD</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в IMD International и Aalto Business School</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Финляндия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437755-4zqkR-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Наталья Токарь</p>
                                <p class="club40-support-mats-slider-item-position">эксперт по коммуникации</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и
                                            руководителей</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в бизнес-акселераторе Чикаго</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>США</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-slider-nav careerum-flex-fec">
                        <div class="club40-support-mats-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9432_18847)">
                                    <g filter="url(#filter0_b_9432_18847)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="black" />
                                    </g>
                                    <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_9432_18847" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_9432_18847" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18847"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_9432_18847">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="club40-support-mats-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9432_18851)">
                                    <g filter="url(#filter0_b_9432_18851)">
                                        <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="black" />
                                    </g>
                                    <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_9432_18851" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_9432_18851" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18851"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_9432_18851">
                                        <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <div class="club40-support-button">
                        <a href="#buy" class="btn-color-main-dark-orange">
                            Выбрать тариф
                        </a>
                    </div>
                </div>
                <div class="club40-support-mats">
                    <div class="club40-support-mats-top careerum-flex-sbfs">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>02 Карьерные консультации</p>
                            </div>
                            <p class="club40-support-header">Команда карьерных коучей и экспертов с международной
                                сертификацией PCC ICF </p>
                        </div>
                        <div>
                            <div>
                                <p>3800+</p>
                                <p>часов проведенных сессий</p>
                                <p>9,5/10</p>
                                <p>средняя оценка карьерных экспертов</p>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-experts-slider">
                        <div class="club40-support-experts-slider-item-about">
                            <div>
                                <div>
                                    <p class="club40-support-experts-slider-item-text">Помогут достичь вашей цели: </p>
                                    <ul>
                                        <li class="position-relative">написать сильное резюме</li>
                                        <li class="position-relative">усилить профиль LinkedIn</li>
                                        <li class="position-relative">потренировать собеседование</li>
                                        <li class="position-relative">поставить карьерную цель</li>
                                        <li class="position-relative">усилить сопро-водительное</li>
                                        <li class="position-relative">подготовиться к переговорам по офферу</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280806527-AkUu1-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Добринская</p>
                            <p class="club40-support-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409766-cqwPu-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Софи Бессон</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409265-9vjpf-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Надежда Община</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>9+ лет в маркетинге и консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 550+ клиентам из США, Европы и СНГ найти работу и сменить карьеру</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Airbus, Hubspot, Google, Farfetch</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Португалия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410646-Tg23o-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410772-6unNS-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Оксана Сыпченко</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет в карьерном коучинге и гос.секторе</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 100+ клиентам найти карьерный вектор, стать увереннее в себе и получить
                                        повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками ERG, DevExpress, Роснефть</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Конго</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410266-0RLoj-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410383-HztZL-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410508-UN5w7-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409625-XnYoE-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Мария Пудалова</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе и США</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409884-sm2PF-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Астра Висаева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге, финансах и инвестициях</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2500+ клиентам определить карьерные вектора и найти работу в России, ЕС и США
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками OZON, EPAM, McKinsey, Nike</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410030-PrNQ2-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Марина Веденичева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410151-lWIq0-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Ирина Шутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч AFC</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ лет в коучинге и коммуникациях</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1000+ клиентам получить офферы с релокацией и повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками PepsiCo, Amazon, VK, Pfizer</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="club40-support-slider-nav careerum-flex-fec">
                        <div class="club40-support-experts-slider-nav-prev">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9432_18847)">
                                    <g filter="url(#filter0_b_9432_18847)">
                                        <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="black" />
                                    </g>
                                    <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_9432_18847" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_9432_18847" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18847"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_9432_18847">
                                        <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="club40-support-experts-slider-nav-next">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_9432_18851)">
                                    <g filter="url(#filter0_b_9432_18851)">
                                        <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="black" />
                                    </g>
                                    <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                        stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <filter id="filter0_b_9432_18851" x="-18.1166" y="-18.1166" width="76.2332"
                                        height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                        <feComposite in2="SourceAlpha" operator="in"
                                            result="effect1_backgroundBlur_9432_18851" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18851"
                                            result="shape" />
                                    </filter>
                                    <clipPath id="clip0_9432_18851">
                                        <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                            fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="club40-support-info careerum-flex-sbst">
                    <div class="club40-support-mers">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>03 Careerum.Club</p>
                        </div>
                        <p class="club40-support-header">Сообщество русскоговорящих профессионалов из 30+ стран</p>
                        <p class="club40-support-mers-text">C Careerum.Club вы сможете:</p>
                        <ul>
                            <li class="position-relative"> Собрать информацию из первых уст о компании, в которую хотите
                                попасть
                            </li>
                            <li class="position-relative">Найти рефералов и попросить рекомендовать вас в компанию на
                                выбранную позицию</li>
                            <li class="position-relative">Легче интегрироваться в новой стране и найти близких по духу людей
                            </li>
                            <li class="position-relative">Расширить нетворкинг — знакомства со специалистами разного уровня:
                                от junior до C-level. Найти партнеров и будущих сотрудников</li>
                        </ul>
                    </div>
                    <div class="club40-support-netw">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>04 Живые онлайн-встречи</p>
                        </div>
                        <p class="club40-support-header">Практикумы и Q&A-эфиры</p>
                        <p class="club40-support-content"><span>Q&A-эфиры</span> — вместе с карьерными экспертами и другими
                            участниками прорабатываем карьерные вопросы от резюме до поиска себя в профессии.</p>
                        <p class="club40-support-content"><span>Практикумы</span> — практический группой формат, где
                            в группе решаются карьерные кейсы.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733908074317-0OqMT-Fram.png"
                            alt="">
                    </div>
                </div>
            <div class="club40-support-about">
                <div class="club40-support-label careerum-flex-fsfs">
                    <p>03 Careerum.Club</p>
                </div>
                <p class="club40-support-header">Доступ к нетворк-сообществу русскоговорящих профессионалов из 30+ стран
                </p>
                <div class="careerum-flex-sbst">
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664719341-9oeGC-Edit.svg"
                            alt="">
                        <p>Соберете информацию из первых уст о компании, в которую хотите попасть</p>
                    </div>
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664719233-GNWR7-Prof.svg"
                            alt="">
                        <p>Найдете рефералов, чтобы получить рекомендации в компанию на выбранную позицию</p>
                    </div>
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664718978-8TCQz-Docu.svg"
                            alt="">
                        <p>Расширите нетворкинг со специалистами разного уровня: от junior до C-level</p>
                    </div>
                </div>
            </div>
            <div class="club40-support-banner">
                <div class="club40-support-label careerum-flex-fsfs">
                    <p>04 Интенсивы</p>
                </div>
                <p class="club40-support-header">Наш флагманский формат, который за короткое время поможет достичь
                    поставленной карьерной цели</p>
                <div class="club40-support-banner-item">
                    <div class="club40-support-banner-bg position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665441926-MVqRi-Vect.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665441820-YTSpe-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665441428-qYqGj-Grou.png"
                            alt="" class="position-absolute">
                    </div>
                    <div class="club40-support-banner-labels careerum-flex-fsfs">
                        <div class="careerum-flex-fsc img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                                alt="">
                            <p>Старт: 19 февраля</p>
                        </div>
                        <div>
                            <p>7 поток</p>
                        </div>
                    </div>
                    <p class="club40-support-banner-subheader">Набор на интенсив:</p>
                    <p class="club40-support-banner-header">Звездный кандидат</p>
                    <ul>
                        <li>
                            Составите продающее резюме
                        </li>
                        <li>
                            Усилите профиль LinkedIn
                        </li>
                        <li>
                            Определите стратегию вашего поиска
                        </li>
                        <li>
                            Научитесь откликаться на вакансии и проходить<br> интервью
                        </li>
                        <li>
                            Освоите переговоры по офферу на ваших условиях
                        </li>
                    </ul>
                    <a href="" class="btn-color-main-black">Узнать подробнее</a>
                </div>
                <div class="club40-support-banner-item2">
                    <div class="careerum-flex-fsfs">
                        <div class="club40-support-banner-item2-label-orange careerum-flex-cc">
                            <p>В подписке Careerum</p>
                        </div>
                        <div class="club40-support-banner-item2-label careerum-flex-cc">
                            <svg width="25" height="26" viewBox="0 0 25 26" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20.4828 4.7431L5.48276 4.75692C5.06854 4.7573 4.73307 5.0934 4.73345 5.50761L4.74727 20.5076C4.74765 20.9218 5.08375 21.2573 5.49796 21.2569L20.498 21.2431C20.9122 21.2427 21.2476 20.9066 21.2473 20.4924L21.2334 5.49241C21.2331 5.0782 20.897 4.74272 20.4828 4.7431Z"
                                    stroke="#FF6A01" stroke-width="1.7825" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M17.4814 3.24586L17.4841 6.24586" stroke="#FF6A01" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.48138 3.25415L8.48415 6.25415" stroke="#FF6A01" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.73691 9.25761L21.2369 9.2424" stroke="#FF6A01" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.3654 12.9969L11.991 17.1259L9.61708 14.8781" stroke="#FF6A01"
                                    stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                            <p>Старт: 26 марта </p>
                        </div>
                        <div class="club40-support-banner-item2-label careerum-flex-cc">
                            <p>3 месяца</p>
                        </div>
                    </div>
                    <p class="club40-support-banner-item2-header">Power Talk</p>
                    <p class="club40-support-banner-item2-text">Курс по сильным коммуникациям<br>для прорыва <span>в карьере</span></p>
                    <a href="https://careerum.com/ru-ru/club/intensive/power-talk-2025" class="btn-color-main-black">Посмотреть программу</a>
                    <div class="position-relative">
                        <div>
                            <div class="position-absolute">реализация амбиций</div>
                            <div class="position-absolute">междyнародная карьера</div>
                            <div class="position-absolute">повышение</div>
                            <div class="position-absolute">лидерские позиции</div>
                            <div class="position-absolute">крутые проекты</div>
                            <div class="position-absolute">кайф от работы</div>
                            <div class="position-absolute">признание экспертизы</div>
                            <div class="position-absolute">рост дохода</div>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741685782103-CmFT1-Grou.png" alt="" class="position-absolute">
                    </div>
                </div>
                <div class="club40-support-banner-item3 position-relative">
                    <div class="careerum-flex-fsfs">
                        <div class="club40-support-banner-item3-label careerum-flex-cc">
                            <svg width="25" height="26" viewBox="0 0 25 26" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5035 4.74309L4.50346 4.75691C4.08925 4.75729 3.75377 5.09339 3.75415 5.5076L3.76797 20.5076C3.76836 20.9218 4.10445 21.2573 4.51867 21.2569L19.5187 21.2431C19.9329 21.2427 20.2684 20.9066 20.268 20.4924L20.2541 5.4924C20.2538 5.07818 19.9177 4.74271 19.5035 4.74309Z"
                                    stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M16.5021 3.24585L16.5048 6.24585" stroke="#0B70FE" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.50207 3.25415L7.50484 6.25415" stroke="#0B70FE" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M3.75761 9.2576L20.2576 9.2424" stroke="#0B70FE" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M15.3861 12.9969L11.0117 17.1259L8.63779 14.8781" stroke="#0B70FE"
                                    stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>26–27 апреля</p>
                        </div>
                        <div class="club40-support-banner-item3-label careerum-flex-cc">
                            <p>Практикум </p>
                        </div>
                    </div>
                    <p class="club40-support-banner-item3-header">Резюме<br> за выходные </p>
                    <p class="club40-support-banner-item3-text">Хватит терять вакансии и время!<br>Создайте резюме,
                        которое продаст вас</p>
                    <p class="club40-support-banner-item3-text-label position-absolute">с экспертом</p>
                    <a href="https://careerum.com/ru-ru/promo/weekend-resume?utm_source=web&utm_medium=ru-ru-club&utm_campaign=cv-weekend&utm_content=banner&utm_term=main"
                        class="btn-color-main-dark-orange">Посмотреть программу</a>
                </div>
            </div>
                <div class="club40-support-bottom-button">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('club40-support2-tablet', {
        label: 'Club 4 support2 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-support-tablet club40-support2-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Careerum — это обучение карьерным навыкам, поддержка экспертов,
                    профессиональный нетворкинг</h2>
                <div class="club40-support-experts">
                    <div class="club40-support-experts-top">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>1. Образовательная платформа</p>
                        </div>
                        <p class="club40-support-header">80 курсов под любую карьерную задачу</p>
                    </div>
                    <div class="club40-support-programms-slider-items">
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Звёздный кандидат</p>
                            <p class="programms-slider-text">Эта программа — must see для всех, кто хоть раз искал работу.
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195877-jxP4N-pic..svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923137096-UO7U4-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Real Me: как найти себя </p>
                            <p class="programms-slider-text">Вы сможете лучше узнать себя настоящего и понять, чего вы
                                хотите для своей карьеры</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195760-k2i68-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136980-Rz3Af-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Международная карьера и релокация</p>
                            <p class="programms-slider-text">Вы узнаете всё о поиске работы в новых для вас странах, освоите
                                LinkedIn и научитесь учитывать культурный контекст</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195611-i209G-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136856-YVoxz-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьерная ракета</p>
                            <p class="programms-slider-text">Вы освоите базу карьерного мышления, узнаете, как расти в
                                зарплате и роли и научитесь планировать и добиваться даже самых амбициозных целей.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195276-Tuk6J-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136724-Jcd5H-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Работать не 24/7</p>
                            <p class="programms-slider-text">Вы повысите свою продуктивность и научитесь получать результаты
                                в проектах</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905207114-JpoWG-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136609-SntZn-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Самооценка и Деньги: не мешайте себе зарабатывать</p>
                            <p class="programms-slider-text">Вы преодолеете эти барьеры, присвоите свои таланты и научитесь
                                опираться на себя и свою ценность</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206995-CzHss-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136496-iK3of-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Публичные выступления</p>
                            <p class="programms-slider-text">Вы прокачаете навыки самопрезентации, научитесь бороться с
                                волнением и убедительно доносить свои мысли </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206870-OTfik-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136368-XNklq-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Жизнь после оффера</p>
                            <p class="programms-slider-text">Вы узнаете, как быстро освоиться на новой работе и найти
                                контакт с руководителем и коллегами. </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206754-7evbK-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136250-vxoGi-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Антикризис</p>
                            <p class="programms-slider-text">Вы узнаете, как оставаться ценным сотрудником даже во времена
                                сокращений</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206605-BqNcB-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136137-toVB5-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьера без стресса</p>
                            <p class="programms-slider-text">Вы освоите методы предотвращения стресса и выгорания,
                                прокачаете эмоциональный интеллект и настроите свой work-life balance.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206462-v4YrG-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136026-DlGgK-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Секреты нетворкинга</p>
                            <p class="programms-slider-text">Вы научитесь развивать и укреплять сеть контактов, освоите
                                small talk и elevator pitch и узнаете, как сформировать личный бренд.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206300-G4EiF-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135902-YaSxb-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Удалёнка</p>
                            <p class="programms-slider-text">Вы разберетесь, как организовать свою удаленную работу и
                                использовать все плюсы формата себе во благо</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206162-axyQs-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135782-HSOgY-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Коммуникация на работе</p>
                            <p class="programms-slider-text">Вы усилите навыки экологичного общения, научитесь достигать
                                своих целей в переговорах и разрешать конфликты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206056-MnQUS-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135662-WTxmr-Fram.svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Open Mindset</p>
                            <p class="programms-slider-text">Вы разовьете разные виды мышления и научитесь смотреть на
                                задачи, проекты и ситуации под новыми, порой непривычными, углами. </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205937-ZsoJe-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135534-kXWnQ-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Эффективный руководитель</p>
                            <p class="programms-slider-text">Вы освоите важные навыки руководителя, изучите лайфхаки по
                                взаимодействию в кросс-функциональных командах и лучше начнете понимать своего босса.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205773-omnR0-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135408-W8WQc-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Новые горизонты</p>
                            <p class="programms-slider-text">Вы узнаете, как сменить сферу и что делать, если вы прямо
                                сейчас оказались в точке выбора нового профессионального пути.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205629-EdGB4-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135278-gzlKn-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьера и финансы</p>
                            <p class="programms-slider-text">Вы узнаете, как добиться финансовой независимости и научитесь
                                грамотно распоряжаться своими деньгами.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205499-YmnJD-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135142-zfMz9-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Зарубежное образование</p>
                            <p class="programms-slider-text">Вы узнаете основные особенности обучения за рубежом и детально
                                рассмотрите поступление на MBA</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205377-zl9WX-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135022-KqJcY-Ð¸Ð».svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Выход из декрета</p>
                            <p class="programms-slider-text">Вы сможете преодолеть страхи и трудности, свойственные при
                                выходе из декрета, и узнаете, как вернуться к работе в бережном, но не менее эффективном
                                режиме.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205223-dT5vR-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923134903-TM6LM-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Мышление Boost</p>
                            <p class="programms-slider-text">Узнайте, как построить стратегию поиска работы, пройти все
                                этапы и получить оффер мечты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905204858-qg4Um-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923134529-X2YUs-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                    </div>
                    <div class="club40-support-mats-slider-wrapper">
                        <p class="club40-support-mats-slider-header">Авторы курсов — ведущие карьерные эксперты и стратеги
                        </p>
                        <div class="club40-support-mats-slider-items">
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285436842-nmhub-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Ольга Лермонтова</p>
                                <p class="club40-support-mats-slider-item-position">фаундер Careerum</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Занимала руководящие должности в Google и Microsoft</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Управляла бизнесом на 20+ рынках Африки и Европы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>12 000+ клиентов из РФ, СНГ, Европы, Америки </p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Италия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437123-F7q7s-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Елена Резанова</p>
                                <p class="club40-support-mats-slider-item-position">карьерный стратег</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>9+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Монако </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437246-oRSRS-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Sophie Vurpillot</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Испания</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437367-I19r8-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Анна Бабич</p>
                                <p class="club40-support-mats-slider-item-position">психолог</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Россия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437505-QfSia-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Montse Lorente</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Перу</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437627-rUPvo-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Санжар Ибрагимов</p>
                                <p class="club40-support-mats-slider-item-position">ментор</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>MBA в швейцарской бизнес-школе IMD</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в IMD International и Aalto Business School</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Финляндия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437755-4zqkR-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Наталья Токарь</p>
                                <p class="club40-support-mats-slider-item-position">эксперт по коммуникации</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и
                                            руководителей</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в бизнес-акселераторе Чикаго</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>США</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-support-mats">
                    <div class="club40-support-mats-top careerum-flex-sbfs">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>2. Карьерные консультации</p>
                            </div>
                            <p class="club40-support-header">Команда карьерных коучей и экспертов с международной
                                сертификацией PCC ICF </p>
                            <div class="careerum-flex-fsc">
                                <p>3800+</p>
                                <p>часов проведенных сессий</p>
                            </div>
                            <div class="careerum-flex-fsc">
                                <p>9,5/10</p>
                                <p>средняя оценка карьерных<br> экспертов</p>
                            </div>
                        </div>
                        <div>
                            <div>
                                <p>Помогут достичь вашей цели: </p>
                                <ul>
                                    <li class="position-relative">написать сильное резюме</li>
                                    <li class="position-relative">усилить профиль LinkedIn</li>
                                    <li class="position-relative">потренировать собеседование</li>
                                    <li class="position-relative">поставить карьерную цель</li>
                                    <li class="position-relative">усилить сопроводительное</li>
                                    <li class="position-relative">подготовиться к переговорам по офферу</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-experts-slider">
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280806527-AkUu1-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Добринская</p>
                            <p class="club40-support-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409766-cqwPu-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Софи Бессон</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409265-9vjpf-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Надежда Община</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>9+ лет в маркетинге и консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 550+ клиентам из США, Европы и СНГ найти работу и сменить карьеру</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Airbus, Hubspot, Google, Farfetch</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Португалия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410646-Tg23o-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410772-6unNS-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Оксана Сыпченко</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет в карьерном коучинге и гос.секторе</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 100+ клиентам найти карьерный вектор, стать увереннее в себе и получить
                                        повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками ERG, DevExpress, Роснефть</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Конго</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410266-0RLoj-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410383-HztZL-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410508-UN5w7-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409625-XnYoE-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Мария Пудалова</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе и США</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409884-sm2PF-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Астра Висаева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге, финансах и инвестициях</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2500+ клиентам определить карьерные вектора и найти работу в России, ЕС и США
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками OZON, EPAM, McKinsey, Nike</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410030-PrNQ2-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Марина Веденичева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410151-lWIq0-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Ирина Шутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч AFC</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ лет в коучинге и коммуникациях</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1000+ клиентам получить офферы с релокацией и повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками PepsiCo, Amazon, VK, Pfizer</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="club40-support-info careerum-flex-sbst">
                    <div class="club40-support-mers">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>3. Careerum.Club</p>
                        </div>
                        <p class="club40-support-header">Сообщество русскоговорящих профессионалов из 30+ стран</p>
                        <p class="club40-support-mers-text">C Careerum.Club вы сможете:</p>
                        <ul>
                            <li class="position-relative">Собрать информацию из первых уст<br> о компании, в которую хотите
                                попасть
                            </li>
                            <li class="position-relative">Найти рефералов и попросить рекомендовать вас в компанию<br> на
                                выбранную позицию</li>
                            <li class="position-relative">Легче интегрироваться в новой стране и найти близких по духу людей
                            </li>
                            <li class="position-relative">Расширить нетворкинг — знакомства со специалистами разного уровня:
                                от junior до C-level. Найти партнеров и будущих сотрудников</li>
                        </ul>
                    </div>
                    <div class="club40-support-netw">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>4. Живые онлайн-встречи</p>
                        </div>
                        <p class="club40-support-header">Практикумы и Q&A-эфиры</p>
                        <p class="club40-support-content"><span>Q&A-эфиры</span> — вместе с карьерными экспертами и другими
                            участниками прорабатываем карьерные вопросы от резюме до поиска себя в профессии.</p>
                        <p class="club40-support-content"><span>Практикумы</span> — практический группой формат, где
                            в группе решаются карьерные кейсы.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733925224291-duvri-Fram.png"
                            alt="">
                    </div>
                </div>
            <div class="club40-support-about">
                <div class="club40-support-label careerum-flex-fsfs">
                    <p>03 Careerum.Club</p>
                </div>
                <p class="club40-support-header">Доступ к нетворк-сообществу русскоговорящих профессионалов из 30+ стран
                </p>
                <div class="careerum-flex-sbst">
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664719341-9oeGC-Edit.svg"
                            alt="">
                        <p>Соберете информацию из первых уст о компании, в которую хотите попасть</p>
                    </div>
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664719233-GNWR7-Prof.svg"
                            alt="">
                        <p>Найдете рефералов, чтобы получить рекомендации в компанию на выбранную позицию</p>
                    </div>
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664718978-8TCQz-Docu.svg"
                            alt="">
                        <p>Расширите нетворкинг со специалистами разного уровня: от junior до C-level</p>
                    </div>
                </div>
            </div>
            <div class="club40-support-banner">
                <div class="club40-support-label careerum-flex-fsfs">
                    <p>04 Интенсивы</p>
                </div>
                <p class="club40-support-header">Наш флагманский формат, который за короткое время поможет достичь
                    поставленной карьерной цели</p>
                <div class="club40-support-banner-item">
                    <div class="club40-support-banner-bg position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737669158458-wxXKC-Vect.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737669158335-5Eip2-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737669157964-7CvXw-Grou.png"
                            alt="" class="position-absolute">
                    </div>
                    <div class="club40-support-banner-labels careerum-flex-fsfs">
                        <div class="careerum-flex-fsc img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                                alt="">
                            <p>Старт: 19 февраля</p>
                        </div>
                        <div>
                            <p>7 поток</p>
                        </div>
                    </div>
                    <p class="club40-support-banner-subheader">Набор на интенсив:</p>
                    <p class="club40-support-banner-header">Звездный кандидат</p>
                    <ul>
                        <li>
                            Составите продающее резюме
                        </li>
                        <li>
                            Усилите профиль LinkedIn
                        </li>
                        <li>
                            Определите стратегию вашего поиска
                        </li>
                        <li>
                            Научитесь откликаться на вакансии и<br> проходить интервью
                        </li>
                        <li>
                            Освоите переговоры по офферу на<br> ваших условиях
                        </li>
                    </ul>
                    <a href="" class="btn-color-main-black">Узнать подробнее</a>
                </div>
                <div class="club40-support-banner-item2">
                    <div class="careerum-flex-fsfs">
                        <div class="club40-support-banner-item2-label-orange careerum-flex-cc">
                            <p>В подписке Careerum</p>
                        </div>
                        <div class="club40-support-banner-item2-label careerum-flex-cc">
                            <svg width="25" height="26" viewBox="0 0 25 26" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20.4828 4.7431L5.48276 4.75692C5.06854 4.7573 4.73307 5.0934 4.73345 5.50761L4.74727 20.5076C4.74765 20.9218 5.08375 21.2573 5.49796 21.2569L20.498 21.2431C20.9122 21.2427 21.2476 20.9066 21.2473 20.4924L21.2334 5.49241C21.2331 5.0782 20.897 4.74272 20.4828 4.7431Z"
                                    stroke="#FF6A01" stroke-width="1.7825" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M17.4814 3.24586L17.4841 6.24586" stroke="#FF6A01" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.48138 3.25415L8.48415 6.25415" stroke="#FF6A01" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.73691 9.25761L21.2369 9.2424" stroke="#FF6A01" stroke-width="1.7825"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.3654 12.9969L11.991 17.1259L9.61708 14.8781" stroke="#FF6A01"
                                    stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                            <p>Старт: 26 марта </p>
                        </div>
                        <div class="club40-support-banner-item2-label careerum-flex-cc">
                            <p>3 месяца</p>
                        </div>
                    </div>
                    <p class="club40-support-banner-item2-header">Power Talk</p>
                    <p class="club40-support-banner-item2-text">Курс по сильным коммуникациям для прорыва<br> <span>в
                            карьере</span></p>
                    <a href="https://careerum.com/ru-ru/club/intensive/power-talk-2025"
                        class="btn-color-main-black">Посмотреть программу</a>
                    <div class="position-relative">
                        <div>
                            <div class="position-absolute">реализация амбиций</div>
                            <div class="position-absolute">междyнародная карьера</div>
                            <div class="position-absolute">повышение</div>
                            <div class="position-absolute">лидерские позиции</div>
                            <div class="position-absolute">крутые проекты</div>
                            <div class="position-absolute">кайф от работы</div>
                            <div class="position-absolute">признание экспертизы</div>
                            <div class="position-absolute">рост дохода</div>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741686784070-bzFOY-Grou.png"
                            alt="" class="position-absolute">
                    </div>
                </div>
                <div class="club40-support-banner-item3 position-relative">
                    <div class="careerum-flex-fsfs">
                        <div class="club40-support-banner-item3-label careerum-flex-cc">
                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.4845 4.24309L5.4845 4.25691C5.07028 4.25729 4.73481 4.59339 4.73519 5.0076L4.74901 20.0076C4.74939 20.4218 5.08548 20.7573 5.4997 20.7569L20.4997 20.7431C20.9139 20.7427 21.2494 20.4066 21.249 19.9924L21.2352 4.9924C21.2348 4.57818 20.8987 4.24271 20.4845 4.24309Z" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M17.4832 2.74586L17.4859 5.74586" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.48315 2.75415L8.48592 5.75415" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.73865 8.7576L21.2386 8.7424" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.3672 12.4969L11.9929 16.6259L9.61891 14.3781" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>26–27 апреля</p>
                        </div>
                        <div class="club40-support-banner-item3-label careerum-flex-cc">
                            <p>Практикум </p>
                        </div>
                    </div>
                    <p class="club40-support-banner-item3-header">Резюме<br> за выходные </p>
                    <p class="club40-support-banner-item3-text">Хватит терять вакансии и время!<br>Создайте резюме,
                        которое продаст вас</p>
                    <p class="club40-support-banner-item3-text-label position-absolute">с экспертом</p>
                    <a href="https://careerum.com/ru-ru/promo/weekend-resume?utm_source=web&utm_medium=ru-ru-club&utm_campaign=cv-weekend&utm_content=banner&utm_term=main"
                        class="btn-color-main-dark-orange">Посмотреть программу</a>
                </div>
            </div>
                <div class="club40-support-bottom-button">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('club40-support2-mobile', {
        label: 'Club 4 support2 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-support-mobile club40-support2-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Careerum — это обучение карьерным навыкам, поддержка экспертов,
                    профессиональный нетворкинг</h2>
                <div class="club40-support-experts">
                    <div class="club40-support-experts-top">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>01 Образовательная платформа</p>
                        </div>
                        <p class="club40-support-header">80 курсов под любую карьерную задачу</p>
                    </div>
                    <div class="club40-support-programms-slider-items">
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Звёздный кандидат</p>
                            <p class="programms-slider-text">Эта программа — must see для всех, кто хоть раз искал работу.
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195877-jxP4N-pic..svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923137096-UO7U4-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Real Me: как найти себя </p>
                            <p class="programms-slider-text">Вы сможете лучше узнать себя настоящего и понять, чего вы
                                хотите для своей карьеры</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195760-k2i68-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136980-Rz3Af-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Международная карьера и релокация</p>
                            <p class="programms-slider-text">Вы узнаете всё о поиске работы в новых для вас странах, освоите
                                LinkedIn и научитесь учитывать культурный контекст</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195611-i209G-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136856-YVoxz-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьерная ракета</p>
                            <p class="programms-slider-text">Вы освоите базу карьерного мышления, узнаете, как расти в
                                зарплате и роли и научитесь планировать и добиваться даже самых амбициозных целей.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195276-Tuk6J-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136724-Jcd5H-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Работать не 24/7</p>
                            <p class="programms-slider-text">Вы повысите свою продуктивность и научитесь получать результаты
                                в проектах</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905207114-JpoWG-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136609-SntZn-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Самооценка и Деньги: не мешайте себе зарабатывать</p>
                            <p class="programms-slider-text">Вы преодолеете эти барьеры, присвоите свои таланты и научитесь
                                опираться на себя и свою ценность</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206995-CzHss-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136496-iK3of-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Публичные выступления</p>
                            <p class="programms-slider-text">Вы прокачаете навыки самопрезентации, научитесь бороться с
                                волнением и убедительно доносить свои мысли </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206870-OTfik-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136368-XNklq-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Жизнь после оффера</p>
                            <p class="programms-slider-text">Вы узнаете, как быстро освоиться на новой работе и найти
                                контакт с руководителем и коллегами. </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206754-7evbK-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136250-vxoGi-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Антикризис</p>
                            <p class="programms-slider-text">Вы узнаете, как оставаться ценным сотрудником даже во времена
                                сокращений</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206605-BqNcB-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136137-toVB5-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьера без стресса</p>
                            <p class="programms-slider-text">Вы освоите методы предотвращения стресса и выгорания,
                                прокачаете эмоциональный интеллект и настроите свой work-life balance.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206462-v4YrG-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136026-DlGgK-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Секреты нетворкинга</p>
                            <p class="programms-slider-text">Вы научитесь развивать и укреплять сеть контактов, освоите
                                small talk и elevator pitch и узнаете, как сформировать личный бренд.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206300-G4EiF-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135902-YaSxb-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Удалёнка</p>
                            <p class="programms-slider-text">Вы разберетесь, как организовать свою удаленную работу и
                                использовать все плюсы формата себе во благо</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206162-axyQs-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135782-HSOgY-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Коммуникация на работе</p>
                            <p class="programms-slider-text">Вы усилите навыки экологичного общения, научитесь достигать
                                своих целей в переговорах и разрешать конфликты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206056-MnQUS-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135662-WTxmr-Fram.svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Open Mindset</p>
                            <p class="programms-slider-text">Вы разовьете разные виды мышления и научитесь смотреть на
                                задачи, проекты и ситуации под новыми, порой непривычными, углами. </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205937-ZsoJe-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135534-kXWnQ-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Эффективный руководитель</p>
                            <p class="programms-slider-text">Вы освоите важные навыки руководителя, изучите лайфхаки по
                                взаимодействию в кросс-функциональных командах и лучше начнете понимать своего босса.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205773-omnR0-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135408-W8WQc-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Новые горизонты</p>
                            <p class="programms-slider-text">Вы узнаете, как сменить сферу и что делать, если вы прямо
                                сейчас оказались в точке выбора нового профессионального пути.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205629-EdGB4-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135278-gzlKn-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Карьера и финансы</p>
                            <p class="programms-slider-text">Вы узнаете, как добиться финансовой независимости и научитесь
                                грамотно распоряжаться своими деньгами.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205499-YmnJD-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135142-zfMz9-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Зарубежное образование</p>
                            <p class="programms-slider-text">Вы узнаете основные особенности обучения за рубежом и детально
                                рассмотрите поступление на MBA</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205377-zl9WX-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135022-KqJcY-Ð¸Ð».svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Выход из декрета</p>
                            <p class="programms-slider-text">Вы сможете преодолеть страхи и трудности, свойственные при
                                выходе из декрета, и узнаете, как вернуться к работе в бережном, но не менее эффективном
                                режиме.</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205223-dT5vR-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923134903-TM6LM-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="club40-support-programms-slider-item position-relative">
                            <p class="programms-slider-header">Мышление Boost</p>
                            <p class="programms-slider-text">Узнайте, как построить стратегию поиска работы, пройти все
                                этапы и получить оффер мечты</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905204858-qg4Um-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923134529-X2YUs-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                    </div>
                    <div class="club40-support-mats-slider-wrapper">
                        <p class="club40-support-mats-slider-header">Авторы курсов — ведущие карьерные эксперты и стратеги
                        </p>
                        <div class="club40-support-mats-slider-items">
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285436842-nmhub-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Ольга Лермонтова</p>
                                <p class="club40-support-mats-slider-item-position">фаундер Careerum</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Занимала руководящие должности в Google и Microsoft</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Управляла бизнесом на 20+ рынках Африки и Европы</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>12 000+ клиентов из РФ, СНГ, Европы, Америки </p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Италия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437123-F7q7s-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Елена Резанова</p>
                                <p class="club40-support-mats-slider-item-position">карьерный стратег</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>9+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогает посмотреть на карьеру целостно и соотнести ее с целями бизнеса.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книг-бестселлеров «Никогда-нибудь» и «Это норм!»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Монако </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437246-oRSRS-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Sophie Vurpillot</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Испания</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437367-I19r8-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Анна Бабич</p>
                                <p class="club40-support-mats-slider-item-position">психолог</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Терапевт в сфере АСТ и эмоционально-фокусированной терапии</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Автор книги-бестселлера «Внутренняя опора»</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Спикер конференций: Psychologies, TeamLead, CodeFest</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Россия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437505-QfSia-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Montse Lorente</p>
                                <p class="club40-support-mats-slider-item-position">рекрутер и коуч</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>10+ лет опыта</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Помогла специалистам из 20+ стран раскрыть потенциал</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Сотрудничала с университетами Европы, США и Латинской Америки.</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Перу</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437627-rUPvo-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Санжар Ибрагимов</p>
                                <p class="club40-support-mats-slider-item-position">ментор</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Опыт в консалтинге в McKinsey & Company, PwC, World Bank Group</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>MBA в швейцарской бизнес-школе IMD</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в IMD International и Aalto Business School</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>Финляндия</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="club40-support-mats-slider-item">
                                <div> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285437755-4zqkR-phot.png"
                                        alt=""> </div>
                                <p class="club40-support-mats-slider-item-name">Наталья Токарь</p>
                                <p class="club40-support-mats-slider-item-position">эксперт по коммуникации</p>
                                <ul>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>CEO проекта по обучению команд маркетинга, продаж, проджект-менеджеров и
                                            руководителей</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                            alt="">
                                        <p>Ментор в бизнес-акселераторе Чикаго</p>
                                    </li>
                                    <li class="careerum-flex-fsfs"> <img
                                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285306187-xC960-Loca.svg"
                                            alt="">
                                        <p>США</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-button">
                        <a href="#buy" class="btn-color-main-dark-orange">
                            Выбрать тариф
                        </a>
                    </div>
                </div>
                <div class="club40-support-mats">
                    <div class="club40-support-mats-top careerum-flex-sbfs">
                        <div>
                            <div class="club40-support-label careerum-flex-fsfs">
                                <p>02 Карьерные консультации</p>
                            </div>
                            <p class="club40-support-header">Команда карьерных коучей и экспертов с международной
                                сертификацией PCC ICF </p>
                            <div class="careerum-flex-fsc">
                                <p>3800+</p>
                                <p>часов проведенных сессий</p>
                            </div>
                            <div class="careerum-flex-fsc">
                                <p>9,5/10</p>
                                <p>средняя оценка карьерных<br> экспертов</p>
                            </div>
                        </div>
                        <div>
                            <div>
                                <p>Помогут достичь вашей цели: </p>
                                <ul>
                                    <li class="position-relative">написать сильное резюме</li>
                                    <li class="position-relative">усилить профиль LinkedIn</li>
                                    <li class="position-relative">потренировать собеседование</li>
                                    <li class="position-relative">поставить карьерную цель</li>
                                    <li class="position-relative">усилить сопроводительное</li>
                                    <li class="position-relative">подготовиться к переговорам по офферу</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club40-support-experts-slider">
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280806527-AkUu1-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Добринская</p>
                            <p class="club40-support-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409766-cqwPu-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Софи Бессон</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409265-9vjpf-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Надежда Община</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>9+ лет в маркетинге и консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 550+ клиентам из США, Европы и СНГ найти работу и сменить карьеру</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Airbus, Hubspot, Google, Farfetch</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Португалия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410646-Tg23o-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410772-6unNS-ÑÐ¼.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Оксана Сыпченко</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет в карьерном коучинге и гос.секторе</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 100+ клиентам найти карьерный вектор, стать увереннее в себе и получить
                                        повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками ERG, DevExpress, Роснефть</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Конго</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410266-0RLoj-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410383-HztZL-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410508-UN5w7-ÐµÐ».png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409625-XnYoE-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Мария Пудалова</p>
                            <p class="club40-support-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе и США</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282409884-sm2PF-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Астра Висаева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге, финансах и инвестициях</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2500+ клиентам определить карьерные вектора и найти работу в России, ЕС и США
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками OZON, EPAM, McKinsey, Nike</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410030-PrNQ2-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Марина Веденичева</p>
                            <p class="club40-support-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="club40-support-experts-slider-item">
                            <div> <img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723282410151-lWIq0-phot.png"
                                    alt="">
                            </div>
                            <p class="club40-support-experts-slider-item-name">Ирина Шутова</p>
                            <p class="club40-support-experts-slider-item-position">Коуч AFC</p>
                            <ul>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941303-GJlu3-Shie.svg"
                                        alt="">
                                    <p>6+ лет в коучинге и коммуникациях</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280940975-gG8Ko-2 Us.svg"
                                        alt="">
                                    <p>Помогла 1000+ клиентам получить офферы с релокацией и повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941429-1DT3V-Work.svg"
                                        alt="">
                                    <p>Работала с сотрудниками PepsiCo, Amazon, VK, Pfizer</p>
                                </li>
                                <li class="careerum-flex-fsfs"> <img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723280941195-eXQNM-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="club40-support-info careerum-flex-sbst">
                    <div class="club40-support-mers">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>3. Careerum.Club</p>
                        </div>
                        <p class="club40-support-header">Сообщество русскоговорящих профессионалов из 30+ стран</p>
                        <p class="club40-support-mers-text">C Careerum.Club вы сможете:</p>
                        <ul>
                            <li class="position-relative">Собрать информацию из первых уст<br> о компании, в которую хотите
                                попасть
                            </li>
                            <li class="position-relative">Найти рефералов и попросить рекомендовать вас в компанию<br> на
                                выбранную позицию</li>
                            <li class="position-relative">Легче интегрироваться в новой стране и найти близких по духу людей
                            </li>
                            <li class="position-relative">Расширить нетворкинг — знакомства со специалистами разного уровня:
                                от junior до C-level. Найти партнеров и будущих сотрудников</li>
                        </ul>
                    </div>
                    <div class="club40-support-netw">
                        <div class="club40-support-label careerum-flex-fsfs">
                            <p>4. Живые онлайн-встречи</p>
                        </div>
                        <p class="club40-support-header">Практикумы и Q&A-эфиры</p>
                        <p class="club40-support-content"><span>Q&A-эфиры</span> — вместе с карьерными экспертами и другими
                            участниками прорабатываем карьерные вопросы от резюме до поиска себя в профессии.</p>
                        <p class="club40-support-content"><span>Практикумы</span> — практический группой формат, где
                            в группе решаются карьерные кейсы.</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733925224291-duvri-Fram.png"
                            alt="">
                    </div>
                </div>
            <div class="club40-support-about">
                <div class="club40-support-label careerum-flex-fsfs">
                    <p>03 Careerum.Club</p>
                </div>
                <p class="club40-support-header">Доступ к нетворк-сообществу русскоговорящих профессионалов из 30+ стран
                </p>
                <div class="careerum-flex-sbst">
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664719341-9oeGC-Edit.svg"
                            alt="">
                        <p>Соберете информацию из первых уст о компании, в которую хотите попасть</p>
                    </div>
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664719233-GNWR7-Prof.svg"
                            alt="">
                        <p>Найдете рефералов, чтобы получить рекомендации в компанию на выбранную позицию</p>
                    </div>
                    <div class="club40-support-about-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737664718978-8TCQz-Docu.svg"
                            alt="">
                        <p>Расширите нетворкинг со специалистами разного уровня: от junior до C-level</p>
                    </div>
                </div>
            </div>
            <div class="club40-support-banner">
                <div class="club40-support-label careerum-flex-fsfs">
                    <p>04 Интенсивы</p>
                </div>
                <p class="club40-support-header">Наш флагманский формат, который за короткое время поможет достичь
                    поставленной карьерной цели</p>
                <div class="club40-support-banner-item">
                    <div class="club40-support-banner-bg position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737669158458-wxXKC-Vect.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737669158335-5Eip2-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737701847250-tYsQq-Grou.png"
                            alt="" class="position-absolute">
                    </div>
                    <div class="club40-support-banner-labels careerum-flex-fsfs">
                        <div class="careerum-flex-cc img">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                                alt="">
                            <p>Старт: 19 февраля</p>
                        </div>
                        <div>
                            <p>7 поток</p>
                        </div>
                    </div>
                    <p class="club40-support-banner-subheader">Набор на интенсив:</p>
                    <p class="club40-support-banner-header">Звездный кандидат</p>
                    <ul>
                        <li>
                            Составите продающее резюме
                        </li>
                        <li>
                            Усилите профиль LinkedIn
                        </li>
                        <li>
                            Определите стратегию вашего поиска
                        </li>
                        <li>
                            Научитесь откликаться на вакансии и<br> проходить интервью
                        </li>
                        <li>
                            Освоите переговоры по офферу на<br> ваших условиях
                        </li>
                    </ul>
                    <a href="" class="btn-color-main-black">Узнать подробнее</a>
                </div>
                <div class="club40-support-banner-item2">
                    <div class="careerum-flex-fsfs">
                        <div class="club40-support-banner-item2-label-orange careerum-flex-cc">
                            <p>В подписке Careerum</p>
                        </div>
                        <div class="club40-support-banner-item2-label careerum-flex-cc">
                            <p>Старт: 26 марта </p>
                        </div>
                        <div class="club40-support-banner-item2-label careerum-flex-cc">
                            <p>3 месяца</p>
                        </div>
                    </div>
                    <p class="club40-support-banner-item2-header">Power Talk</p>
                    <p class="club40-support-banner-item2-text">Курс по сильным коммуникациям для прорыва <span>в
                            карьере</span></p>
                    <div class="position-relative club40-support-banner-imgs">
                        <div>
                            <div class="position-absolute">реализация амбиций</div>
                            <div class="position-absolute">междyнародная карьера</div>
                            <div class="position-absolute">повышение</div>
                            <div class="position-absolute">лидерские позиции</div>
                            <div class="position-absolute">крутые проекты</div>
                            <div class="position-absolute">кайф от работы</div>
                            <div class="position-absolute">признание экспертизы</div>
                            <div class="position-absolute">рост дохода</div>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741687185091-7AUE8-Grou.png"
                            alt="" class="position-absolute">
                    </div>
                    <a href="https://careerum.com/ru-ru/club/intensive/power-talk-2025"
                        class="btn-color-main-black">Посмотреть программу</a>
                </div>
                <div class="club40-support-banner-item3 position-relative">
                    <div class="careerum-flex-fsfs">
                        <div class="club40-support-banner-item3-label careerum-flex-cc">
                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.4845 4.24309L5.4845 4.25691C5.07028 4.25729 4.73481 4.59339 4.73519 5.0076L4.74901 20.0076C4.74939 20.4218 5.08548 20.7573 5.4997 20.7569L20.4997 20.7431C20.9139 20.7427 21.2494 20.4066 21.249 19.9924L21.2352 4.9924C21.2348 4.57818 20.8987 4.24271 20.4845 4.24309Z" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M17.4832 2.74586L17.4859 5.74586" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.48315 2.75415L8.48592 5.75415" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.73865 8.7576L21.2386 8.7424" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.3672 12.4969L11.9929 16.6259L9.61891 14.3781" stroke="#0B70FE" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            <p>26–27 апреля</p>
                        </div>
                        <div class="club40-support-banner-item3-label careerum-flex-cc">
                            <p>Практикум </p>
                        </div>
                    </div>
                    <p class="club40-support-banner-item3-header">Резюме<br> за выходные </p>
                    <p class="club40-support-banner-item3-text">Хватит терять вакансии и время!<br>Создайте резюме,
                        которое продаст вас</p>
                    <p class="club40-support-banner-item3-text-label position-absolute">с экспертом</p>
                    <a href="https://careerum.com/ru-ru/promo/weekend-resume?utm_source=web&utm_medium=ru-ru-club&utm_campaign=cv-weekend&utm_content=banner&utm_term=main"
                        class="btn-color-main-dark-orange">Посмотреть программу</a>
                </div>
            </div>
                <div class="club40-support-bottom-button">
                    <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-form', {
        label: 'Club 4 form',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-form">
            <div class="careerum-container-desc">
                <div class="careerum-flex-sbfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723287242177-1g7uZ-Vect.svg" alt="">
                        <h2>Начните знакомство <br>
                            с Careerum, это бесплатно!</h2>
                        <p>Заполните форму, а мы откроем вам доступ к образовательной платформе Careerum в демо-режиме. Увидите,
                            как работает платформа, и как мы поможем вам достичь целей</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723287284331-kmJYL-Grou.svg" alt="">
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных<br> в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Получить
                                    доступ</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-form-tablet', {
        label: 'Club 4 form (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-form-tablet">
            <div class="careerum-container-tablet">
                <div class="careerum-flex-sbst">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723489041657-m4vpb-Vect.svg" alt="">
                        <h2>Начните знакомство <br>
                            с Careerum, это бесплатно!</h2>
                        <p>Откроем вам доступ к образовательной платформе Careerum в демо-режиме. Увидите, как она работает, и как мы поможем вам достичь целей</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723489074938-2IeWJ-Grou.svg" alt="">
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Получить
                                    доступ</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-form-mobile', {
        label: 'Club 4 form (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-form-mobile">
            <div class="careerum-container-mobile">
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723489041657-m4vpb-Vect.svg"
                            alt="">
                        <h2>Начните знакомство <br>
                            с Careerum, это бесплатно!</h2>
                        <p>Откроем вам доступ к образовательной платформе Careerum в демо-режиме. Увидите, как она работает,
                            и как мы поможем вам достичь целей</p>
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Получить
                                    доступ</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-popup-pay', {
        label: 'Club 4 popup pay',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club40-popup-pay" id="">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="club40-popup-pay-content">
                <div class="careerum-flex-sbfs">
                    <div class="club40-popup-pay-content-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457663947-ZJyDY-Unio.svg"
                            alt="">
                        <div class="club40-popup-pay-content-label m12 careerum-flex-fsfs">
                            <p>Подписка на 12 месяцев</p>
                        </div>
                        <div class="club40-popup-pay-content-label m6 careerum-flex-fsfs">
                            <p>Подписка на 6 месяцев</p>
                        </div>
                        <div class="club40-popup-pay-content-label m3 careerum-flex-fsfs">
                            <p>Подписка на 3 месяца</p>
                        </div>
                        <div class="club40-popup-pay-content-label m1 careerum-flex-fsfs">
                            <p>Подписка на 1 месяц</p>
                        </div>
                        <p>Тариф «Самостоятельный»</p>
                        <ul>
                            <li class="careerum-flex-fsfs club40-popup-pay-content-top-li rub">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Можно в рассрочку — первый платеж через 30 дней</p>
                            </li>
                            <li class="careerum-flex-fsfs club40-popup-pay-content-top-li eur">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Можно платить долями по персональному графику</p>
                            </li>
                            <li class="careerum-flex-fsfs club40-popup-pay-content-top-li single">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Подписка будет продлеваться автоматически за сутки до окончания</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>После оплаты вы получите письмо с инструкцией</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Продление подписки можно отменить в любой момент</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-popup-pay-content-right">
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я принимаю условия Оферты и даю согласие на обработку персональных данных
                                        в соответствии с Политикой конфиденциальности. Подписка будет автоматически
                                        продлеваться по аналогичным условиям за сутки до конца оплаченного периода</p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>К выбору способа оплаты</a>
                                <input type="hidden" hidden name="offerID" value="">
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-popup-pay2', {
        label: 'Club 4 popup pay 2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club40-popup-pay2" id="">
            <div class="popup__close-button-wrapper careerum-flex-cc">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch hidden-tablet-mobile">
                    <path d="M21.5957 21.2718L2.41172 2.16602" stroke="#636463" stroke-width="4" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M2.39951 21.278L21.6035 2.15625" stroke="#636463" stroke-width="4" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-switch hidden-desc">
                    <g clip-path="url(#clip0_10262_11319)">
                        <path d="M10.7979 10.6359L1.20586 1.08301" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M1.19976 10.639L10.8018 1.07812" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_10262_11319">
                            <rect width="12" height="12" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="club40-popup-pay-content">
                <div class="careerum-flex-sbfs">
                    <div class="club40-popup-pay-content-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1738908255470-w31pl-Unio.svg"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1738908245146-uPi0X-Unio.svg"
                            alt="" class="hidden-desc-mobile">
                    </div>
                    <div class="club40-popup-pay-content-right">
                        <p class="club40-popup-pay-content-step">Шаг 1. Укажите свои данные</p>
                        <p class="club40-popup-pay-content-order-label">Ваш заказ:</p>
                        <p class="club40-popup-pay-content-order-header">Подписка Careerum</p>
                        <p class="club40-popup-pay-content-order-header">Тариф «Самостоятельный»</p>
                        <div class="club40-popup-pay-content-label m12 careerum-flex-fsfs">
                            <p>Длительность: 365 дней</p>
                        </div>
                        <div class="club40-popup-pay-content-label m6 careerum-flex-fsfs">
                            <p>Длительность: 180 дней</p>
                        </div>
                        <div class="club40-popup-pay-content-label m3 careerum-flex-fsfs">
                            <p>Длительность: 90 дней</p>
                        </div>
                        <div class="club40-popup-pay-content-label m1 careerum-flex-fsfs">
                            <p>Длительность: 30 дней</p>
                        </div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                        <p class="careerum-club40-form-warn">Неверное имя</p>
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я принимаю условия <a href="/ru-intl/legal/offer">Оферты</a> и даю согласие
                                        на обработку персональных данных
                                        в соответствии с <a href="/ru-ru/legal/privacy">Политикой конфиденциальности</a>.
                                        Подписка будет автоматически
                                        продлеваться по аналогичным условиям за сутки до конца оплаченного периода</p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange careerum-flex-cc" disabled>
                                    Перейти к оплате
                                    <svg width="33" height="32" viewBox="0 0 33 32" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                        <path d="M5.5 16H27.5" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M18.5 7L27.5 16L18.5 25" stroke="#ffffff" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </a>
                                <input type="hidden" hidden name="offerID" value="">
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-popup-subscribe', {
        label: 'Club 4 popup sunscribe',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club40-popup-pay careerum-club40-popup-subscribe" id="">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="club40-popup-pay-content">
                <div class="careerum-flex-sbfs">
                    <div class="club40-popup-pay-content-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457663947-ZJyDY-Unio.svg"
                            alt="">
                        <div class="club40-popup-pay-content-label m12 careerum-flex-fsfs">
                            <p>Подписка на 12 месяцев</p>
                        </div>
                        <div class="club40-popup-pay-content-label m6 careerum-flex-fsfs">
                            <p>Подписка на 6 месяцев</p>
                        </div>
                        <div class="club40-popup-pay-content-label m3 careerum-flex-fsfs">
                            <p>Подписка на 3 месяца</p>
                        </div>
                        <div class="club40-popup-pay-content-label m1 careerum-flex-fsfs">
                            <p>Подписка на 1 месяц</p>
                        </div>
                        <p>Тариф «Самостоятельный»</p>
                        <ul>
                            <li class="careerum-flex-fsfs club40-popup-pay-content-top-li rub">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Можно в рассрочку — первый платеж через 30 дней</p>
                            </li>
                            <li class="careerum-flex-fsfs club40-popup-pay-content-top-li eur">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Можно платить долями по персональному графику</p>
                            </li>
                            <li class="careerum-flex-fsfs club40-popup-pay-content-top-li single">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Подписка будет продлеваться автоматически за сутки до окончания</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>После оплаты вы получите письмо с инструкцией</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457666600-Zs2Dm-Fram.svg"
                                    class="popup-desctop-img" alt="">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723561372476-FqRod-Fram.svg"
                                    class="popup-mobile-img" alt="">
                                <p>Продление подписки можно отменить в любой момент</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-popup-pay-content-right">
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я принимаю условия Оферты и даю согласие на обработку персональных данных
                                        в соответствии с Политикой конфиденциальности. Подписка будет автоматически
                                        продлеваться по аналогичным условиям за сутки до конца оплаченного периода</p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>К выбору способа оплаты</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-popup-subscribe2', {
        label: 'Club 4 popup sunscribe 2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-popup careerum-club40-popup-pay2 careerum-club40-popup-subscribe2" id="">
                <div class="popup__close-button-wrapper careerum-flex-cc">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="close-switch hidden-tablet-mobile">
                        <path d="M21.5957 21.2718L2.41172 2.16602" stroke="#636463" stroke-width="4" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M2.39951 21.278L21.6035 2.15625" stroke="#636463" stroke-width="4" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="close-switch hidden-desc">
                        <g clip-path="url(#clip0_10262_11319)">
                            <path d="M10.7979 10.6359L1.20586 1.08301" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M1.19976 10.639L10.8018 1.07812" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_10262_11319">
                                <rect width="12" height="12" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="club40-popup-pay-content">
                    <div class="careerum-flex-sbfs">
                        <div class="club40-popup-pay-content-left position-relative ">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740733450214-Ioew5-Unio.svg"
                                alt="" class="hidden-tablet-mobile position-absolute z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740733965773-4Cmuy-Unio.svg"
                                alt="" class="hidden-desc-mobile position-absolute z-10">
                            <p class="club40-popup-pay-content-header position-relative z-20">Тариф «С поддержкой»</p>
                            <div class="club40-popup-pay-content-label m12 careerum-flex-fsfs position-relative z-20">
                                <p>Подписка на 365 дней</p>
                            </div>
                            <div class="club40-popup-pay-content-label m6 careerum-flex-fsfs position-relative z-20">
                                <p>Подписка на 180 дней</p>
                            </div>
                            <div class="club40-popup-pay-content-label m3 careerum-flex-fsfs position-relative z-20">
                                <p>Подписка на 90 дней</p>
                            </div>
                            <div class="club40-popup-pay-content-label m1 careerum-flex-fsfs position-relative z-20">
                                <p>Подписка на 30 дней</p>
                            </div>
                            <p class="club40-popup-pay-content-text position-relative z-20">Оставьте заявку — наши менеджеры свяжутся с вами и подберут
                                решение, максимально подходящее для решения вашего карьерного запроса</p>
                        </div>
                        <div class="club40-popup-pay-content-right">
                            <div class="careerum-registration-form-club40">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                    data-gjs-type="deva-registration-form">
                                    <div class="careerum-club40-form-name">
                                        <input type="text" name="name" value="" required placeholder="Имя">
                                        <p class="careerum-club40-form-warn">Неверное имя</p>
                                    </div>
                                    <div class="careerum-club40-form-email">
                                        <input type="text" name="email" value="" required placeholder="Почта">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-phone">
                                        <input type="tel" value="" name="tel" required class="itl-input">
                                        <p class="careerum-club40-form-warn">Поле не заполнено</p>
                                    </div>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я принимаю условия Оферты и даю согласие на обработку персональных данных
                                            в соответствии с Политикой конфиденциальности. Подписка будет автоматически
                                            продлеваться по аналогичным условиям за сутки до конца оплаченного периода</p>
                                    </div>
                                    <a href="#" class="submit-btn btn-color-main-bright-orange careerum-flex-cc" disabled>
                                        <p>Оставить заявку</p>
                                        <svg width="33" height="32" viewBox="0 0 33 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.5 16H27.5" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M18.5 7L27.5 16L18.5 25" stroke="#ffffff" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </a>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });

    blockManager.add('careerum-club40-popup-lk', {
        label: 'Club 4 popup cabinet',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-club40-popup-pay careerum-club40-popup-subscribe careerum-club40-popup-lk" id="login" data-popup-open="thanks" getcourse-group="Вейтлист: личный кабинет">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="club40-popup-pay-content">
                <div class="careerum-flex-sbfs">
                    <div class="club40-popup-pay-content-left">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723457663947-ZJyDY-Unio.svg"
                            alt="">
                        <p>Добро пожаловать в&nbsp;Careerum</p>
                        <div class="club40-popup-pay-content-text">
                            <p>Введите свои данные — после быстрой проверки мы перенаправим вас на страницу авторизации, если у вас уже есть активная подписка.<br><br>Если вы у нас впервые — создадим для вас личный кабинет и дадим демо-доступ к нашей платформе.
                            </p>
                        </div>
                    </div>
                    <div class="club40-popup-pay-content-right">
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-telegram">
                                    <input type="text" name="telegram" value="" required placeholder="Telegram">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent close-switch" disabled>Проверить доступ</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('no-cabinet', {
        label: 'Club 4 popup no cabinet',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div id="thanks-no" class="careerum-popup careerum-club40-popup-cabinet no-cabinet">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="careerum-club40-popup-cabinet-wrapper">
                <div>
                    <div>
                        <p class="careerum-club40-popup-cabinet-header">Теперь у вас есть личный кабинет!</p>
                        <p class="careerum-club40-popup-cabinet-content">Чтобы попасть туда, нужно всего лишь подтвердить
                            свой email.</p>
                        <p class="careerum-club40-popup-cabinet-content">Для этого нажмите кнопку ниже и следуйте
                            инструкции.</p>
                        <a class="close-switch btn-color-main-dark-orange cabinet-activate" href="https://passport.careerum.com">Перейти в личный
                            кабинет</a>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('has-cabinet', {
        label: 'Club 4 popup has cabinet',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div id="thanks-has" class="careerum-popup careerum-club40-popup-cabinet has-cabinet">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="careerum-club40-popup-cabinet-wrapper">
                <div>
                    <div>
                        <p class="careerum-club40-popup-cabinet-header">Welcome back! Рады видеть вас снова</p>
                        <p class="careerum-club40-popup-cabinet-content">Вы уже зарегестрированы в Careerum. Чтобы войти
                            в личный кабинет, нажмите на кнопку ниже.</p>
                        <a class="close-switch btn-color-main-dark-orange" href="https://passport.careerum.com" target="_blank">Войти в личный
                            кабинет</a>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-popup-thanks', {
        label: 'Club 4 popup thanks',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div id="thanks" class="careerum-popup careerum-club40-popup-thanks">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="careerum-club40-popup-thanks-wrapper">
                <div>
                    <div>
                        <p class="careerum-club40-popup-thanks-header">Спасибо, что<br> оставили заявку!</p>
                        <p class="careerum-club40-popup-thanks-content">Наши специалисты свяжутся с вами<br> в течение 24
                            часов</p>
                        <!-- <a class="close-switch btn-color-main-dark-orange" href="#">Войти в личный кабинет</a> -->
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-banner1', {
        label: 'Club 4 banner1',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-banner1">
            <div class="careerum-container-desc">
                <div class="club40-banner1-top">
                    <div class="club40-banner1-top-top">
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-top-bottom">
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721933804-EK5Pa-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="club40-banner1-header">
                    <div class="club40-banner1-labels careerum-flex-fsfs">
                        <div class="club40-banner1-label blue-label">
                            <p>Интенсив по поиску работы</p>
                        </div>
                        <div class="club40-banner1-label">
                            <p>26 августа – 27 октября 2024</p>
                        </div>
                    </div>
                    <h2>Fast Track: быстрый путь к офферу мечты</h2>
                </div>
                <div class="club40-banner1-center careerum-flex-fsfs">
                    <div class="club40-banner1-about careerum-flex-fsfs">
                        <div class="club40-banner1-about-item">
                            <p>8 живых эфиров</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Много практики</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Эксперты международного класса</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Q&A-сессии</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Полезный нетворк и поддержка сообщества</p>
                        </div>
                    </div>
                    <div class="club40-banner1-advantages">
                        <div>
                            <div class="club40-banner1-advantages-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717427906-NTzju-Fram.svg" alt="">
                                <p>Идеально подойдет для поиска как в РФ, так и за рубежом</p>
                            </div>
                            <div class="club40-banner1-advantages-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717427906-NTzju-Fram.svg" alt="">
                                <p>Лучшие  лайфхаки для каждого этапа поиска работы</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-banner1-bottom">
                    <div class="club40-banner1-bottom-top">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718895738-qiN8B-Grou.svg" alt="">
                        <p class="club40-banner1-bottom-header">Интенсив подойдет вам, если:</p>
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717945036-7Fx3v-Unio.svg" alt="">
                                <p>Устали от долгого и безуспешного поиска работы</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717945036-7Fx3v-Unio.svg" alt="">
                                <p>Ваше резюме не читают<br> или игнорируют</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717945036-7Fx3v-Unio.svg" alt="">
                                <p>Нервничаете на интервью и не знаете, как себя вести</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717945036-7Fx3v-Unio.svg" alt="">
                                <p>Боитесь откликаться на «крутые» вакансии</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717945036-7Fx3v-Unio.svg" alt="">
                                <p>Получаете отказы на разных этапах и не понимаете, почему</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723717945036-7Fx3v-Unio.svg" alt="">
                                <p>Не знаете, какие<br> вакансии вам подойдут</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-bottom-bottom">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718896344-N4VBN-Grou.svg" alt="">
                        <p class="club40-banner1-bottom-header">Вы после интенсива:</p>
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718016945-FGdYu-Vect.svg" alt="">
                                <p>Проанализируете рынок и поставите карьерные цели</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718016945-FGdYu-Vect.svg" alt="">
                                <p>Построите стратегию поиска вакансий</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718016945-FGdYu-Vect.svg" alt="">
                                <p>Напишете продающее резюме и сопроводительные письма</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718016945-FGdYu-Vect.svg" alt="">
                                <p>Усилите ваш профиль в LinkedIn и научитесь использовать его в поиске</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718016945-FGdYu-Vect.svg" alt="">
                                <p>Подготовитесь к собеседованиям и переговорам по офферу на русском или английском языках</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723718016945-FGdYu-Vect.svg" alt="">
                                <p>Сделаете свой поиск быстрым и эффективным</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-bottom-label">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721502311-LpuWO-Vect.svg" alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721501990-ar0dE-Grou.svg" alt="">
                        <p>Получите оффер в компании мечты на лучших условиях</p>
                    </div>
                </div>
                <div class="club40-banner1-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Принять участие</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-banner1-tablet', {
        label: 'Club 4 banner1 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-banner1-tablet">
            <div class="careerum-container-tablet">
                <div class="club40-banner1-top">
                    <div class="club40-banner1-top-top">
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-top-bottom">
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="club40-banner1-header">
                    <div class="club40-banner1-labels careerum-flex-fsfs">
                        <div class="club40-banner1-label blue-label">
                            <p>Интенсив по поиску работы</p>
                        </div>
                        <div class="club40-banner1-label">
                            <p>26 августа – 27 октября 2024</p>
                        </div>
                    </div>
                    <h2>Fast Track: быстрый путь к офферу<br> мечты</h2>
                </div>
                <div class="club40-banner1-center careerum-flex-fsfs">
                    <div class="club40-banner1-about careerum-flex-fsfs">
                        <div class="club40-banner1-about-item">
                            <p>8 живых эфиров</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Много практики</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Полезный нетворк</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Q&A-сессии</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Поддержка сообщества</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Эксперты международного класса</p>
                        </div>
                    </div>
                    <div class="club40-banner1-advantages">
                        <div>
                            <div class="club40-banner1-advantages-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724010636-Galjh-Grou.svg" alt="">
                                <p>Идеально подойдет для поиска как в РФ, так и за рубежом</p>
                            </div>
                            <div class="club40-banner1-advantages-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724010636-Galjh-Grou.svg" alt="">
                                <p>Лучшие  лайфхаки для каждого этапа поиска работы</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-banner1-bottom">
                    <div class="club40-banner1-bottom-top">
                        <p class="club40-banner1-bottom-header">Интенсив подойдет вам, если:</p>
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Устали от долгого и безуспешного поиска работы</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Ваше резюме не читают или игнорируют</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Нервничаете на интервью и не знаете, как себя вести</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Боитесь откликаться на «крутые» вакансии</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Получаете отказы на разных этапах и не понимаете, почему</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Не знаете, какие<br> вакансии вам подойдут</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-bottom-bottom">
                        <p class="club40-banner1-bottom-header">Вы после интенсива:</p>
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Проанализируете рынок и поставите карьерные цели</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Построите стратегию поиска вакансий</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Напишете продающее резюме и сопро-водительные письма</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Усилите ваш профиль в LinkedIn и научитесь использовать его в поиске</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Подготовитесь к собеседованиям на русском и английском</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Сделаете свой поиск эффективным и быстрым</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-bottom-label">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723721502311-LpuWO-Vect.svg" alt="">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723725080238-kKiTY-Grou.svg" alt="">
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724888192-WsRoC-Vect.svg" alt="">
                            <p>Получите оффер в компании мечты на лучших условиях</p>
                        </div>
                    </div>
                </div>
                <div class="club40-banner1-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Принять участие</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-banner1-mobile', {
        label: 'Club 4 banner1 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-banner1-mobile">
            <div class="careerum-container-mobile">
                <div class="club40-banner1-top">
                    <div class="club40-banner1-top-top">
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Главный ивент сезона найма</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-top-bottom">
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                            <li class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723723436409-aaIHx-Soft.svg" alt="">
                                <p>Оффер — уже этой осенью!</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="club40-banner1-header">
                    <div class="club40-banner1-labels">
                        <div class="club40-banner1-label blue-label">
                            <p>Интенсив по поиску работы</p>
                        </div>
                        <div class="club40-banner1-label">
                            <p>26 августа – 27 октября 2024</p>
                        </div>
                    </div>
                    <h2>Fast Track: быстрый путь к офферу мечты</h2>
                </div>
                <div class="club40-banner1-center">
                    <div class="club40-banner1-advantages">
                        <div>
                            <div class="club40-banner1-advantages-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724010636-Galjh-Grou.svg" alt="">
                                <p>Идеально подойдет для поиска как в РФ, так и за рубежом</p>
                            </div>
                            <div class="club40-banner1-advantages-item careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724010636-Galjh-Grou.svg" alt="">
                                <p>Лучшие  лайфхаки для каждого этапа поиска работы</p>
                            </div>
                        </div>
                    </div>
                    <div class="club40-banner1-about careerum-flex-fsfs">
                        <div class="club40-banner1-about-item">
                            <p>8 живых эфиров</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Много практики</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Полезный нетворк</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Q&A-сессии</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Поддержка сообщества</p>
                        </div>
                        <div class="club40-banner1-about-item">
                            <p>Эксперты международного класса</p>
                        </div>
                    </div>
                </div>
                <div class="club40-banner1-bottom">
                    <div class="club40-banner1-bottom-top">
                        <p class="club40-banner1-bottom-header">Интенсив подойдет<br> вам, если:</p>
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Устали от долгого и безуспешного поиска работы</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Ваше резюме не читают или игнорируют</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Нервничаете на интервью и не знаете, как себя вести</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Боитесь откликаться на «крутые» вакансии</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Получаете отказы на разных этапах и не понимаете, почему</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724247891-MUKp2-Unio.svg" alt="">
                                <p>Не знаете, какие вакансии вам подойдут</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-bottom-bottom">
                        <p class="club40-banner1-bottom-header">Вы после интенсива:</p>
                        <ul class="careerum-flex-fsfs">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Проанализируете рынок и поставите карьерные цели</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Построите стратегию поиска вакансий</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Напишете продающее резюме и сопроводительные письма</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Усилите ваш профиль в LinkedIn и научитесь использовать его в поиске</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Подготовитесь к собеседованиям<br>на русском или английском языках</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724248356-hQhMB-Vect.svg" alt="">
                                <p>Сделаете свой поиск быстрым и эффективным</p>
                            </li>
                        </ul>
                    </div>
                    <div class="club40-banner1-bottom-label">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723725080238-kKiTY-Grou.svg" alt="">
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723724888192-WsRoC-Vect.svg" alt="">
                            <p>Получите оффер в компании мечты на лучших условиях</p>
                        </div>
                    </div>
                </div>
                <div class="club40-banner1-link">
                    <a href="#buy" class="btn-color-main-dark-orange">Принять участие</a>
                </div>
            </div>
        </div>`
    });
    blockManager.add('careerum-club40-banner2', {
        label: 'Club 4 banner2 responsive',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club40-banner2 main-wrapper">
        <div class="careerum-container-responsive">
            <div class="club40-banner2-labels position-relative">
                <div class="club40-banner2-label-left">
                    <p class="text-white">Интенсив</p>
                </div>
                <div class="club40-banner2-label-center">
                    <p class="text-white">11 ноября – 10 февраля</p>
                </div>
            </div>
            <div class="club40-banner2-header careerum-flex-sbfs">
                <div>
                    <h2>Real Me: как найти<br> себя в работе и жизни</h2>
                    <p class="hidden-desc">Определитесь в каком направлении развивать карьеру и зарабатывать на том, что
                        любите</p>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730623649747-c4j59-Mask.png"
                        alt="" class="hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730628211830-EU9A5-Mask.png"
                        alt="" class="hidden-desc-tablet">
                    <p class="hidden-tablet-mobile">Автор: Ольга Лермонтова,<br> карьерный стратег<br> и фаундер
                        Careerum
                    </p>
                    <p class="hidden-desc">Автор программы:
                        Ольга Лермонтова, карьерный стратег и фаундер Careerum
                    </p>
                </div>
            </div>
            <div class="club40-banner2-center hidden-tablet-mobile">
                <p>Определитесь в каком направлении развивать карьеру и зарабатывать на том, что любите</p>
            </div>
            <div class="club40-banner2-slider">
                <div class="club40-banner2-slider-items">
                    <div class="club40-banner2-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730623883284-N90hT-Grad.svg"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730626858021-GWm6d-Grad.svg"
                            alt="" class="hidden-desc">
                        <p>Откопаете свои таланты, сделаете их фундаментом карьеры</p>
                    </div>
                    <div class="club40-banner2-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730623883171-gAtpm-Glob.svg"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730626857905-eBGtx-Glob.svg"
                            alt="" class="hidden-desc">
                        <p>Найдете свое в работе, даже если все перепробовали</p>
                    </div>
                    <div class="club40-banner2-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730623883048-VVsd0-Smil.svg"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730626857771-NtVEh-Smil.svg"
                            alt="" class="hidden-desc">
                        <p>Справитесь с самозванцем, поверите в свои силы, выйдете из состояния постоянного напряжения
                        </p>
                    </div>
                    <div class="club40-banner2-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730623882740-nubsC-Trop.svg"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1730626857412-X8Rr7-Trop.svg"
                            alt="" class="hidden-desc">
                        <p>Сможете сменить профессию без оглядки на возраст</p>
                    </div>
                </div>
                <div class="club40-banner2-slider-nav position-relative">
                    <div class="club40-banner2-slider-nav-prev">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="cursor-pointer">
                            <g clip-path="url(#clip0_177_2583)">
                                <g filter="url(#filter0_b_177_2583)">
                                    <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="#0B70FE" />
                                </g>
                                <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_177_2583" x="-18.1166" y="-18.1166" width="76.2332"
                                    height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in"
                                        result="effect1_backgroundBlur_177_2583" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_177_2583"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_177_2583">
                                    <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                        fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="club40-banner2-slider-nav-next">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="cursor-pointer">
                            <g clip-path="url(#clip0_177_2587)">
                                <g filter="url(#filter0_b_177_2587)">
                                    <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="#0B70FE" />
                                </g>
                                <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_177_2587" x="-18.1166" y="-18.1166" width="76.2332"
                                    height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in"
                                        result="effect1_backgroundBlur_177_2587" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_177_2587"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_177_2587">
                                    <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                        fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="club40-banner2-link">
                <a href="#buy" class="btn-color-main-dark-orange">Участвовать</a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('club40-tariffs2', {
        label: 'Club 4 tariffs2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-tariffs club40-tariffs2">
            <div class="careerum-container-desc">
                <div class="careerum-flex-fsc club40-tariffs-top-label">
                    <p>График повышения цен: </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737370505194-JDWDp-Chec.svg" alt="" class="auto">
                    <p>15 февраля</p>
                    <p>17 февраля</p>
                    <p>19 февраля</p>
                    <p>22 февраля</p>
                </div>
                <h2 class="careerum-club40-header">Решите свою карьерную задачу с нами</h2>
                <div class="club40-tariffs-nav careerum-flex-sbfs">
                    <div class="club40-tariffs-period careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="1" class="active">1 месяц</li>
                            <li data-period="3">3 месяца</li>
                            <li data-period="6">6 месяцев</li>
                            <li data-period="12">12 месяцев</li>
                        </ul>
                        <div class="club40-tariffs-notif careerum-flex-cc">
                            <div class="club40-tariffs-notif-icon"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt=""></div>
                            <div class="club40-tariffs-notif-content">
                                <p>1 месяц подписки предоставляет 30 дней доступа к платформе</p>
                            </div>
                        </div>
                    </div>
                    <div class="club40-tariffs-curr careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur" class="active">EUR</li>
                            <li data-currency="rub">RUB</li>
                        </ul>
                        <div class="club40-tariffs-notif careerum-flex-cc">
                            <div class="club40-tariffs-notif-icon"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt=""></div>
                            <div class="club40-tariffs-notif-content">
                                <p>Оплата в российских рублях возможна только картой российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-items careerum-flex-fsst">
                    <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                        data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                        data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽" data-fullprice-12m-rub="77 880 ₽"
                        data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                        data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                        data-fullprice-12m-eur="960 €" data-offer-1m-rub="27" data-offer-3m-rub="94" data-offer-6m-rub="95"
                        data-offer-12m-rub="96" data-offer-1m-eur="48" data-offer-3m-eur="97" data-offer-6m-eur="98"
                        data-offer-12m-eur="99" class="club40-tariffs-item careerum-flex-fsfs">
                        <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                        <p class="club40-tariffs-item-header">Доступ к карьерной платформе<br><br></p>
                        <p class="club40-tariffs-item-description">Неограниченное кол-во мест</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <ul>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>80 карьерных курсов</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма, сообщения
                                    работодателям в LinkedIn, деловая email-переписка</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Воркфлоу поиска достижений </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Список платформ для поиска работы в 15 странах</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Алгоритм, чтобы определить свою карьерную стадию </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Скрипт обсуждения зарплаты и оффера </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Формула расчета «Сколько я стою на рынке»
                                </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Алгоритм постановки карьерных гипотез
                                    для смены сферы</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Инструкция по созданию плана карьерного развития</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Методы постановки карьерных целей
                                </p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="club40-tariffs-item-discount careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737368940097-5jGbI-Perc.svg" alt="">
                                <p>Цена со скидкой на 1-ый платеж</p>
                            </div>
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                <div>
                                    <p class="club40-tariffs-item-price-f">8 900 ₽</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-old">12 900 ₽</p>
                                </div>
                            </div><a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                        data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                        data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽" data-fullprice-12m-rub="77 880 ₽"
                        data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                        data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                        data-fullprice-12m-eur="960 €" data-offer-1m-rub="27" data-offer-3m-rub="94" data-offer-6m-rub="95"
                        data-offer-12m-rub="96" data-offer-1m-eur="48" data-offer-3m-eur="97" data-offer-6m-eur="98"
                        data-offer-12m-eur="99" class="club40-tariffs-item careerum-flex-fsfs">
                        <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                        <p class="club40-tariffs-item-header">Доступ к карьерной платформе<br><br></p>
                        <p class="club40-tariffs-item-description">Неограниченное кол-во мест</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <ul>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>80 карьерных курсов</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма, сообщения
                                    работодателям в LinkedIn, деловая email-переписка</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Воркфлоу поиска достижений </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Список платформ для поиска работы в 15 странах</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Алгоритм, чтобы определить свою карьерную стадию </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Скрипт обсуждения зарплаты и оффера </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Формула расчета «Сколько я стою на рынке»
                                </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Алгоритм постановки карьерных гипотез
                                    для смены сферы</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Инструкция по созданию плана карьерного развития</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733913749831-JjiLO-Chec.svg"
                                    alt="">
                                <p>Методы постановки карьерных целей
                                </p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price">
                                <div>
                                    <p class="club40-tariffs-item-price-pm">120 €</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div>
                                    <p>/</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-f">360 €</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div><a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Выбрать тариф</a>
                            <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div data-price="" data-price-1m-rub="14 900 ₽" data-price-3m-rub="11&nbsp;633 ₽"
                        data-fullprice-3m-rub="34&nbsp;900 ₽" data-price-6m-rub="9&nbsp;817 ₽"
                        data-fullprice-6m-rub="58&nbsp;900 ₽" data-price-12m-rub="8 000 ₽" data-fullprice-12m-rub="96 000 ₽"
                        data-price-1m-eur="199 €" data-price-3m-eur="170 €" data-fullprice-3m-eur="510 €"
                        data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €" data-price-12m-eur="100 €"
                        data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="28" data-offer-3m-rub="29"
                        data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49" data-offer-3m-eur="50"
                        data-offer-6m-eur="51" data-offer-12m-eur="52" class="club40-tariffs-item careerum-flex-fsfs">
                        <p class="club40-tariffs-item-label">Популярный</p>
                        <p class="club40-tariffs-item-subheader2">Тариф «С поддержкой»</p>
                        <p class="club40-tariffs-item-header">Платформа +<br>поддержка<br> эксперта в группе</p>
                        <p class="club40-tariffs-item-description">Осталось: 25 мест</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <p class="club40-tariffs-item-subheader">В тариф входят все опции тарифа «Самостоятельный», плюс:
                        </p>
                        <ul>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Групповой чат с экспертом и кураторами платформы</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>2 группые Q&A-встречи в месяц с экспертом для разбора вопросов</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Доступ к Сareerum.Club и всем ивентам клуба</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Доступ к сезонным Интенсивам </p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price">
                                <div>
                                    <p class="club40-tariffs-item-price-pm">170 €</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div>
                                    <p>/</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-f">510 €</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div><a onclick="" href="#subscribe-support"
                                class="btn-color-main-dark-orange no-change">Оставить заявку</a>
                            <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                        </div>
                    </div>
                    <div data-price="" data-price-1m-rub="27 900 ₽" data-price-3m-rub="23&nbsp;900 ₽"
                        data-fullprice-3m-rub="71&nbsp;700 ₽" data-price-6m-rub="18&nbsp;317 ₽"
                        data-fullprice-6m-rub="109&nbsp;900 ₽" data-price-12m-rub="16&nbsp;583 ₽"
                        data-fullprice-12m-rub="199 000 ₽" data-price-1m-eur="360 €" data-price-3m-eur="310 €"
                        data-fullprice-3m-eur="930 €" data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €"
                        data-price-12m-eur="230 €" data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="32"
                        data-offer-3m-rub="100" data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53"
                        data-offer-3m-eur="103" data-offer-6m-eur="104" data-offer-12m-eur="105"
                        class="club40-tariffs-item careerum-flex-fsfs">
                        <p class="club40-tariffs-item-subheader2">Тариф «Индивидуальный подход»</p>
                        <p class="club40-tariffs-item-header">Платформа +<br> личные консультации<br> с экспертом</p>
                        <p class="club40-tariffs-item-description">Осталось: 25 мест</p>
                        <div class="club40-tariffs-item-divider"></div>
                        <p class="club40-tariffs-item-subheader">В тариф входят все преимущества тарифа «С&nbsp;поддержкой»,
                            плюс:</p>
                        <ul>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Персональная поддержка карьерного эксперта и коуча<br> в чате</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>2 видеоконсультации<br> в месяц с экспертом под ваш карьерный запрос </p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Персональный разбор резюме<br> + 3 письменным фидбека по доработке</p>
                            </li>
                            <li class="careerum-flex-fsfs"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                    alt="">
                                <p>Персональный разбор LinkedIn<br>+3 письменным фидбека<br>по доработке</p>
                            </li>
                        </ul>
                        <div class="club40-tariffs-item-bottom">
                            <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price">
                                <div>
                                    <p class="club40-tariffs-item-price-pm">310 €</p>
                                    <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                    <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                </div>
                                <div>
                                    <p>/</p>
                                </div>
                                <div>
                                    <p class="club40-tariffs-item-price-f">930 €</p>
                                    <p>полная стоимость к оплате</p>
                                </div>
                            </div><a onclick="" href="#subscribe-individual"
                                class="btn-color-main-dark-orange no-change">Оставить заявку</a>
                            <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                            <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom careerum-flex-sbfs">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733916035157-i9KVB-Vect.svg"
                            alt="">
                        <p class="club40-tariffs-bottom-header">Не знаете, с чего начать?</p>
                        <p class="club40-tariffs-bottom-subheader">Напишите нам — мы ответим на все вопросы<br> и поможем
                            выбрать лучшее решение под вашу задачу</p><a onclick=""
                            href="https://t.me/careerum_bot?roistat_visit=674480" target="_blank"
                            class="btn-color-main-dark-blue careerum-flex-cc"><svg width="28" height="24"
                                viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                    fill="#C8DAEA"></path>
                                <path
                                    d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                    fill="#A9C6D8"></path>
                                <path
                                    d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                    fill="white"></path>
                            </svg>
                            <p>Написать в Telegram</p>
                        </a>
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278685081-7nUnx-ÑÐ¾.svg"
                            alt="">
                        <div class="careerum-flex-fsfs club40-tariffs-bottom-care">
                            <div><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                    alt=""></div>
                            <div>
                                <p class="club40-tariffs-bottom-care-name">Анна </p>
                                <p class="club40-tariffs-bottom-care-position">Команда заботы Careerum</p>
                                <p class="club40-tariffs-bottom-care-descr">Добрый день! Построить карьеру мечты
                                    в&nbsp;одиночку бывает непросто. Но мы рядом и&nbsp;приведем вас к&nbsp;заветной цели 💙
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom-pay position-relative">
                    <p class="club40-tariffs-bottom-pay-label position-absolute">20% скидка<br> для команд от 3 человек</p>
                    <p class="club40-tariffs-bottom-pay-title">Поможем оплатить<br>
                        подписку через работодателя</p>
                    <p class="club40-tariffs-bottom-pay-text">Мы подготовили шаблон письма для вашего руководителя, в
                        котором описали все плюшки подписки Сareerum и добавили специальные условия, если вы захотите
                        позвать коллег:)</p>
                    <div class="careerum-flex-fsfs">
                        <a href="#" class="btn-color-main-white">Забрать шаблон письма для руководителя </a>
                        <a href="#" class="btn-color-main-white">Оплатить сразу от юр.лица</a>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741088816737-v3uAC-Vect.svg" alt=""
                        class="position-absolute">
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('club40-tariffs2-tablet', {
        label: 'Club 4 tariffs2 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-tariffs-tablet club40-tariffs2-tablet">
            <div class="careerum-container-tablet">
                <div class="careerum-flex-fsc club40-tariffs-top-label">
                    <p>График<br> повышения цен: </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737370505194-JDWDp-Chec.svg" alt="" class="auto">
                    <p>15 февраля</p>
                    <p>17 февраля</p>
                    <p>19 февраля</p>
                    <p>22 февраля</p>
                </div>
                <h2 class="careerum-club40-header-tablet">Решите свою карьерную задачу с нами</h2>
                <div class="club40-tariffs-nav careerum-flex-sbfs">
                    <div class="club40-tariffs-period">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="1" class="active">30 дней</li>
                            <li data-period="3">90 дней</li>
                            <li data-period="6">180 дней</li>
                            <li data-period="12">365 дней</li>
                        </ul>
                    </div>
                </div>
                <div class="club40-tariffs-items careerum-flex-fsst">
                    <div class="careerum-flex-fsst">
                        <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                            data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                            data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽"
                            data-fullprice-12m-rub="77 880 ₽" data-price-1m-eur="149 €" data-price-3m-eur="120 €"
                            data-fullprice-3m-eur="360 €" data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €"
                            data-price-12m-eur="80 €" data-fullprice-12m-eur="960 €" data-offer-1m-rub="27"
                            data-offer-3m-rub="94" data-offer-6m-rub="95" data-offer-12m-rub="96" data-offer-1m-eur="48"
                            data-offer-3m-eur="97" data-offer-6m-eur="98" data-offer-12m-eur="99"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                            <p class="club40-tariffs-item-header">Доступ к карьерной платформе</p>
                            <p class="club40-tariffs-item-description">Неограниченное кол-во мест</p>
                            <ul class="collapsed">
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>80 карьерных курсов</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма, сообщения
                                        работодателям в LinkedIn, деловая email-переписка</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Воркфлоу поиска достижений </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Список платформ для поиска работы в 15 странах</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм, чтобы определить свою карьерную стадию </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Скрипт обсуждения зарплаты и оффера </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Формула расчета «Сколько я стою на рынке»
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм постановки карьерных гипотез
                                        для смены сферы</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Инструкция по созданию плана карьерного развития</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Методы постановки карьерных целей
                                    </p>
                                </li>
                            </ul>
                            <div class="tariffs-item-switcher careerum-flex-fsc">
                                <p>Показать больше</p>
                                <p>Свернуть</p>
                                <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733929611928-Z084c-Care.svg"
                                alt="">
                            </div>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-discount careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737368940097-5jGbI-Perc.svg" alt="">
                                    <p>Цена со скидкой на 1ый платеж</p>
                                </div>
                                <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                    <div>
                                        <p class="club40-tariffs-item-price-f">8 900 ₽</p>
                                    </div>
                                    <div>
                                        <p class="club40-tariffs-item-price-old">12 900 ₽</p>
                                    </div>
                                </div><a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Выбрать тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                            data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                            data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽"
                            data-fullprice-12m-rub="77 880 ₽" data-price-1m-eur="149 €" data-price-3m-eur="120 €"
                            data-fullprice-3m-eur="360 €" data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €"
                            data-price-12m-eur="80 €" data-fullprice-12m-eur="960 €" data-offer-1m-rub="27"
                            data-offer-3m-rub="94" data-offer-6m-rub="95" data-offer-12m-rub="96" data-offer-1m-eur="48"
                            data-offer-3m-eur="97" data-offer-6m-eur="98" data-offer-12m-eur="99"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                            <p class="club40-tariffs-item-header">Доступ к карьерной платформе</p>
                            <p class="club40-tariffs-item-description">Неограниченное кол-во мест</p>
                            <ul class="collapsed">
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>80 карьерных курсов</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма, сообщения
                                        работодателям в LinkedIn, деловая email-переписка</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Воркфлоу поиска достижений </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Список платформ для поиска работы в 15 странах</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм, чтобы определить свою карьерную стадию </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Скрипт обсуждения зарплаты и оффера </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Формула расчета «Сколько я стою на рынке»
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм постановки карьерных гипотез
                                        для смены сферы</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Инструкция по созданию плана карьерного развития</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Методы постановки карьерных целей
                                    </p>
                                </li>
                            </ul>
                            <div class="tariffs-item-switcher careerum-flex-fsc">
                                <p>Показать больше</p>
                                <p>Свернуть</p>
                                <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733929611928-Z084c-Care.svg"
                                alt="">
                            </div>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">310 €</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">930 €</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Выбрать
                                    тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="14 900 ₽" data-price-3m-rub="11&nbsp;633 ₽"
                            data-fullprice-3m-rub="34&nbsp;900 ₽" data-price-6m-rub="9&nbsp;817 ₽"
                            data-fullprice-6m-rub="58&nbsp;900 ₽" data-price-12m-rub="8 000 ₽"
                            data-fullprice-12m-rub="96 000 ₽" data-price-1m-eur="199 €" data-price-3m-eur="170 €"
                            data-fullprice-3m-eur="510 €" data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €"
                            data-price-12m-eur="100 €" data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="28"
                            data-offer-3m-rub="29" data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49"
                            data-offer-3m-eur="50" data-offer-6m-eur="51" data-offer-12m-eur="52"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-label">Популярный</p>
                            <p class="club40-tariffs-item-subheader2">Тариф «С поддержкой»</p>
                            <p class="club40-tariffs-item-header">Платформа +<br>групповой чат с экспертом</p>
                            <p class="club40-tariffs-item-description">Осталось: 25 мест</p>
                            <div class="club40-tariffs-item-divider"></div>
                            <p class="club40-tariffs-item-subheader">В тариф входят все опции тарифа «Самостоятельный»,
                                плюс:
                            </p>
                            <ul>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Групповой чат с экспертом и кураторами платформы</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>2 группые Q&A-встречи в месяц с экспертом для разбора вопросов</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Доступ к Сareerum.Club и всем ивентам клуба</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Доступ к сезонным Интенсивам </p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">310 €</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">930 €</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a onclick="" href="#subscribe-support"
                                    class="btn-color-main-dark-orange no-change">Оставить заявку</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="27 900 ₽" data-price-3m-rub="23&nbsp;900 ₽"
                            data-fullprice-3m-rub="71&nbsp;700 ₽" data-price-6m-rub="18&nbsp;317 ₽"
                            data-fullprice-6m-rub="109&nbsp;900 ₽" data-price-12m-rub="16&nbsp;583 ₽"
                            data-fullprice-12m-rub="199 000 ₽" data-price-1m-eur="360 €" data-price-3m-eur="310 €"
                            data-fullprice-3m-eur="930 €" data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €"
                            data-price-12m-eur="230 €" data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="32"
                            data-offer-3m-rub="100" data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53"
                            data-offer-3m-eur="103" data-offer-6m-eur="104" data-offer-12m-eur="105"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Индивидуальный подход»</p>
                            <p class="club40-tariffs-item-header">Платформа +<br>консультации с экспертом</p>
                            <p class="club40-tariffs-item-description">Осталось: 25 мест</p>
                            <div class="club40-tariffs-item-divider"></div>
                            <p class="club40-tariffs-item-subheader">В тариф входят все преимущества тарифа
                                «С&nbsp;поддержкой»,
                                плюс:</p>
                            <ul>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Персональная поддержка карьерного эксперта и коуча в чате</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>2 видеоконсультации в месяц с экспертом под ваш карьерный запрос </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Персональный разбор резюме<br> + 3 письменным фидбека по доработке</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Персональный разбор LinkedIn<br>+3 письменным фидбека<br>по доработке</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">310 €</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">930 €</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a onclick="" href="#subscribe-individual"
                                    class="btn-color-main-dark-orange no-change">Оставить заявку</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-curr">
                    <div class="club40-tariffs__swicher-block">
                        <div class="club40-tariffs__swicher-top">
                            <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="club40-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="club40-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom careerum-flex-sbfs">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733931610233-Rgii4-Vect.svg"
                            alt="">
                        <p class="club40-tariffs-bottom-header">Не знаете, с чего начать?</p>
                        <p class="club40-tariffs-bottom-subheader">Напишите нам — мы ответим на все вопросы и поможем выбрать лучшее решение под вашу цель</p>
                        <a href="#tg" class="btn-color-main-dark-blue careerum-flex-cc">
                            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                    fill="#C8DAEA" />
                                <path
                                    d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                    fill="#A9C6D8" />
                                <path
                                    d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                    fill="white" />
                            </svg>
                            <p>Написать в Telegram</p>
                        </a>
                    </div>
                    <div>
                        <div class="club40-tariffs-bottom-care">
                            <div class="careerum-flex-fsc">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-tariffs-bottom-care-name">Анна </p>
                                    <p class="club40-tariffs-bottom-care-position">Команда заботы Careerum</p>
                                </div>
                            </div>
                            <p class="club40-tariffs-bottom-care-descr">Добрый день! Построить карьеру мечты в одиночку
                                бывает непросто. Но мы рядом и приведем вас к заветной цели 💙</p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-bottom-pay position-relative">
                    <p class="club40-tariffs-bottom-pay-label position-absolute">20% скидка для<br> команд от 3 человек</p>
                    <p class="club40-tariffs-bottom-pay-title">Поможем оплатить<br>
                        подписку через работодателя</p>
                    <p class="club40-tariffs-bottom-pay-text">Мы подготовили шаблон письма для вашего руководителя, в
                        котором описали все плюшки подписки Сareerum и добавили специальные условия, если вы захотите
                        позвать коллег:)</p>
                    <div class="careerum-flex-fsfs">
                        <a href="#" class="btn-color-main-white">Забрать шаблон письма для руководителя </a>
                        <a href="#" class="btn-color-main-white">Оплатить сразу от юр.лица</a>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741088816737-v3uAC-Vect.svg" alt=""
                        class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741091581709-j6Etn-Vect.svg" alt=""
                        class="position-absolute hidden-desc-mobile">
                </div>
            </div>
        </div>`
    });
    
    blockManager.add('club40-tariffs2-mobile', {
        label: 'Club 4 tariffs2 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-tariffs-mobile club40-tariffs2-mobile">
            <div class="careerum-container-mobile">
                <div class="club40-tariffs-top-label">
                    <p>График повышения цен: </p><br>
                    <div class="careerum-flex-fsc ">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737379529099-NWB2Y-Chec.svg" alt="">
                        <p>15.02</p>
                        <p>17.02</p>
                        <p>19.02</p>
                        <p>22.02</p>
                    </div>
                </div>
                <h2 class="careerum-club40-header-mobile">Решите свою карьерную задачу с нами </h2>
                <div class="club40-tariffs-nav">
                    <div class="club40-tariffs-period">
                        <ul class="careerum-flex-fsfs">
                            <li data-period="1" class="active">30 дней</li>
                            <li data-period="3">90 дней</li>
                            <li data-period="6">180 дней</li>
                            <li data-period="12">365 дней</li>
                        </ul>
                    </div>
                </div>
                <div class="club40-tariffs-curr">
                    <div class="club40-tariffs__swicher-block">
                        <div class="club40-tariffs__swicher-top">
                            <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="club40-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                            </svg>
                        </div>
                        <div class="club40-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="club40-tariffs-items">
                        <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                            data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                            data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽"
                            data-fullprice-12m-rub="77 880 ₽" data-price-1m-eur="149 €" data-price-3m-eur="120 €"
                            data-fullprice-3m-eur="360 €" data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €"
                            data-price-12m-eur="80 €" data-fullprice-12m-eur="960 €" data-offer-1m-rub="27"
                            data-offer-3m-rub="94" data-offer-6m-rub="95" data-offer-12m-rub="96" data-offer-1m-eur="48"
                            data-offer-3m-eur="97" data-offer-6m-eur="98" data-offer-12m-eur="99"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                            <p class="club40-tariffs-item-header">Доступ к карьерной платформе</p>
                            <p class="club40-tariffs-item-description">Неограниченное кол-во мест</p>
                            <ul class="collapsed">
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>80 карьерных курсов</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма, сообщения
                                        работодателям в LinkedIn, деловая email-переписка</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Воркфлоу поиска достижений </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Список платформ для поиска работы в 15 странах</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм, чтобы определить свою карьерную стадию </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Скрипт обсуждения зарплаты и оффера </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Формула расчета «Сколько я стою на рынке»
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм постановки карьерных гипотез
                                        для смены сферы</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Инструкция по созданию плана карьерного развития</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Методы постановки карьерных целей
                                    </p>
                                </li>
                            </ul>
                            <div class="tariffs-item-switcher careerum-flex-fsc">
                                <p>Показать больше</p>
                                <p>Свернуть</p>
                                <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733929611928-Z084c-Care.svg"
                                alt="">
                            </div>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-discount careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737368940097-5jGbI-Perc.svg" alt="">
                                    <p>Цена со скидкой на 1-ый платеж</p>
                                </div>
                                <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                    <div>
                                        <p class="club40-tariffs-item-price-f">8 900 ₽</p>
                                    </div>
                                    <div>
                                        <p class="club40-tariffs-item-price-old">12 900 ₽</p>
                                    </div>
                                </div><a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Выбрать тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                            data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                            data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽"
                            data-fullprice-12m-rub="77 880 ₽" data-price-1m-eur="149 €" data-price-3m-eur="120 €"
                            data-fullprice-3m-eur="360 €" data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €"
                            data-price-12m-eur="80 €" data-fullprice-12m-eur="960 €" data-offer-1m-rub="27"
                            data-offer-3m-rub="94" data-offer-6m-rub="95" data-offer-12m-rub="96" data-offer-1m-eur="48"
                            data-offer-3m-eur="97" data-offer-6m-eur="98" data-offer-12m-eur="99"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Самостоятельный»</p>
                            <p class="club40-tariffs-item-header">Доступ к карьерной платформе</p>
                            <p class="club40-tariffs-item-description">Неограниченное кол-во мест</p>
                            <ul class="collapsed">
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>80 карьерных курсов</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма, сообщения
                                        работодателям в LinkedIn, деловая email-переписка</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Воркфлоу поиска достижений </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Список платформ для поиска работы в 15 странах</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм, чтобы определить свою карьерную стадию </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Скрипт обсуждения зарплаты и оффера </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Формула расчета «Сколько я стою на рынке»
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Алгоритм постановки карьерных гипотез
                                        для смены сферы</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Инструкция по созданию плана карьерного развития</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927490481-3vAu0-Chec.svg"
                                        alt="">
                                    <p>Методы постановки карьерных целей
                                    </p>
                                </li>
                            </ul>
                            <div class="tariffs-item-switcher careerum-flex-fsc">
                                <p>Показать больше</p>
                                <p>Свернуть</p>
                                <img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733929611928-Z084c-Care.svg"
                                alt="">
                            </div>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">310 €</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">930 €</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Выбрать
                                    тариф</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="14 900 ₽" data-price-3m-rub="11&nbsp;633 ₽"
                            data-fullprice-3m-rub="34&nbsp;900 ₽" data-price-6m-rub="9&nbsp;817 ₽"
                            data-fullprice-6m-rub="58&nbsp;900 ₽" data-price-12m-rub="8 000 ₽"
                            data-fullprice-12m-rub="96 000 ₽" data-price-1m-eur="199 €" data-price-3m-eur="170 €"
                            data-fullprice-3m-eur="510 €" data-price-6m-eur="130 €" data-fullprice-6m-eur="780 €"
                            data-price-12m-eur="100 €" data-fullprice-12m-eur="1 200 €" data-offer-1m-rub="28"
                            data-offer-3m-rub="29" data-offer-6m-rub="30" data-offer-12m-rub="31" data-offer-1m-eur="49"
                            data-offer-3m-eur="50" data-offer-6m-eur="51" data-offer-12m-eur="52"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-label">Популярный</p>
                            <p class="club40-tariffs-item-subheader2">Тариф «С поддержкой»</p>
                            <p class="club40-tariffs-item-header">Платформа +<br>групповой чат с экспертом</p>
                            <p class="club40-tariffs-item-description">Осталось: 25 мест</p>
                            <div class="club40-tariffs-item-divider"></div>
                            <p class="club40-tariffs-item-subheader">В тариф входят все опции тарифа «Самостоятельный»,
                                плюс:
                            </p>
                            <ul>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Групповой чат с экспертом и кураторами платформы</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>2 группые Q&A-встречи в месяц с экспертом для разбора вопросов</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Доступ к Сareerum.Club и всем ивентам клуба</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Доступ к сезонным Интенсивам </p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">310 €</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">930 €</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a onclick="" href="#subscribe-support"
                                    class="btn-color-main-dark-orange no-change">Оставить заявку</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="27 900 ₽" data-price-3m-rub="23&nbsp;900 ₽"
                            data-fullprice-3m-rub="71&nbsp;700 ₽" data-price-6m-rub="18&nbsp;317 ₽"
                            data-fullprice-6m-rub="109&nbsp;900 ₽" data-price-12m-rub="16&nbsp;583 ₽"
                            data-fullprice-12m-rub="199 000 ₽" data-price-1m-eur="360 €" data-price-3m-eur="310 €"
                            data-fullprice-3m-eur="930 €" data-price-6m-eur="250 €" data-fullprice-6m-eur="1 500 €"
                            data-price-12m-eur="230 €" data-fullprice-12m-eur="2 760 €" data-offer-1m-rub="32"
                            data-offer-3m-rub="100" data-offer-6m-rub="101" data-offer-12m-rub="102" data-offer-1m-eur="53"
                            data-offer-3m-eur="103" data-offer-6m-eur="104" data-offer-12m-eur="105"
                            class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Индивидуальный подход»</p>
                            <p class="club40-tariffs-item-header">Платформа +<br>консультации с экспертом</p>
                            <p class="club40-tariffs-item-description">Осталось: 25 мест</p>
                            <div class="club40-tariffs-item-divider"></div>
                            <p class="club40-tariffs-item-subheader">В тариф входят все преимущества тарифа
                                «С&nbsp;поддержкой»,
                                плюс:</p>
                            <ul>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Персональная поддержка карьерного эксперта и коуча в чате</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>2 видеоконсультации в месяц с экспертом под ваш карьерный запрос </p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Персональный разбор резюме<br> + 3 письменным фидбека по доработке</p>
                                </li>
                                <li class="careerum-flex-fsfs"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733927796778-lS80O-Fram.svg"
                                        alt="">
                                    <p>Персональный разбор LinkedIn<br>+3 письменным фидбека<br>по доработке</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-wrapper-price">
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-pm">310 €</p>
                                        <p class="club40-tariffs-item-price-pmn1m">цена месяца в&nbsp;пакете</p>
                                        <p class="club40-tariffs-item-price-pm1m">в месяц</p>
                                    </div>
                                    <div class="careerum-flex-fsfs">
                                        <p class="club40-tariffs-item-price-f">930 €</p>
                                        <p>полная стоимость к оплате</p>
                                    </div>
                                </div>
                                <a onclick="" href="#subscribe-individual"
                                    class="btn-color-main-dark-orange no-change">Оставить заявку</a>
                                <p class="club40-tariffs-item-price-rassr-eur" style="">Можно платить долями</p>
                                <p class="club40-tariffs-item-price-rassr-rub" style="display: none;">Можно в рассрочку</p>
                            </div>
                        </div>
                </div>
                <div class="club40-tariffs-bottom">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733936419948-QhCyw-Vect.svg"
                            alt="">
                        <p class="club40-tariffs-bottom-header">Не знаете, с чего начать?</p>
                        <p class="club40-tariffs-bottom-subheader">Напишите нам — мы ответим на все вопросы и поможем
                            выбрать решение под вашу задачу</p>
                    </div>
                    <div>
                        <div class="club40-tariffs-bottom-care">
                            <div class="careerum-flex-fsc">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                        alt="">
                                </div>
                                <div>
                                    <p class="club40-tariffs-bottom-care-name">Анна </p>
                                    <p class="club40-tariffs-bottom-care-position">Команда заботы Careerum</p>
                                </div>
                            </div>
                            <p class="club40-tariffs-bottom-care-descr">Добрый день! Построить карьеру мечты в одиночку
                                бывает непросто. Но мы рядом и приведем вас к заветной цели 💙</p>
                        </div>
                        <a href="#tg" class="btn-color-main-dark-blue careerum-flex-cc">
                            <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                    fill="#C8DAEA" />
                                <path
                                    d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                    fill="#A9C6D8" />
                                <path
                                    d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                    fill="white" />
                            </svg>
                            <p>Написать нам в Telegram</p>
                        </a>
                    </div>
                </div>
                <div class="club40-tariffs-bottom-pay position-relative">
                    <p class="club40-tariffs-bottom-pay-title">Поможем оплатить
                        подписку через работодателя</p>
                    <p class="club40-tariffs-bottom-pay-text">Мы подготовили шаблон письма для вашего руководителя, в
                        котором описали все плюшки подписки Сareerum и добавили специальные условия, если вы захотите
                        позвать коллег:)</p>
                    <p class="club40-tariffs-bottom-pay-label position-relative">20% скидка для<br> команд от 3 человек</p>
                    <div class="careerum-flex-fsfs">
                        <a href="#" class="btn-color-main-white">Забрать шаблон письма для руководителя </a>
                        <a href="#" class="btn-color-main-white">Оплатить сразу от юр.лица</a>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741088816737-v3uAC-Vect.svg" alt=""
                        class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741091581709-j6Etn-Vect.svg" alt=""
                        class="position-absolute hidden-desc-mobile">
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-results', {
        label: 'Club 4 results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-club40-results main-wrapper">
            <div class="careerum-container-responsive">
                <h2 >
                    Результаты, которые достигли наши клиенты
                </h2>
                <div class="club40-results-slider">
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422853-o2LIn-Grou.png"
                                    alt="">
                                <a href="#1" class="position-absolute">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                        <path
                                            d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                            fill="white" />
                                        <path
                                            d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                            fill="white" />
                                        <path
                                            d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                            fill="white" />
                                    </svg>
                                </a>
                            </div>
                            <div>
                                <p>Сергей Михайлов</p>
                                <p>Technical Transfer Lead, Австрия</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Хотел найти работу проджет-менеджера в международной компании и переехать в Западную Европу</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошел Real Me, «Звёздного кандидата», проработал резюме и составил стратегию</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получил оффер c релокацией в Австрию весной 2022 года, увеличил доход в 3 раза</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116421826-n9oaA-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Александра Пинчукова</p>
                                <p>менеджер бизнес-процессов, Германия</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Работала главным бухгалтером. Хотела найти работу в Германии и переехать</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошла «Звёздного кандидата», курсы по LinkedIn и самооценку, работала с коучем и CV-специалистом</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получила оффер в штаб-квартиру Puma в начале 2023 года – после 3 месяцев поиска</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422118-nici9-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Сергей Бухаров</p>
                                <p>Supply Chain Forecast Analyst, Нидерланды</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Уволился из Mars весной 2022 года, так как не смог договориться о релокации, переехал из России в Грузию</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошел курс Real Me, персонально работал с экспертом клуба, составил стратегию</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получил оффер от Mars с релокацией в Нидерланды в середине 2022 года</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422236-vLdYI-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Карина Пысина</p>
                                <p>бизнес-аналитик, Россия</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Пыталась перейти в бизнес-анализ из клиентского отдела, но не смогла и уволилась вникуда</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошла Real Me, «Звёздного кандидата», работала с коучем, составила продающее резюме</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получила оффер бизнес-аналитика, зарплату на 100% выше в 2022 году</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422371-2l7A2-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Тая Штоль</p>
                                <p>UX/UI-дизайнер, Испания</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Потеряла всех клиентов из России в феврале 2022 года. Хотела в найм, но опыт был только во фрилансе</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошла программы «Звёздный кандидат» и «Выход из декрета», работала с коучем</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получила оффер в немецкую компанию. Увеличила доход в 6 раз, получила соцпакет</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422492-aq4aa-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Евгения Вольхина</p>
                                <p>Project Manager, Германия</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Работала консультантом-методологом в Екатеринбурге. Хотела стать project manager в Германии</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошла «Звёздного кандидата», прокачала CV, выстроила нетворк</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получила оффер в Big4 в Москве и зарплату в 3,5 раза больше, потом – оффер в Германию с ростом ещё на 40%</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422621-VPn05-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Олег Федоткин</p>
                                <p>Head of Department, Германия</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Не мог найти работу в Германии, не хотел возвращаться в Москву после окончания контракта Henkel</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошел Real Me, составил стратегию, прорабатывал запрос в паре с участником клуба</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получил оффер на head-позицию с ростом зарплаты на 30% в начале 2022 года</p>
                        </div>
                    </div>
                    <div class="club40-results-slider-item">
                        <div class="careerum-flex-fsc">
                            <div class="position-relative">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723116422737-07i7D-Grou.png"
                                    alt="">
                                    <a href="#1" class="position-absolute">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="16" fill="#00BAFF" />
                                            <path
                                                d="M17.227 13.3841C17.7811 12.6708 18.4708 12.2227 19.3492 12.1343C21.1472 11.9575 22.5443 12.7562 23.013 14.6338C23.125 15.0789 23.178 15.5505 23.1839 16.0103C23.2046 17.5902 23.1869 19.1701 23.1987 20.7529C23.2016 21.0241 23.1191 21.1037 22.8509 21.0978C22.0992 21.0801 21.3447 21.0919 20.593 21.0919C20.2069 21.0919 20.204 21.0919 20.204 20.7146C20.204 19.2821 20.2069 17.8525 20.201 16.42C20.201 16.1695 20.1863 15.919 20.1391 15.6743C20.036 15.1054 19.7648 14.6545 19.1605 14.5159C18.5003 14.3685 17.9521 14.5719 17.5453 15.1202C17.3007 15.4473 17.2299 15.8276 17.2299 16.2255C17.227 17.7228 17.2299 19.2202 17.2299 20.7146C17.2299 20.8236 17.2299 20.9357 17.2299 21.0624C17.1356 21.0742 17.0649 21.0919 16.9941 21.0919C16.1747 21.0948 15.3582 21.086 14.5388 21.0978C14.3207 21.1007 14.2765 21.0182 14.2794 20.8207C14.2853 18.0795 14.2853 15.3353 14.2794 12.5941C14.2794 12.3672 14.359 12.3023 14.5683 12.3053C15.3582 12.3112 16.1482 12.3141 16.9381 12.3053C17.1739 12.3023 17.2476 12.3908 17.2329 12.6148C17.2152 12.8653 17.227 13.1247 17.227 13.3841Z"
                                                fill="white" />
                                            <path
                                                d="M12.7564 16.7155C12.7564 18.0536 12.7505 19.3918 12.7623 20.7329C12.7653 21.01 12.6916 21.1043 12.4027 21.0955C11.6305 21.0749 10.8582 21.0808 10.0889 21.0925C9.85309 21.0955 9.76172 21.0395 9.76172 20.786C9.77056 18.0625 9.77056 15.339 9.76172 12.6125C9.76172 12.362 9.85604 12.2942 10.0889 12.2971C10.87 12.3059 11.6511 12.3089 12.4322 12.2971C12.6975 12.2912 12.7623 12.3973 12.7594 12.6449C12.7505 14.0008 12.7564 15.3596 12.7564 16.7155Z"
                                                fill="white" />
                                            <path
                                                d="M12.9303 9.67361C12.9303 10.552 12.2229 11.2034 11.2591 11.2093C10.3188 11.2152 9.59961 10.5431 9.59961 9.65887C9.59961 8.76871 10.3277 8.10257 11.2915 8.11142C12.2465 8.11731 12.9303 8.76871 12.9303 9.67361Z"
                                                fill="white" />
                                        </svg>
                                    </a>
                            </div>
                            <div>
                                <p>Людмила Киселёва</p>
                                <p>Recruiter ll, США</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Приехала в США как турист, осталась там, работала ассистентом. Хотела начать карьеру в корпорации</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Прошла курсы «Продающее резюме»<br> и «Эффективное интервью».</p>
                        </div>
                        <div class="careerum-flex-fsfs">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733917264234-b6sFK-4275.svg"
                                alt="">
                            <p>Получила оффер ассистента в Microsoft, через год стала рекрутером в Transocean</p>
                        </div>
                    </div>
                </div>
                <div class="club40-results-slider-nav careerum-flex-fec">
                    <div class="club40-results-slider-nav-prev">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_9432_18847)">
                                <g filter="url(#filter0_b_9432_18847)">
                                    <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" fill="black" />
                                </g>
                                <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_9432_18847" x="-18.1166" y="-18.1166" width="76.2332"
                                    height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in"
                                        result="effect1_backgroundBlur_9432_18847" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18847"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_9432_18847">
                                    <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)"
                                        fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <div class="club40-results-slider-nav-next">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_9432_18851)">
                                <g filter="url(#filter0_b_9432_18851)">
                                    <rect x="40" width="40" height="40" transform="rotate(90 40 0)" fill="black" />
                                </g>
                                <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_b_9432_18851" x="-18.1166" y="-18.1166" width="76.2332"
                                    height="76.2332" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.05831" />
                                    <feComposite in2="SourceAlpha" operator="in"
                                        result="effect1_backgroundBlur_9432_18851" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9432_18851"
                                        result="shape" />
                                </filter>
                                <clipPath id="clip0_9432_18851">
                                    <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)"
                                        fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-club40-schedule', {
        label: 'Club 4 schedule (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club40-schedule main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Расписание Careerum 2025</h2>
            <div class="club40-schedule-items careerum-flex-sbst">
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 11 января </p>
                    </div>
                    <p class="club40-schedule-item-header">Карьерные цели на 2025 </p>
                    <p class="club40-schedule-item-subheader">Поставьте карьерные цели с учетом рыночных реалий и
                        синхронизируйте их с бизнес-целями компании</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 19 февраля </p>
                    </div>
                    <p class="club40-schedule-item-header">Звёздный кандидат</p>
                    <p class="club40-schedule-item-subheader">Интенсив по поиску работы в СНГ и за рубежом. Быстрый путь
                        к офферу за 3 месяца с профессиональной поддержкой </p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 23 марта </p>
                    </div>
                    <p class="club40-schedule-item-header">Коммуникация на работе: управляй руководителем и коллегами
                    </p>
                    <p class="club40-schedule-item-subheader">Как строить личные границы, решать конфликты экологично и
                        достигать своих целей в переговорах</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 17 апреля </p>
                    </div>
                    <p class="club40-schedule-item-header">Релокация и поиск работы за рубежом</p>
                    <p class="club40-schedule-item-subheader">Интенсив по поиску работы за границей, определите страну и
                        способ переезда — построите свою стратегию для получения оффера в новой географии</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 20 мая </p>
                    </div>
                    <p class="club40-schedule-item-header">Самооценка и деньги</p>
                    <p class="club40-schedule-item-subheader">Научитесь опираться на себя и свою ценность, сможете
                        спокойно и уверенно называть стоимость своей работы</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 17 июня </p>
                    </div>
                    <p class="club40-schedule-item-header">Карьерный кризис</p>
                    <p class="club40-schedule-item-subheader">Определите, чего вы хотите для своей карьеры, какие
                        суперсилы у вас есть и как всё это соотнести с потребностями рынка</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 18 июля</p>
                    </div>
                    <p class="club40-schedule-item-header">Декрет и перерыв в работе</p>
                    <p class="club40-schedule-item-subheader">Как подготовиться на работе, как не потерять себя в
                        декрете, как преодолеете страхи при выходе на работу. Узнаете, как вернуться к работе в
                        бережном, но не менее эффективном режиме </p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 15 августа</p>
                    </div>
                    <p class="club40-schedule-item-header">Рефреш целей</p>
                    <p class="club40-schedule-item-subheader">Определите, чего вы хотите для своей карьеры, какие
                        суперсилы у вас есть и как всё это соотнести с потребностями рынка</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 8 сентября</p>
                    </div>
                    <p class="club40-schedule-item-header">Звёздный кандидат</p>
                    <p class="club40-schedule-item-subheader">Интенсив по поиску работы в СНГ и за рубежом. Быстрый путь
                        к офферу за 3 месяца с профессиональной поддержкой </p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 16 октября </p>
                    </div>
                    <p class="club40-schedule-item-header">Хочу стать руководителем</p>
                    <p class="club40-schedule-item-subheader">Вы освоите самые важные навыки руководителя, изучите
                        лайфхаки по взаимодействию в кросс-функциональных командах</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 10 ноября</p>
                    </div>
                    <p class="club40-schedule-item-header">Карьерная ракета</p>
                    <p class="club40-schedule-item-subheader">Узнаете, как расти в зарплате и роли и научитесь
                        планировать и добиваться даже самых амбициозных целей</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 10 декабря </p>
                    </div>
                    <p class="club40-schedule-item-header">Подводим итоги года</p>
                    <p class="club40-schedule-item-subheader">Подведете итоги своего продуктивного года и успехов в
                        карьере</p>
                </div>
            </div>
            <div class="club40-schedule-items-slider careerum-flex-sbst">
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 11 января </p>
                    </div>
                    <p class="club40-schedule-item-header">Карьерные цели на 2025 </p>
                    <p class="club40-schedule-item-subheader">Поставьте карьерные цели с учетом рыночных реалий и
                        синхронизируйте их с бизнес-целями компании</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 19 февраля </p>
                    </div>
                    <p class="club40-schedule-item-header">Звёздный кандидат</p>
                    <p class="club40-schedule-item-subheader">Интенсив по поиску работы в СНГ и за рубежом. Быстрый путь
                        к офферу за 3 месяца с профессиональной поддержкой </p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 23 марта </p>
                    </div>
                    <p class="club40-schedule-item-header">Коммуникация на работе: управляй руководителем и коллегами
                    </p>
                    <p class="club40-schedule-item-subheader">Как строить личные границы, решать конфликты экологично и
                        достигать своих целей в переговорах</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 17 апреля </p>
                    </div>
                    <p class="club40-schedule-item-header">Релокация и поиск работы за рубежом</p>
                    <p class="club40-schedule-item-subheader">Интенсив по поиску работы за границей, определите страну и
                        способ переезда — построите свою стратегию для получения оффера в новой географии</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 20 мая </p>
                    </div>
                    <p class="club40-schedule-item-header">Самооценка и деньги</p>
                    <p class="club40-schedule-item-subheader">Научитесь опираться на себя и свою ценность, сможете
                        спокойно и уверенно называть стоимость своей работы</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 17 июня </p>
                    </div>
                    <p class="club40-schedule-item-header">Карьерный кризис</p>
                    <p class="club40-schedule-item-subheader">Определите, чего вы хотите для своей карьеры, какие
                        суперсилы у вас есть и как всё это соотнести с потребностями рынка</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 18 июля</p>
                    </div>
                    <p class="club40-schedule-item-header">Декрет и перерыв в работе</p>
                    <p class="club40-schedule-item-subheader">Как подготовиться на работе, как не потерять себя в
                        декрете, как преодолеете страхи при выходе на работу. Узнаете, как вернуться к работе в
                        бережном, но не менее эффективном режиме </p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 15 августа</p>
                    </div>
                    <p class="club40-schedule-item-header">Рефреш целей</p>
                    <p class="club40-schedule-item-subheader">Определите, чего вы хотите для своей карьеры, какие
                        суперсилы у вас есть и как всё это соотнести с потребностями рынка</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 8 сентября</p>
                    </div>
                    <p class="club40-schedule-item-header">Звёздный кандидат</p>
                    <p class="club40-schedule-item-subheader">Интенсив по поиску работы в СНГ и за рубежом. Быстрый путь
                        к офферу за 3 месяца с профессиональной поддержкой </p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 16 октября </p>
                    </div>
                    <p class="club40-schedule-item-header">Хочу стать руководителем</p>
                    <p class="club40-schedule-item-subheader">Вы освоите самые важные навыки руководителя, изучите
                        лайфхаки по взаимодействию в кросс-функциональных командах</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 10 ноября</p>
                    </div>
                    <p class="club40-schedule-item-header">Карьерная ракета</p>
                    <p class="club40-schedule-item-subheader">Узнаете, как расти в зарплате и роли и научитесь
                        планировать и добиваться даже самых амбициозных целей</p>
                </div>
                <div class="club40-schedule-item">
                    <div class="careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737665347817-RFdZt-Cale.svg"
                            alt="">
                        <p>Старт 10 декабря </p>
                    </div>
                    <p class="club40-schedule-item-header">Подводим итоги года</p>
                    <p class="club40-schedule-item-subheader">Подведете итоги своего продуктивного года и успехов в
                        карьере</p>
                </div>
            </div>
            <div class="club40-schedule-link">
                <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-club40-banner-top', {
        label: 'Club 4 banner-top (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club40-banner-top position-absolute" data-href="#buy" data-timer="no" data-redirect="no"
        data-url="" data-static="yes" data-offset="" data-timer-end="02/24/2025 12:00 GMT+0300" data-theme="light">
        <div>
            <div class="club40-banner-bg position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737661896849-oSmQ4-bulb.png" alt=""
                    class="hidden-tablet-mobile position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737661913259-Qlmap-file.png" alt=""
                    class="hidden-tablet-mobile position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737661960821-rZb6v-Grou.png" alt=""
                    class="hidden-desc-mobile position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737661952376-pRpSK-Grou.png" alt=""
                    class="hidden-desc-tablet position-absolute">
            </div>
            <div class="club40-banner-top careerum-flex-fsc">
                <div class="club40-banner-top-left">
                    <p class="club40-banner-top-sunheader">Старт 19 февраля</p>
                    <p class="club40-banner-top-header">Идет набор на интенсив по поиску работы Получи оффер мечты уже
                        этой весной!</p>
                </div>
                <div class="club40-banner-top-center careerum-flex-fsc">
                    <div class="banner-top-timer careerum-flex-sbfs">
                        <div>
                            <p class="timer-day-number">00</p>
                            <p class="timer-day-text"></p>
                        </div>
                        <div>
                            <p class="timer-hour-number">00</p>
                            <p class="timer-hour-text"></p>
                        </div>
                        <div>
                            <p class="timer-min-number">00</p>
                            <p class="timer-min-text"></p>
                        </div>
                    </div>
                </div>
                <div class="club40-banner-top-right">
                    <a href="#buy" class="btn-color-main-dark-blue">Узнать подробнее</a>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-club40-goals-slider', {
        label: 'Club 4 goals-slider (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-club40-goals-slider main-wrapper">
        <div class="careerum-container-responsive">
            <h2 class="careerum-club40-header">Careerum для вас, если:</h2>
            <div class="club40-goals-tales careerum-flex-fsfs">
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>У вас высокая квалифицикация, но сомневаетесь в своих силах</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Более 3 месяцев ищете работу, но откликов мало, а вакансии не радуют</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Классно справляетесь с задачами, но обычно повышают не вас</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Впервые ищете работу или выходите на первую роль в новой стране</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Каждый год меняете компанию, надеясь, что на новом месте будет лучше</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Вам сложно обсуждать деньги, условия и предлагать свои условия в работе</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Наваливаете на себя кучу проектов и ждете, что руководитель сам заметит ваши результаты</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>У вас нет четкого понимания своих сильных сторон и куда развиваться</p>
                </div>
                <div class="club40-goals-tale careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737668239851-P9zPK-Vect.svg"
                        alt="" class="hidden-desc">
                    <p>Регулярно выгораете, раз в год или чаще меняете работу или уходите в творческий отпуск</p>
                </div>
            </div>
            <div class="club40-goals-nav careerum-flex-fec">
                <div class="club40-goals-nav-prev careerum-flex-cc ">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="club40-goals-nav-next careerum-flex-cc">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-course40-main', {
        label: 'Course 4 main',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-main">
            <div class="careerum-container-desc">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726050859214-4P2O8-Elli.png" alt="">
                <div class="course40-main-top careerum-flex-fsfs">
                    <div class="course40-main-label careerum-flex-fsc">
                        <p>Флагманский курс Careerum</p>
                    </div>
                    <div class="course40-main-label careerum-flex-fsc">
                        <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5034 4.74306L4.50342 4.75688C4.0892 4.75726 3.75373 5.09335 3.75411 5.50757L3.76793 20.5076C3.76831 20.9218 4.10441 21.2573 4.51862 21.2569L19.5186 21.2431C19.9328 21.2427 20.2683 20.9066 20.2679 20.4924L20.2541 5.49237C20.2537 5.07815 19.9176 4.74268 19.5034 4.74306Z"
                                stroke="black" stroke-width="1.7825" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16.502 3.24585L16.5047 6.24585" stroke="black" stroke-width="1.7825"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.50195 3.25415L7.50472 6.25415" stroke="black" stroke-width="1.7825"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.75732 9.25757L20.2573 9.24237" stroke="black" stroke-width="1.7825"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.3862 12.997L11.0119 17.126L8.63796 14.8782" stroke="black" stroke-width="1.7825"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Старт: 8 октября</p>
                    </div>
                </div>
                <div class="course40-main-center careerum-flex-fsfs">
                    <div>
                        <h1>Наука счастья: как жить и работать по любви</h1>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726035652277-6HFSP-Grou.svg"
                            alt="">
                        <p>Курс о том, как найти и поддерживать мотивацию, чтобы никогда больше<br> не выгорать</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <svg width="37" height="44" viewBox="0 0 37 44" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_di_364_995)">
                                        <path
                                            d="M17.0126 5.69061C16.9094 5.16464 16.33 5.22554 16.3383 5.76148L16.409 10.2575C16.5003 16.063 13.5664 20.9562 9.31252 22.0933L6.01812 22.9739C5.62538 23.0789 5.70636 23.8494 6.11236 23.8705L9.51785 24.0469C13.9152 24.2747 17.8023 28.451 18.9201 34.1486L19.7857 38.561C19.8889 39.0871 20.4684 39.0262 20.46 38.4902L20.3893 33.9941C20.2981 28.1886 23.2319 23.2955 27.4859 22.1584L30.7803 21.2778C31.173 21.1727 31.092 20.4023 30.686 20.3812L27.2805 20.2048C22.8831 19.977 18.996 15.8007 17.8783 10.1031L17.0126 5.69061Z"
                                            fill="#F9F9F9" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_di_364_995" x="0.713428" y="0.277515" width="35.3715"
                                            height="43.6967" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="2.52439" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.934668 0 0 0 0 0.74877 0 0 0 0 0.270771 0 0 0 1 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_364_995" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_364_995"
                                                result="shape" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="2.88502" />
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_364_995" />
                                        </filter>
                                    </defs>
                                </svg>
                                <p>Личная работа с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <svg width="37" height="44" viewBox="0 0 37 44" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_di_364_995)">
                                        <path
                                            d="M17.0126 5.69061C16.9094 5.16464 16.33 5.22554 16.3383 5.76148L16.409 10.2575C16.5003 16.063 13.5664 20.9562 9.31252 22.0933L6.01812 22.9739C5.62538 23.0789 5.70636 23.8494 6.11236 23.8705L9.51785 24.0469C13.9152 24.2747 17.8023 28.451 18.9201 34.1486L19.7857 38.561C19.8889 39.0871 20.4684 39.0262 20.46 38.4902L20.3893 33.9941C20.2981 28.1886 23.2319 23.2955 27.4859 22.1584L30.7803 21.2778C31.173 21.1727 31.092 20.4023 30.686 20.3812L27.2805 20.2048C22.8831 19.977 18.996 15.8007 17.8783 10.1031L17.0126 5.69061Z"
                                            fill="#F9F9F9" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_di_364_995" x="0.713428" y="0.277515" width="35.3715"
                                            height="43.6967" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="2.52439" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.934668 0 0 0 0 0.74877 0 0 0 0 0.270771 0 0 0 1 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_364_995" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_364_995"
                                                result="shape" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="2.88502" />
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_364_995" />
                                        </filter>
                                    </defs>
                                </svg>
                                <p>В основе: 200+ исследований и методики<br> Гарварда</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726047277007-RgvCH-Fram.png"
                            alt="" class="course40-main-photo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726047243228-8QJbr-Grou.svg"
                            alt="" class="course40-main-decor">
                    </div>
                </div>
                <h2 class="careerum-club40-header">Кому подойдет этот курс</h2>
                <div class="course40-goals-tales careerum-flex-fsfs">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Руководителям, CEO, <br>топ-менеджерам </p>
                    </div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Предпринимателям<br>Фаундерам стартапов</p>
                    </div>
                    <div class="course40-goals-tale-rotate-right"><img
                            src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723110817980-Y5ocA-Vect.svg"
                            alt="">
                        <p>Middle и Senior-специалистам,<br> тим-лидам</p>
                    </div>
                </div>
                <div class="course40-main-link">
                    <a href="#program" class="btn-color-main-black">Посмотреть программу</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-main-tablet', {
        label: 'Course 4 main (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-main-tablet">
            <div class="careerum-container-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064210085-v3zGQ-Elli.png" alt="">
                <div class="course40-main-top careerum-flex-fsfs">
                    <div class="course40-main-label careerum-flex-fsc">
                        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.5215 2.8125H4.27148C3.96082 2.8125 3.70898 3.06434 3.70898 3.375V14.625C3.70898 14.9357 3.96082 15.1875 4.27148 15.1875H15.5215C15.8321 15.1875 16.084 14.9357 16.084 14.625V3.375C16.084 3.06434 15.8321 2.8125 15.5215 2.8125Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.2715 1.6875V3.9375" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M6.52148 1.6875V3.9375" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M3.70898 6.1875H16.084" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M12.4277 9L9.14414 12.0937L7.36523 10.4062" stroke="black" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p><span>Старт: 8 октября</span></p>
                    </div>
                    <div class="course40-main-label careerum-flex-fsc">
                        <p>Флагманский курс Careerum</p>
                    </div>
                </div>
                <div class="course40-main-center careerum-flex-fsfs">
                    <div>
                        <h2>Наука счастья: как жить и работать по любви</h2>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051137027-gfpcc-Grou.svg"
                            alt="">
                        <p>Курс о том, как найти и поддерживать мотивацию, чтобы никогда больше<br> не выгорать</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <svg width="21" height="26" viewBox="0 0 21 26" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_di_425_1111)">
                                        <path
                                            d="M9.4445 3.96717C9.38544 3.66627 9.05395 3.70111 9.05875 4.00772L9.09918 6.57981C9.15139 9.90108 7.47298 12.7004 5.03939 13.3509L3.15472 13.8547C2.93004 13.9148 2.97636 14.3555 3.20863 14.3676L5.15685 14.4685C7.67252 14.5988 9.89625 16.988 10.5357 20.2475L11.0309 22.7718C11.09 23.0727 11.4215 23.0379 11.4167 22.7313L11.3763 20.1592C11.324 16.8379 13.0025 14.0386 15.4361 13.3881L17.3207 12.8843C17.5454 12.8243 17.4991 12.3835 17.2668 12.3714L15.3186 12.2705C12.8029 12.1402 10.5792 9.75101 9.93972 6.49147L9.4445 3.96717Z"
                                            fill="#F9F9F9" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_di_425_1111" x="0.119487" y="0.870464" width="20.2356"
                                            height="24.9981" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.44416" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.934668 0 0 0 0 0.74877 0 0 0 0 0.270771 0 0 0 1 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_425_1111" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_425_1111"
                                                result="shape" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.65047" />
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_425_1111" />
                                        </filter>
                                    </defs>
                                </svg>
                                <p>Личная работа с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <svg width="21" height="26" viewBox="0 0 21 26" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_di_425_1111)">
                                        <path
                                            d="M9.4445 3.96717C9.38544 3.66627 9.05395 3.70111 9.05875 4.00772L9.09918 6.57981C9.15139 9.90108 7.47298 12.7004 5.03939 13.3509L3.15472 13.8547C2.93004 13.9148 2.97636 14.3555 3.20863 14.3676L5.15685 14.4685C7.67252 14.5988 9.89625 16.988 10.5357 20.2475L11.0309 22.7718C11.09 23.0727 11.4215 23.0379 11.4167 22.7313L11.3763 20.1592C11.324 16.8379 13.0025 14.0386 15.4361 13.3881L17.3207 12.8843C17.5454 12.8243 17.4991 12.3835 17.2668 12.3714L15.3186 12.2705C12.8029 12.1402 10.5792 9.75101 9.93972 6.49147L9.4445 3.96717Z"
                                            fill="#F9F9F9" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_di_425_1111" x="0.119487" y="0.870464" width="20.2356"
                                            height="24.9981" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.44416" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.934668 0 0 0 0 0.74877 0 0 0 0 0.270771 0 0 0 1 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_425_1111" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_425_1111"
                                                result="shape" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.65047" />
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_425_1111" />
                                        </filter>
                                    </defs>
                                </svg>
                                <p>В основе: 200+ исследований<br> и методики Гарварда</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726050611332-czJMK-Fram.png"
                            alt="" class="course40-main-photo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051342566-R4UtQ-Grou.svg"
                            alt="" class="course40-main-decor">
                        <div>
                            <p>Автор: Ольга Лермонтова, фаундер Careerum, карьерный коуч, ex топ-менеджер Google, Microsoft,
                                Intel</p>
                        </div>
                    </div>
                </div>
                <h2>Кому подойдет этот курс</h2>
                <div class="course40-goals-tales careerum-flex-fsst">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051495630-Z6SnH-Vect.svg"
                            alt="">
                        <p>Руководителям, CEO, <br>топ-менеджерам </p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051495630-Z6SnH-Vect.svg"
                            alt="">
                        <p>Предпринимателям,<br>фаундерам стартапов</p>
                    </div>
                    <div class="course40-goals-tale-rotate-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051495630-Z6SnH-Vect.svg"
                            alt="">
                        <p>Middle и Senior-специалистам, тим-лидам</p>
                    </div>
                </div>
                <div class="course40-main-link">
                    <a href="#program" class="btn-color-main-black">Посмотреть программу</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-main-mobile', {
        label: 'Course 4 main (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-main-mobile">
            <div class="careerum-container-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726069479663-wocTl-Elli.png" alt="">
                <div class="course40-main-top careerum-flex-fsfs">
                    <div class="course40-main-label careerum-flex-fsc">
                        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.5215 2.8125H4.27148C3.96082 2.8125 3.70898 3.06434 3.70898 3.375V14.625C3.70898 14.9357 3.96082 15.1875 4.27148 15.1875H15.5215C15.8321 15.1875 16.084 14.9357 16.084 14.625V3.375C16.084 3.06434 15.8321 2.8125 15.5215 2.8125Z"
                                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M13.2715 1.6875V3.9375" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M6.52148 1.6875V3.9375" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M3.70898 6.1875H16.084" stroke="black" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M12.4277 9L9.14414 12.0937L7.36523 10.4062" stroke="black" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p><span>Старт: 8 октября</span></p>
                    </div>
                    <div class="course40-main-label careerum-flex-fsc">
                        <p>Флагманский курс Careerum</p>
                    </div>
                </div>
                <div class="course40-main-center">
                    <div>
                        <h2>Наука счастья: как жить и работать по любви</h2>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726069691779-GE4Xn-Grou.svg"
                            alt="">
                        <p>Курс о том, как найти и поддерживать мотивацию, чтобы никогда больше<br> не выгорать</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <svg width="21" height="26" viewBox="0 0 21 26" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_di_425_1111)">
                                        <path
                                            d="M9.4445 3.96717C9.38544 3.66627 9.05395 3.70111 9.05875 4.00772L9.09918 6.57981C9.15139 9.90108 7.47298 12.7004 5.03939 13.3509L3.15472 13.8547C2.93004 13.9148 2.97636 14.3555 3.20863 14.3676L5.15685 14.4685C7.67252 14.5988 9.89625 16.988 10.5357 20.2475L11.0309 22.7718C11.09 23.0727 11.4215 23.0379 11.4167 22.7313L11.3763 20.1592C11.324 16.8379 13.0025 14.0386 15.4361 13.3881L17.3207 12.8843C17.5454 12.8243 17.4991 12.3835 17.2668 12.3714L15.3186 12.2705C12.8029 12.1402 10.5792 9.75101 9.93972 6.49147L9.4445 3.96717Z"
                                            fill="#F9F9F9" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_di_425_1111" x="0.119487" y="0.870464" width="20.2356"
                                            height="24.9981" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.44416" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.934668 0 0 0 0 0.74877 0 0 0 0 0.270771 0 0 0 1 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_425_1111" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_425_1111"
                                                result="shape" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.65047" />
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_425_1111" />
                                        </filter>
                                    </defs>
                                </svg>
                                <p>Личная работа с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <svg width="21" height="26" viewBox="0 0 21 26" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_di_425_1111)">
                                        <path
                                            d="M9.4445 3.96717C9.38544 3.66627 9.05395 3.70111 9.05875 4.00772L9.09918 6.57981C9.15139 9.90108 7.47298 12.7004 5.03939 13.3509L3.15472 13.8547C2.93004 13.9148 2.97636 14.3555 3.20863 14.3676L5.15685 14.4685C7.67252 14.5988 9.89625 16.988 10.5357 20.2475L11.0309 22.7718C11.09 23.0727 11.4215 23.0379 11.4167 22.7313L11.3763 20.1592C11.324 16.8379 13.0025 14.0386 15.4361 13.3881L17.3207 12.8843C17.5454 12.8243 17.4991 12.3835 17.2668 12.3714L15.3186 12.2705C12.8029 12.1402 10.5792 9.75101 9.93972 6.49147L9.4445 3.96717Z"
                                            fill="#F9F9F9" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_di_425_1111" x="0.119487" y="0.870464" width="20.2356"
                                            height="24.9981" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.44416" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.934668 0 0 0 0 0.74877 0 0 0 0 0.270771 0 0 0 1 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_425_1111" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_425_1111"
                                                result="shape" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="1.65047" />
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_425_1111" />
                                        </filter>
                                    </defs>
                                </svg>
                                <p>В основе: 200+ исследований<br> и методики Гарварда</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726069790705-Jy79a-Fram.png"
                            alt="" class="course40-main-photo">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726069832185-WM9bJ-Grou.svg"
                            alt="" class="course40-main-decor">
                        <div>
                            <p>Автор: Ольга Лермонтова, фаундер Careerum, карьерный коуч, ex топ-менеджер Google, Microsoft,
                                Intel</p>
                        </div>
                    </div>
                </div>
                <h2>Кому подойдет этот курс</h2>
                <div class="course40-goals-tales">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051495630-Z6SnH-Vect.svg"
                            alt="">
                        <p>Руководителям, CEO, топ-менеджерам </p>
                    </div>
                    <div class="course40-goals-tale-rotate-right">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051495630-Z6SnH-Vect.svg"
                            alt="">
                        <p>Предпринимателям, фаундерам стартапов</p>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726051495630-Z6SnH-Vect.svg"
                            alt="">
                        <p>Middle и Senior-специалистам, тим-лидам</p>
                    </div>
                </div>
                <div class="course40-main-link">
                    <a href="#program" class="btn-color-main-black">Посмотреть программу</a>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-about', {
        label: 'Course 4 about',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-about">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Что будет на курсе</h2>
                <div class="course40-about-top careerum-flex-fsst">
                    <div>
                        <p class="course40-about-top-header">Живые эфиры с Ольгой</p>
                        <p class="course40-about-top-subheader">Интерактивные эфиры, где вы получите теорию и сразу же
                            попрактикуетесь ее применять</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Работа в паре с buddy</p>
                        <p class="course40-about-top-subheader">Вы будете разбиты на пары, чтобы прорабатывать свои
                            результаты, поддерживать и мотивировать друг друга</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Практические сессии </p>
                        <p class="course40-about-top-subheader">Встречи с экспертом, где разберем домашние задания,
                            упражнения и сложные вопросы</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Групповой чат курса</p>
                        <p class="course40-about-top-subheader">Комьюнити курса, чтобы делиться опытом, обсуждать трудные
                            темы и находить новые решения</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Мастер-майнды с Ольгой</p>
                        <p class="course40-about-top-subheader">Интенсивные сессии по обмену опытом и идеями, чтобы получать
                            инсайты для своего роста</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Доступ к материалам курса</p>
                        <p class="course40-about-top-subheader">Когда закончатся сессии, доступ к курсу останется, сможете
                            пользоваться материалами еще месяц</p>
                    </div>
                </div>
                <div class="course40-about-bottom careerum-flex-fsst">
                    <div>
                        <p class="course40-about-bottom-label">Помогут закрепить новые привычки</p>
                        <p class="course40-about-bottom-header">Практические задания</p>
                        <p class="course40-about-bottom-subheader">Практика:</p>
                        <ul>
                            <li>Оценка уровня счастья</li>
                            <li>Рефрейминг: пересмотр прошлых ошибок и неудач как шагов к успеху</li>
                            <li>Планирование идеальной рабочей недели с акцентом на мотивацию и удовольствие</li>
                            <li>«Проявления доброты» и благодарности</li>
                            <li>Создание шаблонов карьерного плана и целей на ближайший год</li>
                        </ul>
                        <p class="course40-about-bottom-subheader">Ежедневные упражнения: </p>
                        <ul>
                            <li>Для укрепления самооценки и нахождения положительных аспектов в жизни</li>
                        </ul>
                    </div>
                    <div>
                        <p class="course40-about-bottom-label">Останутся с вами навсегда</p>
                        <p class="course40-about-bottom-header">Чеклисты, артефакты, гайды</p>
                        <p class="course40-about-bottom-subheader">Гайды и артефакты:</p>
                        <ul>
                            <li>Формула счастья «МОСТ»</li>
                            <li>Шкала мотивации Деси и Райана для регуляции собственной деятельности</li>
                            <li>Список привычек счастливых людей для ежедневной практики</li>
                        </ul>
                        <p class="course40-about-bottom-subheader">Чеклисты и трекеры:</p>
                        <ul>
                            <li>Ментальная гигиена</li>
                            <li>Качественный сон</li>
                            <li>Работа с критикой</li>
                            <li>Карьерное планирование</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-about-tablet', {
        label: 'Course 4 about (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-about-tablet">
            <div class="careerum-container-tablet">
                <h2 class="careerum-club40-header-tablet">Что будет на курсе</h2>
                <div class="course40-about-top careerum-flex-fsst">
                    <div>
                        <p class="course40-about-top-header">Живые эфиры с Ольгой</p>
                        <p class="course40-about-top-subheader">Интерактивные эфиры, где вы получите теорию и сразу же
                            попрактикуетесь ее применять</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Работа в паре с buddy</p>
                        <p class="course40-about-top-subheader">Вы будете разбиты на пары, чтобы прорабатывать свои
                            результаты, поддерживать и мотивировать друг друга</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Практические сессии </p>
                        <p class="course40-about-top-subheader">Встречи с экспертом, где разберем домашние задания,
                            упражнения и сложные вопросы</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Групповой чат курса</p>
                        <p class="course40-about-top-subheader">Комьюнити курса, чтобы делиться опытом, обсуждать трудные
                            темы и находить новые решения</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Мастер-майнды с Ольгой</p>
                        <p class="course40-about-top-subheader">Интенсивные сессии по обмену опытом и идеями, чтобы получать
                            инсайты для своего роста</p>
                    </div>
                    <div>
                        <p class="course40-about-top-header">Доступ к материалам курса</p>
                        <p class="course40-about-top-subheader">Когда закончатся сессии, доступ к курсу останется, сможете
                            пользоваться материалами еще месяц</p>
                    </div>
                </div>
                <div class="course40-about-bottom careerum-flex-fsst">
                    <div>
                        <p class="course40-about-bottom-label">Помогут закрепить новые привычки</p>
                        <p class="course40-about-bottom-header">Практические задания</p>
                        <p class="course40-about-bottom-subheader">Практика:</p>
                        <ul>
                            <li>Оценка уровня счастья</li>
                            <li>Рефрейминг: пересмотр прошлых ошибок и неудач как шагов к успеху</li>
                            <li>Планирование идеальной рабочей недели с акцентом на мотивацию и удовольствие</li>
                            <li>«Проявления доброты» и благодарности</li>
                            <li>Создание шаблонов карьерного плана и целей на ближайший год</li>
                        </ul>
                        <p class="course40-about-bottom-subheader">Ежедневные упражнения: </p>
                        <ul>
                            <li>Для укрепления самооценки и нахождения положительных аспектов в жизни</li>
                        </ul>
                    </div>
                    <div>
                        <p class="course40-about-bottom-label">Останутся с вами навсегда</p>
                        <p class="course40-about-bottom-header">Чеклисты, артефакты, гайды</p>
                        <p class="course40-about-bottom-subheader">Гайды и артефакты:</p>
                        <ul>
                            <li>Формула счастья «МОСТ»</li>
                            <li>Шкала мотивации Деси и Райана для регуляции собственной деятельности</li>
                            <li>Список привычек счастливых людей для ежедневной практики</li>
                        </ul>
                        <p class="course40-about-bottom-subheader">Чеклисты и трекеры:</p>
                        <ul>
                            <li>Ментальная гигиена</li>
                            <li>Качественный сон</li>
                            <li>Работа с критикой</li>
                            <li>Карьерное планирование</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-about-mobile', {
        label: 'Course 4 about (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-about-mobile">
            <div class="careerum-container-mobile">
                <h2 class="careerum-club40-header-mobile">Что еще будет на курсе</h2>
                <div class="course40-about-top about-top-slider">
                    <div class="course40-about-top-item">
                        <p class="course40-about-top-header">Живые эфиры с Ольгой</p>
                        <p class="course40-about-top-subheader">Интерактивные эфиры, где вы получите теорию и сразу же
                            попрактикуетесь ее применять</p>
                    </div>
                    <div class="course40-about-top-item">
                        <p class="course40-about-top-header">Работа в паре с buddy</p>
                        <p class="course40-about-top-subheader">Вы будете разбиты на пары, чтобы прорабатывать свои
                            результаты, поддерживать и мотивировать друг друга</p>
                    </div>
                    <div class="course40-about-top-item">
                        <p class="course40-about-top-header">Практические сессии </p>
                        <p class="course40-about-top-subheader">Встречи с экспертом, где разберем домашние задания,
                            упражнения и сложные вопросы</p>
                    </div>
                    <div class="course40-about-top-item">
                        <p class="course40-about-top-header">Групповой чат курса</p>
                        <p class="course40-about-top-subheader">Комьюнити курса, чтобы делиться опытом, обсуждать трудные
                            темы и находить новые решения</p>
                    </div>
                    <div class="course40-about-top-item">
                        <p class="course40-about-top-header">Мастер-майнды с Ольгой</p>
                        <p class="course40-about-top-subheader">Интенсивные сессии по обмену опытом и идеями, чтобы получать
                            инсайты для своего роста</p>
                    </div>
                    <div class="course40-about-top-item">
                        <p class="course40-about-top-header">Доступ к материалам курса</p>
                        <p class="course40-about-top-subheader">Когда закончатся сессии, доступ к курсу останется, сможете
                            пользоваться материалами еще месяц</p>
                    </div>
                </div>
                <div class="course40-about-bottom">
                    <div>
                        <p class="course40-about-bottom-label">Помогут закрепить новые привычки</p>
                        <p class="course40-about-bottom-header">Практические задания</p>
                        <p class="course40-about-bottom-subheader">Практика:</p>
                        <ul>
                            <li>Оценка уровня счастья</li>
                            <li>Рефрейминг: пересмотр прошлых ошибок и неудач как шагов к успеху</li>
                            <li>Планирование идеальной рабочей недели с акцентом на мотивацию и удовольствие</li>
                            <li>«Проявления доброты» и благодарности</li>
                            <li>Создание шаблонов карьерного плана и целей на ближайший год</li>
                        </ul>
                        <p class="course40-about-bottom-subheader">Ежедневные упражнения: </p>
                        <ul>
                            <li>Для укрепления самооценки и нахождения положительных аспектов в жизни</li>
                        </ul>
                    </div>
                    <div>
                        <p class="course40-about-bottom-label">Останутся с вами навсегда</p>
                        <p class="course40-about-bottom-header">Чеклисты, артефакты, гайды</p>
                        <p class="course40-about-bottom-subheader">Гайды и артефакты:</p>
                        <ul>
                            <li>Формула счастья «МОСТ»</li>
                            <li>Шкала мотивации Деси и Райана для регуляции собственной деятельности</li>
                            <li>Список привычек счастливых людей для ежедневной практики</li>
                        </ul>
                        <p class="course40-about-bottom-subheader">Чеклисты и трекеры:</p>
                        <ul>
                            <li>Ментальная гигиена</li>
                            <li>Качественный сон</li>
                            <li>Работа с критикой</li>
                            <li>Карьерное планирование</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-results', {
        label: 'Course 4 results',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-results">
            <div class="careerum-container-desc">
                <h2 class="careerum-club40-header">Результаты наших клиентов</h2>
                <div class="course40-results-items careerum-flex-fsst">
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Елена Фролова</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="116" height="20" viewBox="0 0 116 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3439 14.8985L14.2814 17.3985C14.7892 17.7188 15.4142 17.2422 15.2657 16.6563L14.1251 12.1719C14.0943 12.0476 14.0992 11.9171 14.1393 11.7955C14.1793 11.6738 14.253 11.566 14.3517 11.4844L17.8829 8.53908C18.3439 8.15627 18.1095 7.38283 17.5079 7.34377L12.8986 7.04689C12.7728 7.03958 12.6519 6.99578 12.5506 6.92086C12.4493 6.84594 12.372 6.74314 12.3282 6.62502L10.6095 2.29689C10.564 2.17182 10.4811 2.06377 10.3721 1.98742C10.2631 1.91107 10.1332 1.87012 10.0001 1.87012C9.86702 1.87012 9.73715 1.91107 9.62814 1.98742C9.51912 2.06377 9.43624 2.17182 9.39074 2.29689L7.67199 6.62502C7.62819 6.74314 7.55092 6.84594 7.44964 6.92086C7.34836 6.99578 7.22745 7.03958 7.10168 7.04689L2.49231 7.34377C1.89074 7.38283 1.65637 8.15627 2.11731 8.53908L5.64856 11.4844C5.74726 11.566 5.82089 11.6738 5.86097 11.7955C5.90106 11.9171 5.90596 12.0476 5.87512 12.1719L4.82043 16.3281C4.64074 17.0313 5.39074 17.6016 5.99231 17.2188L9.65637 14.8985C9.75912 14.8331 9.87836 14.7984 10.0001 14.7984C10.1219 14.7984 10.2411 14.8331 10.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M34.3439 14.8985L38.2814 17.3985C38.7892 17.7188 39.4142 17.2422 39.2657 16.6563L38.1251 12.1719C38.0943 12.0476 38.0992 11.9171 38.1393 11.7955C38.1793 11.6738 38.253 11.566 38.3517 11.4844L41.8829 8.53908C42.3439 8.15627 42.1095 7.38283 41.5079 7.34377L36.8986 7.04689C36.7728 7.03958 36.6519 6.99578 36.5506 6.92086C36.4493 6.84594 36.372 6.74314 36.3282 6.62502L34.6095 2.29689C34.564 2.17182 34.4811 2.06377 34.3721 1.98742C34.2631 1.91107 34.1332 1.87012 34.0001 1.87012C33.867 1.87012 33.7372 1.91107 33.6281 1.98742C33.5191 2.06377 33.4362 2.17182 33.3907 2.29689L31.672 6.62502C31.6282 6.74314 31.5509 6.84594 31.4496 6.92086C31.3484 6.99578 31.2274 7.03958 31.1017 7.04689L26.4923 7.34377C25.8907 7.38283 25.6564 8.15627 26.1173 8.53908L29.6486 11.4844C29.7473 11.566 29.8209 11.6738 29.861 11.7955C29.9011 11.9171 29.906 12.0476 29.8751 12.1719L28.8204 16.3281C28.6407 17.0313 29.3907 17.6016 29.9923 17.2188L33.6564 14.8985C33.7591 14.8331 33.8784 14.7984 34.0001 14.7984C34.1219 14.7984 34.2411 14.8331 34.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M58.3439 14.8985L62.2814 17.3985C62.7892 17.7188 63.4142 17.2422 63.2657 16.6563L62.1251 12.1719C62.0943 12.0476 62.0992 11.9171 62.1393 11.7955C62.1793 11.6738 62.253 11.566 62.3517 11.4844L65.8829 8.53908C66.3439 8.15627 66.1095 7.38283 65.5079 7.34377L60.8986 7.04689C60.7728 7.03958 60.6519 6.99578 60.5506 6.92086C60.4493 6.84594 60.372 6.74314 60.3282 6.62502L58.6095 2.29689C58.564 2.17182 58.4811 2.06377 58.3721 1.98742C58.2631 1.91107 58.1332 1.87012 58.0001 1.87012C57.867 1.87012 57.7372 1.91107 57.6281 1.98742C57.5191 2.06377 57.4362 2.17182 57.3907 2.29689L55.672 6.62502C55.6282 6.74314 55.5509 6.84594 55.4496 6.92086C55.3484 6.99578 55.2274 7.03958 55.1017 7.04689L50.4923 7.34377C49.8907 7.38283 49.6564 8.15627 50.1173 8.53908L53.6486 11.4844C53.7473 11.566 53.8209 11.6738 53.861 11.7955C53.9011 11.9171 53.906 12.0476 53.8751 12.1719L52.8204 16.3281C52.6407 17.0313 53.3907 17.6016 53.9923 17.2188L57.6564 14.8985C57.7591 14.8331 57.8784 14.7984 58.0001 14.7984C58.1219 14.7984 58.2411 14.8331 58.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M82.3439 14.8985L86.2814 17.3985C86.7892 17.7188 87.4142 17.2422 87.2657 16.6563L86.1251 12.1719C86.0943 12.0476 86.0992 11.9171 86.1393 11.7955C86.1793 11.6738 86.253 11.566 86.3517 11.4844L89.8829 8.53908C90.3439 8.15627 90.1095 7.38283 89.5079 7.34377L84.8986 7.04689C84.7728 7.03958 84.6519 6.99578 84.5506 6.92086C84.4493 6.84594 84.372 6.74314 84.3282 6.62502L82.6095 2.29689C82.564 2.17182 82.4811 2.06377 82.3721 1.98742C82.2631 1.91107 82.1332 1.87012 82.0001 1.87012C81.867 1.87012 81.7372 1.91107 81.6281 1.98742C81.5191 2.06377 81.4362 2.17182 81.3907 2.29689L79.672 6.62502C79.6282 6.74314 79.5509 6.84594 79.4496 6.92086C79.3484 6.99578 79.2274 7.03958 79.1017 7.04689L74.4923 7.34377C73.8907 7.38283 73.6564 8.15627 74.1173 8.53908L77.6486 11.4844C77.7473 11.566 77.8209 11.6738 77.861 11.7955C77.9011 11.9171 77.906 12.0476 77.8751 12.1719L76.8204 16.3281C76.6407 17.0313 77.3907 17.6016 77.9923 17.2188L81.6564 14.8985C81.7591 14.8331 81.8784 14.7984 82.0001 14.7984C82.1219 14.7984 82.2411 14.8331 82.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M106.344 14.8985L110.281 17.3985C110.789 17.7188 111.414 17.2422 111.266 16.6563L110.125 12.1719C110.094 12.0476 110.099 11.9171 110.139 11.7955C110.179 11.6738 110.253 11.566 110.352 11.4844L113.883 8.53908C114.344 8.15627 114.109 7.38283 113.508 7.34377L108.899 7.04689C108.773 7.03958 108.652 6.99578 108.551 6.92086C108.449 6.84594 108.372 6.74314 108.328 6.62502L106.609 2.29689C106.564 2.17182 106.481 2.06377 106.372 1.98742C106.263 1.91107 106.133 1.87012 106 1.87012C105.867 1.87012 105.737 1.91107 105.628 1.98742C105.519 2.06377 105.436 2.17182 105.391 2.29689L103.672 6.62502C103.628 6.74314 103.551 6.84594 103.45 6.92086C103.348 6.99578 103.227 7.03958 103.102 7.04689L98.4923 7.34377C97.8907 7.38283 97.6564 8.15627 98.1173 8.53908L101.649 11.4844C101.747 11.566 101.821 11.6738 101.861 11.7955C101.901 11.9171 101.906 12.0476 101.875 12.1719L100.82 16.3281C100.641 17.0313 101.391 17.6016 101.992 17.2188L105.656 14.8985C105.759 14.8331 105.878 14.7984 106 14.7984C106.122 14.7984 106.241 14.8331 106.344 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="course40-results-item-text">
                            <p>Добрый день! Я очень благодарна Ольге и Карьеруму за мега полезные материалы, позитивную
                                атмосферу, общение, поддержку коучей. Решила сделать перерыв и направить энергию на новый
                                рабочий функционал, который выбрала как раз в Карьерум. Большое спасибо!!!</p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Анонимный отзыв</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="116" height="20" viewBox="0 0 116 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3439 14.8985L14.2814 17.3985C14.7892 17.7188 15.4142 17.2422 15.2657 16.6563L14.1251 12.1719C14.0943 12.0476 14.0992 11.9171 14.1393 11.7955C14.1793 11.6738 14.253 11.566 14.3517 11.4844L17.8829 8.53908C18.3439 8.15627 18.1095 7.38283 17.5079 7.34377L12.8986 7.04689C12.7728 7.03958 12.6519 6.99578 12.5506 6.92086C12.4493 6.84594 12.372 6.74314 12.3282 6.62502L10.6095 2.29689C10.564 2.17182 10.4811 2.06377 10.3721 1.98742C10.2631 1.91107 10.1332 1.87012 10.0001 1.87012C9.86702 1.87012 9.73715 1.91107 9.62814 1.98742C9.51912 2.06377 9.43624 2.17182 9.39074 2.29689L7.67199 6.62502C7.62819 6.74314 7.55092 6.84594 7.44964 6.92086C7.34836 6.99578 7.22745 7.03958 7.10168 7.04689L2.49231 7.34377C1.89074 7.38283 1.65637 8.15627 2.11731 8.53908L5.64856 11.4844C5.74726 11.566 5.82089 11.6738 5.86097 11.7955C5.90106 11.9171 5.90596 12.0476 5.87512 12.1719L4.82043 16.3281C4.64074 17.0313 5.39074 17.6016 5.99231 17.2188L9.65637 14.8985C9.75912 14.8331 9.87836 14.7984 10.0001 14.7984C10.1219 14.7984 10.2411 14.8331 10.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M34.3439 14.8985L38.2814 17.3985C38.7892 17.7188 39.4142 17.2422 39.2657 16.6563L38.1251 12.1719C38.0943 12.0476 38.0992 11.9171 38.1393 11.7955C38.1793 11.6738 38.253 11.566 38.3517 11.4844L41.8829 8.53908C42.3439 8.15627 42.1095 7.38283 41.5079 7.34377L36.8986 7.04689C36.7728 7.03958 36.6519 6.99578 36.5506 6.92086C36.4493 6.84594 36.372 6.74314 36.3282 6.62502L34.6095 2.29689C34.564 2.17182 34.4811 2.06377 34.3721 1.98742C34.2631 1.91107 34.1332 1.87012 34.0001 1.87012C33.867 1.87012 33.7372 1.91107 33.6281 1.98742C33.5191 2.06377 33.4362 2.17182 33.3907 2.29689L31.672 6.62502C31.6282 6.74314 31.5509 6.84594 31.4496 6.92086C31.3484 6.99578 31.2274 7.03958 31.1017 7.04689L26.4923 7.34377C25.8907 7.38283 25.6564 8.15627 26.1173 8.53908L29.6486 11.4844C29.7473 11.566 29.8209 11.6738 29.861 11.7955C29.9011 11.9171 29.906 12.0476 29.8751 12.1719L28.8204 16.3281C28.6407 17.0313 29.3907 17.6016 29.9923 17.2188L33.6564 14.8985C33.7591 14.8331 33.8784 14.7984 34.0001 14.7984C34.1219 14.7984 34.2411 14.8331 34.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M58.3439 14.8985L62.2814 17.3985C62.7892 17.7188 63.4142 17.2422 63.2657 16.6563L62.1251 12.1719C62.0943 12.0476 62.0992 11.9171 62.1393 11.7955C62.1793 11.6738 62.253 11.566 62.3517 11.4844L65.8829 8.53908C66.3439 8.15627 66.1095 7.38283 65.5079 7.34377L60.8986 7.04689C60.7728 7.03958 60.6519 6.99578 60.5506 6.92086C60.4493 6.84594 60.372 6.74314 60.3282 6.62502L58.6095 2.29689C58.564 2.17182 58.4811 2.06377 58.3721 1.98742C58.2631 1.91107 58.1332 1.87012 58.0001 1.87012C57.867 1.87012 57.7372 1.91107 57.6281 1.98742C57.5191 2.06377 57.4362 2.17182 57.3907 2.29689L55.672 6.62502C55.6282 6.74314 55.5509 6.84594 55.4496 6.92086C55.3484 6.99578 55.2274 7.03958 55.1017 7.04689L50.4923 7.34377C49.8907 7.38283 49.6564 8.15627 50.1173 8.53908L53.6486 11.4844C53.7473 11.566 53.8209 11.6738 53.861 11.7955C53.9011 11.9171 53.906 12.0476 53.8751 12.1719L52.8204 16.3281C52.6407 17.0313 53.3907 17.6016 53.9923 17.2188L57.6564 14.8985C57.7591 14.8331 57.8784 14.7984 58.0001 14.7984C58.1219 14.7984 58.2411 14.8331 58.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M82.3439 14.8985L86.2814 17.3985C86.7892 17.7188 87.4142 17.2422 87.2657 16.6563L86.1251 12.1719C86.0943 12.0476 86.0992 11.9171 86.1393 11.7955C86.1793 11.6738 86.253 11.566 86.3517 11.4844L89.8829 8.53908C90.3439 8.15627 90.1095 7.38283 89.5079 7.34377L84.8986 7.04689C84.7728 7.03958 84.6519 6.99578 84.5506 6.92086C84.4493 6.84594 84.372 6.74314 84.3282 6.62502L82.6095 2.29689C82.564 2.17182 82.4811 2.06377 82.3721 1.98742C82.2631 1.91107 82.1332 1.87012 82.0001 1.87012C81.867 1.87012 81.7372 1.91107 81.6281 1.98742C81.5191 2.06377 81.4362 2.17182 81.3907 2.29689L79.672 6.62502C79.6282 6.74314 79.5509 6.84594 79.4496 6.92086C79.3484 6.99578 79.2274 7.03958 79.1017 7.04689L74.4923 7.34377C73.8907 7.38283 73.6564 8.15627 74.1173 8.53908L77.6486 11.4844C77.7473 11.566 77.8209 11.6738 77.861 11.7955C77.9011 11.9171 77.906 12.0476 77.8751 12.1719L76.8204 16.3281C76.6407 17.0313 77.3907 17.6016 77.9923 17.2188L81.6564 14.8985C81.7591 14.8331 81.8784 14.7984 82.0001 14.7984C82.1219 14.7984 82.2411 14.8331 82.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M106.344 14.8985L110.281 17.3985C110.789 17.7188 111.414 17.2422 111.266 16.6563L110.125 12.1719C110.094 12.0476 110.099 11.9171 110.139 11.7955C110.179 11.6738 110.253 11.566 110.352 11.4844L113.883 8.53908C114.344 8.15627 114.109 7.38283 113.508 7.34377L108.899 7.04689C108.773 7.03958 108.652 6.99578 108.551 6.92086C108.449 6.84594 108.372 6.74314 108.328 6.62502L106.609 2.29689C106.564 2.17182 106.481 2.06377 106.372 1.98742C106.263 1.91107 106.133 1.87012 106 1.87012C105.867 1.87012 105.737 1.91107 105.628 1.98742C105.519 2.06377 105.436 2.17182 105.391 2.29689L103.672 6.62502C103.628 6.74314 103.551 6.84594 103.45 6.92086C103.348 6.99578 103.227 7.03958 103.102 7.04689L98.4923 7.34377C97.8907 7.38283 97.6564 8.15627 98.1173 8.53908L101.649 11.4844C101.747 11.566 101.821 11.6738 101.861 11.7955C101.901 11.9171 101.906 12.0476 101.875 12.1719L100.82 16.3281C100.641 17.0313 101.391 17.6016 101.992 17.2188L105.656 14.8985C105.759 14.8331 105.878 14.7984 106 14.7984C106.122 14.7984 106.241 14.8331 106.344 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="course40-results-item-text">
                            <p>Мне очень понравилось участвовать в Мастермаинде, во встречах посредством Coffee Buddy.
                                Познакомилась с интересными людьми, посмотрела на себя со стороны, отметив свои сильные
                                стороны и над чем надо поработать, узнала мнение о себе других незнакомых ранее людей,
                                пообщалась с экспертом.</p>
                        </div>
                    </div>
                    <div class="course40-results-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726040618214-Dzugu-Mask.png"
                                    alt="">
                                <p>Наталья Макеева</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="116" height="20" viewBox="0 0 116 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3439 14.8985L14.2814 17.3985C14.7892 17.7188 15.4142 17.2422 15.2657 16.6563L14.1251 12.1719C14.0943 12.0476 14.0992 11.9171 14.1393 11.7955C14.1793 11.6738 14.253 11.566 14.3517 11.4844L17.8829 8.53908C18.3439 8.15627 18.1095 7.38283 17.5079 7.34377L12.8986 7.04689C12.7728 7.03958 12.6519 6.99578 12.5506 6.92086C12.4493 6.84594 12.372 6.74314 12.3282 6.62502L10.6095 2.29689C10.564 2.17182 10.4811 2.06377 10.3721 1.98742C10.2631 1.91107 10.1332 1.87012 10.0001 1.87012C9.86702 1.87012 9.73715 1.91107 9.62814 1.98742C9.51912 2.06377 9.43624 2.17182 9.39074 2.29689L7.67199 6.62502C7.62819 6.74314 7.55092 6.84594 7.44964 6.92086C7.34836 6.99578 7.22745 7.03958 7.10168 7.04689L2.49231 7.34377C1.89074 7.38283 1.65637 8.15627 2.11731 8.53908L5.64856 11.4844C5.74726 11.566 5.82089 11.6738 5.86097 11.7955C5.90106 11.9171 5.90596 12.0476 5.87512 12.1719L4.82043 16.3281C4.64074 17.0313 5.39074 17.6016 5.99231 17.2188L9.65637 14.8985C9.75912 14.8331 9.87836 14.7984 10.0001 14.7984C10.1219 14.7984 10.2411 14.8331 10.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M34.3439 14.8985L38.2814 17.3985C38.7892 17.7188 39.4142 17.2422 39.2657 16.6563L38.1251 12.1719C38.0943 12.0476 38.0992 11.9171 38.1393 11.7955C38.1793 11.6738 38.253 11.566 38.3517 11.4844L41.8829 8.53908C42.3439 8.15627 42.1095 7.38283 41.5079 7.34377L36.8986 7.04689C36.7728 7.03958 36.6519 6.99578 36.5506 6.92086C36.4493 6.84594 36.372 6.74314 36.3282 6.62502L34.6095 2.29689C34.564 2.17182 34.4811 2.06377 34.3721 1.98742C34.2631 1.91107 34.1332 1.87012 34.0001 1.87012C33.867 1.87012 33.7372 1.91107 33.6281 1.98742C33.5191 2.06377 33.4362 2.17182 33.3907 2.29689L31.672 6.62502C31.6282 6.74314 31.5509 6.84594 31.4496 6.92086C31.3484 6.99578 31.2274 7.03958 31.1017 7.04689L26.4923 7.34377C25.8907 7.38283 25.6564 8.15627 26.1173 8.53908L29.6486 11.4844C29.7473 11.566 29.8209 11.6738 29.861 11.7955C29.9011 11.9171 29.906 12.0476 29.8751 12.1719L28.8204 16.3281C28.6407 17.0313 29.3907 17.6016 29.9923 17.2188L33.6564 14.8985C33.7591 14.8331 33.8784 14.7984 34.0001 14.7984C34.1219 14.7984 34.2411 14.8331 34.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M58.3439 14.8985L62.2814 17.3985C62.7892 17.7188 63.4142 17.2422 63.2657 16.6563L62.1251 12.1719C62.0943 12.0476 62.0992 11.9171 62.1393 11.7955C62.1793 11.6738 62.253 11.566 62.3517 11.4844L65.8829 8.53908C66.3439 8.15627 66.1095 7.38283 65.5079 7.34377L60.8986 7.04689C60.7728 7.03958 60.6519 6.99578 60.5506 6.92086C60.4493 6.84594 60.372 6.74314 60.3282 6.62502L58.6095 2.29689C58.564 2.17182 58.4811 2.06377 58.3721 1.98742C58.2631 1.91107 58.1332 1.87012 58.0001 1.87012C57.867 1.87012 57.7372 1.91107 57.6281 1.98742C57.5191 2.06377 57.4362 2.17182 57.3907 2.29689L55.672 6.62502C55.6282 6.74314 55.5509 6.84594 55.4496 6.92086C55.3484 6.99578 55.2274 7.03958 55.1017 7.04689L50.4923 7.34377C49.8907 7.38283 49.6564 8.15627 50.1173 8.53908L53.6486 11.4844C53.7473 11.566 53.8209 11.6738 53.861 11.7955C53.9011 11.9171 53.906 12.0476 53.8751 12.1719L52.8204 16.3281C52.6407 17.0313 53.3907 17.6016 53.9923 17.2188L57.6564 14.8985C57.7591 14.8331 57.8784 14.7984 58.0001 14.7984C58.1219 14.7984 58.2411 14.8331 58.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M82.3439 14.8985L86.2814 17.3985C86.7892 17.7188 87.4142 17.2422 87.2657 16.6563L86.1251 12.1719C86.0943 12.0476 86.0992 11.9171 86.1393 11.7955C86.1793 11.6738 86.253 11.566 86.3517 11.4844L89.8829 8.53908C90.3439 8.15627 90.1095 7.38283 89.5079 7.34377L84.8986 7.04689C84.7728 7.03958 84.6519 6.99578 84.5506 6.92086C84.4493 6.84594 84.372 6.74314 84.3282 6.62502L82.6095 2.29689C82.564 2.17182 82.4811 2.06377 82.3721 1.98742C82.2631 1.91107 82.1332 1.87012 82.0001 1.87012C81.867 1.87012 81.7372 1.91107 81.6281 1.98742C81.5191 2.06377 81.4362 2.17182 81.3907 2.29689L79.672 6.62502C79.6282 6.74314 79.5509 6.84594 79.4496 6.92086C79.3484 6.99578 79.2274 7.03958 79.1017 7.04689L74.4923 7.34377C73.8907 7.38283 73.6564 8.15627 74.1173 8.53908L77.6486 11.4844C77.7473 11.566 77.8209 11.6738 77.861 11.7955C77.9011 11.9171 77.906 12.0476 77.8751 12.1719L76.8204 16.3281C76.6407 17.0313 77.3907 17.6016 77.9923 17.2188L81.6564 14.8985C81.7591 14.8331 81.8784 14.7984 82.0001 14.7984C82.1219 14.7984 82.2411 14.8331 82.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M106.344 14.8985L110.281 17.3985C110.789 17.7188 111.414 17.2422 111.266 16.6563L110.125 12.1719C110.094 12.0476 110.099 11.9171 110.139 11.7955C110.179 11.6738 110.253 11.566 110.352 11.4844L113.883 8.53908C114.344 8.15627 114.109 7.38283 113.508 7.34377L108.899 7.04689C108.773 7.03958 108.652 6.99578 108.551 6.92086C108.449 6.84594 108.372 6.74314 108.328 6.62502L106.609 2.29689C106.564 2.17182 106.481 2.06377 106.372 1.98742C106.263 1.91107 106.133 1.87012 106 1.87012C105.867 1.87012 105.737 1.91107 105.628 1.98742C105.519 2.06377 105.436 2.17182 105.391 2.29689L103.672 6.62502C103.628 6.74314 103.551 6.84594 103.45 6.92086C103.348 6.99578 103.227 7.03958 103.102 7.04689L98.4923 7.34377C97.8907 7.38283 97.6564 8.15627 98.1173 8.53908L101.649 11.4844C101.747 11.566 101.821 11.6738 101.861 11.7955C101.901 11.9171 101.906 12.0476 101.875 12.1719L100.82 16.3281C100.641 17.0313 101.391 17.6016 101.992 17.2188L105.656 14.8985C105.759 14.8331 105.878 14.7984 106 14.7984C106.122 14.7984 106.241 14.8331 106.344 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="course40-results-item-text">
                            <p>Ольга, здравствуйте! Прохожу курс по самооценке в Карьеруме, наконец-то работаю в
                                тройке-очень интересный опыт! Спасибо, что вы с командой создали такую крутую платформу.</p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Анонимный отзыв</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="116" height="20" viewBox="0 0 116 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3439 14.8985L14.2814 17.3985C14.7892 17.7188 15.4142 17.2422 15.2657 16.6563L14.1251 12.1719C14.0943 12.0476 14.0992 11.9171 14.1393 11.7955C14.1793 11.6738 14.253 11.566 14.3517 11.4844L17.8829 8.53908C18.3439 8.15627 18.1095 7.38283 17.5079 7.34377L12.8986 7.04689C12.7728 7.03958 12.6519 6.99578 12.5506 6.92086C12.4493 6.84594 12.372 6.74314 12.3282 6.62502L10.6095 2.29689C10.564 2.17182 10.4811 2.06377 10.3721 1.98742C10.2631 1.91107 10.1332 1.87012 10.0001 1.87012C9.86702 1.87012 9.73715 1.91107 9.62814 1.98742C9.51912 2.06377 9.43624 2.17182 9.39074 2.29689L7.67199 6.62502C7.62819 6.74314 7.55092 6.84594 7.44964 6.92086C7.34836 6.99578 7.22745 7.03958 7.10168 7.04689L2.49231 7.34377C1.89074 7.38283 1.65637 8.15627 2.11731 8.53908L5.64856 11.4844C5.74726 11.566 5.82089 11.6738 5.86097 11.7955C5.90106 11.9171 5.90596 12.0476 5.87512 12.1719L4.82043 16.3281C4.64074 17.0313 5.39074 17.6016 5.99231 17.2188L9.65637 14.8985C9.75912 14.8331 9.87836 14.7984 10.0001 14.7984C10.1219 14.7984 10.2411 14.8331 10.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M34.3439 14.8985L38.2814 17.3985C38.7892 17.7188 39.4142 17.2422 39.2657 16.6563L38.1251 12.1719C38.0943 12.0476 38.0992 11.9171 38.1393 11.7955C38.1793 11.6738 38.253 11.566 38.3517 11.4844L41.8829 8.53908C42.3439 8.15627 42.1095 7.38283 41.5079 7.34377L36.8986 7.04689C36.7728 7.03958 36.6519 6.99578 36.5506 6.92086C36.4493 6.84594 36.372 6.74314 36.3282 6.62502L34.6095 2.29689C34.564 2.17182 34.4811 2.06377 34.3721 1.98742C34.2631 1.91107 34.1332 1.87012 34.0001 1.87012C33.867 1.87012 33.7372 1.91107 33.6281 1.98742C33.5191 2.06377 33.4362 2.17182 33.3907 2.29689L31.672 6.62502C31.6282 6.74314 31.5509 6.84594 31.4496 6.92086C31.3484 6.99578 31.2274 7.03958 31.1017 7.04689L26.4923 7.34377C25.8907 7.38283 25.6564 8.15627 26.1173 8.53908L29.6486 11.4844C29.7473 11.566 29.8209 11.6738 29.861 11.7955C29.9011 11.9171 29.906 12.0476 29.8751 12.1719L28.8204 16.3281C28.6407 17.0313 29.3907 17.6016 29.9923 17.2188L33.6564 14.8985C33.7591 14.8331 33.8784 14.7984 34.0001 14.7984C34.1219 14.7984 34.2411 14.8331 34.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M58.3439 14.8985L62.2814 17.3985C62.7892 17.7188 63.4142 17.2422 63.2657 16.6563L62.1251 12.1719C62.0943 12.0476 62.0992 11.9171 62.1393 11.7955C62.1793 11.6738 62.253 11.566 62.3517 11.4844L65.8829 8.53908C66.3439 8.15627 66.1095 7.38283 65.5079 7.34377L60.8986 7.04689C60.7728 7.03958 60.6519 6.99578 60.5506 6.92086C60.4493 6.84594 60.372 6.74314 60.3282 6.62502L58.6095 2.29689C58.564 2.17182 58.4811 2.06377 58.3721 1.98742C58.2631 1.91107 58.1332 1.87012 58.0001 1.87012C57.867 1.87012 57.7372 1.91107 57.6281 1.98742C57.5191 2.06377 57.4362 2.17182 57.3907 2.29689L55.672 6.62502C55.6282 6.74314 55.5509 6.84594 55.4496 6.92086C55.3484 6.99578 55.2274 7.03958 55.1017 7.04689L50.4923 7.34377C49.8907 7.38283 49.6564 8.15627 50.1173 8.53908L53.6486 11.4844C53.7473 11.566 53.8209 11.6738 53.861 11.7955C53.9011 11.9171 53.906 12.0476 53.8751 12.1719L52.8204 16.3281C52.6407 17.0313 53.3907 17.6016 53.9923 17.2188L57.6564 14.8985C57.7591 14.8331 57.8784 14.7984 58.0001 14.7984C58.1219 14.7984 58.2411 14.8331 58.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M82.3439 14.8985L86.2814 17.3985C86.7892 17.7188 87.4142 17.2422 87.2657 16.6563L86.1251 12.1719C86.0943 12.0476 86.0992 11.9171 86.1393 11.7955C86.1793 11.6738 86.253 11.566 86.3517 11.4844L89.8829 8.53908C90.3439 8.15627 90.1095 7.38283 89.5079 7.34377L84.8986 7.04689C84.7728 7.03958 84.6519 6.99578 84.5506 6.92086C84.4493 6.84594 84.372 6.74314 84.3282 6.62502L82.6095 2.29689C82.564 2.17182 82.4811 2.06377 82.3721 1.98742C82.2631 1.91107 82.1332 1.87012 82.0001 1.87012C81.867 1.87012 81.7372 1.91107 81.6281 1.98742C81.5191 2.06377 81.4362 2.17182 81.3907 2.29689L79.672 6.62502C79.6282 6.74314 79.5509 6.84594 79.4496 6.92086C79.3484 6.99578 79.2274 7.03958 79.1017 7.04689L74.4923 7.34377C73.8907 7.38283 73.6564 8.15627 74.1173 8.53908L77.6486 11.4844C77.7473 11.566 77.8209 11.6738 77.861 11.7955C77.9011 11.9171 77.906 12.0476 77.8751 12.1719L76.8204 16.3281C76.6407 17.0313 77.3907 17.6016 77.9923 17.2188L81.6564 14.8985C81.7591 14.8331 81.8784 14.7984 82.0001 14.7984C82.1219 14.7984 82.2411 14.8331 82.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M106.344 14.8985L110.281 17.3985C110.789 17.7188 111.414 17.2422 111.266 16.6563L110.125 12.1719C110.094 12.0476 110.099 11.9171 110.139 11.7955C110.179 11.6738 110.253 11.566 110.352 11.4844L113.883 8.53908C114.344 8.15627 114.109 7.38283 113.508 7.34377L108.899 7.04689C108.773 7.03958 108.652 6.99578 108.551 6.92086C108.449 6.84594 108.372 6.74314 108.328 6.62502L106.609 2.29689C106.564 2.17182 106.481 2.06377 106.372 1.98742C106.263 1.91107 106.133 1.87012 106 1.87012C105.867 1.87012 105.737 1.91107 105.628 1.98742C105.519 2.06377 105.436 2.17182 105.391 2.29689L103.672 6.62502C103.628 6.74314 103.551 6.84594 103.45 6.92086C103.348 6.99578 103.227 7.03958 103.102 7.04689L98.4923 7.34377C97.8907 7.38283 97.6564 8.15627 98.1173 8.53908L101.649 11.4844C101.747 11.566 101.821 11.6738 101.861 11.7955C101.901 11.9171 101.906 12.0476 101.875 12.1719L100.82 16.3281C100.641 17.0313 101.391 17.6016 101.992 17.2188L105.656 14.8985C105.759 14.8331 105.878 14.7984 106 14.7984C106.122 14.7984 106.241 14.8331 106.344 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="course40-results-item-text">
                            <p>С помощью Карьерума уже праздную годовщину на работе-вызове в хорошем смысле слова! Самое
                                крутое, что навык осознанности распространяется и на все остальные сферы жизни!</p>
                        </div>
                    </div>
                    <div class="course40-results-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041134760-xloV5-Mask.png"
                                    alt="">
                                <p>Elvira Melentyeva</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="116" height="20" viewBox="0 0 116 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3439 14.8985L14.2814 17.3985C14.7892 17.7188 15.4142 17.2422 15.2657 16.6563L14.1251 12.1719C14.0943 12.0476 14.0992 11.9171 14.1393 11.7955C14.1793 11.6738 14.253 11.566 14.3517 11.4844L17.8829 8.53908C18.3439 8.15627 18.1095 7.38283 17.5079 7.34377L12.8986 7.04689C12.7728 7.03958 12.6519 6.99578 12.5506 6.92086C12.4493 6.84594 12.372 6.74314 12.3282 6.62502L10.6095 2.29689C10.564 2.17182 10.4811 2.06377 10.3721 1.98742C10.2631 1.91107 10.1332 1.87012 10.0001 1.87012C9.86702 1.87012 9.73715 1.91107 9.62814 1.98742C9.51912 2.06377 9.43624 2.17182 9.39074 2.29689L7.67199 6.62502C7.62819 6.74314 7.55092 6.84594 7.44964 6.92086C7.34836 6.99578 7.22745 7.03958 7.10168 7.04689L2.49231 7.34377C1.89074 7.38283 1.65637 8.15627 2.11731 8.53908L5.64856 11.4844C5.74726 11.566 5.82089 11.6738 5.86097 11.7955C5.90106 11.9171 5.90596 12.0476 5.87512 12.1719L4.82043 16.3281C4.64074 17.0313 5.39074 17.6016 5.99231 17.2188L9.65637 14.8985C9.75912 14.8331 9.87836 14.7984 10.0001 14.7984C10.1219 14.7984 10.2411 14.8331 10.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M34.3439 14.8985L38.2814 17.3985C38.7892 17.7188 39.4142 17.2422 39.2657 16.6563L38.1251 12.1719C38.0943 12.0476 38.0992 11.9171 38.1393 11.7955C38.1793 11.6738 38.253 11.566 38.3517 11.4844L41.8829 8.53908C42.3439 8.15627 42.1095 7.38283 41.5079 7.34377L36.8986 7.04689C36.7728 7.03958 36.6519 6.99578 36.5506 6.92086C36.4493 6.84594 36.372 6.74314 36.3282 6.62502L34.6095 2.29689C34.564 2.17182 34.4811 2.06377 34.3721 1.98742C34.2631 1.91107 34.1332 1.87012 34.0001 1.87012C33.867 1.87012 33.7372 1.91107 33.6281 1.98742C33.5191 2.06377 33.4362 2.17182 33.3907 2.29689L31.672 6.62502C31.6282 6.74314 31.5509 6.84594 31.4496 6.92086C31.3484 6.99578 31.2274 7.03958 31.1017 7.04689L26.4923 7.34377C25.8907 7.38283 25.6564 8.15627 26.1173 8.53908L29.6486 11.4844C29.7473 11.566 29.8209 11.6738 29.861 11.7955C29.9011 11.9171 29.906 12.0476 29.8751 12.1719L28.8204 16.3281C28.6407 17.0313 29.3907 17.6016 29.9923 17.2188L33.6564 14.8985C33.7591 14.8331 33.8784 14.7984 34.0001 14.7984C34.1219 14.7984 34.2411 14.8331 34.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M58.3439 14.8985L62.2814 17.3985C62.7892 17.7188 63.4142 17.2422 63.2657 16.6563L62.1251 12.1719C62.0943 12.0476 62.0992 11.9171 62.1393 11.7955C62.1793 11.6738 62.253 11.566 62.3517 11.4844L65.8829 8.53908C66.3439 8.15627 66.1095 7.38283 65.5079 7.34377L60.8986 7.04689C60.7728 7.03958 60.6519 6.99578 60.5506 6.92086C60.4493 6.84594 60.372 6.74314 60.3282 6.62502L58.6095 2.29689C58.564 2.17182 58.4811 2.06377 58.3721 1.98742C58.2631 1.91107 58.1332 1.87012 58.0001 1.87012C57.867 1.87012 57.7372 1.91107 57.6281 1.98742C57.5191 2.06377 57.4362 2.17182 57.3907 2.29689L55.672 6.62502C55.6282 6.74314 55.5509 6.84594 55.4496 6.92086C55.3484 6.99578 55.2274 7.03958 55.1017 7.04689L50.4923 7.34377C49.8907 7.38283 49.6564 8.15627 50.1173 8.53908L53.6486 11.4844C53.7473 11.566 53.8209 11.6738 53.861 11.7955C53.9011 11.9171 53.906 12.0476 53.8751 12.1719L52.8204 16.3281C52.6407 17.0313 53.3907 17.6016 53.9923 17.2188L57.6564 14.8985C57.7591 14.8331 57.8784 14.7984 58.0001 14.7984C58.1219 14.7984 58.2411 14.8331 58.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M82.3439 14.8985L86.2814 17.3985C86.7892 17.7188 87.4142 17.2422 87.2657 16.6563L86.1251 12.1719C86.0943 12.0476 86.0992 11.9171 86.1393 11.7955C86.1793 11.6738 86.253 11.566 86.3517 11.4844L89.8829 8.53908C90.3439 8.15627 90.1095 7.38283 89.5079 7.34377L84.8986 7.04689C84.7728 7.03958 84.6519 6.99578 84.5506 6.92086C84.4493 6.84594 84.372 6.74314 84.3282 6.62502L82.6095 2.29689C82.564 2.17182 82.4811 2.06377 82.3721 1.98742C82.2631 1.91107 82.1332 1.87012 82.0001 1.87012C81.867 1.87012 81.7372 1.91107 81.6281 1.98742C81.5191 2.06377 81.4362 2.17182 81.3907 2.29689L79.672 6.62502C79.6282 6.74314 79.5509 6.84594 79.4496 6.92086C79.3484 6.99578 79.2274 7.03958 79.1017 7.04689L74.4923 7.34377C73.8907 7.38283 73.6564 8.15627 74.1173 8.53908L77.6486 11.4844C77.7473 11.566 77.8209 11.6738 77.861 11.7955C77.9011 11.9171 77.906 12.0476 77.8751 12.1719L76.8204 16.3281C76.6407 17.0313 77.3907 17.6016 77.9923 17.2188L81.6564 14.8985C81.7591 14.8331 81.8784 14.7984 82.0001 14.7984C82.1219 14.7984 82.2411 14.8331 82.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M106.344 14.8985L110.281 17.3985C110.789 17.7188 111.414 17.2422 111.266 16.6563L110.125 12.1719C110.094 12.0476 110.099 11.9171 110.139 11.7955C110.179 11.6738 110.253 11.566 110.352 11.4844L113.883 8.53908C114.344 8.15627 114.109 7.38283 113.508 7.34377L108.899 7.04689C108.773 7.03958 108.652 6.99578 108.551 6.92086C108.449 6.84594 108.372 6.74314 108.328 6.62502L106.609 2.29689C106.564 2.17182 106.481 2.06377 106.372 1.98742C106.263 1.91107 106.133 1.87012 106 1.87012C105.867 1.87012 105.737 1.91107 105.628 1.98742C105.519 2.06377 105.436 2.17182 105.391 2.29689L103.672 6.62502C103.628 6.74314 103.551 6.84594 103.45 6.92086C103.348 6.99578 103.227 7.03958 103.102 7.04689L98.4923 7.34377C97.8907 7.38283 97.6564 8.15627 98.1173 8.53908L101.649 11.4844C101.747 11.566 101.821 11.6738 101.861 11.7955C101.901 11.9171 101.906 12.0476 101.875 12.1719L100.82 16.3281C100.641 17.0313 101.391 17.6016 101.992 17.2188L105.656 14.8985C105.759 14.8331 105.878 14.7984 106 14.7984C106.122 14.7984 106.241 14.8331 106.344 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="course40-results-item-text">
                            <p>My last career crisis was solved with Careerum's help. Now I see career as something that is
                                forming and changing all the time. With good planning it is easier to avoid a crisis moment.
                                Forever grateful!
                            </p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Милана Александрова</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="116" height="20" viewBox="0 0 116 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3439 14.8985L14.2814 17.3985C14.7892 17.7188 15.4142 17.2422 15.2657 16.6563L14.1251 12.1719C14.0943 12.0476 14.0992 11.9171 14.1393 11.7955C14.1793 11.6738 14.253 11.566 14.3517 11.4844L17.8829 8.53908C18.3439 8.15627 18.1095 7.38283 17.5079 7.34377L12.8986 7.04689C12.7728 7.03958 12.6519 6.99578 12.5506 6.92086C12.4493 6.84594 12.372 6.74314 12.3282 6.62502L10.6095 2.29689C10.564 2.17182 10.4811 2.06377 10.3721 1.98742C10.2631 1.91107 10.1332 1.87012 10.0001 1.87012C9.86702 1.87012 9.73715 1.91107 9.62814 1.98742C9.51912 2.06377 9.43624 2.17182 9.39074 2.29689L7.67199 6.62502C7.62819 6.74314 7.55092 6.84594 7.44964 6.92086C7.34836 6.99578 7.22745 7.03958 7.10168 7.04689L2.49231 7.34377C1.89074 7.38283 1.65637 8.15627 2.11731 8.53908L5.64856 11.4844C5.74726 11.566 5.82089 11.6738 5.86097 11.7955C5.90106 11.9171 5.90596 12.0476 5.87512 12.1719L4.82043 16.3281C4.64074 17.0313 5.39074 17.6016 5.99231 17.2188L9.65637 14.8985C9.75912 14.8331 9.87836 14.7984 10.0001 14.7984C10.1219 14.7984 10.2411 14.8331 10.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M34.3439 14.8985L38.2814 17.3985C38.7892 17.7188 39.4142 17.2422 39.2657 16.6563L38.1251 12.1719C38.0943 12.0476 38.0992 11.9171 38.1393 11.7955C38.1793 11.6738 38.253 11.566 38.3517 11.4844L41.8829 8.53908C42.3439 8.15627 42.1095 7.38283 41.5079 7.34377L36.8986 7.04689C36.7728 7.03958 36.6519 6.99578 36.5506 6.92086C36.4493 6.84594 36.372 6.74314 36.3282 6.62502L34.6095 2.29689C34.564 2.17182 34.4811 2.06377 34.3721 1.98742C34.2631 1.91107 34.1332 1.87012 34.0001 1.87012C33.867 1.87012 33.7372 1.91107 33.6281 1.98742C33.5191 2.06377 33.4362 2.17182 33.3907 2.29689L31.672 6.62502C31.6282 6.74314 31.5509 6.84594 31.4496 6.92086C31.3484 6.99578 31.2274 7.03958 31.1017 7.04689L26.4923 7.34377C25.8907 7.38283 25.6564 8.15627 26.1173 8.53908L29.6486 11.4844C29.7473 11.566 29.8209 11.6738 29.861 11.7955C29.9011 11.9171 29.906 12.0476 29.8751 12.1719L28.8204 16.3281C28.6407 17.0313 29.3907 17.6016 29.9923 17.2188L33.6564 14.8985C33.7591 14.8331 33.8784 14.7984 34.0001 14.7984C34.1219 14.7984 34.2411 14.8331 34.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M58.3439 14.8985L62.2814 17.3985C62.7892 17.7188 63.4142 17.2422 63.2657 16.6563L62.1251 12.1719C62.0943 12.0476 62.0992 11.9171 62.1393 11.7955C62.1793 11.6738 62.253 11.566 62.3517 11.4844L65.8829 8.53908C66.3439 8.15627 66.1095 7.38283 65.5079 7.34377L60.8986 7.04689C60.7728 7.03958 60.6519 6.99578 60.5506 6.92086C60.4493 6.84594 60.372 6.74314 60.3282 6.62502L58.6095 2.29689C58.564 2.17182 58.4811 2.06377 58.3721 1.98742C58.2631 1.91107 58.1332 1.87012 58.0001 1.87012C57.867 1.87012 57.7372 1.91107 57.6281 1.98742C57.5191 2.06377 57.4362 2.17182 57.3907 2.29689L55.672 6.62502C55.6282 6.74314 55.5509 6.84594 55.4496 6.92086C55.3484 6.99578 55.2274 7.03958 55.1017 7.04689L50.4923 7.34377C49.8907 7.38283 49.6564 8.15627 50.1173 8.53908L53.6486 11.4844C53.7473 11.566 53.8209 11.6738 53.861 11.7955C53.9011 11.9171 53.906 12.0476 53.8751 12.1719L52.8204 16.3281C52.6407 17.0313 53.3907 17.6016 53.9923 17.2188L57.6564 14.8985C57.7591 14.8331 57.8784 14.7984 58.0001 14.7984C58.1219 14.7984 58.2411 14.8331 58.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M82.3439 14.8985L86.2814 17.3985C86.7892 17.7188 87.4142 17.2422 87.2657 16.6563L86.1251 12.1719C86.0943 12.0476 86.0992 11.9171 86.1393 11.7955C86.1793 11.6738 86.253 11.566 86.3517 11.4844L89.8829 8.53908C90.3439 8.15627 90.1095 7.38283 89.5079 7.34377L84.8986 7.04689C84.7728 7.03958 84.6519 6.99578 84.5506 6.92086C84.4493 6.84594 84.372 6.74314 84.3282 6.62502L82.6095 2.29689C82.564 2.17182 82.4811 2.06377 82.3721 1.98742C82.2631 1.91107 82.1332 1.87012 82.0001 1.87012C81.867 1.87012 81.7372 1.91107 81.6281 1.98742C81.5191 2.06377 81.4362 2.17182 81.3907 2.29689L79.672 6.62502C79.6282 6.74314 79.5509 6.84594 79.4496 6.92086C79.3484 6.99578 79.2274 7.03958 79.1017 7.04689L74.4923 7.34377C73.8907 7.38283 73.6564 8.15627 74.1173 8.53908L77.6486 11.4844C77.7473 11.566 77.8209 11.6738 77.861 11.7955C77.9011 11.9171 77.906 12.0476 77.8751 12.1719L76.8204 16.3281C76.6407 17.0313 77.3907 17.6016 77.9923 17.2188L81.6564 14.8985C81.7591 14.8331 81.8784 14.7984 82.0001 14.7984C82.1219 14.7984 82.2411 14.8331 82.3439 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M106.344 14.8985L110.281 17.3985C110.789 17.7188 111.414 17.2422 111.266 16.6563L110.125 12.1719C110.094 12.0476 110.099 11.9171 110.139 11.7955C110.179 11.6738 110.253 11.566 110.352 11.4844L113.883 8.53908C114.344 8.15627 114.109 7.38283 113.508 7.34377L108.899 7.04689C108.773 7.03958 108.652 6.99578 108.551 6.92086C108.449 6.84594 108.372 6.74314 108.328 6.62502L106.609 2.29689C106.564 2.17182 106.481 2.06377 106.372 1.98742C106.263 1.91107 106.133 1.87012 106 1.87012C105.867 1.87012 105.737 1.91107 105.628 1.98742C105.519 2.06377 105.436 2.17182 105.391 2.29689L103.672 6.62502C103.628 6.74314 103.551 6.84594 103.45 6.92086C103.348 6.99578 103.227 7.03958 103.102 7.04689L98.4923 7.34377C97.8907 7.38283 97.6564 8.15627 98.1173 8.53908L101.649 11.4844C101.747 11.566 101.821 11.6738 101.861 11.7955C101.901 11.9171 101.906 12.0476 101.875 12.1719L100.82 16.3281C100.641 17.0313 101.391 17.6016 101.992 17.2188L105.656 14.8985C105.759 14.8331 105.878 14.7984 106 14.7984C106.122 14.7984 106.241 14.8331 106.344 14.8985Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="course40-results-item-text">
                            <p>Вижу, как влияют наша с вами работа, спорт и корректные фокусировки влияют на нужный
                                результат. Поняла, что поработала 3 года практически без отпусков. Даже деньги не тратила,
                                потому что было некогда. Хочу потратить и вложиться в ремонт и свое продвижение.
                                Материальные изменения способствуют ментальным и душевным трансформациям. Большое вам
                                спасибо за терпение, внимание и поддержку!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-results-tablet', {
        label: 'Course 4 results (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-results-tablet">
            <div class="careerum-container-tablet">
                <h2>Результаты наших клиентов</h2>
                <div class="course40-results-items results-items-slider">
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Елена Фролова</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Добрый день! Я очень благодарна Ольге и Карьеруму за мега полезные материалы, позитивную
                                атмосферу, общение, поддержку коучей. Решила сделать перерыв и направить энергию на новый
                                рабочий функционал, который выбрала как раз в Карьерум. Большое спасибо!!!</p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Анонимный отзыв</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Мне очень понравилось участвовать в Мастермаинде, во встречах посредством Coffee Buddy.
                                Познакомилась с интересными людьми, посмотрела на себя со стороны, отметив свои сильные
                                стороны и над чем надо поработать, узнала мнение о себе других незнакомых ранее людей,
                                пообщалась с экспертом.</p>
                        </div>
                    </div>
                    <div class="course40-results-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726040618214-Dzugu-Mask.png"
                                    alt="">
                                <p>Наталья Макеева</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Ольга, здравствуйте! Прохожу курс по самооценке в Карьеруме, наконец-то работаю в
                                тройке-очень интересный опыт! Спасибо, что вы с командой создали такую крутую платформу.</p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Анонимный отзыв</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>С помощью Карьерума уже праздную годовщину на работе-вызове в хорошем смысле слова! Самое
                                крутое, что навык осознанности распространяется и на все остальные сферы жизни!</p>
                        </div>
                    </div>
                    <div class="course40-results-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041134760-xloV5-Mask.png"
                                    alt="">
                                <p>Elvira Melentyeva</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>My last career crisis was solved with Careerum's help. Now I see career as something that is
                                forming and changing all the time. With good planning it is easier to avoid a crisis moment.
                                Forever grateful!
                            </p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Милана Александрова</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Вижу, как влияют наша с вами работа, спорт и корректные фокусировки влияют на нужный
                                результат. Поняла, что поработала 3 года практически без отпусков. Даже деньги не тратила,
                                потому что было некогда. Хочу потратить и вложиться в ремонт и свое продвижение.
                                Материальные изменения способствуют ментальным и душевным трансформациям. Большое вам
                                спасибо за терпение, внимание и поддержку!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-results-mobile', {
        label: 'Course 4 results (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-results-mobile">
            <div class="careerum-container-mobile">
                <h2>Результаты наших клиентов</h2>
                <div class="course40-results-items results-items-slider">
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Елена Фролова</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Добрый день! Я очень благодарна Ольге и Карьеруму за мега полезные материалы, позитивную
                                атмосферу, общение, поддержку коучей. Решила сделать перерыв и направить энергию на новый
                                рабочий функционал, который выбрала как раз в Карьерум. Большое спасибо!!!</p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Анонимный отзыв</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Мне очень понравилось участвовать в Мастермаинде, во встречах посредством Coffee Buddy.
                                Познакомилась с интересными людьми, посмотрела на себя со стороны, отметив свои сильные
                                стороны и над чем надо поработать, узнала мнение о себе других незнакомых ранее людей,
                                пообщалась с экспертом.</p>
                        </div>
                    </div>
                    <div class="course40-results-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726040618214-Dzugu-Mask.png"
                                    alt="">
                                <p>Наталья Макеева</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Ольга, здравствуйте! Прохожу курс по самооценке в Карьеруме, наконец-то работаю в
                                тройке-очень интересный опыт! Спасибо, что вы с командой создали такую крутую платформу.</p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Анонимный отзыв</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>С помощью Карьерума уже праздную годовщину на работе-вызове в хорошем смысле слова! Самое
                                крутое, что навык осознанности распространяется и на все остальные сферы жизни!</p>
                        </div>
                    </div>
                    <div class="course40-results-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041134760-xloV5-Mask.png"
                                    alt="">
                                <p>Elvira Melentyeva</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>My last career crisis was solved with Careerum's help. Now I see career as something that is
                                forming and changing all the time. With good planning it is easier to avoid a crisis moment.
                                Forever grateful!
                            </p>
                        </div>
                    </div>
                    <div class="course40-results-item no-image-item">
                        <div class="course40-results-item-top">
                            <div class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726041211406-mZpvu-Mask.png"
                                    alt="">
                                <p>Милана Александрова</p>
                            </div>
                        </div>
                        <div class="course40-results-item-sep"></div>
                        <div class="course40-results-item-star">
                            <svg width="97" height="17" viewBox="0 0 97 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.29302 12.8441L11.4498 14.8484C11.8569 15.1052 12.358 14.7231 12.239 14.2533L11.3245 10.6581C11.2998 10.5585 11.3037 10.4538 11.3359 10.3563C11.368 10.2588 11.427 10.1724 11.5062 10.1069L14.3373 7.7456C14.7068 7.43869 14.5189 6.8186 14.0366 6.78728L10.3412 6.54927C10.2403 6.54341 10.1434 6.50829 10.0622 6.44823C9.981 6.38816 9.91906 6.30575 9.88394 6.21105L8.50598 2.74108C8.4695 2.64081 8.40305 2.55418 8.31565 2.49297C8.22825 2.43176 8.12413 2.39893 8.01743 2.39893C7.91072 2.39893 7.8066 2.43176 7.7192 2.49297C7.6318 2.55418 7.56535 2.64081 7.52887 2.74108L6.15091 6.21105C6.11579 6.30575 6.05385 6.38816 5.97265 6.44823C5.89145 6.50829 5.79451 6.54341 5.69368 6.54927L1.99823 6.78728C1.51594 6.8186 1.32804 7.43869 1.69758 7.7456L4.52867 10.1069C4.6078 10.1724 4.66684 10.2588 4.69897 10.3563C4.73111 10.4538 4.73504 10.5585 4.71031 10.6581L3.86474 13.9903C3.72068 14.554 4.32198 15.0112 4.80426 14.7043L7.74183 12.8441C7.82421 12.7917 7.91981 12.7639 8.01743 12.7639C8.11504 12.7639 8.21064 12.7917 8.29302 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M28.3272 12.8441L31.484 14.8484C31.8911 15.1052 32.3922 14.7231 32.2732 14.2533L31.3587 10.6581C31.334 10.5585 31.3379 10.4538 31.3701 10.3563C31.4022 10.2588 31.4612 10.1724 31.5404 10.1069L34.3714 7.7456C34.741 7.43869 34.5531 6.8186 34.0708 6.78728L30.3754 6.54927C30.2745 6.54341 30.1776 6.50829 30.0964 6.44823C30.0152 6.38816 29.9532 6.30575 29.9181 6.21105L28.5402 2.74108C28.5037 2.64081 28.4372 2.55418 28.3498 2.49297C28.2624 2.43176 28.1583 2.39893 28.0516 2.39893C27.9449 2.39893 27.8408 2.43176 27.7534 2.49297C27.666 2.55418 27.5995 2.64081 27.5631 2.74108L26.1851 6.21105C26.15 6.30575 26.088 6.38816 26.0068 6.44823C25.9256 6.50829 25.8287 6.54341 25.7279 6.54927L22.0324 6.78728C21.5501 6.8186 21.3622 7.43869 21.7318 7.7456L24.5629 10.1069C24.642 10.1724 24.701 10.2588 24.7332 10.3563C24.7653 10.4538 24.7692 10.5585 24.7445 10.6581L23.8989 13.9903C23.7549 14.554 24.3562 15.0112 24.8384 14.7043L27.776 12.8441C27.8584 12.7917 27.954 12.7639 28.0516 12.7639C28.1492 12.7639 28.2448 12.7917 28.3272 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M48.3624 12.8441L51.5191 14.8484C51.9263 15.1052 52.4273 14.7231 52.3083 14.2533L51.3939 10.6581C51.3691 10.5585 51.3731 10.4538 51.4052 10.3563C51.4374 10.2588 51.4964 10.1724 51.5755 10.1069L54.4066 7.7456C54.7761 7.43869 54.5882 6.8186 54.106 6.78728L50.4105 6.54927C50.3097 6.54341 50.2127 6.50829 50.1315 6.44823C50.0503 6.38816 49.9884 6.30575 49.9533 6.21105L48.5753 2.74108C48.5388 2.64081 48.4724 2.55418 48.385 2.49297C48.2976 2.43176 48.1935 2.39893 48.0868 2.39893C47.9801 2.39893 47.8759 2.43176 47.7885 2.49297C47.7011 2.55418 47.6347 2.64081 47.5982 2.74108L46.2202 6.21105C46.1851 6.30575 46.1232 6.38816 46.042 6.44823C45.9608 6.50829 45.8638 6.54341 45.763 6.54927L42.0676 6.78728C41.5853 6.8186 41.3974 7.43869 41.7669 7.7456L44.598 10.1069C44.6771 10.1724 44.7362 10.2588 44.7683 10.3563C44.8004 10.4538 44.8044 10.5585 44.7796 10.6581L43.9341 13.9903C43.79 14.554 44.3913 15.0112 44.8736 14.7043L47.8112 12.8441C47.8935 12.7917 47.9891 12.7639 48.0868 12.7639C48.1844 12.7639 48.28 12.7917 48.3624 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M68.3965 12.8441L71.5533 14.8484C71.9604 15.1052 72.4615 14.7231 72.3425 14.2533L71.4281 10.6581C71.4033 10.5585 71.4073 10.4538 71.4394 10.3563C71.4715 10.2588 71.5306 10.1724 71.6097 10.1069L74.4408 7.7456C74.8103 7.43869 74.6224 6.8186 74.1401 6.78728L70.4447 6.54927C70.3439 6.54341 70.2469 6.50829 70.1657 6.44823C70.0845 6.38816 70.0226 6.30575 69.9875 6.21105L68.6095 2.74108C68.573 2.64081 68.5066 2.55418 68.4192 2.49297C68.3318 2.43176 68.2276 2.39893 68.1209 2.39893C68.0142 2.39893 67.9101 2.43176 67.8227 2.49297C67.7353 2.55418 67.6689 2.64081 67.6324 2.74108L66.2544 6.21105C66.2193 6.30575 66.1574 6.38816 66.0762 6.44823C65.995 6.50829 65.898 6.54341 65.7972 6.54927L62.1017 6.78728C61.6195 6.8186 61.4316 7.43869 61.8011 7.7456L64.6322 10.1069C64.7113 10.1724 64.7704 10.2588 64.8025 10.3563C64.8346 10.4538 64.8386 10.5585 64.8138 10.6581L63.9683 13.9903C63.8242 14.554 64.4255 15.0112 64.9078 14.7043L67.8453 12.8441C67.9277 12.7917 68.0233 12.7639 68.1209 12.7639C68.2186 12.7639 68.3142 12.7917 68.3965 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M88.4307 12.8441L91.5875 14.8484C91.9946 15.1052 92.4957 14.7231 92.3767 14.2533L91.4622 10.6581C91.4375 10.5585 91.4414 10.4538 91.4736 10.3563C91.5057 10.2588 91.5647 10.1724 91.6439 10.1069L94.475 7.7456C94.8445 7.43869 94.6566 6.8186 94.1743 6.78728L90.4789 6.54927C90.378 6.54341 90.2811 6.50829 90.1999 6.44823C90.1187 6.38816 90.0568 6.30575 90.0216 6.21105L88.6437 2.74108C88.6072 2.64081 88.5407 2.55418 88.4533 2.49297C88.3659 2.43176 88.2618 2.39893 88.1551 2.39893C88.0484 2.39893 87.9443 2.43176 87.8569 2.49297C87.7695 2.55418 87.703 2.64081 87.6666 2.74108L86.2886 6.21105C86.2535 6.30575 86.1915 6.38816 86.1103 6.44823C86.0291 6.50829 85.9322 6.54341 85.8314 6.54927L82.1359 6.78728C81.6536 6.8186 81.4657 7.43869 81.8353 7.7456L84.6664 10.1069C84.7455 10.1724 84.8045 10.2588 84.8367 10.3563C84.8688 10.4538 84.8727 10.5585 84.848 10.6581L84.0024 13.9903C83.8584 14.554 84.4597 15.0112 84.942 14.7043L87.8795 12.8441C87.9619 12.7917 88.0575 12.7639 88.1551 12.7639C88.2527 12.7639 88.3483 12.7917 88.4307 12.8441Z"
                                    fill="#FF9F01" stroke="#FF9F01" stroke-width="1.00216" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
    
                        </div>
                        <div class="course40-results-item-text">
                            <p>Вижу, как влияют наша с вами работа, спорт и корректные фокусировки влияют на нужный
                                результат. Поняла, что поработала 3 года практически без отпусков. Даже деньги не тратила,
                                потому что было некогда. Хочу потратить и вложиться в ремонт и свое продвижение.
                                Материальные изменения способствуют ментальным и душевным трансформациям. Большое вам
                                спасибо за терпение, внимание и поддержку!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-banner1', {
        label: 'Course 4 banner1',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-banner1" data-redirect="no" data-url="" data-static="yes" data-offset=""
            data-timer-end="09/13/2024 23:59 GMT+0300">
            <div class="careerum-container-desc careerum-flex-cc">
                <div class="careerum-flex-cc">
                    <p>Курс стартует через</p>
                    <div>
                        <div class="course40-banner1-timer careerum-flex-cc">
                            <div>
                                <p class="timer-day-number">00</p>
                                <p class="timer-day-text">дней</p>
                            </div>
                            <div>
                                <p class="timer-hour-number">00</p>
                                <p class="timer-hour-text">часов</p>
                            </div>
                            <div>
                                <p class="timer-min-number">00</p>
                                <p class="timer-min-text">минут</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#buy" class="btn-color-main-black">Лист ожидания</a>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726063588942-SwGhf-ÑÐ¾.svg" alt="">
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-results-banner1', {
        label: 'Course 4 banner1 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-banner1-tablet" data-redirect="no" data-url="" data-static="yes" data-offset=""
            data-timer-end="09/13/2024 23:59 GMT+0300">
            <div class="careerum-container-tablet careerum-flex-sbc">
                <div class="careerum-flex-sbc">
                    <p>Курс стартует через</p>
                    <div>
                        <div class="course40-banner1-timer careerum-flex-cc">
                            <div>
                                <p class="timer-day-number">00</p>
                                <p class="timer-day-text">дней</p>
                            </div>
                            <div>
                                <p class="timer-hour-number">00</p>
                                <p class="timer-hour-text">часов</p>
                            </div>
                            <div>
                                <p class="timer-min-number">00</p>
                                <p class="timer-min-text">минут</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#buy" class="btn-color-main-black">Лист ожидания</a>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726063310723-kdnwW-ÑÐ¾.svg" alt="">
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-banner1-mobile', {
        label: 'Course 4 banner1 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-banner1-mobile" data-redirect="no" data-url="" data-static="yes" data-offset=""
            data-timer-end="09/13/2024 23:59 GMT+0300">
            <div class="careerum-container-mobile">
                <div class="careerum-flex-sbc">
                    <p>Курс стартует через</p>
                    <div>
                        <div class="course40-banner1-timer careerum-flex-cc">
                            <div>
                                <p class="timer-day-number">00</p>
                                <p class="timer-day-text">дней</p>
                            </div>
                            <div>
                                <p class="timer-hour-number">00</p>
                                <p class="timer-hour-text">часов</p>
                            </div>
                            <div>
                                <p class="timer-min-number">00</p>
                                <p class="timer-min-text">минут</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <a href="#buy" class="btn-color-main-black">Лист ожидания</a>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726063310723-kdnwW-ÑÐ¾.svg" alt="">
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-tariffs', {
        label: 'Course 4 tariffs',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-tariffs">
            <div class="careerum-container-desc">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043257012-W5UXY-Rect.png" alt="">
                <h2 class="careerum-club40-header">Условия участия</h2>
                <p>У курса не будет открытых продаж. Добавляйтесь в лист ожидания,<br> чтобы попасть на него и получить
                    доступ по лучшей цене</p>
                <div class="careerum-flex-cc course40-tariffs-curr-wrapper">
                    <div class="course40-tariffs-curr careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur" class="">EUR</li>
                            <li data-currency="rub" class="active">RUB</li>
                        </ul>
                        <div class="course40-tariffs-notif careerum-flex-cc">
                            <div class="course40-tariffs-notif-icon"><img
                                    src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt=""></div>
                            <div class="course40-tariffs-notif-content">
                                <p>Оплата в российских рублях возможна только картой российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="course40-tariffs-items careerum-flex-cst" data-price-rub="">
                    <div class="course40-tariffs-item careerum-flex-fsfs" data-price-rub="65 000 ₽" data-price-eur="650 €">
                        <p class="course40-tariffs-item-header">Базовый</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>Доступ к живым эфирам с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>Работа в чате с куратором</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>Работа в паре с buddy, с которым вы будете прорабатывать свои результаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>2 практические сессии, чтобы глубже разобрать важные для вас вопросы</p>
                            </li>
                        </ul>
                        <div>
                            <p class="course40-tariffs-item-price">65 000 ₽</p>
                            <a href="#" class="btn-color-main-black">Лист ожидания </a>
                        </div>
                    </div>
                    <div class="course40-tariffs-item careerum-flex-fsfs" data-price-rub="150 000 ₽"
                        data-price-eur="1 500 €">
                        <p class="course40-tariffs-item-label">Всего: 20 мест</p>
                        <p class="course40-tariffs-item-header">Индивидуальная работа с Ольгой Лермонтовой</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043818982-MWYlb-Fram.svg"
                                    alt="">
                                <p><span>2 мастермайнда в группе из 10 человек с Ольгой Лермонтовой, на которых будут
                                        проработаны лично ваши кейсы</span></p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>Доступ к живым эфирам с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>Работа в чате с куратором</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>Работа в паре с buddy, с которым вы будете прорабатывать свои результаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726043794907-HbEAM-Chec.svg"
                                    alt="">
                                <p>2 практические сессии, чтобы глубже разобрать важные для вас вопросы</p>
                            </li>
                        </ul>
                        <div>
                            <p class="course40-tariffs-item-price">150 000 ₽</p>
                            <a href="#" class="btn-color-main-black">Лист ожидания </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-tariffs-tablet', {
        label: 'Course 4 tariffs (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-tariffs-tablet">
            <div class="careerum-container-tablet">
                <!-- <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064307622-aQIq7-Rect.png" alt=""> -->
                <h2>Условия участия</h2>
                <p>У курса не будет открытых продаж. Добавляйтесь в лист ожидания,<br> чтобы попасть на него и получить
                    доступ по лучшей цене</p>
                <div class="course40-tariffs-items careerum-flex-fsst" data-price-rub="">
                    <div class="course40-tariffs-item careerum-flex-fsfs" data-price-rub="65 000 ₽" data-price-eur="650 €">
                        <p class="course40-tariffs-item-header">Базовый</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Доступ к живым эфирам с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в чате с куратором</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в паре с buddy, с которым вы будете прорабатывать свои результаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>2 практические сессии, чтобы глубже разобрать важные для вас вопросы</p>
                            </li>
                        </ul>
                        <div>
                            <p class="course40-tariffs-item-price">65 000 ₽</p>
                            <a href="#" class="btn-color-main-black">Лист ожидания </a>
                        </div>
                    </div>
                    <div class="course40-tariffs-item careerum-flex-fsfs" data-price-rub="150 000 ₽"
                        data-price-eur="1 500 €">
                        <p class="course40-tariffs-item-label">Осталось: 20 мест</p>
                        <p class="course40-tariffs-item-header">Индивидуальная работа с Ольгой Лермонтовой</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570641-3n9ce-Fram.svg"
                                    alt="">
                                <p><span>2 мастермайнда в группе из 10 человек с Ольгой Лермонтовой, на которых будут
                                        проработаны лично ваши кейсы</span></p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Доступ к живым эфирам с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в чате с куратором</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в паре с buddy, с которым вы будете прорабатывать свои результаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>2 практические сессии, чтобы глубже разобрать важные для вас вопросы</p>
                            </li>
                        </ul>
                        <div>
                            <p class="course40-tariffs-item-price">150 000 ₽</p>
                            <a href="#" class="btn-color-main-black">Лист ожидания </a>
                        </div>
                    </div>
                </div>
                <div class="course40-tariffs-curr">
                    <div class="club40-tariffs__swicher-block">
                        <div class="club40-tariffs__swicher-top">
                            <p class="club40-tariffs__swicher-header">Посмотреть цены
                                в
                                <span>EUR</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none" class="club40-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="club40-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub" class="active">
                                    RUB
                                </li>
                                <li data-currency="eur" class="">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-course40-tariffs-mobile', {
        label: 'Course 4 tariffs (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-course40-tariffs-mobile">
            <div class="careerum-container-mobile">
                <h2>Условия участия</h2>
                <p>У курса не будет открытых продаж. Добавляйтесь в лист ожидания, чтобы <br>попасть на него и получить
                    доступ по лучшей цене</p>
                <div class="course40-tariffs-curr">
                    <div class="club40-tariffs__swicher-block">
                        <div class="club40-tariffs__swicher-top">
                            <p class="club40-tariffs__swicher-header">Посмотреть цены
                                в
                                <span>EUR</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="club40-tariffs__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="club40-tariffs__swicher-bottom">
                            <ul>
                                <li data-currency="rub" class="active">
                                    RUB
                                </li>
                                <li data-currency="eur" class="">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
                <div class="course40-tariffs-items">
                    <div class="course40-tariffs-item careerum-flex-fsfs" data-price-rub="65 000 ₽" data-price-eur="650 €">
                        <p class="course40-tariffs-item-header">Базовый</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Доступ к живым эфирам с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в чате с куратором</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в паре с buddy, с которым вы будете прорабатывать свои результаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>2 практические сессии, чтобы глубже разобрать важные для вас вопросы</p>
                            </li>
                        </ul>
                        <div>
                            <p class="course40-tariffs-item-price">65 000 ₽</p>
                            <a href="#" class="btn-color-main-black">Лист ожидания </a>
                        </div>
                    </div>
                    <div class="course40-tariffs-item careerum-flex-fsfs" data-price-rub="150 000 ₽"
                        data-price-eur="1 500 €">
                        <p class="course40-tariffs-item-label">Осталось: 20 мест</p>
                        <p class="course40-tariffs-item-header">Индивидуальная работа с Ольгой Лермонтовой</p>
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570641-3n9ce-Fram.svg"
                                    alt="">
                                <p><span>2 мастермайнда в группе из 10 человек с Ольгой Лермонтовой, на которых будут
                                        проработаны лично ваши кейсы</span></p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Доступ к живым эфирам с Ольгой Лермонтовой</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в чате с куратором</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>Работа в паре с buddy, с которым вы будете прорабатывать свои результаты</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1726064570404-Jm6Zo-Chec.svg"
                                    alt="">
                                <p>2 практические сессии, чтобы глубже разобрать важные для вас вопросы</p>
                            </li>
                        </ul>
                        <div>
                            <p class="course40-tariffs-item-price">150 000 ₽</p>
                            <a href="#" class="btn-color-main-black">Лист ожидания </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-blackfriday-main', {
        label: 'Black friday main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-blackfriday-main main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731910870671-8wMca-Elli.png" alt=""
                class="position-absolute z-10">
            <div class="careerum-flex-fsfs position-relative z-20 blackfriday-main__top">
                <div class="position-relative">
                    <h1 class="position-relative z-10">BLACK FRIDAY</h1>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732702169493-AB4tY-Grou.png"
                            alt="" class="position-absolute z-20 hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732710712112-sKn3B-Grou.png"
                            alt="" class="position-absolute z-20 hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732715793717-CSjIx-Grou.png"
                            alt="" class="position-absolute z-20 hidden-desc-tablet">
                    </div>
                </div>
                <div class="position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731911478189-S2vLD-Vect.svg"
                        alt="" class="position-absolute z-20 hidden-tablet-mobile">
                    <p class="blackfriday-main__subheader position-relative z-10 hidden-tablet-mobile">Лучшие курсы из
                        подписки
                        Сareerum
                        за <span>14 900 ₽</span> 5 690 ₽ </p>
                    <p class="blackfriday-main__subheader position-relative z-10 hidden-desc">Лучшие курсы
                        из подписки
                        Сareerum
                        за <span>14 900 ₽</span><span class="position-relative"><img
                                src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732008867256-0zvS7-Vect.svg"
                                alt="" class="position-absolute z-20"></span> 5 690 ₽ </p>
                    <p class="blackfriday-main__text position-relative z-10">И больше никаких «черных понедельников» на
                        работе!</p>
                </div>
            </div>
            <div class="position-relative z-20 blackfriday-main__center">
                <div class="position-absolute blackfriday-main__center-top careerum-flex-fsc">
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="position-absolute blackfriday-main__center-bottom careerum-flex-fsc">
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="blackfriday-main__bottom position-relative">
                <p class="hidden-tablet-mobile">🎁 В подарок — месяц подписки на Careerum.Tips</p>
                <p class="hidden-desc">🎁 В подарок к покупке: месяц подписки на Careerum.Tips </p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731918326211-H07JU-Vect.svg" alt=""
                    class="blackfriday-main__bottom-left position-absolute hidden-mobile">
                <p>70 писем-уроков, которые помогут решить любую карьерную задачу</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731919048635-oK82s-Grou.png" alt=""
                    class="blackfriday-main__bottom-right position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731933425253-xoE6s-Grou.png" alt=""
                    class="blackfriday-main__bottom-right position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732017887120-6DVsn-Grou.png" alt=""
                    class="blackfriday-main__bottom-right hidden-desc-tablet">
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-blackfriday-tales', {
        label: 'Black friday tales (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-blackfriday-tales main-wrapper">
        <div class="careerum-container-responsive">
            <div class="blackfriday-tales-header position-relative">
                <h2>Лучшие курсы из подписки</h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732709671524-3GKLk-Grou.png" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732712919539-f1RyJ-Grou.png" alt=""
                    class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732717279175-edjte-Grou.png" alt=""
                    class="position-absolute hidden-desc-tablet">
            </div>
            <div class="blackfriday-tales-currency position-relative z-20">
                <div class="hidden-tablet-mobile">
                    <div class="blackfriday-tales-currency-desctop careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur">EUR</li>
                            <li data-currency="rub" class="active">RUB</li>
                        </ul>
                        <div class="blackfriday-tales-notif careerum-flex-cc">
                            <div class="blackfriday-tales-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="blackfriday-tales-notif-content">
                                <p>Оплата в российских рублях возможна только картой
                                    российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden-desc position-relative">
                    <div class="blackfriday-tales__swicher-block position-absolute">
                        <div class="blackfriday-tales__swicher-top">
                            <p class="blackfriday-tales__swicher-header">Посмотреть
                                цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="blackfriday-tales__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="blackfriday-tales__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="blackfriday-tales careerum-flex-fsfs position-relative z-10">
                <div class="blackfriday-tale careerum-flex-fsfs position-relative blackfriday-tale-change-currency"
                    price-current-eur="56 €" price-current-rub="5 690 ₽" price-old-eur="149 €" price-old-rub="14900 ₽"
                    link-eur="#eur" link-rub="#rub">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920558380-LZI1S-Fram.png"
                        alt="" class="hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732005724556-ACS5J-Fram.png"
                        alt="" class="hidden-desc-mobile">
                    <div class="blackfriday-tale__label position-absolute">
                        <p>поиск работы</p>
                    </div>
                    <div class="blackfriday-tale__header">
                        <h3>Продающее резюме</h3>
                        <p>Пошаговая инструкция для создания идеального резюме.</p>
                    </div>
                    <div class="blackfriday-tale__content">
                        <div class="careerum-flex-fsc blackfriday-tale__switcher">
                            <p>Программа курса</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                <path
                                    d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <ol>
                            <li>Эффективная основа любого резюме: принципы написания, формат</li>
                            <li>Достижения: как найти и упаковать </li>
                            <li>Как «докрутить» резюме до уровня топ-компаний рынка</li>
                            <li>Как получать максимум откликов: лайфхаки кастомизации резюме под вакансии</li>
                        </ol>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Доступ на 90 дней</p>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 60%</p>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                </div>
                <div class="blackfriday-tale careerum-flex-fsfs position-relative blackfriday-tale-change-currency"
                    price-current-eur="56 €" price-current-rub="5 690 ₽" price-old-eur="149 €" price-old-rub="14900 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920571409-iJ8hG-Fram.png"
                        alt="" class="hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732005724428-RwfiV-Fram.png"
                        alt="" class="hidden-desc-mobile">
                    <div class="blackfriday-tale__label position-absolute">
                        <p>релокация</p>
                    </div>
                    <div class="blackfriday-tale__header">
                        <h3>Международная карьера и релокация</h3>
                        <p>Стратегия для получения оффера в новой географии. </p>
                    </div>
                    <div class="blackfriday-tale__content">
                        <div class="careerum-flex-fsc blackfriday-tale__switcher">
                            <p>Программа курса</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                <path
                                    d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <ol>
                            <li>Алгоритм поиска работы за границей</li>
                            <li>Выбор страны, способы переезда</li>
                            <li>Отличия рынка СНГ, Азии и Европы</li>
                            <li>Упаковка своего опыта на новом рынке</li>
                            <li>Постановка целей</li>
                            <li>Составление и адаптация резюме</li>
                            <li>LinkedIn для развития карьеры</li>
                            <li>Прохождение интервью</li>
                            <li>Коммуникация с иностранными коллегами</li>
                            <li>Обсуждение оффера</li>
                        </ol>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Доступ на 90 дней</p>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 60%</p>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                </div>
                <div class="blackfriday-tale careerum-flex-fsfs position-relative blackfriday-tale-change-currency"
                    price-current-eur="56 €" price-current-rub="5 690 ₽" price-old-eur="149 €" price-old-rub="14900 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920582141-pZszF-Fram.png"
                        alt="" class="hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732005724312-5MiTW-Fram.png"
                        alt="" class="hidden-desc-mobile">
                    <div class="blackfriday-tale__label position-absolute hidden">
                        <p>поиск работы</p>
                    </div>
                    <div class="blackfriday-tale__header">
                        <h3>Карьера в кризис: как найти и не потерять работу</h3>
                        <p>Чтобы расти в компании и получать офферы вопреки сокращениям и изменениям на рынке.</p>
                    </div>
                    <div class="blackfriday-tale__content">
                        <div class="careerum-flex-fsc blackfriday-tale__switcher">
                            <p>Программа курса</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                <path
                                    d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <ol>
                            <li>Типы кризисов: панарама рынка</li>
                            <li>Алгоритм анализа кризисов</li>
                            <li>Боли компаний в кризис</li>
                            <li>ЛПР: кто и как нанимает в кризис</li>
                            <li>Позиционирование себя на рынке труда</li>
                            <li>Лайфхаки поиск работы в кризис</li>
                            <li>Ценный сотрудник: как закрепиться в текущей компании в кризис</li>
                        </ol>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Доступ на 90 дней</p>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 60%</p>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                </div>
                <div class="blackfriday-tale careerum-flex-fsfs position-relative blackfriday-tale-change-currency"
                    price-current-eur="56 €" price-current-rub="5 690 ₽" price-old-eur="149 €" price-old-rub="14900 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920591736-3vsCV-Fram.png"
                        alt="" class="hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732005724175-jhZhx-Fram.png"
                        alt="" class="hidden-desc-mobile">
                    <div class="blackfriday-tale__label position-absolute hidden">
                        <p>поиск работы</p>
                    </div>
                    <div class="blackfriday-tale__header">
                        <h3>Нетворкинг для карьеры и жизни</h3>
                        <p>Измените отношение к нетворкингу — избавитесь от барьеров и начнете строить нетворк во время
                            обучения.</p>
                    </div>
                    <div class="blackfriday-tale__content">
                        <div class="careerum-flex-fsc blackfriday-tale__switcher">
                            <p>Программа курса</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                <path
                                    d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <ol>
                            <li>Цели и ценности нетворкинга</li>
                            <li>Мышление и навыки продвинутого нетворкера</li>
                            <li>Где и с кем? Портрет окружения</li>
                            <li>Эффективные каналы поиска</li>
                            <li>Как строить отношения</li>
                            <li>Бонус: уроки по построению личного бренда</li>
                        </ol>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Доступ на 90 дней</p>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 60%</p>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                </div>
                <div class="blackfriday-tale careerum-flex-fsfs position-relative blackfriday-tale-change-currency"
                    price-current-eur="56 €" price-current-rub="5 690 ₽" price-old-eur="149 €" price-old-rub="14900 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920601523-8qdN5-Fram.png"
                        alt="" class="hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732005724053-MnuIv-Fram.png"
                        alt="" class="hidden-desc-mobile">
                    <div class="blackfriday-tale__label position-absolute hidden">
                        <p>поиск работы</p>
                    </div>
                    <div class="blackfriday-tale__header">
                        <h3>Great Deal: как получить оффер мечты</h3>
                        <p>Научитесь презентовать свой опыт и договариваться о желаемой зарплате, выгодном соцпакете и
                            других бонусах.</p>
                    </div>
                    <div class="blackfriday-tale__content">
                        <div class="careerum-flex-fsc blackfriday-tale__switcher">
                            <p>Программа курса</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                <path
                                    d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <ol>
                            <ol>
                                <li>Менталитет продавца</li>
                                <li>Предмет переговоров — не только зарплата</li>
                                <li>BATNA: ваша и компании</li>
                                <li>Как вести переговоры о зарплате</li>
                                <li>Процесс предоставления и принятия оффера</li>
                                <li>Установок, которые мешают продаже навыков</li>
                            </ol>
                        </ol>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Доступ на 90 дней</p>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 60%</p>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                </div>
                <div class="blackfriday-tale careerum-flex-fsfs position-relative blackfriday-tale-change-currency"
                    price-current-eur="56 €" price-current-rub="5 690 ₽" price-old-eur="149 €" price-old-rub="14900 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920609714-yudWd-Fram.png"
                        alt="" class="hidden-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732005723774-LfVSR-Fram.png"
                        alt="" class="hidden-desc-mobile">
                    <div class="blackfriday-tale__label position-absolute hidden">
                        <p>поиск работы</p>
                    </div>
                    <div class="blackfriday-tale__header">
                        <h3>Пробейте карьерный потолок</h3>
                        <p>Достигните целей как в Googlе, результатов как в Forbеs. Освойте базу карьерного мышления для
                            быстрого роста</p>
                    </div>
                    <div class="blackfriday-tale__content">
                        <div class="careerum-flex-fsc blackfriday-tale__switcher">
                            <p>Программа курса</p>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                <path
                                    d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                    stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                <path
                                    d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <ol>
                            <li>Основные стопперы на пути к целям</li>
                            <li>Первые шаги постановки целей</li>
                            <li>Синхронизация ваших целей с целями компании</li>
                            <li>OKR — метод постановки амбициозных целей</li>
                            <li>План на день и неделю</li>
                            <li>Актуализация целей</li>
                            <li>Проводники к вашим карьерным целям</li>
                            <li>Как стать ценным специалистом и стоить дороже</li>
                            <li>Как обсуждать повышение зарплаты</li>
                            <li>Как добиться повышения</li>
                        </ol>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__descr">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <p>Доступ на 90 дней</p>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 60%</p>
                    </div>
                    <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                </div>
            </div>
            <div class="blackfriday-tales-single careerum-flex-sbfs  blackfriday-tale-change-currency"
                price-current-eur="149 €" price-current-rub="14 900 ₽" price-old-eur="894 €" price-old-rub="89 480 ₽"
                link-eur="#eur2" link-rub="#buy">
                <div class="position-relative z-20">
                    <div class="blackfriday-tales-currency position-relative z-20 hidden-mobile">
                        <div class="hidden-tablet-mobile">
                            <div class="blackfriday-tales-currency-desctop careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs">
                                    <li data-currency="eur">EUR</li>
                                    <li data-currency="rub" class="active">RUB</li>
                                </ul>
                                <div class="blackfriday-tales-notif careerum-flex-cc">
                                    <div class="blackfriday-tales-notif-icon">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt="">
                                    </div>
                                    <div class="blackfriday-tales-notif-content">
                                        <p>Оплата в российских рублях возможна только картой
                                            российского банка. В&nbsp;евро — картой
                                            зарубежного банка</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hidden-desc">
                            <div class="blackfriday-tales__swicher-block">
                                <div class="blackfriday-tales__swicher-top">
                                    <p class="blackfriday-tales__swicher-header">Посмотреть
                                        цены в
                                        <span>RUB</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" class="blackfriday-tales__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="blackfriday-tales__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="active">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3>Забирайте все курсы черной пятницы</h3>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732709046280-YP2xU-ÑÐº.png"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732714223868-K96cn-ÑÐº.png"
                        alt="" class="position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732716930506-nvEZa-Grou.png"
                        alt="" class="position-relative hidden-desc-tablet">
                    <div class="hidden-desc">
                        <div class="careerum-flex-fsc blackfriday-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ на 90 дней</p>
                        </div>
                    </div>
                    <div class="careerum-flex-fsc blackfriday-tale__price">
                        <p class="price-current">5 690 ₽</p>
                        <p class="price-old">14900 ₽</p>
                        <p>— 80%</p>
                    </div>
                    <div class="hidden-tablet-mobile">
                        <div class="careerum-flex-fsc blackfriday-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ на 90 дней</p>
                        </div>
                    </div>
                    <a href="#buy" class="btn-color-main-black hidden-tablet-mobile">Выбрать</a>
                    <a href="#buy" class="btn-color-main-dark-orange hidden-desc">Выбрать</a>
                </div>
                <div class="position-relative z-10 hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732709002700-hfne0-Grou.svg"
                        alt="" class="position-relative hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732714316732-7gUuE-ÐÐ.svg"
                        alt="" class="position-relative hidden-desc">
                </div>
            </div>
            <div class="blackfriday-tales-header position-relative">
                <h2>Карьерные бустеры — 1 курс + 1 курс </h2>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732709690402-x5fnJ-Grou.png" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732713012357-QBeQq-Grou.png" alt=""
                    class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732717403143-VMYUl-Grou.png" alt=""
                    class="position-absolute hidden-desc-tablet">
            </div>
            <div class="blackfriday-tales-currency position-relative z-20 hidden-mobile">
                <div class="hidden-tablet-mobile">
                    <div class="blackfriday-tales-currency-desctop careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur">EUR</li>
                            <li data-currency="rub" class="active">RUB</li>
                        </ul>
                        <div class="blackfriday-tales-notif careerum-flex-cc">
                            <div class="blackfriday-tales-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="blackfriday-tales-notif-content">
                                <p>Оплата в российских рублях возможна только картой
                                    российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden-desc position-relative">
                    <div class="blackfriday-tales__swicher-block position-absolute">
                        <div class="blackfriday-tales__swicher-top">
                            <p class="blackfriday-tales__swicher-header">Посмотреть
                                цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="blackfriday-tales__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="blackfriday-tales__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="blackfriday-tales-center position-relative z-10">
                <div class="blackfriday-tale-center careerum-flex-fsfs blackfriday-tale-change-currency"
                    price-current-eur="88 €" price-current-rub="8 880 ₽" price-old-eur="298 €" price-old-rub="29 800 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <div>
                        <h3>Бустер «Поиск работы»</h3>
                        <div class="hidden-desc-tablet">
                            <h4>Что входит:</h4>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Продающее резюме</h5>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Great Deal: как получить оффер мечты</h5>
                        </div>
                        <div class="hidden-desc">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsc blackfriday-tale__price">
                            <p class="price-current">5 690 ₽</p>
                            <p class="price-old">14900 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <div class="hidden-tablet-mobile">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                    </div>
                    <div class="hidden-mobile">
                        <h4>Что входит:</h4>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Продающее резюме</h5>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Great Deal: как получить оффер мечты</h5>
                    </div>
                    <div class="position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732707637954-tUakT-Fram.svg"
                            alt="" class="position-relative hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732715226614-uuG0K-Fram.svg"
                            alt="" class="position-relative hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732717727845-lOzCy-Fram.svg"
                            alt="" class="position-relative hidden-desc-tablet">
                    </div>
                </div>
                <div class="blackfriday-tale-center careerum-flex-fsfs blackfriday-tale-change-currency"
                    price-current-eur="88 €" price-current-rub="8 880 ₽" price-old-eur="298 €" price-old-rub="29 800 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <div>
                        <h3>Бустер<br> «Работа в кризис»</h3>
                        <div class="hidden-desc-tablet">
                            <h4>Что входит:</h4>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Карьера в кризис: как найти и не потерять работу</h5>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Нетворкинг для карьеры и жизни</h5>
                        </div>
                        <div class="hidden-desc">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsc blackfriday-tale__price">
                            <p class="price-current">5 690 ₽</p>
                            <p class="price-old">14900 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <div class="hidden-tablet-mobile">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>
                    </div>
                    <div class="hidden-mobile">
                        <h4>Что входит:</h4>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Карьера в кризис: как найти и не потерять работу</h5>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Нетворкинг для карьеры и жизни</h5>
                    </div>
                    <div class="position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732710015441-QP8Cg-Fram.svg"
                            alt="" class="position-relative hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732715328692-MNzQ3-Fram.svg"
                            alt="" class="position-relative hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732718073661-RFtuV-Fram.svg"
                            alt="" class="position-relative hidden-desc-tablet">
                    </div>
                </div>
                <div class="blackfriday-tale-center careerum-flex-fsfs blackfriday-tale-change-currency"
                    price-current-eur="88 €" price-current-rub="8 880 ₽" price-old-eur="298 €" price-old-rub="29 800 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <div>
                        <h3 class="hidden-tablet">Бустер «Релокация»</h3>
                        <h3 class="hidden-desc-mobile">Бустер<br> «Релокация»</h3>
                        <div class="hidden-desc-tablet">
                            <h4>Что входит:</h4>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Международная карьера и релокация</h5>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Great Deal: как получить оффер мечты</h5>
                        </div>
                        <div class="hidden-desc">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsc blackfriday-tale__price">
                            <p class="price-current">5 690 ₽</p>
                            <p class="price-old">14900 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <div class="hidden-tablet-mobile">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>

                    </div>
                    <div class="hidden-mobile">
                        <h4>Что входит:</h4>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Международная карьера и релокация</h5>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Great Deal: как получить оффер мечты</h5>
                    </div>
                    <div class="position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732710111629-uhGbR-Fram.svg"
                            alt="" class="position-relative hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732715357072-oUZ1q-Fram.svg"
                            alt="" class="position-relative hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732718227868-Lwojy-Fram.svg"
                            alt="" class="position-relative hidden-desc-tablet">
                    </div>
                </div>
                <div class="blackfriday-tale-center careerum-flex-fsfs blackfriday-tale-change-currency"
                    price-current-eur="88 €" price-current-rub="8 880 ₽" price-old-eur="298 €" price-old-rub="29 800 ₽"
                    link-eur="#eur2" link-rub="#rub2">
                    <div>
                        <h3>Бустер<br>«Рост в карьере»</h3>
                        <div class="hidden-desc-tablet">
                            <h4>Что входит:</h4>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Продающее резюме</h5>
                            <p class="blackfriday-tale-center__label">курс</p>
                            <h5>Пробейте карьерный потолок</h5>
                        </div>
                        <div class="hidden-desc">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <div class="careerum-flex-fsc blackfriday-tale__price">
                            <p class="price-current">5 690 ₽</p>
                            <p class="price-old">14900 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <div class="hidden-tablet-mobile">
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Выбрать</a>

                    </div>
                    <div class="hidden-mobile">
                        <h4>Что входит:</h4>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Продающее резюме</h5>
                        <p class="blackfriday-tale-center__label">курс</p>
                        <h5>Пробейте карьерный потолок</h5>
                    </div>
                    <div class="position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732710188294-AV1Xu-Fram.svg"
                            alt="" class="position-relative hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732715390858-QYyaS-Fram.svg"
                            alt="" class="position-relative hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732718297575-lLVd0-Fram.svg"
                            alt="" class="position-relative hidden-desc-tablet">
                    </div>
                </div>
            </div>
            <div class="blackfriday-tales-bottom careerum-flex-sbfs">
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278649360-d3raW-Vect.svg"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732006365323-z7bdR-Vect.svg"
                        alt="" class="hidden-desc">
                    <p class="blackfriday-tales-bottom-header">Не знаете, какой курс выбрать?</p>
                    <p class="blackfriday-tales-bottom-subheader">Напишите нам — мы поможем выбрать лучшее решение под
                        вашу задачу</p>
                    <a href="https://t.me/careerum_support?roistat_visit=660124" target="_blank"
                        class="btn-color-main-dark-orange careerum-flex-cc hidden-mobile">
                        <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                                fill="#C8DAEA"></path>
                            <path
                                d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                                fill="#A9C6D8"></path>
                            <path
                                d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                                fill="white"></path>
                        </svg>
                        <p id="i03ubjg">Написать нам в Telegram</p>
                    </a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278685081-7nUnx-ÑÐ¾.svg"
                        alt="" class="hidden-tablet-mobile">
                    <div class="careerum-flex-fsfs blackfriday-tales-bottom-care">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723278768285-Yeat8-phot.png"
                                alt="">
                        </div>
                        <div>
                            <p class="blackfriday-tales-bottom-care-name">Анна </p>
                            <p class="blackfriday-tales-bottom-care-position">Команда
                                заботы Careerum</p>
                            <p class="blackfriday-tales-bottom-care-descr hidden-tablet-mobile">Добрый
                                день! Построить карьеру мечты в&nbsp;одиночку
                                бывает непросто. Но мы рядом и&nbsp;приведем вас к&nbsp;заветной цели 💙</p>
                        </div>

                        <p class="blackfriday-tales-bottom-care-descr hidden-desc">Добрый
                            день! Построить карьеру мечты в&nbsp;одиночку
                            бывает непросто. Но мы рядом и&nbsp;приведем вас к&nbsp;заветной цели 💙</p>
                    </div>
                </div>
                <a href="https://t.me/careerum_support?roistat_visit=660124" target="_blank"
                    class="btn-color-main-dark-orange careerum-flex-cc hidden-desc-tablet">
                    <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.9104 12.5754L9.51374 19.781C9.51374 19.781 9.83922 20.4552 10.1877 20.4552C10.5363 20.4552 15.7201 15.0624 15.7201 15.0624L21.4847 3.92822L7.00329 10.7153L6.9104 12.5754Z"
                            fill="#C8DAEA"></path>
                        <path
                            d="M10.3623 14.4233L9.86251 19.7346C9.86251 19.7346 9.65332 21.362 11.2804 19.7346C12.9074 18.1072 14.4648 16.8522 14.4648 16.8522"
                            fill="#A9C6D8"></path>
                        <path
                            d="M6.9574 12.8324L1.60225 11.0876C1.60225 11.0876 0.962247 10.828 1.16833 10.2392C1.21075 10.1177 1.29633 10.0144 1.55233 9.83687C2.73889 9.00981 23.5146 1.54247 23.5146 1.54247C23.5146 1.54247 24.1012 1.3448 24.4471 1.47628C24.5327 1.50277 24.6097 1.55152 24.6703 1.61755C24.7309 1.68357 24.7728 1.7645 24.7918 1.85205C24.8292 2.00668 24.8448 2.16578 24.8383 2.32473C24.8366 2.46224 24.82 2.58969 24.8074 2.78956C24.6808 4.83116 20.8942 20.0683 20.8942 20.0683C20.8942 20.0683 20.6677 20.9599 19.856 20.9904C19.6565 20.9969 19.4578 20.9631 19.2716 20.8911C19.0855 20.8191 18.9157 20.7103 18.7725 20.5713C17.1797 19.2012 11.6742 15.5012 10.4577 14.6875C10.4302 14.6688 10.4071 14.6445 10.3899 14.6161C10.3727 14.5877 10.3617 14.5559 10.3578 14.523C10.3408 14.4372 10.4341 14.3309 10.4341 14.3309C10.4341 14.3309 20.0205 5.80981 20.2756 4.91527C20.2954 4.84597 20.2208 4.81177 20.1206 4.84213C19.4838 5.07637 8.44622 12.0467 7.22803 12.816C7.14034 12.8425 7.04766 12.8481 6.9574 12.8324Z"
                            fill="white"></path>
                    </svg>
                    <p id="i03ubjg">Написать нам в Telegram</p>
                </a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-blackfriday-mini', {
        label: 'Black friday main mini (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-blackfriday-mini main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731910870671-8wMca-Elli.png" alt=""
                class="position-absolute z-10">
            <div class="careerum-flex-fsfs position-relative z-20 blackfriday-mini__top">
                <div class="position-relative">
                    <h1 class="position-relative z-10">BLACK FRIDAY</h1>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732087441952-QhniV-Soft.svg"
                        alt="" class="position-absolute z-20 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732095446798-lWx8b-Grou.png"
                        alt="" class="position-absolute z-20 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732102990307-sJjMO-Grou.png"
                        alt="" class="position-absolute z-20 hidden-desc-tablet">
                </div>
                <div class="position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732088491366-QHtRr-Grou.png"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732095699205-5ASbQ-Soft.png"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <p class="blackfriday-mini__subheader position-relative z-20">Больше никаких «черных понедельников»
                        на работе</p>
                    <p class="blackfriday-mini__text position-relative z-20">Лучшие инструменты Careerum для запуска
                        вашей карьеры в космос!</p>
                </div>
                <div>
                    <a href="#form" class="btn-color-main-dark-orange">Зарегистрироваться бесплатно</a>
                </div>
            </div>
            <div class="blackfriday-mini__center position-relative z-20">
                <div class="blackfriday-mini__center-header position-relative">
                    <h2>После регистрации вы получите</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732088625516-cMx0r-Unio.svg"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732096105492-yDQ18-Grou.png"
                        alt="" class="position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732101266490-BKgHM-Grou.png"
                        alt="" class="position-absolute hidden-desc-tablet">
                </div>
                <div class="blackfriday-mini__center-row1 position-relative careerum-flex-sbfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090285714-w52Ap-Soft.png"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732101558827-ymFft-Grou.png"
                        alt="" class="position-absolute hidden-desc-tablet">
                    <div class="blackfriday-mini__center-row-header careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090324312-2vgc7-Gift.svg"
                                alt="" class="hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732101429959-yvPO3-Gift.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Подарки</p>
                            <p>самые важные шаблоны для поиска работы</p>
                        </div>
                    </div>
                    <div class="blackfriday-mini__center-row-content careerum-flex-fsfs position-relative">
                        <div>
                            <p>Шаблоны резюме</p>
                            <p>На русском и английском </p>
                        </div>
                        <div>
                            <p>Шаблоны сопроводительного</p>
                            <p>На русском и английском </p>
                        </div>
                        <div>
                            <p>Шаблон воронки поиска работы</p>
                        </div>
                        <div>
                            <p>Шаблон для поиска достижений в резюме</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090350618-adOk5-Soft.png"
                            alt="" class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732096736844-YwyHh-Grou.png"
                            alt="" class="position-absolute hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732102083433-J0cbz-Soft.png"
                            alt="" class="position-absolute hidden-desc-tablet">
                    </div>
                </div>
                <div class="blackfriday-mini__center-row2 position-relative careerum-flex-sbfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090395032-s4smc-Grou.png"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732102204590-auOAE-Soft.png"
                        alt="" class="position-absolute hidden-desc-tablet">
                    <div class="blackfriday-mini__center-row-header careerum-flex-fsc">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090369169-WzyHp-Alar.svg"
                                alt="" class="hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732102257014-1x5Pu-Alar.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Будете первым</p>
                        </div>
                    </div>
                    <div class="blackfriday-mini__center-row-content careerum-flex-fsfs">
                        <div>
                            <p>Раньше всех узнаете о старте распродажи</p>
                        </div>
                        <div>
                            <p>Получите доступ к секретным предложениям</p>
                        </div>
                    </div>
                </div>
                <div class="blackfriday-mini__center-row3 position-relative careerum-flex-sbfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090473251-R73mQ-Soft.png"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732097471151-HoZKj-Soft.png"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <div class="blackfriday-mini__center-row-header careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090496439-i14ac-Spar.svg"
                                alt="" class="hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732102715673-EauTU-Spar.svg"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p>Лучшие курсы из подписки Сareerum </p>
                        </div>
                    </div>
                    <div class="blackfriday-mini__center-row-content position-relative">
                        <div>
                            <p>Купить курсы по отдельности можно только в дни Черной пятницы</p>
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732090525217-mNNEf-Grou.png"
                            alt="" class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732097607850-0WAtP-Grou.png"
                            alt="" class="position-absolute hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732102814481-Ey9Dj-Grou.png"
                            alt="" class="position-absolute hidden-desc-tablet">
                    </div>
                </div>
                <div class="blackfriday-mini__center-link">
                    <a href="#form" class="btn-color-main-dark-orange">Зарегистрироваться бесплатно</a>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-blackfriday-form', {
        label: 'Black friday form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-blackfriday-form main-wrapper">
        <div class="careerum-container-responsive">
            <div class="position-relative z-20 blackfriday-main__center">
                <div class="position-absolute blackfriday-main__center-top careerum-flex-fsc">
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="position-absolute blackfriday-main__center-bottom careerum-flex-fsc">
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="blackfriday-main__center-item careerum-flex-fsc">
                        <p>29.11 – 2.12</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                        <p>Черная пятница в Careerum</p>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-mobile">
                            <g filter="url(#filter0_ddif_8591_18890)">
                                <path
                                    d="M16.7048 5.54245C16.6482 5.16194 16.0941 5.17826 16.06 5.56144L15.7743 8.77598C15.4054 12.9268 12.2402 16.2841 8.11836 16.8968L4.92622 17.3712C4.54567 17.4278 4.56199 17.9819 4.94522 18.016L8.15975 18.3017C12.3106 18.6707 15.6678 21.8358 16.2805 25.9577L16.755 29.1498C16.8116 29.5304 17.3656 29.5141 17.3997 29.1308L17.6855 25.9163C18.0544 21.7655 21.2195 18.4082 25.3415 17.7955L28.5336 17.3211C28.9141 17.2645 28.8978 16.7104 28.5146 16.6763L25.3001 16.3906C21.1492 16.0216 17.7919 12.8565 17.1793 8.73459L16.7048 5.54245Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8591_18890" x="0.281295" y="0.89775" width="32.8969"
                                    height="32.8969" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.50783" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8591_18890" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="2.18382" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8591_18890"
                                        result="effect2_dropShadow_8591_18890" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8591_18890"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3.01566" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8591_18890" />
                                    <feGaussianBlur stdDeviation="0.456069"
                                        result="effect4_foregroundBlur_8591_18890" />
                                </filter>
                            </defs>
                        </svg>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="hidden-desc-tablet">
                            <g filter="url(#filter0_ddif_8658_6545)">
                                <path
                                    d="M11.0999 3.7525C11.0828 3.53034 10.7621 3.51696 10.7266 3.73693L10.4292 5.58229C10.0452 7.96515 8.07839 9.77445 5.67185 9.95871L3.80813 10.1014C3.58595 10.1184 3.57257 10.4392 3.79257 10.4747L5.63793 10.7721C8.02076 11.1561 9.83006 13.1229 10.0143 15.5294L10.157 17.3932C10.1741 17.6153 10.4948 17.6287 10.5303 17.4087L10.8277 15.5634C11.2117 13.1805 13.1785 11.3712 15.5851 11.187L17.4488 11.0443C17.6709 11.0272 17.6843 10.7064 17.4644 10.671L15.619 10.3736C13.2361 9.98956 11.4268 8.02277 11.2426 5.61621L11.0999 3.7525Z"
                                    fill="#FFF2DD" />
                            </g>
                            <defs>
                                <filter id="filter0_ddif_8658_6545" x="0.960073" y="0.904165" width="19.3367"
                                    height="19.3374" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="0.92338" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.825684 0 0 0 0 0.377441 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_8658_6545" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.33735" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                        values="0 0 0 0 0.980518 0 0 0 0 0.75998 0 0 0 0 0.192912 0 0 0 1 0" />
                                    <feBlend mode="normal" in2="effect1_dropShadow_8658_6545"
                                        result="effect2_dropShadow_8658_6545" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8658_6545"
                                        result="shape" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="1.84676" />
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
                                    <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8658_6545" />
                                    <feGaussianBlur stdDeviation="0.279292" result="effect4_foregroundBlur_8658_6545" />
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="position-relative z-10 blackfriday-form__wrapper careerum-flex-sbfs">
                <div class="position-relative">
                    <div class="blackfriday-form__wrapper-label">
                        <p>29.11 — 2.12</p>
                    </div>
                    <h2>BLACK FRIDAY</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732093891499-OGwP4-Soft.png"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1732103370450-YA9sb-Grou.png"
                        alt="" class="position-absolute hidden-desc-tablet">
                </div>
                <div>
                    <div class="careerum-registration-form-club40">
                        <form class="deva-form" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-club40-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-club40-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-club40-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                        href="#">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                disabled>Зарегистрироваться бесплатно</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-blackfriday-banner', {
        label: 'Black friday banner (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-blackfriday-banner z-50" data-redirect="no" data-url="" data-static="yes" data-offset=""
        data-timer-end="12/02/2024 23:59 GMT+0300">
        <div class="careerum-container-responsive careerum-flex-sbc">
            <div>
                <p class="hidden-mobile">29.11 — 2.12</p>
                <p>Распродажа закончится через</p>
            </div>
            <div class="blackfriday-banner-timer careerum-flex-cc">
                <div>
                    <p class="timer-day-number">00</p>
                    <p class="timer-day-text">дней</p>
                </div>
                <div>
                    <p class="timer-hour-number">00</p>
                    <p class="timer-hour-text">часов</p>
                </div>
                <div>
                    <p class="timer-min-number">00</p>
                    <p class="timer-min-text">минут</p>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-blackfriday-popup', {
        label: 'Black friday popup 2 предложения (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
        <div class="careerum-popup careerum-blackfriday-popup" id="rub2">
            <div class="popup__close-button-wrapper">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="close-switch">
                    <rect width="32" height="32" rx="16" fill="#C2C2C2" />
                    <g clip-path="url(#clip0_7555_2802)">
                        <path d="M20.7979 20.6359L11.2059 11.083" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.1998 20.639L20.8018 11.0781" stroke="white" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_7555_2802">
                            <rect width="12" height="12" fill="white" transform="translate(10 10)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="blackfriday-popup-content">
                <div class="careerum-flex-sbst">
                    <div class="blackfriday-popup-content-left careerum-flex-fsfs">
                        <h3>Курс «Продающее резюме»</h3>
                        <div>
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                            <div class="careerum-flex-fsc blackfriday-tale__price">
                                <p class="price-current">5 690 ₽</p>
                                <p class="price-old">14900 ₽</p>
                                <p>— 60%</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue close-switch popup-open-next">Купить только этот курс</a>
                    </div>
                    <div class="blackfriday-popup-content-right">
                        <h3>Набор из 2 курсов</h3>
                        <p class="blackfriday-popup__label">курс</p>
                        <h5>Продающее резюме</h5>
                        <p class="blackfriday-popup__label">курс</p>
                        <h5>Пробейте карьерный потолок</h5>
                        <div>
                            <div class="careerum-flex-fsc blackfriday-tale__descr">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <p>Доступ на 90 дней</p>
                            </div>
                            <div class="careerum-flex-fsc blackfriday-tale__price">
                                <p class="price-current">8 880 ₽</p>
                                <p class="price-old">29800 ₽</p>
                                <p>— 70%</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-orange close-switch popup-open-next">Купить 2 курса</a>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('careerum-gift', {
        label: 'Gift (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-gift main-wrapper">
        <div class="careerum-container-responsive">
            <div class="position-relative z-10 gift-backgrounds">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734950889834-rHAQw-Grou.png" class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734951099806-gRn0x-Elli.png" class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734951100141-3NBB6-Grou.png" class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734971344861-JsQEk-Grou.png" class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734971345352-LczH3-Elli.png" class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734971345510-AI8mC-Grou.png" class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734973591828-HO3KP-Grou.png" class="position-absolute hidden-desc-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734973592436-WenHI-Elli.png" class="position-absolute hidden-desc-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734973592323-IrWRN-Grou.png" class="position-absolute hidden-desc-tablet">
            </div>
            <div class="position-relative z-20 gift-top-logo">
                <a href="#">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734936850728-lmFrT-logo.svg"
                        alt="logo">
                </a>
            </div>
            <div class="position-relative z-20 careerum-flex-sbfs gift-form-top">
                <div>
                    <h1>Подарок для коллег, который выделит вас из череды поздравлений от GPT-чата</h1>
                    <div class="careerum-flex-fsfs gift-form-top-imgs">
                        <div class="gift-form-top-img-left">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734947838017-MnYVP-Fram.png" alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734962914067-eV7bV-Fram.png" alt="" class="hidden-desc">
                        </div>
                        <div class="gift-form-top-img-right">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734947839757-1Rh3U-Fram.png" alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734962914187-LkN79-Fram.png" alt="" class="hidden-desc">
                        </div>
                    </div>
                </div>
                <div class="gift-form-wrapper">
                    <div class="careerum-registration-form-club40">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-club40-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-club40-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-club40-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Забрать подарки для коллег</a>
                        </form>
                    </div>
                </div>
            </div>
            <div class="position-relative z-20 careerum-flex-fsfs gift-cards">
                <div class="position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734948657417-ExXly-Grou.svg" alt="" class="position-absolute hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734972396090-LsxxB-Grou.svg" alt="" class="position-absolute hidden-desc-tablet">
                    <h2>Набор из 20 открыток</h2>
                    <p class="gift-cards-text">С классной графикой и веселым пожеланием. Хватит на всех коллег!</p>
                    <p class="gift-cards-text">В формате PDF: можно отправить коллеге онлайн или распечатать</p>
                </div>
                <div class="careerum-flex-fsfs position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734948792866-5Nqot-Fram.png" alt="" class="position-relative hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734948792988-MIAsP-Fram.png" alt="" class="position-relative hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734948792456-Betc7-Fram.png" alt="" class="position-relative hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734963359415-6O2Jv-Grou.png" alt="" class="position-relative hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734972523654-JjGcE-Ð¾Ñ.png" alt="" class="position-relative hidden-desc-tablet">
                </div>
            </div>
            <div class="position-relative z-20 careerum-flex-fsfs gift-bot">
                <div class="position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734949510687-SizIJ-Grou.svg" alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734963767444-xaGrI-Grou.svg" alt="" class="position-relative hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734972949222-FB5UL-Grou.svg" alt="" class="position-relative hidden-desc-tablet">
                    <h2>Бот с карьерными аффирмациями</h2>
                    <p class="gift-bot-text">Бот будет слать аффирмации с нотками карьерного роста вашему коллеге:</p>
                    <ul>
                        <li>Чтобы понедельники радовали</li>
                        <li>Чтобы не проваливаться в синдром самозванца</li>
                        <li>Чтобы замечать свои успехи</li>
                        <li>Чтобы расти в профессии</li>
                    </ul>
                </div>
                <div class="position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734949709865-j8Whk-Fram.png" alt="" class="position-relative hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734963605425-dX3jj-Fram.png" alt="" class="position-relative hidden-desc">
                    <div class="position-absolute gift-bot-chats">
                        <div class="position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734949710219-70WlA-chat.png" alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734963606070-S8qeR-chat.png" alt="" class="hidden-desc">
                            <p class="position-absolute">Я всегда стремлюсь к профессиональному и личному росту.</p>
                        </div>
                        <div class="position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734949710434-OrP4s-chat.png" alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734963605945-2VCQj-chat.png" alt="" class="hidden-desc">
                            <p class="position-absolute">Я открыто говорю о своих успехах и достижениях.</p>
                        </div>
                        <div class="position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734949710326-x8od6-chat.png" alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734963605795-izSHZ-chat.png" alt="" class="hidden-desc">
                            <p class="position-absolute">Я не боюсь совершать ошибки</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="position-relative z-20 careerum-flex-sbfs gift-form-bottom">
                <div>
                    <p class="gift-form-bottom-header">Нетворкинг — двигатель карьеры,  а Новый год — прекрасный повод, чтобы поддерживать связи</p>
                </div>
                <div class="gift-form-wrapper">
                    <div class="careerum-registration-form-club40">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm" data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-club40-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-club40-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-club40-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Забрать подарки для коллег</a>
                        </form>
                    </div>
                </div>
            </div>
            <div class="position-relative z-20 gift-bottom-logo careerum-flex-fsc">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1734950717967-BtVec-Unio.svg" alt="">
                <p>© Careerum 2024<br>
                    Все права защищены</p>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-veb4-main', {
        label: 'Veb 4 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb4-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736950651807-6b5Dy-Elli.png" alt=""
                        class="hidden-desc-tablet position-absolute z-10">
                    <div class="veb4-main-top position-relative z-20">
                        <div class="veb4-main-logo careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736925596516-FtEaP-logo.svg"
                                alt="" class="hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736950477033-PxsRw-Grou.svg"
                                alt="" class="hidden-desc-tablet">
                            <p>платформа карьерного развития</p>
                        </div>
                        <div class="veb4-main-date careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736949235494-I9oAA-Cale.svg"
                                alt="" class="hidden-desc-tablet">
                            <p>18 февраля, 19:00 мск</p>
                        </div>
                        <div class="veb4-main-subheader">
                            <p>Бесплатный мастер-класс</p>
                        </div>
                        <div class="veb4-main-header position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736926183347-QUGUJ-Grou.svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736926182956-AtQV0-Grou.svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736942909360-jfBcT-Grou.svg"
                                alt="" class="position-absolute hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736942909087-IIaw0-Grou.svg"
                                alt="" class="position-absolute hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736951304683-0xD9G-Grou.svg"
                                alt="" class="position-absolute hidden-desc-tablet">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736951304411-EmDAQ-Grou.svg"
                                alt="" class="position-absolute hidden-desc-tablet">
                            <h1>Разбор ошибок поиска работы</h1>
                        </div>
                        <div class="veb4-main-speakers careerum-flex-cst">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736926498127-1Moo4-Mask.png"
                                    alt="">
                                <p>Ольга Лермонтова, карьерный стратег,<br> Италия</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736926498393-FvGzg-Mask.png"
                                    alt="">
                                <p>Софи Бессон, карьерный эксперт,<br> Израиль</p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736926498602-xyDdb-Mask.png"
                                    alt="">
                                <p>Майя Бурякина, карьерный эксперт,<br> США</p>
                            </div>
                        </div>
                        <div class="veb4-main-button">
                            <div class="careerum-flex-cfs">
                                <p>0₽</p>
                                <p>4990₽</p>
                            </div>
                            <a href="#form-top" class="btn-color-main-dark-orange">Зарегистрироваться бесплатно</a>
                        </div>
                        <div class="veb4-main-label position-absolute careerum-flex-cc">
                            <p><span>всего<br> 3 000 </span> бесплатных<br> мест</p>
                        </div>
                        <div class="veb4-main-speakers-label position-absolute">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736926183240-iiRlr-Grou.svg"
                                alt="" class="position-relative hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736945259231-5jkx2-Grou.svg"
                                alt="" class="position-relative hidden-desc">
                            <p>Спикеры</p>
                        </div>
                    </div>
                    <div class="veb4-main-bottom careerum-flex-sbfs position-relative z-20">
                        <div>
                            <p>Узнайте, как получить job offer уже этой весной:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652870-1TAFs-Chec.svg"
                                        alt="">
                                    <p>Обсудим тренды найма в РФ и за рубежом в 2025 году</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652764-dc0XW-Targ.svg"
                                        alt="">
                                    <p>Топ-10 главных ошибок поиска работы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652497-K8yBL-Note.svg"
                                        alt="">
                                    <p>Найдем слабые места в вашем резюме и усилим его</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652497-K8yBL-Note.svg"
                                        alt="">
                                    <p>Разберем кейсы кандидатов, которые привели к офферам</p>
                                </li>
                            </ul>
                        </div>
                        <div class="veb4-main-bottom-right-wrapper">
                            <div class="veb4-main-bottom-right">
                                <div class="careerum-flex-fsfs">
                                    <p>4990₽</p>
                                    <div class="careerum-flex-fsc">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740388082908-oiKTq-Lock.svg"
                                            alt="">
                                        <p>Доступ на 30 дней</p>
                                    </div>
                                </div>
                                <a href="#" class="btn-color-main-dark-orange">Купить запись мастер-класса</a>
                            </div>
                        </div>
                        <div>
                            <div class="careerum-registration-form-club40">
                                <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                    data-gjs-type="deva-registration-form">
                                    <div class="careerum-club40-form-name">
                                        <input type="text" name="name" value="" required placeholder="Имя">
                                    </div>
                                    <div class="careerum-club40-form-telegram">
                                        <input type="text" name="telegram" value="" required placeholder="Telegram">
                                    </div>
                                    <div class="careerum-club40-form-email">
                                        <input type="text" name="email" value="" required placeholder="Почта">
                                    </div>
                                    <div class="careerum-club40-form-phone">
                                        <input type="tel" value="" name="tel" required class="itl-input">
                                    </div>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                                href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                    </div>
                                    <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                        disabled>Зарегистрироваться бесплатно</a>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });

    blockManager.add('careerum-veb4-problems', {
        label: 'Veb 4 problems (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb4-problems main-wrapper">
                <div class="careerum-container-responsive">
                    <h2>Прожарки — в прямом эфире эксперты разберут вашу проблему и дадут решение </h2>
                    <div class="veb4-problems-items careerum-flex-fsst">
                        <div class="veb4-problems-item position-relative">
                            <p class="veb4-problems-item-header position-relative z-20">Прожарка резюме и LinkedIn</p>
                            <p class="veb4-problems-item-text position-relative z-20">Подготовьте свое CV и ссылку на LinkedIn.
                                Будь готовы скинуть
                                в чат во время эфира</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736935871039-eT2ri-3d-i.png"
                                alt="" class="position-absolute hidden-tablet-mobile z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736947607375-C9g83-3d-i.png"
                                alt="" class="position-absolute hidden-desc-mobile z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736952574883-izTjR-3d-i.png"
                                alt="" class="position-absolute hidden-desc-tablet z-10">
                        </div>
                        <div class="veb4-problems-item position-relative">
                            <p class="veb4-problems-item-header position-relative z-20">Прожарка ваших ошибок поиска</p>
                            <p class="veb4-problems-item-text position-relative z-20">После регистрации заполните анкету и
                                опишите вашу проблему поиска
                                работы. Эксперты сделают разбор в прямом эфире</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736935363047-yk19N-3dic.png"
                                alt="" class="position-absolute hidden-tablet-mobile z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736947607646-8iqUJ-3dic.png"
                                alt="" class="position-absolute hidden-desc-mobile z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736952575157-tzjbK-3dic.png"
                                alt="" class="position-absolute hidden-desc-tablet z-10">
                        </div>
                        <div class="veb4-problems-item position-relative">
                            <p class="veb4-problems-item-header white position-relative z-20">Разбор успешных кейсов кандидатов
                            </p>
                            <p class="veb4-problems-item-text white position-relative z-20">Поделимся кейсами клиентов, которые
                                уже работают в крупных
                                компаниях по всему миру</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736935781880-SVcag-3dic.png"
                                alt="" class="position-absolute hidden-tablet-mobile z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736947607771-NbToc-3dic.png"
                                alt="" class="position-absolute hidden-desc-mobile z-10">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736952575277-DiESd-3dic.png"
                                alt="" class="position-absolute hidden-desc-tablet z-10">
                        </div>
                    </div>
                </div>
            </div>`
    });

    blockManager.add('careerum-veb4-form', {
        label: 'Veb 4 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-veb4-form main-wrapper">
                <div class="careerum-container-responsive careerum-flex-sbfs position-relative">
                    <div>
                        <div class="veb4-form-label careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736949235494-I9oAA-Cale.svg"
                                alt="" class="hidden-desc">
                            <p>18 февраля, 19:00 мск</p>
                        </div>
                        <div class="veb4-form-subheader">
                            <p>Бесплатный мастер-класс</p>
                        </div>
                        <div class="veb4-form-header position-relative">
                            <h2>Разбор ошибок поиска работы</h2>
                            <div class="position-absolute">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736939895228-zeoHb-Grou.svg"
                                    alt="" class="position-absolute hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736939894354-KVhTB-Grou.svg"
                                    alt="" class="position-absolute hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736949623688-Kr4Em-Grou.svg"
                                    alt="" class="position-absolute hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736949623420-8fdGM-Grou.svg"
                                    alt="" class="position-absolute hidden-desc-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736953912661-mWEsK-Grou.svg"
                                    alt="" class="position-absolute hidden-desc-tablet">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736953912392-nkgHk-Grou.svg"
                                    alt="" class="position-absolute hidden-desc-tablet">
                            </div>
                        </div>
                        <ul class="hidden-tablet-mobile">
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652764-dc0XW-Targ.svg"
                                    alt="">
                                <p>Рассмотрим топ-10 главных ошибок</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652870-1TAFs-Chec.svg"
                                    alt="">
                                <p>Обсудим тренды найма в РФ и за рубежом в 2025 году</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652497-K8yBL-Note.svg"
                                    alt="">
                                <p>Найдем слабые места в вашем резюме и усилим его</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1736928652497-K8yBL-Note.svg"
                                    alt="">
                                <p>Разберем кейсы кандидатов, которые привели к офферам</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <div class="careerum-registration-form-club40">
                            <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-agree">
                                    <label>
                                        <input type="checkbox" name="agree">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                fill="none">
                                                <path
                                                    d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                            </svg>
                                        </div>
                                    </label>
                                    <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                            href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                                </div>
                                <div class="careerum-club40-form-price careerum-flex-fsfs hidden-tablet-mobile">
                                    <p>0₽</p>
                                    <p>4990₽</p>
                                </div>
                                <a href="#" class="submit-btn btn-color-main-bright-orange button-sent"
                                    disabled>Зарегистрироваться бесплатно</a>
                            </form>
                        </div>
                    </div>
                    <div class="veb4-form-label-absolute position-absolute careerum-flex-cc">
                        <p><span>всего<br> 3 000 </span> бесплатных<br> мест</p>
                    </div>
                </div>
            </div>`
    });

    blockManager.add('careerum-veb4-reviews', {
        label: 'Veb 4 reviews',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-veb4-reviews main-wrapper">
        <div class="careerum-container-responsive">
            <h2>
                Отзывы о мастер-классе
            </h2>
            <div class="veb4-reviews-slider-wrapper">
                <div class="veb4-reviews-slider">
                    <div class="veb4-reviews-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740389145330-LPZI9-Grou.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740395529224-SL34w-Grou.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740399621516-UqvkB-Grou.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                    <div class="veb4-reviews-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740389145101-GHBFB-Grou.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740395529017-VIaLI-Grou.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740399621294-CmmKG-Grou.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                    <div class="veb4-reviews-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740389144866-eBX5n-Grou.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740395528854-u7dHD-Grou.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740399621107-W2FxV-Grou.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                    <div class="veb4-reviews-slider-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740389144459-RdEXL-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740395528492-snR9w-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740399620770-w4hSc-Fram.png"
                            alt="" class="hidden-desc-tablet">
                    </div>
                </div>
            </div>
            <div class="veb4-reviews-nav careerum-flex-fec">
                <div class="veb4-reviews-nav-prev">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1227_3497)">
                            <foreignObject x="-18.1166" y="-18.1167" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_1227_3497_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" y="39.9999" width="40" height="40"
                                transform="rotate(-90 0 39.9999)" fill="black" />
                            <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_1227_3497_clip_path">
                                <rect transform="translate(18.1166 18.1167)" y="39.9999" width="40" height="40"
                                    transform="rotate(-90 0 39.9999)" />
                            </clipPath>
                            <clipPath id="clip0_1227_3497">
                                <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="veb4-reviews-nav-next">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1227_3501)">
                            <foreignObject x="-18.1166" y="-18.1165" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_1227_3501_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" x="40" y="0.00012207" width="40" height="40"
                                transform="rotate(90 40 0.00012207)" fill="black" />
                            <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_1227_3501_clip_path">
                                <rect transform="translate(18.1166 18.1165)" x="40" y="0.00012207" width="40"
                                    height="40" transform="rotate(90 40 0.00012207)" />
                            </clipPath>
                            <clipPath id="clip0_1227_3501">
                                <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-veb4-buy', {
        label: 'Veb 4 buy',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-veb4-buy main-wrapper" data-amount-rub="4990₽" data-amount-eur="50€" data-link-rub="#popup1"
        data-link-eur="#popup2">
        <div class="careerum-container-responsive">
            <div class="veb4-buy-curr-wrapper careerum-flex-fec position-relative z-20">
                <div class="veb4-buy-curr hidden-tablet-mobile">
                    <ul class="careerum-flex-fsfs">
                        <li data-currency="eur">EUR</li>
                        <li data-currency="rub" class="active">RUB</li>
                    </ul>
                </div>
                <div class="club40-tariffs__swicher-block position-absolute">
                    <div class="club40-tariffs__swicher-top">
                        <p class="club40-tariffs__swicher-header">Посмотреть цены в
                            <span>EUR</span>
                        </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                            fill="none" class="club40-tariffs__swicher-arrow">
                            <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                        </svg>
                    </div>
                    <div class="club40-tariffs__swicher-bottom">
                        <ul>
                            <li data-currency="rub" class="active">
                                RUB
                            </li>
                            <li data-currency="eur">
                                EUR
                            </li>
                        </ul>
                        <p>
                            Обратите внимание,<br> что оплата в российских рублях
                            возможна только<br> с карты
                            российского банка. Оплата в евро — с карты зарубежного банка
                        </p>
                    </div>
                </div>
            </div>
            <div class="veb4-buy-tale position-relative z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391593737-Ni2HV-Vect.svg" alt=""
                    class="position-absolute z-10 hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740397264383-dSx1B-Vect.svg" alt=""
                    class="position-absolute z-10 hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740400299379-ar9lM-Vect.svg" alt=""
                    class="position-absolute z-10 hidden-desc-tablet">
                <div class="position-relative z-20 veb4-buy-tale-top">
                    <div>
                        <p>Запись мастер-класса</p>
                    </div>
                    <h2>Тренды найма 2025 и разбор ошибок поиска работы</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391623575-hiJq5-Grou.svg"
                        alt="" class="position-absolute veb4-buy-tale-header-line1 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391623718-d2BY9-Vect.svg"
                        alt="" class="position-absolute veb4-buy-tale-header-line2 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740397263782-qgpr2-Grou.svg"
                        alt="" class="position-absolute veb4-buy-tale-header-line1 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740397264221-MO2cN-Vect.svg"
                        alt="" class="position-absolute veb4-buy-tale-header-line2 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740400299151-gyoD7-Grou.svg"
                        alt="" class="position-absolute veb4-buy-tale-header-line1 hidden-desc-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740400298857-7i4Tq-Vect.svg"
                        alt="" class="position-absolute veb4-buy-tale-header-line2 hidden-desc-tablet">
                </div>
                <div class="careerum-flex-sbfs z-20 position-relative veb4-buy-tale-bottom">
                    <div class="veb4-buy-bottom-left">
                        <ul>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391717586-E46Ev-Targ.svg"
                                    alt="">
                                <p>Рассмотрим топ-10 главных ошибок</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391717467-T15aS-Chec.svg"
                                    alt="">
                                <p>Обсудим тренды найма в РФ и за рубежом в 2025 году</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391717198-HnIaj-Note.svg"
                                    alt="">
                                <p>Найдем слабые места в вашем резюме и усилим его</p>
                            </li>
                            <li class="careerum-flex-fsfs">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740391717198-HnIaj-Note.svg"
                                    alt="">
                                <p>Разберем кейсы кандидатов, которые привели к офферам</p>
                            </li>
                        </ul>
                    </div>
                    <div class="veb4-buy-bottom-right">
                        <div class="careerum-flex-fsfs">
                            <p class="veb4-buy-amount">4990₽</p>
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740388082908-oiKTq-Lock.svg"
                                    alt="">
                                <p>Доступ на 30 дней</p>
                            </div>
                        </div>
                        <a href="#" class="btn-color-main-dark-orange">Купить</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-main', {
        label: 'Product 4 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-main main-wrapper">
        <div class="careerum-container-responsive careerum-flex-sbfs position-relative">
            <div class="position-relative z-20">
                <p class="product-main-subheader hidden-desc-mobile">Интенсив по поиску работы</p>
                <div class="product-main-labels careerum-flex-fsfs">
                    <div class="product-main-label careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737042994011-gJfkx-Cale.svg"
                            alt="">
                        <p>Старт: 19 февраля</p>
                    </div>
                    <div class="product-main-label careerum-flex-fsc">
                        <p>7 поток</p>
                    </div>
                </div>
                <p class="product-main-subheader hidden-tablet">Интенсив по поиску работы</p>
                <h1>Звездный кандидат</h1>
                <p class="product-main-text">Дадим рецепт сильного кандидата и доведем за руку до оффера</p>
                <a href="#buy" class="btn-color-main-dark-orange hidden-tablet-mobile">Записаться в лист ожидания</a>
            </div>
            <div class="position-relative z-20">
                <ul class="position-relative z-20">
                    <li class="careerum-flex-fsfs single-line">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043560355-D29fs-Soft.svg"
                            alt="">
                        <p>Покажем рынок найма изнутри</p>
                    </li>
                    <li class="careerum-flex-fsfs single-line">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043560355-D29fs-Soft.svg"
                            alt="">
                        <p>Инсайты от лучших рекрутеров</p>
                    </li>
                    <li class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043560355-D29fs-Soft.svg"
                            alt="">
                        <p>CV — ваше первое свидание с рекрутером, сделаем его идеальным</p>
                    </li>
                    <li class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043560355-D29fs-Soft.svg"
                            alt="">
                        <p>Практикумы с нанимающими менеджерами из разных индустрий</p>
                    </li>
                    <li class="careerum-flex-fsfs single-line">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043560355-D29fs-Soft.svg"
                            alt="">
                        <p>Самые свежие лернинги для сильного профиля Linkedin</p>
                    </li>
                    <li class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043560355-D29fs-Soft.svg"
                            alt="">
                        <p>Научитесь откликаться на вакансии и проходить интервью</p>
                    </li>
                </ul>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737121332146-y4ULC-ÑÐ¾.svg" alt=""
                    class="position-absolute z-10 hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737122441597-DBVrD-ÑÐ¾.svg" alt=""
                    class="position-absolute z-10 hidden-desc">
            </div>
            <div class="product-main-bg position-absolute z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737118447411-8GuBV-Grou.svg" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043095328-vmmHO-Grou.svg" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737043154452-Eaan2-Elli.png" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737122309330-EtJCB-Grou.svg" alt=""
                    class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737141459264-XAMtv-Grou.svg" alt=""
                    class="position-absolute hidden-desc-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737141478189-WnDGz-Elli.png" alt=""
                    class="position-absolute hidden-desc-tablet">
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-for', {
        label: 'Product 4 for (desktop only)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-for main-wrapper hidden-tablet-mobile">
        <div class="careerum-container-responsive position-relative ">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044315136-AS5It-Vect.svg" alt=""
                class="position-absolute ">
            <h2 class="careerum-club40-header">Кому подойдет интенсив</h2>
            <div class="product-for-items">
                <div class="product-for-item dark careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044753241-RT3IJ-Smil.svg"
                        alt="">
                    <p>Боитесь, что не найдете работу и от стресса даже не можете начать ее искать</p>
                </div>
                <div class="product-for-item medium careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044753112-ViVhQ-XCir.svg"
                        alt="">
                    <p>Не знаете, как правильно откликаться на вакансии, чтобы вас заметил рекрутер</p>
                </div>
                <div class="product-for-item dark careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044753004-6Zjqe-Thum.svg"
                        alt="">
                    <p>Не понимаете, как выгодно презентовать ваш уникальный опыт через цифры и достижения </p>
                </div>
                <div class="product-for-item light careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044816664-0Vh5s-Smil.svg"
                        alt="">
                    <p>Более 3 месяцев ищете работу, но откликов мало, а вакансии не радуют</p>
                </div>
                <div class="product-for-item medium careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044753112-ViVhQ-XCir.svg"
                        alt="">
                    <p>Есть пробелы в карьере: декрет / релокация / выгорание. Уверены, что с таким «багажом» никуда не
                        примут!</p>
                </div>
                <div class="product-for-item light careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737044752752-cykoA-Warn.svg"
                        alt="">
                    <p>Хотите, чтобы кто-то дал вам конкретную инструкцию, как получить оффер</p>
                </div>
            </div>
            <div class="product-for-nav careerum-flex-fec">
                <div class="product-for-nav-prev careerum-flex-cc ">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="product-for-nav-next careerum-flex-cc">
                    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white" stroke-width="2.64201"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-about', {
        label: 'Product 4 about (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-about main-wrapper">
        <div class="careerum-container-responsive">
            <h2 class="careerum-club40-header">90% резюме отклоняются за 10 секунд!</h2>
            <p class="product-about-subheader">Покажем закулисье найма и научим, как стать самым желанным кандидатом на
                высококонкурентном рынке </p>
            <div class="product-about-items-3text careerum-flex-sbfs">
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>≈250 резюме</p>
                        <p>на одну вакансию</p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>6–8 секунд</p>
                        <p>тратят рекрутеры на просмотр резюме</p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>только 4% претендентов</p>
                        <p>получают приглашение на интервью</p>
                    </div>
                </div>
            </div>
            <div class="product-about-items-1img">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737046412326-Hz8cK-Grou.png" alt=""
                    class="hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737123915246-vWZnp-Grou.png" alt=""
                    class="hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737135286861-84qi5-Grou.png" alt=""
                    class="hidden-desc-tablet">
            </div>
            <div class="product-about-items-1text careerum-flex-fsfs">
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>Больше раундов отбора с разными стейкхолдерами</p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737046439272-rQNVl-Grou.png"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737124058064-64NMC-Grou.png"
                        alt="" class="hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737135501503-ygNg5-Grou.png"
                        alt="" class="hidden-desc-tablet">
                </div>
            </div>
            <div class="product-about-items-3text careerum-flex-sbfs">
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>Сокращения</p>
                        <p>массовые сокращения, которые продолжаться в 2025 году</p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>Минимум в 13 компаниях </p>
                        <p>в среднем нужно пройти собеседование, чтобы получить оффер </p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>Минимум 200 откликов </p>
                        <p>в среднем нужно для оффера за рубежом </p>
                    </div>
                </div>
            </div>
            <div class="product-about-items-3text careerum-flex-sbfs">
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>Вcе сложнее пройти ATS</p>
                        <p>резюме на первом этапе перестал оценивать человек. Все делается автоматически</p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>76% кандидатов имеют навыки работы с ИИ</p>
                        <p>активно повышают навыки работы с ИИ, чтобы оставаться конкурентоспособными на рынке </p>
                    </div>
                </div>
                <div class="careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737045888405-XKmnZ-Warn.svg"
                        alt="">
                    <div>
                        <p>6-8 месяцев</p>
                        <p>средний срок поиска в России и за рубежом в 2025 году</p>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-form', {
        label: 'Product 4 form (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-form main-wrapper">
        <div class="careerum-container-responsive">
            <div class="product-form-wrapper careerum-flex-sbfs">
                <div class="product-form-left position-relative">
                    <h2>Запишитесь в лист ожидания</h2>
                    <div class="position-relative z-10">
                        <p>Только участники листа ожидания получат самую низкую цену и 2 урока по резюме до старта
                            интенсива</p>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737047236076-zFGEE-Grou.svg"
                            alt="" class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737124607208-FicsP-Grou.svg"
                            alt="" class="position-absolute hidden-desc-mobile">
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737047235806-Wgc2S-Unio.svg"
                        alt="" class="position-absolute z-20 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737125439121-qU02p-Unio.svg"
                        alt="" class="position-absolute z-20 hidden-desc-mobile">
                </div>
                <div class="product-form-right">

                    <div class="careerum-registration-form-club40">
                        <form class="deva-form getcourse-email-signup" name="devaRegistrationForm"
                            data-gjs-type="deva-registration-form">
                            <div class="careerum-club40-form-name">
                                <input type="text" name="name" value="" required placeholder="Имя">
                            </div>
                            <div class="careerum-club40-form-email">
                                <input type="text" name="email" value="" required placeholder="Почта">
                            </div>
                            <div class="careerum-club40-form-phone">
                                <input type="tel" value="" name="tel" required class="itl-input">
                            </div>
                            <div class="careerum-club40-form-agree">
                                <label>
                                    <input type="checkbox" name="agree">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                            fill="none">
                                            <path
                                                d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                </label>
                                <p>Я даю согласие на обработку своих персональных данных в соответствии с <a
                                        href="/ru-ru/legal/privacy" target="_blank">Политикой конфиденциальности</a></p>
                            </div>
                            <a href="#" class="submit-btn btn-color-main-bright-orange button-sent" disabled>Записаться
                                в лист ожидания</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-how', {
        label: 'Product 4 how (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-how main-wrapper">
        <div class="careerum-container-responsive careerum-flex-fsfs">
            <div class="product-how-left">
                <h2 class="careerum-club40-header">Как устроен интенсив</h2>
                <div class="hidden-tablet-mobile">
                    <p class="product-how-left-header">Часть заданий вы будете выполнять в командах</p>
                    <p class="product-how-left-text">Работа в команде поможет:</p>
                    <ul>
                        <li class="position-relative">Увидеть свои сильные качества со стороны</li>
                        <li class="position-relative">Получить обратную связь от профессионалов в вашей сфере и
                            объективно упаковать свой опыт</li>
                        <li class="position-relative">Не потерять мотивацию и дойти до конца</li>
                    </ul>
                </div>
            </div>
            <div class="product-how-right careerum-flex-fsfs">
                <div class="product-how-right-item hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702981-9uB8J-Vide.svg"
                        alt="">
                    <p>Уроки в записи</p>
                    <p>5 блоков и 34 урока. Каждый урок по 10–15 минут
                    </p>
                </div>
                <div class="product-how-right-item hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702882-4UrQQ-Book.svg"
                        alt="">
                    <p>Практикумы с рекрутерами</p>
                    <p>Практические эфиры с рекрутерами с экспертизой найма в ведущие компании РФ и мира</p>
                </div>
                <div class="product-how-right-item hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702776-o8qTO-Ligh.svg"
                        alt="">
                    <p>Чат интенсива</p>
                    <p>Обратная связь от кураторов и экспертов в ежедневном формате</p>
                </div>
                <div class="product-how-right-item hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702524-0JafV-Note.svg"
                        alt="">
                    <p>Домашние задания</p>
                    <p>Упакуете свой опыт в резюме, усилите профессиональные соцсети и научитесь проходить интервью</p>
                </div>
                <div class="product-how-right-items-wrapper hidden-desc-tablet">
                    <div class="product-how-right-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702981-9uB8J-Vide.svg"
                            alt="">
                        <p>Уроки в записи</p>
                        <p>5 блоков и 34 урока. Каждый урок по 10–15 минут
                        </p>
                    </div>
                    <div class="product-how-right-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702882-4UrQQ-Book.svg"
                            alt="">
                        <p>Практикумы с рекрутерами</p>
                        <p>Практические эфиры с рекрутерами с экспертизой найма в ведущие компании РФ и мира</p>
                    </div>
                    <div class="product-how-right-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702776-o8qTO-Ligh.svg"
                            alt="">
                        <p>Чат интенсива</p>
                        <p>Обратная связь от кураторов и экспертов в ежедневном формате</p>
                    </div>
                    <div class="product-how-right-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737048702524-0JafV-Note.svg"
                            alt="">
                        <p>Домашние задания</p>
                        <p>Упакуете свой опыт в резюме, усилите профессиональные соцсети и научитесь проходить интервью
                        </p>
                    </div>
                </div>
                <div class="product-how-right-list hidden-desc">
                    <p class="product-how-left-header">Часть заданий вы будете выполнять в командах</p>
                    <p class="product-how-left-text">Работа в команде поможет:</p>
                    <ul>
                        <li class="position-relative">Увидеть свои сильные качества со стороны</li>
                        <li class="position-relative">Получить обратную связь от профессионалов в вашей сфере и
                            объективно упаковать свой опыт</li>
                        <li class="position-relative">Не потерять мотивацию и дойти до конца</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-results', {
        label: 'Product 4 results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-results main-wrapper">
        <div class="careerum-container-responsive">
            <h2 class="careerum-club40-header">Ваши результаты интенсива</h2>
            <p class="product-results-subheader">Поможем получить оффер на ваших условиях, а не брать любой, который
                дают</p>
            <div class="product-results-items careerum-flex-sbst">
                <div class="product-results-item">
                    <p>1 месяц</p>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737049255820-nCPaN-Vect.svg"
                            alt="">
                        <p>Упаковка опыта и первые интервью</p>
                    </div>
                    <ul>
                        <li class="position-relative">Резюме</li>
                        <li class="position-relative">Linkedin</li>
                        <li class="position-relative">Сопроводительные</li>
                        <li class="position-relative">Анализ рынка и вакансий</li>
                        <li class="position-relative">Первые интервью</li>
                    </ul>
                </div>
                <div class="product-results-item">
                    <p>2 месяц</p>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737049255820-nCPaN-Vect.svg"
                            alt="">
                        <p>Активные собеседования</p>
                    </div>
                    <ul>
                        <li class="position-relative">Актуализация стратегии поиска после первых интервью</li>
                        <li class="position-relative">Подготовка к собеседованиям</li>
                        <li class="position-relative">Активные собеседования </li>
                    </ul>
                </div>
                <div class="product-results-item">
                    <p>3 месяц</p>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737049255820-nCPaN-Vect.svg"
                            alt="">
                        <p>Финалы интервью и первые офферы</p>
                    </div>
                    <ul>
                        <li class="position-relative">Подготовка к финальным собеседованиям с руководителем</li>
                        <li class="position-relative">Подготовка в переговорам по офферу</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-news', {
        label: 'Product 4 news (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-news main-wrapper">
        <div class="careerum-container-responsive">
            <h2 class="careerum-club40-header">Мы постоянно обновляем программу, вот последние новинки интенсива</h2>
            <div class="product-news-top">
                <div class="careerum-flex-fsfs">
                    <div class="product-news-top-left">
                        <p>Практикумы с рекрутерами и нанимающими менеджерами</p>
                    </div>
                    <div class="product-news-top-right">
                        <p>Вы получите самую актуальную информацию о специфике найма, требованиях к кандидатам и этапах
                            найма в ведущих компаниях РФ и мира из первых уст нанимающих менеджеров</p>
                    </div>
                </div>
                <div class="product-news-slider-wrapper">
                    <div class="product-news-items">
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120156550-FcOKG-trav.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Найм в крупные компании и корпорации в РФ</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как искать рефералов и получать рекомендации</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Работа с внутренними рекрутерами и прохождение оценочных центров</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Важность нетворкинга</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120156433-CXAVW-noti.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Найм в FAANG (Facebook, Amazon, Apple, Netflix,
                                Google)</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Специфика найма в крупнейшие технологические компании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Особенности многоэтапных интервью</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Внутренняя культура</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120156322-ok7Cz-rock.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Хочу работать в стартапах</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как оценить риски и возможности работы в стартапах и скейлапах на собеседовании?
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как искать такие компании, и как подавать свой опыт в резюме, чтобы вас заметили?
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как договариваться об опционах?</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120156220-oY0c4-zoom.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Поиск работы через рекрутинговые агентства</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Эффективное взаимодействие с рекрутерами и хедхантерами</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Практические кейсы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как выбирать агентства </p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120156107-86fx7-comp.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Особенности найма в технологические компании</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Каких кандидатов ищут</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Этапы отборов</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>На что смотрят в резюме </p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120156003-9swnz-eth-.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Найм в Web3 и криптокомпании</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Специфика трудоустройства в блокчейн-проекты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Особенности компенсации в токенах и работу с DAO</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Риски и возможности</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155897-8ywcu-thum.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Управление онлайн-репутацией при поиске работы</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Управление репутационными рисками</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Работе с цифровым следом</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Профессиональные соцсети</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155790-9Gs3L-hear.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Найм в некоммерческий сектор</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Особенности трудоустройства в НКО и социальные предприятия</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Специфика мотивации</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Компенсации</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155673-RnHp8-lock.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Поиск работы в регулируемых индустриях</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Специфика найма в финансовый сектор, здравоохранение и другие области с жёстким
                                        регулированием</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Зарплатные вилки</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Возможности для роста</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155556-mliey-boy-.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Возрастные стереотипы при поиске работы</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Стратегии позиционирования опыта как преимущества</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Преодоление возрастных стереотипов </p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155451-vSVTC-pain.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Найм на креативные позиции: портфолио и тестовые
                            </p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Особенности поиска работы в творческих индустриях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как создавать портфолио, и на что делать акценты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как управлять потоком тестовых заданий</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155334-jzFVs-penc.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Сами делайте свои тестовые</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Оценка серьезности намерений работодателя, анализ объема работы, защита
                                        интеллектуальной собственности</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Red flags в тестовых заданиях</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Убедительная презентация тестового задания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155221-Qpf3B-targ.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Смена профессии и поиска работы в новой сфере</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как упаковать свой прошлый опыт</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>На что делать акцент на собеседовании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Бенчмарки воронки поиска при смене сферы</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-news-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737120155109-jQMVy-forw.png"
                                    alt="">
                            </div>
                            <p class="product-news-slider-item-name">Переход между ролями внутри корпорации</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Как организовать личное развитие для успешного перехода</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Роль HR и руководителя в осуществлении перехода</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723285254869-xXFal-Chec.svg"
                                        alt="">
                                    <p>Когда нет смысла переходить внутри компании, а пора уходить</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="product-news-slider-nav careerum-flex-fec">
                        <div class="product-news-slider-nav-prev careerum-flex-cc ">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="product-news-slider-nav-next careerum-flex-cc">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-news-bottom careerum-flex-fsfs position-relative">
                <div class="product-news-bottom-left">
                    <p>Добавили уроки по LinkedIn с самыми свежими обновлениями соцсети</p>
                </div>
                <div class="product-news-bottom-right">
                    <p>Прокачаете свой профиль, так чтобы рекрутеры сами писали вам каждый день</p>
                </div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737051095754-28pQk-3d-i.png" alt=""
                    class="position-absolute hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737129155951-RtQdT-3d-i.png" alt=""
                    class="position-absolute hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737137757750-IUCSZ-3d-i.png" alt=""
                    class="position-absolute hidden-desc-tablet">
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-additional', {
        label: 'Product 4 additional (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-additional main-wrapper">
        <div class="careerum-container-responsive">
            <h2 class="careerum-club40-header">Что еще будет на интенсиве?</h2>
            <div class="product-additional-top">
                <p class="product-additional-header">Доступ к нетворк-сообществу русскоговорящих профессионалов из 30+
                    стран</p>
                <div class="product-additional-top-items careerum-flex-sbst">
                    <div class="product-additional-top-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737051816284-lh227-Edit.svg"
                            alt="">
                        <p>Соберете информацию из первых уст о компании, в которую хотите попасть</p>
                    </div>
                    <div class="product-additional-top-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737051816177-SAaQ4-Prof.svg"
                            alt="">
                        <p>Найдете рефералов, чтобы получить рекомендации в компанию на выбранную позицию</p>
                    </div>
                    <div class="product-additional-top-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737051815933-aZMPt-Docu.svg"
                            alt="">
                        <p>Расширите нетворкинг со специалистами разного уровня: от junior до C-level</p>
                    </div>
                </div>
            </div>
            <div class="product-additional-bottom">
                <p class="product-additional-header">Доступ к карьерной платформе Careerum</p>
                <p class="product-additional-subheader">На время интенсива вы получите полный доступ ко всей платформе и
                    80 курсам в записи под любую карьерную задачу</p>
                <div class="product-additional-slider">
                    <div class="product-additional-slider-items">
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Освоиться на новой работе и быстро начать
                                приносить пользу</p>
                            <p class="product-additional-slider-text">Курс «Жизнь после оффера»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206754-7evbK-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136250-vxoGi-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Выстроить границы с руководителем и коллегами
                            </p>
                            <p class="product-additional-slider-text">Курс «Коммуникация на работе»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206056-MnQUS-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135782-HSOgY-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Получить повышение через полгода</p>
                            <p class="product-additional-slider-text">Курс «Карьерная ракета»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195276-Tuk6J-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136724-Jcd5H-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Найти работу за границей быстро и без проблем
                            </p>
                            <p class="product-additional-slider-text">Курс «Международная карьера и релокация»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195611-i209G-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136856-YVoxz-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Достигать результатов в разы быстрее</p>
                            <p class="product-additional-slider-text">Курс «Работать не 24/7»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905207114-JpoWG-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136609-SntZn-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Работать без выгораний и демотивации</p>
                            <p class="product-additional-slider-text">Курс «Карьера без стресса»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206462-v4YrG-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136026-DlGgK-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Сформировать здоровую самооценку и расти в
                                доходе</p>
                            <p class="product-additional-slider-text">Курс «Самооценка и Деньги: не мешайте себе
                                зарабатывать»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206995-CzHss-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136496-iK3of-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Развивать сеть контактов, формировать личный
                                бренд</p>
                            <p class="product-additional-slider-text">Курс «Секреты нетворкинга»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206300-G4EiF-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135902-YaSxb-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Работать из дома эффективно и без прокрастинации
                            </p>
                            <p class="product-additional-slider-text">Курс «Удаленка»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206162-axyQs-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135408-W8WQc-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Добиться финансовой самостоятельность</p>
                            <p class="product-additional-slider-text">Курс «Карьера и финансы»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206995-CzHss-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135142-zfMz9-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Разобраться в себе и понять, чего хочется от
                                карьеры</p>
                            <p class="product-additional-slider-text">Курс «Real Me: как найти себя»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733903195760-k2i68-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136980-Rz3Af-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Смело вести переговоры, презентации и смол-токи
                            </p>
                            <p class="product-additional-slider-text">Курс «Публичные выступления»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206870-OTfik-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136368-XNklq-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Сохранять свою ценность даже во времена
                                сокращений</p>
                            <p class="product-additional-slider-text">Курс «Антикризис»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905206605-BqNcB-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923136137-toVB5-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Видеть задачи и проекты с новых сторон</p>
                            <p class="product-additional-slider-text">Курс «Open Mindset»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205937-ZsoJe-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135662-WTxmr-Fram.svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Стать руководителем, который ведет команды и
                                растит KPI</p>
                            <p class="product-additional-slider-text">Курс «Эффективный руководитель»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205773-omnR0-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135534-kXWnQ-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Перейти в новую сферу быстро и без потери в
                                доходе</p>
                            <p class="product-additional-slider-text">Курс «Новые горизонты»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205629-EdGB4-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135278-gzlKn-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Понять, в чем особенности обучения за рубежом
                            </p>
                            <p class="product-additional-slider-text">Курс «Зарубежное образование»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205377-zl9WX-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923135022-KqJcY-Ð¸Ð».svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Преодолеете трудности при выходе из декрета</p>
                            <p class="product-additional-slider-text">Курс «Выход из декрета»</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905205223-dT5vR-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923134903-TM6LM-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                        <div class="product-additional-slider-item position-relative">
                            <p class="product-additional-slider-header">Построите стратегию поиска работы и получите
                                оффер</p>
                            <p class="product-additional-slider-text">Курс «Карьерная ракета»
                            </p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733905204858-qg4Um-pic .svg"
                                alt="" class="position-absolute hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1733923134529-X2YUs-pic .svg"
                                alt="" class="position-absolute hidden-desc">
                        </div>
                    </div>
                    <div class="product-additional-nav careerum-flex-fec">
                        <div class="product-additional-nav-prev careerum-flex-cc ">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="product-additional-nav-next careerum-flex-cc">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                    stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-reviews', {
        label: 'Product 4 reviews (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-reviews main-wrapper">
        <div class="careerum-container-responsive">
            <div class="product-reviews-top careerum-flex-fsfs">
                <div class="product-reviews-top-left">
                    <h2>За 5 лет существования проекта программа «Звездный кандидат» была проверена на 7 000+
                        участниках, вот их отзывы</h2>
                </div>
                <div class="product-reviews-top-right">
                    <div class="position-relative z-20">
                        <p>5 лет</p>
                    </div>
                    <div class="position-relative z-10">
                        <p>7 000+ участников</p>
                    </div>
                </div>
            </div>
            <div class="product-reviews-bottom">
                <div class="product-reviews-items careerum-flex-fsst">
                    <div class="product-reviews-item">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737054548224-3DIfB-Mask.png"
                                alt="">
                            <p>Марина Мухаметшина</p>
                        </div>
                        <p>Проходила курс «Звёздный кандидат», пошагово применяя все практики. В одну из компаний, где
                            предложили оффер, собеседовалась до вступления в клуб и мне предложили доход всего на 10%
                            больше и должность аналогичную моей. При этом разница между собеседованиями была в месяц и
                            фактически мои скиллы не изменились, я просто научилась расставлять акценты, благодаря
                            кyрсy.</p>
                        <p>По результатам получены 2 оффера. Один с разницей в +35% к заработной плате и предложением
                            управленческой должности, второй с разницей +52% к заработной плате и расширением
                            компетенций.</p>
                    </div>
                    <div class="product-reviews-item">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737055570722-z5Ztf-imag.png"
                                alt="">
                            <p>Александра Анцyпова</p>
                        </div>
                        <p>Я прошла курс «Звездный кандидат», который не только помог проработать свое резюме, но и
                            получить оффер в компанию, где сейчас работаю. Я в целом поняла, как правильно составлять
                            резюме, что туда включать, как формулировать свои достижения.</p>
                    </div>
                    <div class="product-reviews-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737055829051-CftUX-01 7.png"
                            alt="">
                    </div>
                    <div class="product-reviews-item">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737055571025-S7iiv-imag.png"
                                alt="">
                            <p>Юлия Новикова</p>
                        </div>
                        <p>«Звездный кандидат» помог составить воронку поиска работы, проработать резюме и
                            сопроводительное письмо, а также проходить интервью. Через 3 месяца активной работы, я
                            смогла получить оффер в компанию по новой профессии. На такой результат повлияли навыки
                            презентации и хорошее позиционирование, а также знания, которые я получила на курсе
                            «Звездный кандидат».</p>
                    </div>
                    <div class="product-reviews-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737055829517-HIv3L-03 2.png"
                            alt="">
                    </div>
                    <div class="product-reviews-item">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737055571141-clyAM-imag.png"
                                alt="">
                            <p>Арина Кyнашко</p>
                        </div>
                        <p>Мне нужно было за короткий срок овладеть инструментами поиска вакансий и найти применение
                            своим навыкам на рынке. Программа «Звездный кандидат» с этим помогла: я построила стратегию
                            поиска работы, научилась составлять продающее резюме и правильно преподносить себя на
                            интервью.</p>
                    </div>
                    <div class="product-reviews-item">
                        <div class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737055571242-5S4jz-imag.png"
                                alt="">
                            <div>
                                <p>Мария Кyзнецова</p>
                                <div class="careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737056294053-Xa5hV-ocat.svg"
                                        alt="">
                                    <p>Франция</p>
                                </div>
                            </div>
                        </div>
                        <p>Благодаря курсам «Звездного кандидата» я поняла, что нужно откликаться на вакансии, даже если
                            описание подходит не на 100%. Также я смогла фокусироваться не на отсутствии каких-то
                            навыков, а на том, как имеющийся опыт и скиллы помогут решать рабочие задачи.</p>
                    </div>
                    <div class="product-reviews-item">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737056212828-SQ92g-Fram.png"
                            alt="">
                    </div>
                </div>
                <div class="product-reviews-nav careerum-flex-fec">
                    <div class="product-reviews-nav-prev careerum-flex-cc ">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.19055 8.13997L15.8105 8.13997" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.46289 14.3859L2.18956 8.13924L8.46289 1.89258" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="product-reviews-nav-next careerum-flex-cc">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8095 8.14128L2.18945 8.14128" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.53711 1.89534L15.8104 8.14201L9.53711 14.3887" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-product-tariffs', {
        label: 'Product 4 tariffs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-product-tariffs main-wrapper">
        <div class="careerum-container-responsive">
            <div class="product-tariffs-label">
                <p>Открытие продаж 15.02</p>
            </div>
            <h2 class="careerum-club40-header">Выберите удобный вариант участия — подписку помесячно или на 3 месяца
            </h2>
            <div class="product-tariffs-items-wrapper">
                <div class="product-tariffs-items careerum-flex-fsst">
                    <div class="product-tariffs-item careerum-flex-fsfs">
                        <div class="product-tariffs-item-top">
                            <p>Тариф «Самостоятельный»</p>
                        </div>
                        <div class="product-tariffs-item-content position-relative">
                            <p class="product-tariffs-item-header hidden-tablet-mobile">Доступ к интенсиву в записи без
                                обратной связи<br><br>
                            </p>
                            <p class="product-tariffs-item-header hidden-desc">Доступ к интенсиву в записи без обратной
                                связи</p>
                            <p class="product-tariffs-item-places hidden-tablet-mobile opacity-0">Всего: 30 мест</p>
                            <div class="product-tariffs-item-divider hidden-tablet-mobile"></div>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737057207301-OhLpp-Chec.svg"
                                        alt="">
                                    <p><span>Доступ к интенсиву Звёздный кандидат В ЗАПИСИ</span></p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737057207301-OhLpp-Chec.svg"
                                        alt="">
                                    <p>Шаблоны и примеры: резюме на русском и английском, сопроводительные письма,
                                        сообщения
                                        работодателямв LinkedIn, деловая email-переписка</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737057207301-OhLpp-Chec.svg"
                                        alt="">
                                    <p>Воркфлоу поиска достижений </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737057207301-OhLpp-Chec.svg"
                                        alt="">
                                    <p>Список платформ для поиска работы в 15 странах</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737057207301-OhLpp-Chec.svg"
                                        alt="">
                                    <p>Трекер заявок на вакансии, чтобы всегда знать, что и куда отправили</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-tariffs-item-link">
                            <a href="#" class="btn-color-main-dark-orange">Записаться в лист ожидания</a>
                        </div>
                    </div>
                    <div class="product-tariffs-item careerum-flex-fsfs">
                        <div class="product-tariffs-item-top">
                            <p>Тариф «С поддержкой»</p>
                        </div>
                        <div class="product-tariffs-item-content position-relative">
                            <div class="product-tariffs-item-label careerum-flex-fsc position-absolute ">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1737121018148-1grJT-Fire.svg"
                                    alt="">
                                <p>Оптимальный</p>
                            </div>
                            <p class="product-tariffs-item-header hidden-tablet-mobile">Интенсив с практикой и обратной
                                связью<br><br><br>
                            </p>
                            <p class="product-tariffs-item-header hidden-desc">Интенсив с практикой и обратной связью
                            </p>
                            <p class="product-tariffs-item-places hidden-tablet-mobile opacity-0">Всего: 30 мест</p>
                            <div class="product-tariffs-item-divider hidden-tablet-mobile"></div>
                            <p class="product-tariffs-item-description">В тариф входят все опции тарифа
                                «Самостоятельный»,
                                плюс:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                        alt="">
                                    <p>Групповой чат с экспертом и кураторами платформы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                        alt="">
                                    <p>10 практикумов<br>- Резюме<br>- Linkedin<br>- Стратегия поиска<br>- Интервью
                                        RU<br>-
                                        Интервью EN<br>- Эфиры с нанимающими менеджерами и рекрутерами</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                        alt="">
                                    <p>2 групповые Q&A-встречи в месяц с экспертом для разбора вопросов</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                        alt="">
                                    <p>Доступ к нетворк-сообществу</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-tariffs-item-link">
                            <a href="#" class="btn-color-main-dark-orange">Записаться в лист ожидания</a>
                        </div>
                    </div>
                    <div class="product-tariffs-item careerum-flex-fsfs">
                        <div class="product-tariffs-item-top">
                            <p>Тариф «Индивидуальный подход»</p>
                        </div>
                        <div class="product-tariffs-item-content position-relative">
                            <p class="product-tariffs-item-header hidden-tablet-mobile">Интенсив с практикой и обратной
                                связью + личные консультации с экспертом</p>
                            <p class="product-tariffs-item-header hidden-desc">Интенсив с практикой и обратной связью +
                                личные консультации с экспертом</p>
                            <p class="product-tariffs-item-places">Всего: 30 мест</p>
                            <div class="product-tariffs-item-divider hidden-tablet-mobile"></div>
                            <p class="product-tariffs-item-description">В тариф входят все преимущества тарифа
                                «С поддержкой», плюс:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723136684555-7a9hK-Fram.svg"
                                        alt="">
                                    <p>4 личные карьерные консультации с экспертом:<br>- разбор резюме<br>- разбор
                                        Linkedin<br>-
                                        стратегия поиска <br>- подготовка интервью или ваша карьерная задача</p>
                                </li>
                            </ul>
                        </div>
                        <div class="product-tariffs-item-link">
                            <a href="#" class="btn-color-main-dark-orange">Записаться в лист ожидания</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('careerum-quiz-main', {
        label: 'Quiz main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-quiz-main main-wrapper">
        <div class="careerum-container-responsive">
            <div class="quiz-main__logo careerum-flex-fsfs">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740463548843-nZTDm-logo.svg" alt="" class="hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740464735927-6BiS8-logo.svg" alt="" class="hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740464735927-6BiS8-logo.svg" alt="" class="hidden-desc-tablet">
                <p>— платформа карьерного развития</p>
            </div>
            <div class="quiz-main__header position-relative">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740463548351-moA8R-line.svg" alt="" class="hidden-tablet-mobile position-absolute z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740464735767-YykH4-line.svg" alt="" class="hidden-desc-mobile position-absolute z-10">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740465429607-y6lU4-line.svg" alt="" class="hidden-desc-tablet position-absolute z-10">
                <p class="position-relative z-20">Тест</p>
                <h1>«Как вас воспринимают <span>коллеги</span>?» </h1>
            </div>
            <div class="quiz-main__content careerum-flex-sbst">
                <div class="quiz-main__content-left">
                    <div>
                        <p class="quiz-main__content-number">1</p>
                        <p class="quiz-main__content-text">Определите ваш текущий стиль профессиональной коммуникации</p>
                    </div>
                    <div>
                        <p class="quiz-main__content-number">2</p>
                        <p class="quiz-main__content-text">Выявите ключевые области для роста вашего влияния в команде</p>
                    </div>
                    <div>
                        <p class="quiz-main__content-number">3</p>
                        <p class="quiz-main__content-text">Получите персональные рекомендации по усилению вашей позиции</p>
                    </div>
                </div>
                <div class="quiz-main__content-right position-relative careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740463548716-h6SsP-Img..svg" alt="" class="position-absolute hidden-tablet-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740464735426-txtKO-Img .svg" alt="" class="position-absolute hidden-desc-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740465429319-DLv87-Img .svg" alt="" class="position-absolute hidden-desc-tablet z-10">
                    <a href="#" class="btn-color-main-dark-orange position-relative z-20">Пройти тест</a>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-consultations4-main', {
        label: 'Consultations main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-main main-wrapper">
                <div class="careerum-container-responsive80 careerum-flex-fsfs">
                    <div class="consultations4-main-left">
                        <p class="consultations4-main__subheader">Поможем с любым карьерным вопросом</p>
                        <h1 class="consultations4-main__header">Консультации с карьерными экспертами</h1>
                        <div class="consultations4-main__bottom careerum-flex-fsfs">
                            <div>
                                <p class="consultations4-main__tale-header">9.7</p>
                                <p class="consultations4-main__tale-text">средняя оценка специалистов Careerum</p>
                            </div>
                            <div>
                                <p class="consultations4-main__tale-header">3800+</p>
                                <p class="consultations4-main__tale-text">часов проведенных сессий</p>
                            </div>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-orange hidden-mobile">Купить консультацию</a>
                    </div>
                    <div class="consultations4-main-right position-relative">
                        <div class="position-relative z-20">
                            <p>Получить персональную<br> поддержку</p>
                        </div>
                        <div class="position-relative z-30">
                            <p>Составить стратегию<br> достижения результата</p>
                        </div>
                        <div class="position-relative z-50">
                            <p>Команда экспертов
                                с международным опытом</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739972912741-97II1-Grou.png"
                                alt="">
                        </div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739972599324-IHwFD-Grou.png" alt=""
                            class="position-absolute z-10 consultations4-main__img-1 hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739972842938-WYqeP-Grou.png" alt=""
                            class="position-absolute z-60 consultations4-main__img-2 hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739992321722-6C9cG-Grou.png" alt=""
                            class="position-absolute z-10 consultations4-main__img-1 hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739992322044-r8LDT-Grou.png" alt=""
                            class="position-absolute z-60 consultations4-main__img-2 hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739996780487-GKAfe-Grou.png" alt=""
                            class="position-absolute z-0 consultations4-main__img-1 hidden-desc-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739996780337-pyKgA-Grou.png" alt=""
                            class="position-absolute z-20 consultations4-main__img-2 hidden-desc-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739996780092-LT9HL-Grou.png" alt=""
                            class="position-absolute z-60 consultations4-main__img-3 hidden-desc-tablet">
                    </div>
                    <a href="#buy" class="btn-color-main-dark-orange hidden-desc-tablet">Купить консультацию</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consultations4-experts', {
        label: 'Consultations experts (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-experts main-wrapper">
                <div class="careerum-container-responsive80">
                    <h2>Команда карьерных коучей
                        и экспертов с международной сертификацией</h2>
                    <div class="consultations4-experts-slider-item-about">
                        <p class="slider-item-about__header">Помогут достичь
                            вашей цели: </p>
                        <p class="slider-item-about__text">написать сильное резюме</p>
                        <p class="slider-item-about__text">усилить профиль LinkedIn</p>
                        <p class="slider-item-about__text">потренировать собеседование</p>
                        <p class="slider-item-about__text">поставить карьерную цель</p>
                        <p class="slider-item-about__text">усилить сопроводительное</p>
                        <p class="slider-item-about__text hidden-mobile">подготовиться к переговорам<br> по офферу</p>
                        <p class="slider-item-about__text hidden-desc-tablet">подготовиться<br> к переговорам по офферу</p>
                    </div>
                    <div class="consultations4-experts-slider">
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974820355-Yiojz-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Софи Бессон</p>
                            <p class="consultations4-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>6+ в HR и карьерном консультировании</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 700+ клиентам составить резюме<br> и найти работу в Европе, США и Канаде</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Disney, Intel, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Израиль</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974820231-kcH25-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Мария Пудалова</p>
                            <p class="consultations4-experts-slider-item-position">Карьерный эксперт</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>7+ лет в PR и стратегии выстраивания бренда</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 400+ клиентам улучшить CV и найти работу в Европе<br>
                                        и США</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Deloitte, BBDO, Microsoft</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Германия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974820121-GoyEh-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Виктория Албаутова</p>
                            <p class="consultations4-experts-slider-item-position">Коуч ICU</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и маркетинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 150+ клиентам построить выигрышные стратегии и бренды</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        компаниями Beiesdorf, Philips, Johnson&Johnson, Novartis</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974819890-ow3jn-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Елена Добринская</p>
                            <p class="consultations4-experts-slider-item-position">PCC ICF </p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>10+ лет в коучинге и финансах </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 1700+ клиентам обрести уверенность и подготовиться к собеседованиям</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Sony, Ernst&Young, Deloitte</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>ОАЭ</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974820009-ZZk0F-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Яна Хмельницкая</p>
                            <p class="consultations4-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>15+ лет в HR, карьерном коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 800+ клиентам подготовиться к интервью на английском языке и релоцироваться
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Ford, Leroy Merlin, Unilever, Mars</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Турция</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974819773-6nNdM-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Елена Эльзенбах</p>
                            <p class="consultations4-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>11+ лет опыта в коучинге, НКО и EdTech</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 1300+ клиентам из РФ, Европы и СНГ получить оффер через укрепление самооценки
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Lamoda, Яндекс, Mail, InDriver</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974819542-PjU8d-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Светлана Шуйская</p>
                            <p class="consultations4-experts-slider-item-position">Коуч ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>18+ лет в коучинге и закупках</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 300+ клиентам вырасти в доходе, составить стратегию, начать свое дело</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Metro Cash&Carry, Yandex, Avito</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Россия</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974819342-HAYLL-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Марина Веденичева</p>
                            <p class="consultations4-experts-slider-item-position">Коуч PCC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>18+ лет в HR и карьерном коучинге</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>Помогла 2000+ клиентам усилить лидерские качества и получить повышение</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Работала с<br>
                                        сотрудниками Mars, Shell, Ernst & Young</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>Великобритания</p>
                                </li>
                            </ul>
                        </div>
                        <div class="consultations4-experts-slider-item">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739974818773-lLZ2m-phot.png"
                                    alt="">
                            </div>
                            <p class="consultations4-experts-slider-item-name">Майя Бурякина</p>
                            <p class="consultations4-experts-slider-item-position">Коуч ACC ICF</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310928-GL8NO-Sjie.svg"
                                        alt="">
                                    <p>10 лет в подборе, адаптации и развитии персонала</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310822-h04vz-User.svg"
                                        alt="">
                                    <p>150+ консультаций на тему поиска работы и построения карьеры</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310710-qRFZA-Work.svg"
                                        alt="">
                                    <p>Организатор семинаров «Поиск работы в США» в Кремниевой долине</p>
                                </li>
                                <li class="careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739975310370-49q4A-Loca.svg"
                                        alt="">
                                    <p>США, Россия</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="consultations4-experts-nav careerum-flex-fec">
                        <div class="consultations4-experts-nav-prev hidden-tablet-mobile">
                            <svg width="55" height="54" viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="55" height="54" rx="27" transform="matrix(-1 0 0 1 55 0)" fill="black" />
                                <path
                                    d="M40 25.5C40.8284 25.5 41.5 26.1716 41.5 27C41.5 27.8284 40.8284 28.5 40 28.5V25.5ZM13.9393 28.0607C13.3536 27.4749 13.3536 26.5251 13.9393 25.9393L23.4853 16.3934C24.0711 15.8076 25.0208 15.8076 25.6066 16.3934C26.1924 16.9792 26.1924 17.9289 25.6066 18.5147L17.1213 27L25.6066 35.4853C26.1924 36.0711 26.1924 37.0208 25.6066 37.6066C25.0208 38.1924 24.0711 38.1924 23.4853 37.6066L13.9393 28.0607ZM40 28.5H15V25.5H40V28.5Z"
                                    fill="white" />
                            </svg>
                        </div>
                        <div class="consultations4-experts-nav-next">
                            <svg width="55" height="54" viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="55" height="54" rx="27" fill="black" />
                                <path
                                    d="M15 25.5C14.1716 25.5 13.5 26.1716 13.5 27C13.5 27.8284 14.1716 28.5 15 28.5V25.5ZM41.0607 28.0607C41.6464 27.4749 41.6464 26.5251 41.0607 25.9393L31.5147 16.3934C30.9289 15.8076 29.9792 15.8076 29.3934 16.3934C28.8076 16.9792 28.8076 17.9289 29.3934 18.5147L37.8787 27L29.3934 35.4853C28.8076 36.0711 28.8076 37.0208 29.3934 37.6066C29.9792 38.1924 30.9289 38.1924 31.5147 37.6066L41.0607 28.0607ZM15 28.5H40V25.5H15V28.5Z"
                                    fill="white" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consultations4-tariffs', {
        label: 'Consultations tariffs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-tariffs main-wrapper">
                <div class="careerum-container-responsive80">
                    <h2>Задачи, которые вы сможете решить на консультации</h2>
                    <div class="consultations4-tariffs-currency position-relative z-20">
                        <div class="hidden-tablet-mobile">
                            <div class="consultations4-tariffs-currency-desctop careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs">
                                    <li data-currency="eur" class="active">EUR</li>
                                    <li data-currency="rub">RUB</li>
                                </ul>
                                <div class="consultations4-tariffs-notif careerum-flex-cc">
                                    <div class="consultations4-tariffs-notif-icon">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt="">
                                    </div>
                                    <div class="consultations4-tariffs-notif-content">
                                        <p>Оплата в российских рублях возможна только картой
                                            российского банка. В&nbsp;евро — картой
                                            зарубежного банка</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hidden-desc position-relative">
                            <div class="consultations4-tariffs__swicher-block position-absolute">
                                <div class="consultations4-tariffs__swicher-top">
                                    <p class="consultations4-tariffs__swicher-header">Посмотреть
                                        цены в
                                        <span>RUB</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" class="consultations4-tariffs__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="consultations4-tariffs__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="active">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="consultations4-tariffs-items careerum-flex-sbst position-relative z-10">
                        <div class="consultations4-tariffs-item"  data-price-rub="15 000 ₽" data-price-eur="150 €" data-link-rub="#r" data-link-eur="#e">
                            <div class="consultations4-tariffs-item__top careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982403554-1E3A5-File.svg"
                                        alt="">
                                    <p>Резюме + сопроводительное письмо</p>
                                </div>
                                <p>15 000 ₽</p>
                            </div>
                            <a href="#" class="btn-color-main-dark-orange">Купить</a>
                            <div class="consultations4-tariffs-item__bottom">
                                <p class="consultations4-tariffs-item__header-bottom">Что входит:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Онлайн-встреча 50 минут</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Разбор резюме</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Разбор сопроводительного письма</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Упаковка опыта под выбранную вами вакансию</p>
                                    </li>
                                </ul>
                                <p class="consultations4-tariffs-item__header-bottom">По итогам встречи вы получите:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Запись встречи, чтобы можно было пересмотреть</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Шаблоны: резюме на русском или английском</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Примеры цепляющих сопроводительных писем</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="consultations4-tariffs-item">
                            <div class="consultations4-tariffs-item__top careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982403443-Fw2Ex-basi.svg"
                                        alt="">
                                    <p>LinkedIn + сопроводительное письмо для отклика
                                        в соцсети</p>
                                </div>
                                <p>15 000 ₽</p>
                            </div>
                            <a href="#" class="btn-color-main-dark-orange">Купить</a>
                            <div class="consultations4-tariffs-item__bottom">
                                <p class="consultations4-tariffs-item__header-bottom">Что входит:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Онлайн-встреча 50 минут</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Разбор профиля LinkedIn</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Разбор сопроводительного письма</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Упаковка саммари для профиля</p>
                                    </li>
                                </ul>
                                <p class="consultations4-tariffs-item__header-bottom">По итогам встречи вы получите:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Запись встречи, чтобы можно было пересмотреть</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Чек-лист сильного профиля</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Примеры сильных профилей</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Примеры цепляющих сопроводительных писем</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="consultations4-tariffs-item">
                            <div class="consultations4-tariffs-item__top careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982403318-tYifd-sola.svg"
                                        alt="">
                                    <p>Потренироваться проходить интервью</p>
                                    <span>на русском или английском</span>
                                </div>
                                <p>12 500 ₽</p>
                            </div>
                            <a href="#" class="btn-color-main-dark-orange">Купить</a>
                            <div class="consultations4-tariffs-item__bottom">
                                <p class="consultations4-tariffs-item__header-bottom">Что входит:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Онлайн-встреча 50 минут</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Интервью</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Разбор интервью: обратная связь, что улучшить</p>
                                    </li>
                                </ul>
                                <p class="consultations4-tariffs-item__header-bottom">По итогам встречи вы получите:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Запись встречи, чтобы можно было пересмотреть</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Чек-лист самых популярных вопросов на интервью</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Алгоритм ответов на вопросы</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="consultations4-tariffs-item">
                            <div class="consultations4-tariffs-item__top careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982403200-0LPkd-file.svg"
                                        alt="">
                                    <p>Откликаюсь,<br> но не приглашают на интервью</p>
                                </div>
                                <p>15 000 ₽</p>
                            </div>
                            <a href="#" class="btn-color-main-dark-orange">Купить</a>
                            <div class="consultations4-tariffs-item__bottom">
                                <p class="consultations4-tariffs-item__header-bottom">Что входит:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Онлайн-встреча 50 минут</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Анализ резюме/LinkedIn относительно вакансий, на которые откликаетесь</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Анализ сопроводительного письма</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Анализ количества откликов
                                            и приглашений на интервью</p>
                                    </li>
                                </ul>
                                <p class="consultations4-tariffs-item__header-bottom">По итогам встречи вы получите:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Запись встречи, чтобы можно было пересмотреть</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Чек-лист ошибок вашего поиска работы и рекомендации
                                            по улучшению</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="consultations4-tariffs-item">
                            <div class="consultations4-tariffs-item__top careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982403091-kqFeq-file.svg"
                                        alt="">
                                    <p>Карьерная консультация</p>
                                </div>
                                <div class="careerum-flex-fsc">
                                    <p>Примеры запросов:</p>
                                    <p class="hidden-desc-mobile">не умею себя продавать</p>
                                    <p>боюсь проходить собеседования</p>
                                    <p>личные границы на работе</p>
                                    <p>work-life-balance</p>
                                    <p class="hidden-desc">не знаю, что делать дальше в карьере</p>
                                    <p>синдром самозванца</p>
                                    <p class="hidden-tablet">не умею себя продавать</p>
                                    <p class="hidden-tablet-mobile">не знаю, что делать дальше в карьере</p>
                                    <p>адаптация на новой работе</p>
                                </div>
                                <p>10 000 ₽</p>
                            </div>
                            <a href="#" class="btn-color-main-dark-orange">Купить</a>
                            <div class="consultations4-tariffs-item__bottom">
                                <p class="consultations4-tariffs-item__header-bottom">Что входит:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Онлайн-встреча 50 минут</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Разбор вашего запроса</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Составление плана действий по выходу из ситуации</p>
                                    </li>
                                </ul>
                                <p class="consultations4-tariffs-item__header-bottom">По итогам встречи вы получите:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Запись встречи, чтобы можно было пересмотреть</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Список рекомендаций</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="consultations4-tariffs-item">
                            <div class="consultations4-tariffs-item__top careerum-flex-fsfs">
                                <div class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982402845-RA0pi-file.svg"
                                        alt="">
                                    <p>Индивидуальная стратегическая сессия</p>
                                </div>
                                <p>20 500 ₽</p>
                            </div>
                            <a href="#" class="btn-color-main-dark-orange">Купить</a>
                            <div class="consultations4-tariffs-item__bottom">
                                <p class="consultations4-tariffs-item__header-bottom">Что входит:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Онлайн-встреча 2 часа</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Ретроспектива, в какой точке вы сейчас</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Постановка целей, куда хотите прийти</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214299-YtzAo-1723.svg"
                                            alt="">
                                        <p>Пошаговый план</p>
                                    </li>
                                </ul>
                                <p class="consultations4-tariffs-item__header-bottom">По итогам встречи вы получите:</p>
                                <ul>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Запись встречи, чтобы можно было пересмотреть</p>
                                    </li>
                                    <li>
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739982214025-QSJ5W-1733.svg"
                                            alt="">
                                        <p>Пошаговый план и как по нему идти</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consultations4-about', {
        label: 'Consultations about (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-about main-wrapper">
                <div class="careerum-container-responsive80">
                    <h2>Научитесь проходить собеседования</h2>
                    <div class="consultations4-about__wrapper careerum-flex-fsfs position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987071263-xStpm-Line.svg" alt=""
                            class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739995412211-lmOpp-Line.svg" alt=""
                            class="position-absolute hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739999369620-KRWKK-Line.svg" alt=""
                            class="position-absolute hidden-desc-tablet">
                        <div class="consultations4-about__left position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987103601-zwt1r-Grou.svg"
                                alt="" class="position-absolute hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739999536017-AZg0B-Grou.svg"
                                alt="" class="position-absolute hidden-desc-tablet">
                            <div class="careerum-flex-fsfs">
                                <p class="consultations4-about__label-fill position-relative z-20">Старт 4 февраля</p>
                                <p class="consultations4-about__label-line position-relative z-10">4 zoom-встречи</p>
                            </div>
                            <p class="consultations4-about__subheader">Набор в на групповые консультации</p>
                            <p class="consultations4-about__header">Тренируемся проходить собеседования </p>
                            <p class="consultations4-about__text">Что входит:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987150703-BujMK-Trop.svg"
                                        alt="">
                                    <p>Решите топ-7 главных проблем поиска работы</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987150600-5b1tK-Fram.svg"
                                        alt="">
                                    <p>Определите слабые места именно в вашем резюме и узнаете, как их исправить</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987150490-UEG9Q-File.svg"
                                        alt="">
                                    <p>Разберёте резюме кандидатов, которые привели к офферам</p>
                                </li>
                            </ul>
                            <a href="#" class="btn-color-main-black-blue hidden-tablet-mobile ">Записаться</a>
                        </div>
                        <div class="consultations4-about__right position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987189660-29MMf-Grou.png"
                                alt="" class="consultations4-about__expert position-absolute z-10 hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739987189550-45mLh-Vect.svg"
                                alt="" class="consultations4-about__arrow position-absolute hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739999970088-jtIgm-Grou.png"
                                alt="" class="consultations4-about__expert position-absolute z-10 hidden-desc-tablet">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739999969821-nHzCM-Vect.svg"
                                alt="" class="consultations4-about__arrow position-absolute hidden-desc-tablet z-30">
                            <p class="position-absolute z-20">Cофи Бессон, СV-экспертка, помогла 400+ клиентам найти работу
                                в США, Европе и Канаде</p>
                        </div>
                        <a href="#" class="btn-color-main-black-blue hidden-desc">Записаться</a>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consultations4-how', {
        label: 'Consultations how (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-how main-wrapper">
                <div class="careerum-container-responsive80">
                    <h2>Как работают консультации</h2>
                    <div class="consultations4-how-items careerum-flex-sbst">
                        <div class="consultations4-how-item">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739988511541-LxX8p-file.svg"
                                    alt="">
                                <p>Шаг 1</p>
                            </div>
                            <p>После оплаты вам приходит письмо
                                с анкетой, которую нужно заполнить под ваш карьерный запрос</p>
                        </div>
                        <div class="consultations4-how-item">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739988511429-SiYKS-file.svg"
                                    alt="">
                                <p>Шаг 2</p>
                            </div>
                            <p>Подбираем специалиста в течение
                                48 часов. <br>
                                Чем подробнее вы ее заполните, тем точнее мы сможем подобрать для вас специалиста с опытом
                                именно
                                в вашей теме</p>
                        </div>
                        <div class="consultations4-how-item">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739988511315-LXuvT-file.svg"
                                    alt="">
                                <p>Шаг 3</p>
                            </div>
                            <p>С вами связывается эксперт
                                и согласовывает дату и время консультации</p>
                        </div>
                        <div class="consultations4-how-item">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739988511200-7SFGg-file.svg"
                                    alt="">
                                <p>Шаг 4</p>
                            </div>
                            <p>Консультации проходят онлайн
                                в удобное для вас время.<br>
                                Каждая консультация длится 50 минут</p>
                        </div>
                        <div class="consultations4-how-item">
                            <div class="careerum-flex-fsc">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739988510967-XhEOY-1737.svg"
                                    alt="">
                                <p>Шаг 5</p>
                            </div>
                            <p>После консультации мы высылаем
                                вам на почту запись консультации
                                и дополнительные материалы</p>
                        </div>
                        <div class="consultations4-how-item blue">
                            <div>
                                <div class="careerum-flex-fsc">
                                    <p>Важно!</p>
                                </div>
                                <p>Приобретенную услугу необходимо использовать в течение одного месяца.</p>
                                <p>Вы можете перенести или отменить консультацию максимум за 24 часа до назначенного времени</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-consultations4-results', {
        label: 'Consultations results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-consultations4-results main-wrapper">
                <div class="careerum-container-responsive80 position-relative">
                    <h2>Результаты, которые достигли наши клиенты</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989926087-ZmEP0-Vect.svg" alt=""
                        class="position-absolute hidden-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000555748-yHq8l-Vect.svg" alt=""
                        class="position-absolute hidden-desc-tablet">
                    <div class="consultations4-results-slider">
                        <div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989577711-UJIIY-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000800246-DijJg-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989577577-FoFng-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000800141-IjFjR-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989577434-ZEKRs-Grou.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000800036-ez15y-Grou.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989577315-5Y3u9-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000799933-nICc8-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989577186-rBQdA-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000799830-8LGtj-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989577040-7jz0j-Grou.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000799725-HyHLH-Grou.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989576903-pErZw-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000799609-1tVto-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989576656-UP3Uo-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000799444-mIm3T-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                            <div class="consultations4-results-item">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1739989576270-9JAOX-feed.png"
                                    alt="" class="hidden-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740000799137-1UZoT-feed.png"
                                    alt="" class="hidden-desc-tablet">
                            </div>
                        </div>
                    </div>
                    <div class="consultations4-results-nav careerum-flex-fec">
                        <div class="consultations4-results-nav-prev hidden-tablet-mobile">
                            <svg width="55" height="54" viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="55" height="54" rx="27" transform="matrix(-1 0 0 1 55 0)" fill="black" />
                                <path
                                    d="M40 25.5C40.8284 25.5 41.5 26.1716 41.5 27C41.5 27.8284 40.8284 28.5 40 28.5V25.5ZM13.9393 28.0607C13.3536 27.4749 13.3536 26.5251 13.9393 25.9393L23.4853 16.3934C24.0711 15.8076 25.0208 15.8076 25.6066 16.3934C26.1924 16.9792 26.1924 17.9289 25.6066 18.5147L17.1213 27L25.6066 35.4853C26.1924 36.0711 26.1924 37.0208 25.6066 37.6066C25.0208 38.1924 24.0711 38.1924 23.4853 37.6066L13.9393 28.0607ZM40 28.5H15V25.5H40V28.5Z"
                                    fill="white" />
                            </svg>
                        </div>
                        <div class="consultations4-results-nav-next">
                            <svg width="55" height="54" viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="55" height="54" rx="27" fill="black" />
                                <path
                                    d="M15 25.5C14.1716 25.5 13.5 26.1716 13.5 27C13.5 27.8284 14.1716 28.5 15 28.5V25.5ZM41.0607 28.0607C41.6464 27.4749 41.6464 26.5251 41.0607 25.9393L31.5147 16.3934C30.9289 15.8076 29.9792 15.8076 29.3934 16.3934C28.8076 16.9792 28.8076 17.9289 29.3934 18.5147L37.8787 27L29.3934 35.4853C28.8076 36.0711 28.8076 37.0208 29.3934 37.6066C29.9792 38.1924 30.9289 38.1924 31.5147 37.6066L41.0607 28.0607ZM15 28.5H40V25.5H15V28.5Z"
                                    fill="white" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-intens4-main', {
        label: 'Intensive main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-main main-wrapper">
        <div class="careerum-container-responsive">
            <div class="careerum-flex-sbfs">
                <div class="intens4-main__left position-relative z-10">
                    <div class="careerum-flex-fsfs intens4-main__labels">
                        <div class="intens4-main__label-orange careerum-flex-cc">
                            <p>В подписке Careerum</p>
                        </div>
                        <div class="intens4-main__label-white careerum-flex-cc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999546789-0SCnq-Cale.svg"
                                alt="" class="hidden-mobile">
                            <p>Старт: 26 марта</p>
                        </div>
                        <div class="intens4-main__label-white careerum-flex-cc">
                            <p>3 месяца</p>
                        </div>
                    </div>
                    <h1>Power Talk</h1>
                    <p>Курс по сильным коммуникациям для прорыва <span>в карьере</span></p>
                    <a href="#" class="btn-color-main-dark-orange">Посмотреть программу</a>
                </div>
                <div class="intens4-main__right position-relative z-20">
                    <div class="position-absolute">
                        <div class="position-absolute">реализация амбиций</div>
                        <div class="position-absolute">повышение</div>
                        <div class="position-absolute">лидерские позиции</div>
                        <div class="position-absolute">крутые проекты</div>
                        <div class="position-absolute">кайф от работы</div>
                        <div class="position-absolute">признание экспертизы</div>
                        <div class="position-absolute">рост дохода</div>
                        <div class="position-absolute">междyнародная карьера</div>
                    </div>
                    <div class="position-absolute hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078378188-45W7p-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078378071-r4bpQ-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741680347838-xi93E-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377850-1z6D8-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377729-Ksjx0-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377624-yfuX6-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377517-omO51-Elli.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377238-nhRrP-Grou.svg"
                            alt="" class="position-absolute">
                    </div>
                    <div class="position-absolute hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741681330796-OI5ej-Grou.png"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741681330513-9vlXf-Grou.png"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741085385517-jn4GJ-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377850-1z6D8-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377729-Ksjx0-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377624-yfuX6-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377517-omO51-Elli.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741078377238-nhRrP-Grou.svg"
                            alt="" class="position-absolute">
                    </div>
                    <div class="position-absolute hidden-desc-tablet">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741681778188-6j3Uk-Grou.png"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741681777917-Bixv2-Grou.png"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741158067504-ocGNc-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741681661110-iIxUw-Grou.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741158067391-XQGXF-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741158067828-cJvcD-Star.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741158067613-wKSp4-Elli.svg"
                            alt="" class="position-absolute">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741158067276-fhnWa-Grou.svg"
                            alt="" class="position-absolute">
                    </div>
                </div>
            </div>
            <a href="#" class="btn-color-main-dark-orange">Посмотреть программу</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-for', {
        label: 'Intensive for (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-for main-wrapper">
        <div class="careerum-container-responsive">
            <div class="intens4-for__top position-relative">
                <h2>Курс подойдет</h2>
                <p>Если ваша карьера зависит от умения эффективно общаться, продавать идеи и влиять на людей, и вы:</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999614418-9fsgy-Vect.svg" alt=""
                    class="position-absolute hidden-tablet-mobile">
            </div>
            <div class="intens4-for__bottom">
                <div class="careerum-flex-cfs item-wide">
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999943541-vDISS-img..png"
                                alt="">
                        </div>
                        <div>
                            <p>Middle/Senior, хочу получить повышение и научиться обосновывать свои карьерные запросы
                            </p>
                        </div>
                    </div>
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999943242-7DCtW-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Управляю отношениями с партнерами и клиентами, хочу научиться мастерству сильных
                                переговоров</p>
                        </div>
                    </div>
                </div>
                <div class="careerum-flex-cfs">
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999943650-AICbC-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Head of, хочу начать делегировать задачи и не тянуть все на себе</p>
                        </div>
                    </div>
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999943761-UXHzp-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Свежий тимлид без опыта управления, хочу стать настоящим лидером </p>
                        </div>
                    </div>
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999943879-6LskC-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Удаленщица, хочу проще и быстрее договариваться с коллегами </p>
                        </div>
                    </div>
                </div>
                <div class="careerum-flex-cfs item-wide">
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999944001-15ZxY-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Продакт-менеджер на стыке нескольких отделов и хочу научиться эффективно общаться со
                                специалистами с разным бэкграундом </p>
                        </div>
                    </div>
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999944106-Z8jKx-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Менеджер проектов с несколькими стейкхолдерами, хочу научиться защищать свои идеи
                                аргументировано и без стресса</p>
                        </div>
                    </div>
                </div>
                <div class="careerum-flex-cfs">
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999944376-lHBfM-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Специалистка, хочу выстроить здоровые отношения с командой без токсика и манипуляций </p>
                        </div>
                    </div>
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999944501-Xl2zq-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Незаметный профи, хочу повысить свою экспертность в глазах коллег </p>
                        </div>
                    </div>
                    <div class="intens4-for__bottom-item careerum-flex-fsfs">
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740999944621-c5JVv-img .png"
                                alt="">
                        </div>
                        <div>
                            <p>Руководительница, хочу научиться “продавать” идеи команде и давать экологичную обратную
                                связь </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-how', {
        label: 'Intensive how (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-how main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Как слабые коммуникации тормозят ваш рост?</h2>
            <p>*По данным исследований McKinsey, Harvard Business Review и Project Management Institute </p>
            <div class="intens4-how__item yellow careerum-flex-fsst">
                <div class="position-relative">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-how__item-header">67%</p>
                        <p class="intens4-how__item-label right">специалистов</p>
                    </div>
                    <p class="intens4-how__item-text">Испытывают трудности при продвижении своих идей руководству</p>
                </div>
                <div class="position-relative">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-how__item-header">83%</p>
                        <p class="intens4-how__item-label left">профессионалов</p>
                    </div>
                    <p class="intens4-how__item-text">Признают, что испытывают стресс при публичной защите проектов
                        и важных переговорах</p>
                </div>
                <div class="position-relative">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-how__item-header">91%</p>
                        <p class="intens4-how__item-label left">удалёнщиков</p>
                    </div>
                    <p class="intens4-how__item-text">Отмечают, что качество коммуникации напрямую влияет
                        на их эффективность</p>
                </div>
            </div>
            <div class="intens4-how__item violet careerum-flex-fsst">
                <div class="position-relative">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-how__item-header">72%</p>
                        <p class="intens4-how__item-label right">специалистов</p>
                    </div>
                    <p class="intens4-how__item-text">Чувствуют, что недостаток soft навыков мешает карьерному росту</p>
                </div>
                <div class="position-relative">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-how__item-header">64%</p>
                        <p class="intens4-how__item-label left">руководителей</p>
                    </div>
                    <p class="intens4-how__item-text">Считают слабые коммуникативные навыки главным препятствием
                        для повышения сотрудников</p>
                </div>
                <div class="position-relative">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-how__item-header">58%</p>
                        <p class="intens4-how__item-label left">проектов</p>
                    </div>
                    <p class="intens4-how__item-text">Терпят неудачу из-за неэффективного общения внутри команды</p>
                </div>
            </div>
            <div class="intens4-how__item white careerum-flex-sbst">
                <div class="careerum-flex-sbst">
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000145239-hlKmG-Smil.svg"
                            alt="">
                        <p>Не знаете, как продвигать себя, чтобы расти в зарплате и должности</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000145118-lKveO-Thum.svg"
                            alt="">
                        <p>Постоянно сомневаетесь в своей экспертизе при общении с коллегами</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000144797-MIJQl-XCir.svg"
                            alt="">
                        <p>Не умеете давать обратную связь коллегам, тем более негативную</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000145118-lKveO-Thum.svg"
                            alt="">
                        <p>Не умеете устанавливать и поддерживать профессиональные границы</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000144797-MIJQl-XCir.svg"
                            alt="">
                        <p>Не умеете конструктивно решать конфликты на работе. Злитесь и токсичите</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000145239-hlKmG-Smil.svg"
                            alt="">
                        <p>Сталкиваетесь с манипуляциями и токсичностью со стороны команды</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000144797-MIJQl-XCir.svg"
                            alt="">
                        <p>Не умеете «продать» свои идеи и инициативы руководителю</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000145239-hlKmG-Smil.svg"
                            alt="">
                        <p>Не умеете аргументировать свою позицию коллегам</p>
                    </div>
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000145118-lKveO-Thum.svg"
                            alt="">
                        <p>Не умеете получать результат от планёрок</p>
                    </div>
                </div>
            </div>
            <a href="#programm" class="btn-color-main-dark-orange">Посмотреть программу</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-banner', {
        label: 'Intensive banner (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-banner main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <div class="position-absolute z-10 hidden-tablet-mobile ">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000264057-oLGsP-Elli.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000263944-1q4AV-Vect.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000263826-JADnC-Star.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000263593-cQxcP-Vect.svg" alt=""
                    class="position-absolute">
            </div>
            <div class="position-absolute z-10 hidden-desc-mobile ">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741070661907-njDCw-Elli.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741070661665-V3Plv-Vect.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741070661783-3nkze-Star.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741070661365-U1Ypy-Vect.svg" alt=""
                    class="position-absolute">
            </div>
            <div class="position-absolute z-10 hidden-desc-tablet ">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741103664140-kL2jK-Elli.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741103664007-iX1Fu-Vect.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741103663900-gUrbl-Star.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741103663637-li3HL-Vect.svg" alt=""
                    class="position-absolute">
            </div>
            <p class="intens4-banner-subheader position-relative z-20">Big Idea </p>
            <h2 class="position-relative z-20">Power Talk</h2>
            <p class="intens4-banner-header position-relative z-20 hidden-mobile">Is The New Sexy</p>
            <p class="intens4-banner-header position-relative z-20 hidden-desc-tablet">Is The</p>
            <p class="intens4-banner-header position-relative z-20 hidden-desc-tablet">New Sexy</p>
            <p class="intens4-banner-text position-relative z-20">Сделаем деловое общение человечным, а ваш карьерный
                рост — неизбежным</p>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-study', {
        label: 'Intensive study (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-study main-wrapper">
        <div class="careerum-container-responsive">
            <div class="intens4-study__top position-relative">
                <p class="intens4-study__label position-relative">В подписке Careerum</p>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000320579-rrgjn-Line.svg" alt=""
                    class="position-absolute z-10 hidden-tablet-mobile">
                <h2>Как проходит обучение </h2>
                <p class="hidden-mobile">В течение месяца мы будем превращать вас из застенчивых профи в харизматичных
                    коммуникаторов </p>
            </div>
            <div class="intens4-study__bottom careerum-flex-sbst">
                <div class="intens4-study__item gray hidden-desc-tablet">
                    <p class="intens4-study__item-text2">В течение месяца мы будем превращать вас из застенчивых профи в
                        харизматичных коммуникаторов </p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Формат</p>
                    <p class="intens4-study__item-text">Формат интенсива — 3 месяца </p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Видеоуроки</p>
                    <p class="intens4-study__item-text">20 емких видеолекций</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title hidden-tablet-mobile">Практики с экспертами</p>
                    <p class="intens4-study__item-title hidden-desc">Практики</p>
                    <p class="intens4-study__item-text">5 онлайн-практик и живой разбор кейсов</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Тренировка soft skills</p>
                    <p class="intens4-study__item-text">Домашние задания на тренировку soft навыков</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Нетворкинг</p>
                    <p class="intens4-study__item-text">Лидерский нетворкинг — 4 встречи</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Coffee buddy</p>
                    <p class="intens4-study__item-text">Еженедельные Coffeе Buddy</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Q&A-сессии</p>
                    <p class="intens4-study__item-text">6 Q&A-сессий с коучами из команды Careerum</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Buddy-поддержка</p>
                    <p class="intens4-study__item-text">Buddy-поддержка: мотивация и менторство в тройках с другими
                        участниками по принципу “равный равному”</p>
                </div>
                <div class="intens4-study__item position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000319498-YCtvg-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741071192302-1FB9B-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile ">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741104474141-vpvrr-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet ">
                    <p class="intens4-study__item-title">Комьюнити</p>
                    <p class="intens4-study__item-text">Чат нетворк-комьюнити с поддержкой кураторов</p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-programm', {
        label: 'Intensive programm (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-programm main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Программа</h2>
            <div class="intens4-programm__item">
                <div class="intens4-programm__item-top">
                    <p class="intens4-programm__item-label">Модуль 1 </p>
                    <p class="intens4-programm__item-header">EcoTalk. Здоровое общение и личные границы на работе</p>
                    <div class="intens4-programm__item-top-list">
                        <div class="careerum-flex-sbc">
                            <p>Как корректно формулировать свои мысли. Разбор типичных ошибок</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Как реагировать на агрессию пассивную и явную</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Личные границы на работе: как корректно отказать в просьбе, как отказаться от «неважной»
                                работы</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Экологичная обратная связь</p>
                            <p>Видеолекция</p>
                        </div>
                    </div>
                </div>
                <div class="intens4-programm__item-bottom careerum-flex-sbst">
                    <div class="intens4-programm__item-expert pink careerum-flex-sbfs">
                        <div>
                            <p class="hidden-desc-tablet intens4-programm__item-expert-title">Практика с экспертом</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000437656-i7KD7-Phot.png"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741072738899-O092O-Phot.png"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741105374395-6lC7h-Phot.png"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p class="hidden-mobile intens4-programm__item-expert-title">Практика с экспертом</p>
                            <p class="intens4-programm__item-expert-name">Ольга Лермонтова</p>
                            <p class="intens4-programm__item-expert-text">Карьерный стратег и сертифированный коуч</p>
                            <p class="intens4-programm__item-expert-text">Основательница Careerum</p>
                            <p class="intens4-programm__item-expert-text">15+ лет на руководящих позициях в
                                tech-компаниях: Google, Microsoft, Intel, управляла бизнесом на 20+ рынках Африки,
                                Западной и Восточной Европы</p>
                            <div class="careerum-flex-fsc intens4-programm__item-expert-img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000778483-nTpGq-Goog.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000778386-bVEtA-Micr.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000778104-k5S1h-Inte.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741072962354-cibm0-Logo.png"
                                    alt="" class="hidden-desc">
                            </div>
                        </div>
                        <div class="careerum-flex-fsc">
                            <p>’’</p>
                            <p class="intens4-programm__item-expert-quote">Коммуникации — это не дар, а «мышца», которую
                                нужно регулярно качать</p>
                        </div>
                    </div>
                    <div>
                        <p>Экологичное лидерство</p>
                        <div class="intens4-programm__item-bottom-list">
                            <p>Эмпатичная коммуникация: как слышать и быть услышанным</p>
                            <p>Конструктивная обратная связь: как давать и принимать</p>
                            <p>Ассертивность в действии: уверенное общение без агрессии</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="intens4-programm__item">
                <div class="intens4-programm__item-top">
                    <p class="intens4-programm__item-label">Модуль 2 </p>
                    <p class="intens4-programm__item-header">Эффективное управление конфликтами и переговоры</p>
                    <div class="intens4-programm__item-top-list">
                        <div class="careerum-flex-sbc">
                            <p>Тренируем навык переговоров</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Сильные вопросы и виды слушания</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Медиация конфликтов, тактики влияния и ваш стиль переговоров</p>
                            <p>Видеолекция</p>
                        </div>
                    </div>
                </div>
                <div class="intens4-programm__item-bottom careerum-flex-sbst">
                    <div class="intens4-programm__item-expert yellow careerum-flex-sbfs">
                        <div>
                            <p class="hidden-desc-tablet intens4-programm__item-expert-title">Практика с экспертом</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000438199-3PnZ6-Phot.png"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741072738752-21Q01-Phot.png"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741105374864-icUYb-Phot.png"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p class="hidden-mobile intens4-programm__item-expert-title">Практика с экспертом</p>
                            <p class="intens4-programm__item-expert-name">Михаил Ромашов</p>
                            <p class="intens4-programm__item-expert-text">Product Owner SberCIB</p>
                            <p class="intens4-programm__item-expert-text">Старший преподаватель в Soft Skills Lab</p>
                            <p class="intens4-programm__item-expert-text">Преподаватель в НИУ ВШЭ</p>
                            <div class="careerum-flex-fsc intens4-programm__item-expert-img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000885542-qmH5d-_.sv.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000885234-qbXlw-ÐÐ¾.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000884880-DRWyh-Sber.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741073525674-lNp6U-logo.png"
                                    alt="" class="hidden-desc">
                            </div>
                        </div>
                        <div class="careerum-flex-fsc">
                            <p>’’</p>
                            <p class="intens4-programm__item-expert-quote">Коммуникация — это валюта карьерного роста,
                                которая никогда не обесценивается</p>
                        </div>
                    </div>
                    <div>
                        <p>Как работать с теми, кто бесит</p>
                        <div class="intens4-programm__item-bottom-list">
                            <p>Как справляться с манипуляциями на работе и в жизни?</p>
                            <p>Как работать с эмоциональными людьми?</p>
                            <p>Как работать с теми, кто бесит?</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="intens4-programm__item">
                <div class="intens4-programm__item-top">
                    <p class="intens4-programm__item-label">Модуль 3 </p>
                    <p class="intens4-programm__item-header">Как «продавать» свои идеи руководителю и команде</p>
                    <div class="intens4-programm__item-top-list">
                        <div class="careerum-flex-sbc">
                            <p>Как находить общую цель с собеседником и учитывать контекст коммуникации</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Как «продать» идею своему руководителю или стейкхолдерам</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Отработка возражений после презентации идей. Разбор инструментов и кейсов</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Как «продать» идею команде. Коучинговые приемы работы с командой для руководителей</p>
                            <p>Видеолекция</p>
                        </div>
                    </div>
                </div>
                <div class="intens4-programm__item-bottom careerum-flex-sbst">
                    <div class="intens4-programm__item-expert violet careerum-flex-sbfs">
                        <div>
                            <p class="hidden-desc-tablet intens4-programm__item-expert-title">Практика с экспертом</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000438199-3PnZ6-Phot.png"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741072738752-21Q01-Phot.png"
                                alt="" class="hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741105374864-icUYb-Phot.png"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p class="hidden-mobile intens4-programm__item-expert-title">Практика с экспертом</p>
                            <p class="intens4-programm__item-expert-name">Михаил Ромашов</p>
                            <p class="intens4-programm__item-expert-text">Product Owner SberCIB</p>
                            <p class="intens4-programm__item-expert-text">Старший преподаватель в Soft Skills Lab</p>
                            <p class="intens4-programm__item-expert-text">Преподаватель в НИУ ВШЭ</p>
                            <div class="careerum-flex-fsc intens4-programm__item-expert-img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000885542-qmH5d-_.sv.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000885234-qbXlw-ÐÐ¾.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000884880-DRWyh-Sber.svg"
                                    alt="" class="hidden-tablet-mobile">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741073525674-lNp6U-logo.png"
                                    alt="" class="hidden-desc">
                            </div>
                        </div>
                        <div class="careerum-flex-fsc">
                            <p>’’</p>
                            <p class="intens4-programm__item-expert-quote">Эффективная коммуникация — это мост между
                                вашим потенциалом и его признанием </p>
                        </div>
                    </div>
                    <div>
                        <p>Как влюбить в вашу идею</p>
                        <div class="intens4-programm__item-bottom-list">
                            <p>Как превратить любую идею в проект, который невозможно отклонить</p>
                            <p>Техники влияния на коллег, которые работают даже в самых сложных ситуациях</p>
                            <p>Методы построения доверия в переговорах</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="intens4-programm__item">
                <div class="intens4-programm__item-top">
                    <p class="intens4-programm__item-label">Модуль 4 </p>
                    <p class="intens4-programm__item-header">Формула повышения в зарплате и должности</p>
                    <div class="intens4-programm__item-top-list">
                        <div class="careerum-flex-sbc">
                            <p>Как отчитываться по результатам, чтобы стать ценным сотрудником и вас заметили</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Как реагировать на критику руководителя, повышая свой авторитет</p>
                            <p>Видеолекция</p>
                        </div>
                        <div class="careerum-flex-sbc">
                            <p>Формула повышения в должности: как определить стратегически важную работу и расширить
                                свои полномочия</p>
                            <p>Видеолекция</p>
                        </div>
                    </div>
                </div>
                <div class="intens4-programm__item-bottom careerum-flex-sbst">
                    <div class="intens4-programm__item-expert blue careerum-flex-sbfs">
                        <div>
                            <p class="hidden-desc-tablet intens4-programm__item-expert-title">Практика с экспертом</p>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741000438039-uy43G-Phot.png"
                                alt="" class="hidden-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/" alt=""
                                class="hidden-desc-tablet">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741105374748-wK44D-Phot.png"
                                alt="" class="hidden-desc-tablet">
                        </div>
                        <div>
                            <p class="hidden-mobile intens4-programm__item-expert-title">Практика с экспертом</p>
                            <p class="intens4-programm__item-expert-name">Мила Плющ</p>
                            <p class="intens4-programm__item-expert-text">CMO International Ads Яндекс</p>
                            <div class="careerum-flex-fsc intens4-programm__item-expert-img">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001287772-2kJN1-logo.svg"
                                    alt="">
                            </div>
                        </div>
                        <div class="careerum-flex-fsc">
                            <p>’’</p>
                            <p class="intens4-programm__item-expert-quote">Ваши идеи заслуживают быть услышанными.
                                Научитесь говорить так, чтобы к вам прислушивались</p>
                        </div>
                    </div>
                    <div>
                        <p>Как управлять руководителем</p>
                        <div class="intens4-programm__item-bottom-list">
                            <p>Понимание целей и приоритетов руководителя</p>
                            <p>Развитие проактивного подхода к коммуникации</p>
                            <p>Управление ожиданиями и установление границ</p>
                        </div>
                    </div>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-results', {
        label: 'Intensive results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-results main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Результаты курса</h2>
            <div class="intens4-results-slider">
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Научитесь уверенно презентовать свои идеи руководству и согласовывать проекты</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Освоите техники влияния
                        для эффективной работы с командой</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Разовьете навыки стратегической коммуникации для перехода на следующий карьерный уровень</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Сможете эффективно управлять конфликтами и сложными ситуациями на работе</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Установите профессиональные границы и научитесь их поддерживать </p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Научитесь позиционировать свою экспертизу для получения более значимых проектов</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Научитесь управлять стрессом и повышенной ответственностью</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Выстроите продуктивные отношений с коллегами из других отделов</p>
                </div>
                <div class="intens4-results-slider-item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740997682340-MYXc9-Chec.svg"
                        alt="">
                    <p>Сможете уверенно лидировать проекты и команды </p>
                </div>
            </div>
            <div class="intens4-results-slider-nav careerum-flex-fec">
                <div class="intens4-results-slider-prev">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_387_1573)">
                            <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_387_1573_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                transform="rotate(-90 0 40)" fill="black" />
                            <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_387_1573_clip_path" transform="translate(18.1166 18.1166)">
                                <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                            </clipPath>
                            <clipPath id="clip0_387_1573">
                                <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="intens4-results-slider-next">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_387_1577)">
                            <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_387_1577_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" x="40" width="40" height="40"
                                transform="rotate(90 40 0)" fill="black" />
                            <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_387_1577_clip_path" transform="translate(18.1166 18.1166)">
                                <rect x="40" width="40" height="40" transform="rotate(90 40 0)" />
                            </clipPath>
                            <clipPath id="clip0_387_1577">
                                <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-cases', {
        label: 'Intensive cases (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-cases main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Кейсы наших выпускников — повышение в зарплате и должности</h2>
            <div class="intens4-cases-slider">
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590923-CSFGg-Fram.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Юлия Кормановская</p>
                        <p class="intens4-cases__item-position">Account Manager,
                            Германия</p>
                        <p class="intens4-cases__item-description">Мечта о международной карьере, непонимание, как
                            достичь этой цели</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Выросла в должности и доходе на 13%, получила новый
                            контракт в Германии на 4 года</p>
                        <p class="intens4-cases__item-result-item">Научилась позиционировать свою экспертизу</p>
                        <p class="intens4-cases__item-result-item">Прокачала навык переговоров по офферу</p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590803-hjrc0-Fram.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Александра Воробьева</p>
                        <p class="intens4-cases__item-position">Finance manager, Турция</p>
                        <p class="intens4-cases__item-description">Переживала из-за синдрома самозванца и неуверенности
                            в себе</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Получила работу в компании мечты, увеличила доход на
                            40%</p>
                        <p class="intens4-cases__item-result-item">Научилась позиционировать свою экспертизу</p>
                        <p class="intens4-cases__item-result-item">Научилась в свою пользу защищать идеи и задачи</p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590572-zNhsB-Fram.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Виктория Сагина</p>
                        <p class="intens4-cases__item-position">Planning Specialist, Россия</p>
                        <p class="intens4-cases__item-description">Хотела сменить работу, сомневалась в своих силах, не
                            знала, как найти компанию с подходящими ценностями</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Оффер и рост зарплаты на 50%</p>
                        <p class="intens4-cases__item-result-item">Научилась позиционировать свою экспертизу</p>
                        <p class="intens4-cases__item-result-item">Научилась вести переговоры по офферу</p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590696-Nge11-Fram.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Екатерина Козлова</p>
                        <p class="intens4-cases__item-position">Head of Customer Service & Account Management, Россия
                        </p>
                        <p class="intens4-cases__item-description">Декрет, была в состоянии выгорания, не понимала, чего
                            хочет в работе</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Вышла из декрета с минимальным стрессом, вернулась к
                            работе с ростом зарплаты на 7%</p>
                        <p class="intens4-cases__item-result-item">Научилась аргументировать свою позицию перед
                            руководителем</p>
                        <p class="intens4-cases__item-result-item">Прокачала навык переговоров</p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590451-7fblz-Imag.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Анна Лисина</p>
                        <p class="intens4-cases__item-position">Сontent & Marketing Director, Колумбия</p>
                        <p class="intens4-cases__item-description">Желание развивать карьеру в маркетинге и вырасти в
                            должности</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Повышение внутри компании до Creative & Brand
                            Marketing Lead</p>
                        <p class="intens4-cases__item-result-item">Улучшила навыки публичных выступлений и защиты
                            проектов</p>
                        <p class="intens4-cases__item-result-item">Прокачала навык переговоров</p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590337-6yW9u-Imag.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Екатерина Савченко</p>
                        <p class="intens4-cases__item-position">PhD студентка, Университет Мангейма, Германия</p>
                        <p class="intens4-cases__item-description">Неуверенность, выгорание, страх конкуренции в
                            Германии</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Выросла до PhD студента,
                            yвеличила доход на 38%
                        </p>
                        <p class="intens4-cases__item-result-item">Научилась перезентовать свои достижения и результаты
                            руководителю</p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001590181-V5L67-Imag.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Анастасия Сергиенко</p>
                        <p class="intens4-cases__item-position">Senior Consultant, Camelot IT lab, Германия
                        </p>
                        <p class="intens4-cases__item-description">Стремилась построить международную карьеру и вырасти
                            в доходе</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Релоцировалась в Германию, выросла в доходе в 2 раза
                        </p>
                        <p class="intens4-cases__item-result-item">Научилась презентовать свои достижения и экспертизу
                        </p>
                    </div>
                </div>
                <div class="intens4-cases__item">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741001589848-49mwc-Imag.png"
                        alt="">
                    <div>
                        <p class="intens4-cases__item-name">Анастасия Вербицкая</p>
                        <p class="intens4-cases__item-position">Зам. гендиректора по стратегии и развитию, Россия

                        </p>
                        <p class="intens4-cases__item-description">Стабильная работа, но не было радости от карьеры</p>
                        <div class="intens4-cases__item-result-header careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1740998228805-IPuQO-Chec.svg"
                                alt="">
                            <p>Результат с Careerum:</p>
                        </div>
                        <p class="intens4-cases__item-result-item">Получила оффер в желаемую компанию и повышение на
                            новой месте через 2 месяца</p>
                        <p class="intens4-cases__item-result-item">Вести диалог с руководством и обосновывать карьерные
                            запросы</p>
                    </div>
                </div>
            </div>
            <div class="intens4-cases-slider-nav careerum-flex-fec">
                <div class="intens4-cases-slider-prev">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_387_1573)">
                            <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_387_1573_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" y="40" width="40" height="40"
                                transform="rotate(-90 0 40)" fill="black" />
                            <path d="M13.1905 19.9993L26.8105 19.9993" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M19.4629 26.2453L13.1896 19.9986L19.4629 13.752" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_387_1573_clip_path" transform="translate(18.1166 18.1166)">
                                <rect y="40" width="40" height="40" transform="rotate(-90 0 40)" />
                            </clipPath>
                            <clipPath id="clip0_387_1573">
                                <rect y="40" width="40" height="40" rx="20" transform="rotate(-90 0 40)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="intens4-cases-slider-next">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_387_1577)">
                            <foreignObject x="-18.1166" y="-18.1166" width="76.2332" height="76.2332">
                                <div xmlns="http://www.w3.org/1999/xhtml"
                                    style="backdrop-filter:blur(9.06px);clip-path:url(#bgblur_1_387_1577_clip_path);height:100%;width:100%">
                                </div>
                            </foreignObject>
                            <rect data-figma-bg-blur-radius="18.1166" x="40" width="40" height="40"
                                transform="rotate(90 40 0)" fill="black" />
                            <path d="M26.8095 20.0007L13.1895 20.0007" stroke="white" stroke-width="2.64201"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M20.5371 13.7547L26.8104 20.0014L20.5371 26.248" stroke="white"
                                stroke-width="2.64201" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="bgblur_1_387_1577_clip_path" transform="translate(18.1166 18.1166)">
                                <rect x="40" width="40" height="40" transform="rotate(90 40 0)" />
                            </clipPath>
                            <clipPath id="clip0_387_1577">
                                <rect x="40" width="40" height="40" rx="20" transform="rotate(90 40 0)" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
            <a href="#buy" class="btn-color-main-dark-orange">Выбрать тариф</a>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-subscribe', {
        label: 'Intensive subscribe (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-subscribe main-wrapper">
        <div class="careerum-container-responsive">
            <h2>Что такое подписка Careerum</h2>
            <div class="intens4-subscribe-top careerum-flex-sbfs">
                <div class="intens4-subscribe-yellow">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-subscribe-white-header">80</p>
                        <p class="intens4-subscribe-white-label">курсов в подписке</p>
                    </div>
                    <p class="intens4-subscribe-white-subheader">Решите вашу карьерную задачу</p>
                    <ul>
                        <li class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741012112094-hQvrJ-Chec.svg"
                                alt="">
                            <p>Написать резюме и найти работу </p>
                        </li>
                        <li class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741012112094-hQvrJ-Chec.svg"
                                alt="">
                            <p>Получить повышение</p>
                        </li>
                        <li class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741012112094-hQvrJ-Chec.svg"
                                alt="">
                            <p>Выйти из декрета на крутую работу</p>
                        </li>
                        <li class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741012112094-hQvrJ-Chec.svg"
                                alt="">
                            <p>Перерыв в работе</p>
                        </li>
                        <li class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741012112094-hQvrJ-Chec.svg"
                                alt="">
                            <p>Релоцироваться</p>
                        </li>
                        <li class="careerum-flex-fsc">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741012112094-hQvrJ-Chec.svg"
                                alt="">
                            <p>Понять следующий шаг в карьере</p>
                        </li>
                    </ul>
                    <div class="position-relative">
                        <p class="position-absolute z-20">удобная платформа</p>
                        <p class="position-absolute z-10">постоянные обновления</p>
                    </div>
                </div>
                <div>
                    <div class="intens4-subscribe-white">
                        <div class="careerum-flex-fsfs">
                            <p class="intens4-subscribe-white-header">AI</p>
                            <p class="intens4-subscribe-white-label">помощники</p>
                        </div>
                        <p class="intens4-subscribe-white-text">Резюме-ассистент, тренер по интервью, карьерный аналитик
                        </p>
                    </div>
                    <div class="intens4-subscribe-white">
                        <div class="careerum-flex-fsfs">
                            <p class="intens4-subscribe-white-header">Meetup</p>
                            <p class="intens4-subscribe-white-label">days</p>
                        </div>
                        <p class="intens4-subscribe-white-text">Тематические онлайн-ивенты каждый месяц</p>
                    </div>
                </div>
            </div>
            <div class="intens4-subscribe-bottom careerum-flex-sbst">
                <div class="intens4-subscribe-white">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-subscribe-white-header">9.5</p>
                        <p class="intens4-subscribe-white-label">средняя оценка</p>
                    </div>
                    <p class="intens4-subscribe-white-text">Карьерных экспертов и коучей Careerum</p>
                </div>
                <div class="intens4-subscribe-white">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-subscribe-white-header">10</p>
                        <p class="intens4-subscribe-white-label">интенсивов в год</p>
                    </div>
                    <p class="intens4-subscribe-white-text">Онлайн-интенсивы, где много практики и обучения у топовых
                        экспертов рынка</p>
                </div>
                <div class="intens4-subscribe-white">
                    <div class="careerum-flex-fsfs">
                        <p class="intens4-subscribe-white-header">Q&A</p>
                        <p class="intens4-subscribe-white-label">сессии</p>
                    </div>
                    <p class="intens4-subscribe-white-text">Онлайн-разбор ваших кейсов с экспертами и коучами Careerum
                    </p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-boost', {
        label: 'Intensive boost (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-boost main-wrapper">
        <div class="careerum-container-responsive">
            <div class="intens4-boost__wrapper">
                <div class="intens4-boost__top position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741013741278-6Rzkn-Arro.svg"
                        alt="" class="position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741083914483-OSc1Z-Arro.svg"
                        alt="" class="position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741108583006-LwxXN-Arro.svg"
                        alt="" class="position-absolute hidden-desc-tablet">
                    <h2>Годовая программа буста карьеры на <span>2025</span> </h2>
                    <p>В рамках подписки вы сможете участвовать в интенсивах и прокачивать один из карьерных навыков</p>
                    <div class="intens4-boost__item-last careerum-flex-fsst">
                        <div class="careerum-flex-cc">Январь</div>
                        <div>Карьерные цели на 2025</div>
                    </div>
                    <div class="intens4-boost__item-last careerum-flex-fsst">
                        <div class="careerum-flex-cc">Февраль</div>
                        <div>Звездный кандидат</div>
                    </div>
                    <div class="intens4-boost__item-current row-2 careerum-flex-fsst">
                        <div class="careerum-flex-cc">Март</div>
                        <div>Коммуникация на работе: управляй руководителем и коллегами</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Апрель</div>
                        <div>Релокация и поиск работы за рубежом</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Май</div>
                        <div>Самооценка и деньги</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Июнь</div>
                        <div>Карьерный кризис</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Июль</div>
                        <div>Декрет и перерыв в работе</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Август</div>
                        <div>Рефреш целей</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Сентябрь</div>
                        <div>Звездный кандидат</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Октябрь</div>
                        <div>Хочу стать руководителем</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Ноябрь</div>
                        <div>Карьерная ракета</div>
                    </div>
                    <div class="intens4-boost__item-future careerum-flex-fsst">
                        <div class="careerum-flex-cc">Декабрь</div>
                        <div>Подводим итоги года</div>
                    </div>
                    <div class="intens4-boost__item-gradient position-absolute">
                    </div>
                </div>
                <div class="intens4-boost__bottom">
                    <div class="intens4-boost__bottom-top careerum-flex-sbst">
                        <div class="intens4-boost__bottom-top-left careerum-flex-fsfs">
                            <div class="careerum-flex-fsfs">
                                <p class="intens4-boost__bottom-top-header">600+</p>
                                <p class="intens4-boost__bottom-top-label">профессионалов</p>
                            </div>
                            <div class="careerum-flex-fsfs">
                                <p class="intens4-boost__bottom-top-header"><span>из</span> 50</p>
                                <p class="intens4-boost__bottom-top-label">стран</p>
                            </div>
                            <div>
                                <p class="intens4-boost__bottom-subheader">Сильное профессиональное комьюнити по всему
                                    миру
                                </p>
                            </div>
                        </div>
                        <div class="intens4-boost__bottom-top-right hidden-mobile">
                            <p class="intens4-boost__bottom-header">Нетворкинг</p>
                            <p class="intens4-boost__bottom-text">Регулярные онлайн-встречи, а еще наши подписчики
                                дружат
                                оффлайн в разных странах :)</p>
                        </div>
                    </div>
                    <div class="intens4-boost__bottom-center careerum-flex-sbst">
                        <div class="intens4-boost__bottom-top-right hidden-desc-tablet">
                            <p class="intens4-boost__bottom-header">Нетворкинг</p>
                            <p class="intens4-boost__bottom-text">Регулярные онлайн-встречи, а еще наши подписчики
                                дружат
                                оффлайн в разных странах :)</p>
                        </div>
                        <div class="intens4-boost__bottom-center-left">
                            <p class="intens4-boost__bottom-header">Сoffee Buddy</p>
                            <p class="intens4-boost__bottom-text">Еженедельные встречи-знакомства</p>
                        </div>
                        <div class="intens4-boost__bottom-center-right">
                            <p class="intens4-boost__bottom-header">Клубы по интересам</p>
                            <p class="intens4-boost__bottom-text">English Speaking club, Mindfullness Club и другие</p>
                        </div>
                    </div>
                    <div class="intens4-boost__bottom-bottom careerum-flex-sbst">
                        <div class="intens4-boost__bottom-bottom-left">
                            <p class="intens4-boost__bottom-subheader2">Участники из топовых компаний</p>
                        </div>
                        <div class="intens4-boost__bottom-bottom-right">
                            <div class="intens4-boost__bottom-row">
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002650039-SQyje-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110315357-MY1aU-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649933-DtsCA-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110315794-h61cj-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649826-4aoDW-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110315668-P7k3X-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649711-m8OgA-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110316019-UNfD5-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649592-aXz33-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110399429-at1lG-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649479-s4z06-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110399180-89vwx-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649370-yDZve-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110399664-pS6Hf-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741016349221-Awmag-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110399545-RLua7-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002733313-ktpGf-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110470822-5z99s-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984724-YlMGO-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110470506-VFcKd-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741016494247-3yo1H-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110470930-lT5z0-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984839-bFXtJ-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110470717-HIkW2-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002933541-5gOd1-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110548043-wQrvm-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002933885-4BI8d-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110548155-kDSqp-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002818574-dGqyI-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110547785-8WYpT-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002934419-pEXW9-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110548258-MHnFa-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002881390-DglVk-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110598663-YpoKv-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002881636-20M0F-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110598772-LG6Ef-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002881738-rUd6v-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110599016-SE5h2-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002881956-L789O-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110599118-AtfH1-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002882055-3b09F-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110640429-fXoCK-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002882163-Lw4QS-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110640546-nR1J3-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984373-ayHsi-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110640213-tSnwe-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984949-h5LFK-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110640320-fkKpP-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002933643-dQy0X-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110702958-RypfK-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741017148231-8jY8W-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110703062-5xDjx-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002881859-DSLjv-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110703172-6NNwk-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984125-xDA0R-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110702710-ntrl6-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741017241617-RU7Ld-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110745838-gbHLt-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984620-EBqMl-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110745729-bIMj4-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002934207-bBbrx-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110745943-K5DSJ-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984492-TPXBo-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110745623-ZhTri-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984002-3uqrI-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110813685-4jbRz-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002818354-Lz8Bw-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110813923-zN9F3-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002818473-iYUqq-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110814033-CzX2l-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002984249-hq9ir-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110814158-A8z6g-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002818688-8z8Ix-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110859226-T4D6H-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741017415896-Ohh9Z-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110859333-Js4if-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741017454811-IWYRT-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110859445-OVyc6-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002732772-LJCNs-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110859572-f3y3a-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002732883-WfFwO-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110892202-9jgYD-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002732986-Qrhko-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110892306-tUMo1-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002882266-wXBDm-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110891967-lzfkk-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002817778-MEPzC-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110892074-tAInC-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002818031-drfq7-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110938064-2BMvc-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741017659715-utdrz-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110938184-2kBCQ-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002818253-ujk4l-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110938294-f2xZ0-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002733102-9fFZM-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110938399-Zqi1v-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002733211-vvpOy-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110938515-IFvht-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002650039-SQyje-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110315357-MY1aU-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649933-DtsCA-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110315794-h61cj-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649826-4aoDW-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110315668-P7k3X-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649711-m8OgA-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110316019-UNfD5-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                                <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741002649592-aXz33-Fram.png"
                                        alt="" class="hidden-tablet-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741110399429-at1lG-Fram.png"
                                        alt="" class="hidden-desc">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-photos', {
        label: 'Intensive photos (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-photos main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2 class="position-relative z-10">Поможем построить карьеру по любви в любой точке мира</h2>
            <div class="position-relative hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003206277-S1wKF-Hear.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003206168-T4Mmm-line.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003221899-v3lM0-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003205913-eE2xd-Vect.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003222218-XshNs-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003222394-TKcxr-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003222581-9Ya5X-Phot.png" alt=""
                    class="position-absolute">
            </div>
            <div class="position-relative hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741076944516-Wiis9-Hear.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741076944405-vCLgu-line.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003221899-v3lM0-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741076944142-eCtSb-Vect.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003222218-XshNs-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003222394-TKcxr-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741003222581-9Ya5X-Phot.png" alt=""
                    class="position-absolute">
            </div>
            <div class="position-relative hidden-desc-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741111375383-imt4p-Hear.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741111375275-odKSx-line.svg" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741111369236-qjNjq-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741076944142-eCtSb-Vect.svg" alt=""
                    class="position-absolute hidden-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741111368896-fhiLO-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741111369379-crjTF-Phot.png" alt=""
                    class="position-absolute">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741111369496-11Pxm-Phot.png" alt=""
                    class="position-absolute">
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-intens4-quiz', {
        label: 'Intensive quiz (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-intens4-quiz main-wrapper">
        <div class="careerum-container-responsive">
            <p class="intens4-quiz-label position-relative">Пройдите тест</p>
            <h2>«Как вас воспринимают <span>коллеги</span>?» </h2>
            <div class="intens4-quiz__content careerum-flex-sbst">
                <div class="intens4-quiz__content-left">
                    <div>
                        <p class="intens4-quiz__content-number">1</p>
                        <p class="intens4-quiz__content-text">Определите ваш текущий стиль профессиональной коммуникации
                        </p>
                    </div>
                    <div>
                        <p class="intens4-quiz__content-number">2</p>
                        <p class="intens4-quiz__content-text">Выявите ключевые области для роста вашего влияния
                            в команде
                        </p>
                    </div>
                    <div>
                        <p class="intens4-quiz__content-number">3</p>
                        <p class="intens4-quiz__content-text">Получите персональные рекомендации по усилению вашей
                            позиции
                        </p>
                    </div>
                </div>
                <div class="intens4-quiz__content-right position-relative careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741089855693-Gz8qs-Img..svg"
                        alt="" class="position-absolute hidden-tablet-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741099055168-ILd7Q-Img .svg"
                        alt="" class="position-absolute hidden-desc-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741112779275-OJxa1-Img .svg"
                        alt="" class="position-absolute hidden-desc-tablet z-10">
                    <a href="#" class="btn-color-main-white position-relative z-20">Пройти тест</a>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-trip-main', {
        label: 'Trip main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-trip-main main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <div class="position-relative">
                <h1 class="position-relative z-30">Работающие шаблоны резюме</h1>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741591489273-NRdw5-Grou.png" alt=""
                    class="position-absolute z-20 hidden-tablet-mobile trip-main-img-label">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741599409660-IVYrq-Grou.png" alt=""
                    class="position-absolute z-20 hidden-desc-mobile trip-main-img-label">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741613978147-RwdRK-Grou.png" alt=""
                    class="position-absolute z-20 hidden-desc-tablet trip-main-img-label">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731910870671-8wMca-Elli.png" alt=""
                    class="position-absolute z-10 trip-main-img-bg">
            </div>
            <div class="trip-tales-currency position-relative z-20">
                <div class="hidden-tablet-mobile">
                    <div class="trip-tales-currency-desctop careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur" class="active">EUR</li>
                            <li data-currency="rub">RUB</li>
                        </ul>
                        <div class="trip-tales-notif careerum-flex-cc">
                            <div class="trip-tales-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="trip-tales-notif-content">
                                <p>Оплата в российских рублях возможна только картой
                                    российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden-desc position-relative">
                    <div class="trip-tales__swicher-block position-absolute">
                        <div class="trip-tales__swicher-top">
                            <p class="trip-tales__swicher-header">Посмотреть
                                цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="trip-tales__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="trip-tales__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="trip-tales position-relative z-10">
                <div class="careerum-flex-fsfs">
                    <div class="trip-tale careerum-flex-fsfs position-relative trip-tale-change-currency"
                        data-price-new-eur="56 €" data-price-new-rub="5 690 ₽" data-price-eur="149 €"
                        data-price-rub="14900 ₽" data-href-eur="#eur" data-href-rub="#rub">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741593134110-Q0Klr-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741601382277-ujMSF-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741614219401-OYUPg-Fram.png"
                            alt="" class="hidden-desc-tablet">
                        <div class="trip-tale__header">
                            <h3>Шаблон хронологического резюме RU и EN</h3>
                            <p>Чтобы показать стабильный карьерный рост</p>
                            <p>Формат четко покажет ваш профессиональный путь, начиная с текущего места работы</p>
                        </div>
                        <div class="trip-tale__content">
                            <div class="careerum-flex-fsc trip-tale__switcher">
                                <p>Кому подойдет</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                    <path
                                        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                        stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                    <path
                                        d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                        stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <ol>
                                <li>Эффективная основа любого резюме: принципы написания, формат</li>
                                <li>Достижения: как найти и упаковать </li>
                                <li>Как «докрутить» резюме до уровня топ-компаний рынка</li>
                                <li>Как получать максимум откликов: лайфхаки кастомизации резюме под вакансии</li>
                            </ol>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ навсегда</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">490 ₽</p>
                            <p class="price-old">1490 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Купить</a>
                    </div>
                    <div class="trip-tale careerum-flex-fsfs position-relative trip-tale-change-currency"
                        data-price-new-eur="56 €" data-price-new-rub="5 690 ₽" data-price-eur="149 €"
                        data-price-rub="14900 ₽" data-href-eur="#eur" data-href-rub="#rub">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741593133973-h55Uf-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741601382125-B6SRt-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741614219271-0ORV0-Fram.png"
                            alt="" class="hidden-desc-tablet">
                        <div class="trip-tale__header">
                            <h3>Шаблон функционального резюме RU и EN</h3>
                            <p>Акцент на навыках, а не на датах</p>
                            <p>Формат подсветит умения и достижения, даже если были перерывы в карьере
                            </p>
                        </div>
                        <div class="trip-tale__content">
                            <div class="careerum-flex-fsc trip-tale__switcher">
                                <p>Кому подойдет</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                    <path
                                        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                        stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                    <path
                                        d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                        stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <ol>
                                <li>Есть длительный перерыв в работе</li>
                                <li>Меняете сферу деятельности </li>
                                <li>Хотите подчеркнуть transferable skills</li>
                                <li>Работали на нескольких проектах одновременно</li>
                                <li>Опыт работы не связан напрямую с желаемой должностью</li>
                            </ol>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ навсегда</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">490 ₽</p>
                            <p class="price-old">1490 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Купить</a>
                    </div>
                    <div class="trip-tale careerum-flex-fsfs position-relative trip-tale-change-currency"
                        data-price-new-eur="56 €" data-price-new-rub="5 690 ₽" data-price-eur="149 €"
                        data-price-rub="14900 ₽" data-href-eur="#eur" data-href-rub="#rub">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741593133604-wBokn-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741601396190-SlO5L-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741614218994-NPfCK-Fram.png"
                            alt="" class="hidden-desc-tablet">
                        <div class="trip-tale__header">
                            <h3>Шаблон комбинированного резюме RU и EN</h3>
                            <p>Показать опыт и навыки одновременно</p>
                            <p>Объединяет оба формата, чтобы эффектно представить себя работодателю
                            </p>
                        </div>
                        <div class="trip-tale__content">
                            <div class="careerum-flex-fsc trip-tale__switcher">
                                <p>Кому подойдет</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                    <path
                                        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                        stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                    <path
                                        d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                        stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <ol>
                                <li>Хотите подчеркнуть навыки и опыт работы</li>
                                <li>Есть значимые достижения, которые важно подсветить</li>
                                <li>Претендуете на позицию, где важны опыт и конкретные умения</li>
                                <li>Хотите сделать резюме адаптивным под разные вакансии</li>
                            </ol>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ навсегда</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">490 ₽</p>
                            <p class="price-old">1490 ₽</p>
                            <p>— 70%</p>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Купить</a>
                    </div>
                </div>
            </div>
            <div class="trip-tales-currency position-relative z-20 hidden-desc">
                <div class="hidden-tablet-mobile">
                    <div class="trip-tales-currency-desctop careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur" class="active">EUR</li>
                            <li data-currency="rub">RUB</li>
                        </ul>
                        <div class="trip-tales-notif careerum-flex-cc">
                            <div class="trip-tales-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="trip-tales-notif-content">
                                <p>Оплата в российских рублях возможна только картой
                                    российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden-desc position-relative">
                    <div class="trip-tales__swicher-block position-absolute">
                        <div class="trip-tales__swicher-top">
                            <p class="trip-tales__swicher-header">Посмотреть
                                цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="trip-tales__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="trip-tales__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="trip-tales-single careerum-flex-sbfs trip-tale-change-currency" data-price-new-eur="149 €"
                data-price-new-rub="14 900 ₽" data-price-eur="894 €" data-price-rub="89 480 ₽" data-href-eur="#eur2"
                data-href-rub="#buy">
                <div class="position-relative">
                    <div class="trip-tales-currency position-relative z-20 hidden-tablet-mobile">
                        <div class="hidden-tablet-mobile">
                            <div class="trip-tales-currency-desctop careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs">
                                    <li data-currency="eur" class="active">EUR</li>
                                    <li data-currency="rub">RUB</li>
                                </ul>
                                <div class="trip-tales-notif careerum-flex-cc">
                                    <div class="trip-tales-notif-icon">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt="">
                                    </div>
                                    <div class="trip-tales-notif-content">
                                        <p>Оплата в российских рублях возможна только картой
                                            российского банка. В&nbsp;евро — картой
                                            зарубежного банка</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hidden-desc">
                            <div class="trip-tales__swicher-block">
                                <div class="trip-tales__swicher-top">
                                    <p class="trip-tales__swicher-header">Посмотреть
                                        цены в
                                        <span>RUB</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" class="trip-tales__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="trip-tales__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="active">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3>🎁 Забирайте пак из 6 шаблонов резюме </h3>
                    <div class="trip-tales-single-bottom">
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ навсегда</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">990 ₽</p>
                            <p class="price-old">4 470 ₽</p>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-orange hidden-mobile">Купить</a>
                        <a href="#buy" class="btn-color-main-dark-blue hidden-desc-tablet">Купить</a>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741596108887-VuMM6-ÑÐº.png"
                        alt="" class="trip-tales-single-img-sale position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741596109039-feyv6-Grou.png"
                        alt="" class="trip-tales-single-img-bg position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741601948203-VCkr0-ÑÐº.png"
                        alt="" class="trip-tales-single-img-sale position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741601947887-6yQZT-Grou.png"
                        alt="" class="trip-tales-single-img-bg position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741614810631-Sjt89-ÑÐº.png"
                        alt="" class="trip-tales-single-img-sale position-absolute hidden-desc-tablet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741614810324-tFzCx-Grou.png"
                        alt="" class="trip-tales-single-img-bg position-absolute hidden-desc-tablet">
                </div>
            </div>
            <h2><span>🔥</span>Прокачайте резюме</h2>
            <div class="trip-tales careerum-flex-fsfs position-relative z-10">
                <div class=" careerum-flex-fsfs">
                    <div class="trip-tale trip-tale-no-button careerum-flex-fsfs position-relative trip-tale-change-currency"
                        data-price-new-eur="56 €" data-price-new-rub="5 690 ₽" data-price-eur="149 €"
                        data-price-rub="14900 ₽" data-href-eur="#eur" data-href-rub="#rub">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920558380-LZI1S-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741611831676-XaOWs-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741615342381-3yVNk-Fram.png"
                            alt="" class="hidden-desc-tablet">
                        <div class="trip-tale__label position-absolute">
                            <p>поиск работы</p>
                        </div>
                        <div class="trip-tale__header">
                            <h3>Продающее резюме</h3>
                            <p>Пошаговая инструкция для создания идеального резюме.</p>
                        </div>
                        <div class="trip-tale__content">
                            <div class="careerum-flex-fsc trip-tale__switcher">
                                <p>Программа курса</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                    <path
                                        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                        stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                    <path
                                        d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                        stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <ol>
                                <li>Эффективная основа любого резюме: принципы написания, формат</li>
                                <li>Достижения: как найти и упаковать </li>
                                <li>Как «докрутить» резюме до уровня топ-компаний рынка</li>
                                <li>Как получать максимум откликов: лайфхаки кастомизации резюме под вакансии</li>
                            </ol>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ на 30 дней</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">14 900 ₽</p>
                            <p class="price-name">обычная цена</p>
                        </div>
                    </div>
                    <div class="trip-tale trip-tale-no-button careerum-flex-fsfs position-relative trip-tale-change-currency"
                        data-price-new-eur="56 €" data-price-new-rub="5 690 ₽" data-price-eur="149 €"
                        data-price-rub="14900 ₽" data-href-eur="#eur2" data-href-rub="#rub2">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920571409-iJ8hG-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741611831507-xh19w-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741615342229-EUxH0-Fram.png"
                            alt="" class="hidden-desc-tablet">
                        <div class="trip-tale__header">
                            <h3>Пак из 6 шаблонов резюме</h3>
                            <p>Универсальное решение для поиска работы в любой сфере и любой точке мира
                            </p>
                        </div>
                        <div class="trip-tale__content">
                            <div class="careerum-flex-fsc trip-tale__switcher">
                                <p>Кому подойдет</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                    <path
                                        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                        stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                    <path
                                        d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                        stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <ol>
                                <li>Шлете резюме сотнями, а работодатели их игнорят</li>
                                <li>Сменили несколько мест работы, не знаете, как это подать</li>
                                <li>Были перерывы в карьере, страшно, что никуда не примут</li>
                                <li>Есть классный опыт, но непонятно, как его упаковать</li>
                                <li>Чувствуете, что резюме отстало от рынка</li>
                                <li>Хотите, чтобы рекрутеры сразу понимали вашу ценность</li>
                                <li>Боитесь, что ваш опыт выглядит хаотично</li>
                                <li>Не знаете, как адаптировать резюме под зарубежный рынок</li>
                            </ol>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ навсегда</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">990 ₽</p>
                            <p class="price-old">4 470 ₽</p>
                        </div>
                    </div>
                    <div class="trip-tale trip-tale-no-button careerum-flex-fsfs position-relative trip-tale-change-currency"
                        data-price-new-eur="56 €" data-price-new-rub="5 690 ₽" data-price-eur="149 €"
                        data-price-rub="14900 ₽" data-href-eur="#eur2" data-href-rub="#rub2">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1731920582141-pZszF-Fram.png"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741611831244-XH62k-Fram.png"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741615341945-Z5sIT-Fram.png"
                            alt="" class="hidden-desc-tablet">
                        <div class="trip-tale__header">
                            <h3>Доступ к карьерной платформе</h3>
                            <p>Буст вашего поиска работы: уроки по Linkedin, сопроводительным письмам, собеседованиям
                            </p>
                        </div>
                        <div class="trip-tale__content">
                            <div class="careerum-flex-fsc trip-tale__switcher">
                                <p>Что еще входит</p>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-mobile">
                                    <path
                                        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                                        stroke="white" stroke-width="2" stroke-miterlimit="10" />
                                    <path d="M20.5 14.5L16 19.5L11.5 14.5" stroke="white" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" class="hidden-desc-tablet">
                                    <path
                                        d="M12 21.6147C16.9706 21.6147 21 17.5853 21 12.6147C21 7.64418 16.9706 3.61475 12 3.61475C7.02944 3.61475 3 7.64418 3 12.6147C3 17.5853 7.02944 21.6147 12 21.6147Z"
                                        stroke="white" stroke-width="1.5" stroke-miterlimit="10" />
                                    <path d="M15.375 11.4897L12 15.2397L8.625 11.4897" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <ol>
                                <li>Шаблоны и примеры:<br>
                                    ·  резюме на русском и английском<br>
                                    ·  спроводительные письма<br>
                                    ·  сообщения работодателям в LinkedIn<br>
                                    ·  деловая email-переписка<br>
                                    ·  Алгоритм анализа кризисов</li>
                                <li>Шаблон поиска достижений</li>
                                <li>Список платформ для поиска работы в 15 странах</li>
                                <li>Трекер откликов на вакансии, чтобы всегда знать, что и куда отправили</li>
                            </ol>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__descr">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.625 8.25V4.875C8.625 3.97989 8.98058 3.12145 9.61351 2.48851C10.2465 1.85558 11.1049 1.5 12 1.5C12.8951 1.5 13.7535 1.85558 14.3865 2.48851C15.0194 3.12145 15.375 3.97989 15.375 4.875"
                                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p>Доступ на 30 дней</p>
                        </div>
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">12 900 ₽</p>
                            <p class="price-name">обычная цена</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="trip-tales-currency position-relative z-20 hidden-desc">
                <div class="hidden-tablet-mobile">
                    <div class="trip-tales-currency-desctop careerum-flex-fsst">
                        <ul class="careerum-flex-fsfs">
                            <li data-currency="eur" class="active">EUR</li>
                            <li data-currency="rub">RUB</li>
                        </ul>
                        <div class="trip-tales-notif careerum-flex-cc">
                            <div class="trip-tales-notif-icon">
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                    alt="">
                            </div>
                            <div class="trip-tales-notif-content">
                                <p>Оплата в российских рублях возможна только картой
                                    российского банка. В&nbsp;евро — картой
                                    зарубежного банка</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden-desc position-relative">
                    <div class="trip-tales__swicher-block position-absolute">
                        <div class="trip-tales__swicher-top">
                            <p class="trip-tales__swicher-header">Посмотреть
                                цены в
                                <span>RUB</span>
                            </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" class="trip-tales__swicher-arrow">
                                <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                </path>
                            </svg>
                        </div>
                        <div class="trip-tales__swicher-bottom">
                            <ul>
                                <li data-currency="rub">
                                    RUB
                                </li>
                                <li data-currency="eur" class="active">
                                    EUR
                                </li>
                            </ul>
                            <p>
                                Обратите внимание,<br> что оплата в российских
                                рублях
                                возможна только<br> с карты
                                российского банка. Оплата в евро — с карты зарубежного банка
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="trip-tales-single trip-single-dark careerum-flex-sbfs trip-tale-change-currency"
                data-price-new-eur="149 €" data-price-new-rub="14 900 ₽" data-price-eur="894 €" data-price-rub="89 480 ₽"
                data-href-eur="#eur2" data-href-rub="#buy">
                <div class="position-relative">
                    <div class="trip-tales-currency position-relative z-20 hidden-tablet-mobile">
                        <div class="hidden-tablet-mobile">
                            <div class="trip-tales-currency-desctop careerum-flex-fsst">
                                <ul class="careerum-flex-fsfs">
                                    <li data-currency="eur" class="active">EUR</li>
                                    <li data-currency="rub">RUB</li>
                                </ul>
                                <div class="trip-tales-notif careerum-flex-cc">
                                    <div class="trip-tales-notif-icon">
                                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                            alt="">
                                    </div>
                                    <div class="trip-tales-notif-content">
                                        <p>Оплата в российских рублях возможна только картой
                                            российского банка. В&nbsp;евро — картой
                                            зарубежного банка</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hidden-desc">
                            <div class="trip-tales__swicher-block">
                                <div class="trip-tales__swicher-top">
                                    <p class="trip-tales__swicher-header">Посмотреть
                                        цены в
                                        <span>RUB</span>
                                    </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" class="trip-tales__swicher-arrow">
                                        <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black">
                                        </path>
                                    </svg>
                                </div>
                                <div class="trip-tales__swicher-bottom">
                                    <ul>
                                        <li data-currency="rub">
                                            RUB
                                        </li>
                                        <li data-currency="eur" class="active">
                                            EUR
                                        </li>
                                    </ul>
                                    <p>
                                        Обратите внимание,<br> что оплата в российских
                                        рублях
                                        возможна только<br> с карты
                                        российского банка. Оплата в евро — с карты зарубежного банка
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h3>Суперцена на прокачку резюме</h3>
                    <ul>
                        <li>курс Продающее резюме</li>
                        <li>пак из 6 шаблонов резюме</li>
                        <li>доступ к карьерной платформе</li>
                    </ul>
                    <div class="trip-tales-single-bottom careerum-flex-fsfs">
                        <div class="careerum-flex-fsc trip-tale__price">
                            <p class="price-current">8 900 ₽</p>
                            <p class="price-old">30 770 ₽</p>
                        </div>
                        <a href="#buy" class="btn-color-main-dark-blue">Купить</a>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741597972335-NAiyj-ÑÐº.png"
                        alt="" class="trip-tales-single-img-sale2 position-absolute hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741612309356-NZpOb-ÑÐº.png"
                        alt="" class="trip-tales-single-img-sale2 position-absolute hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1741615602137-2TUss-ÑÐº.png"
                        alt="" class="trip-tales-single-img-sale2 position-absolute hidden-desc-tablet">
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-thanks4-main', {
        label: 'Thanks 4 main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-thanks4-main main-wrapper">
                <div class="careerum-container-responsive">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742311866232-kETb7-Elli.png" alt="" class="hidden-tablet-mobile position-absolute z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742311875120-7wh1S-Elli.png" alt="" class="hidden-desc-mobile position-absolute z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742311882813-ei3Sp-Elli.png" alt="" class="hidden-desc-tablet position-absolute z-10">
                    <h1 class="position-relative z-20">Поздравляем! </h1>
                    <p class="thanks4-subheader position-relative z-20">Скоро вы направите свою карьерную ракету к звездам</p>
                    <div class="thanks4-imgs position-relative z-30">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742311781107-riejF-arro.svg" alt=""
                            class="hidden-tablet-mobile position-absolute z-10">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742311822768-srMVZ-arro.svg" alt="" class="hidden-desc-mobile position-absolute z-10">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742311831156-Qfio1-arro.svg" alt="" class="hidden-desc-tablet position-absolute z-10">
                    </div>
                    <div class="thanks4-block-blue position-relative z-20">
                        <p>Оплата прошла успешно. В ближайшее время<br> вам на почту придет письмо с инструкцией и анкетой</p>
                        <p>Пожалуйста, прочитайте письмо и заполните анкету, только после этого мы сможем подобрать эксперта для
                            вас</p>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-cv-main', {
        label: 'CV main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-main main-wrapper">
        <div class="careerum-container-responsive position-relative careerum-flex-sbst">
            <div class="careerum-flex-fsfs position-relative">
                <div class="cv-main-labels careerum-flex-fsfs">
                    <div class="careerum-flex-cc cv-main-label">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742975857217-KWAd1-Cale.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743002908774-rOptU-Cale.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>26-27 апреля</p>
                    </div>
                    <div class="careerum-flex-cc cv-main-label">
                        <p>Практикум</p>
                    </div>
                </div>
                <div class="cv-main-float-header position-absolute">с экспертом</div>
                <h1>Резюме<br> за выходные</h1>
                <p>Хватит терять вакансии и время!<br> Создайте резюме, которое продаст вас</p>
                <a href="#program" class="btn-color-main-dark-orange">Посмотреть программу</a>
            </div>
            <div class="careerum-flex-fsfs">
                <div class="careerum-flex-fsfs cv-main-right pink">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976497912-ac2Vk-Star.svg"
                        alt="">
                    <p>Дадим рабочий алгоритм, чтобы усилить резюме. Проверен на 5 000+ клиентов, которые получили
                        офферы</p>
                </div>
                <div class="careerum-flex-fsfs cv-main-right orange">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976497797-8p28K-Edit.svg"
                        alt="">
                    <p>Готовое мощное резюме за 2 дня интенсивной работы</p>
                </div>
                <div class="careerum-flex-fsfs cv-main-right violet">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976497389-FK9N0-Pape.svg"
                        alt="">
                    <p>3 индивидуальных разбора
                        вашего резюме карьерным экспертом</p>
                </div>
                <div class="careerum-flex-fsfs cv-main-right blue">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976497673-YkVOO-Pape.svg"
                        alt="">
                    <p>Количество мест ограничено, чтобы обеспечить качественную обратную связь каждому участнику
                    </p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-who', {
        label: 'CV who (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-who main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Кому подойдет?</h2>
            <div class="cv-who-cards careerum-flex-sbst">
                <div class="cv-who-card single careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Нужно быстрее найти работу</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Необходимо срочно создать профессиональное резюме с нуля</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Отправляете отклики, но не получаете приглашения на собеседования </p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Сделали резюме по шаблону hh или брали консультации по резюме, но не помогло</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Требуется экспертная оценка и конкретные рекомендации по улучшению резюме</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Стремитесь получить более высокую позицию и зарплату, но резюме не отражает ваш потенциал</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Давно не искали работу и не понимаете требования работодателей</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Не знаете, как показать свой опыт емко через цифры, кейсы и выгоду для бизнеса</p>
                </div>
                <div class="cv-who-card careerum-flex-fsfs full">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742976695926-yjMSH-Icon.svg"
                        alt="">
                    <p>Вы не ищете работу, но хотите оформить свой опыт и научиться обновлять резюме на регулярной
                        основе, чтобы всегда быть готовым</p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-why', {
        label: 'CV why (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-why main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Почему действовать нужно именно сейчас?</h2>
            <div class="cv-why-cards careerum-flex-sbst">
                <div class="cv-why-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977181183-l0pV4-Icon.svg"
                        alt="">
                    <p class="cv-why-card-header">Сезон активного найма закончится в июне</p>
                    <p class="cv-why-card-text">Компании закрывают вакансии до конца мая по ключевым проектам</p>
                </div>
                <div class="cv-why-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977181066-SpdRR-Icon.svg"
                        alt="">
                    <p class="cv-why-card-header">Лучшие вакансии будут заняты </p>
                    <p class="cv-why-card-text">Придется ждать следующего активного сезона найма в начале осени</p>
                </div>
                <div class="cv-why-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977180762-XuLxY-Icon.svg"
                        alt="">
                    <p class="cv-why-card-header hidden-tablet">Времени на метод проб и ошибок нет</p>
                    <p class="cv-why-card-header hidden-desc-mobile">Времени<br> на метод проб<br>и ошибок нет</p>
                    <p class="cv-why-card-text">Каждая неудачная попытка отдаляет вас от желаемой работы</p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-power', {
        label: 'CV power (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-power main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Сила резюме в поиске работы</h2>
            <div class="cv-power-cards careerum-flex-sbst">
                <div class="cv-power-card top blue">
                    <p>Резюме — это не просто документ, а мощный инструмент самоанализа и профессионального
                        позиционирования, который открывает двери к новым карьерным возможностям!</p>
                </div>
                <div class="cv-power-card pink">
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977784191-zA9oM-Tick.svg"
                            alt="">
                        <p>Фундамент карьеры</p>
                    </div>
                    <ul>
                        <li>Глубокая проработка профессионального опыта</li>
                        <li>Чёткое понимание своих сильных сторон</li>
                        <li>Структурированный анализ достижений </li>
                    </ul>
                </div>
                <div class="cv-power-card yellow">
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977784191-zA9oM-Tick.svg"
                            alt="">
                        <p>Карьерный компас</p>
                    </div>
                    <ul>
                        <li>Определение желаемого направления развития</li>
                        <li>Осознание своей профессиональной ценности</li>
                        <li>Фокус на релевантном опыте</li>
                    </ul>
                </div>
                <div class="cv-power-card violet">
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977784191-zA9oM-Tick.svg"
                            alt="">
                        <p>Инструмент самопрезентации</p>
                    </div>
                    <ul>
                        <li>Ваша профессиональная визитная карточка </li>
                        <li>Первое впечатление о вас как специалисте</li>
                        <li>Демонстрация вашей экспертизы</li>
                    </ul>
                </div>
                <div class="cv-power-card light-blue">
                    <div class="careerum-flex-fsfs">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742977784191-zA9oM-Tick.svg"
                            alt="">
                        <p>Инвестиция в будущее</p>
                    </div>
                    <ul>
                        <li>База для карьерного роста</li>
                        <li>Артефакт вашего профессионального пути </li>
                        <li>Платформа для повышения дохода</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-format', {
        label: 'CV format (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-format main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Формат — практика и много обратной связи </h2>
            <div class="cv-format-cards careerum-flex-sbst">
                <div class="cv-format-card position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742983113104-pN9Wl-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742996318664-tgFTh-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743004329512-SUdDr-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <p>01.</p>
                    <p class="position-relative z-20">2 дня интенсивной практической работы над резюме</p>
                </div>
                <div class="cv-format-card position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742983112996-PUj4B-Star.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742996318558-2RkzY-Star.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743004329398-7Aa7y-Star.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <p>02.</p>
                    <p class="position-relative z-20">Мини-группы до 15 человек, чтобы yделить максимyм внимания каждому
                    </p>
                </div>
                <div class="cv-format-card position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742983112882-Htfe5-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742996318437-P6tQD-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743004329285-8FmKM-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <p>03.</p>
                    <p class="position-relative z-20">Разбор сложных вопросов экспертами в формате<br> Q&A-сессии</p>
                </div>
                <div class="cv-format-card position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742983112758-Vv6cj-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742996318032-ByTHn-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743004329025-z5FJD-Vect.svg"
                        alt="" class="position-absolute z-10 hidden-desc-tablet">
                    <p>04.</p>
                    <p class="position-relative z-20">3 раунда персонального фидбека от экспертов </p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-schedule', {
        label: 'CV schedule (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-schedule main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <div class="position-absolute cv-schedule-label">Скорая помощь для резюме</div>
            <h2>Расписание практикума</h2>
            <div class="cv-schedule-cards careerum-flex-sbst">
                <div class="cv-schedule-card card-day">
                    <div class="careerum-flex-fsc cv-schedule-card-date">
                        <p class="cv-schedule-card-label">1 день</p>
                        <p>26 апреля, сб</p>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>11:00–11:45</p>
                            <p>45 мин</p>
                        </div>
                        <div>
                            <p>Структура резюме: </p>
                            <ul>
                                <li>Первый разбор с примерами резюме участников</li>
                                <li>Функциональное и хронологическое резюме — когда какое использовать</li>
                                <li>Вопросы по структуре резюме</li>
                            </ul>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time yellow careerum-flex-fsfs">
                        <div>
                            <p>11:45–12:00</p>
                            <p>1 час 15 мин</p>
                        </div>
                        <div>
                            <p>Самостоятельная работа: </p>
                            <p> Исправляем свои резюме,
                                исходя из рекомендаций экспертов</p>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>12:00–13:30</p>
                            <p>1,5 часа</p>
                        </div>
                        <div>
                            <p>Summary резюме:</p>
                            <ul>
                                <li>Что должно содержать, какого размера, и тд</li>
                                <li>Разборы summary резюме участников со скринами их резюме</li>
                            </ul>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time pink careerum-flex-fsfs">
                        <div>
                            <p>13:30–14:00</p>
                            <p>30 мин</p>
                        </div>
                        <div>
                            <p>Перерыв</p>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>14:00–15:30</p>
                            <p>1,5 часа</p>
                        </div>
                        <div>
                            <p>Работающие промты для сильного summary:</p>
                            <ul>
                                <li>Вопросы по summary</li>
                                <li>Разбор резюме участников. Примеры, как промты могут улучшить summary </li>
                            </ul>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time yellow careerum-flex-fsfs">
                        <div>
                            <p>15:30–17:00</p>
                            <p>1,5 часа</p>
                        </div>
                        <div>
                            <p>Самостоятельная работа: </p>
                            <p> Исправляем свои резюме,
                                исходя из рекомендаций экспертов</p>
                        </div>
                    </div>
                </div>
                <div class="cv-schedule-card card-day">
                    <div class="careerum-flex-fsc cv-schedule-card-date">
                        <p class="cv-schedule-card-label">2 день</p>
                        <p>27 апреля, вс</p>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>11:00–13:30</p>
                            <p>2,5 часа </p>
                        </div>
                        <div>
                            <p>Достижения в резюме:</p>
                            <ul>
                                <li>Вопросы по достижениям в резюме</li>
                                <li>Как должны быть описаны, как формулировать</li>
                                <li>Разборы достижений в резюме участников</li>
                            </ul>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time violet careerum-flex-fsfs">
                        <div>
                            <p>13:30–14:00</p>
                            <p>1 час</p>
                        </div>
                        <div>
                            <p>Перерыв</p>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>14:00–14:30</p>
                            <p>30 мин</p>
                        </div>
                        <div>
                            <p>Работающие промты для написания сильных достиений</p>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time yellow careerum-flex-fsfs">
                        <div>
                            <p>14:30–15:30</p>
                            <p>1 час</p>
                        </div>
                        <div>
                            <p>Самостоятельная работа: </p>
                            <p> Исправляем свои резюме,
                                исходя из рекомендаций экспертов</p>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>15:30–16:30</p>
                            <p>1 час</p>
                        </div>
                        <div>
                            <p>Разбор ошибок поиска работы </p>
                        </div>
                    </div>
                    <div class="cv-schedule-card-time blue careerum-flex-fsfs">
                        <div>
                            <p>16:30–17:30</p>
                            <p>1 час</p>
                        </div>
                        <div>
                            <p>Q&A-сессия с экспертами:</p>
                            <ul>
                                <li>Заключительная сессия вопросов по написанию резюме</li>
                                <li>Нетворкинг с участниками практикума</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="cv-schedule-card card-text">
                    <div class="careerum-flex-fsfs cv-schedule-card-header">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742984837323-nAEMm-Tick.svg"
                            alt="">
                        <p>Уроки и шаблоны по резюме</p>
                    </div>
                    <ul>
                        <li>5 видеоуроков-инструкций по созданию резюме. Откроем за 2 недели до старта </li>
                        <li>Шаблоны резюме под разные кейсы</li>
                        <li>Гайд по поиску достижений и упаковке своего опыта</li>
                    </ul>
                </div>
                <div class="cv-schedule-card card-text">
                    <div class="careerum-flex-fsfs cv-schedule-card-header">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742984837323-nAEMm-Tick.svg"
                            alt="">
                        <p>Чат с экспертами</p>
                    </div>
                    <ul>
                        <li>Чат на 1 неделю с экспертами для получения фидбэка от эксперта на формулировки саммари
                            и достижений</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-experts-why', {
        label: 'CV experts-why (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-experts-why main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Почему стоит доверить резюме карьерному эксперту?</h2>
            <div class="cv-experts-why-cards careerum-flex-sbst">
                <div class="cv-experts-why-card blue">
                    <p>Знает требования работодателей и помогает пройти отбор </p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Имеет опыт в вашем рынке, сфере и грейде: ежедневно помогает составлять резюме сотням кандидатов
                    </p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Знает, как исправить ошибки резюме и зацепить рекрутера</p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Знает, как сделать резюме идеальным: использует практики отработанные на тысячах кандидатов</p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Помогает скрыть недостатки: долгий перерыв в работе, мало опыта, возраст 40+</p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Помогает упаковывать опыт через достижения, цифры, факты и пользу для компании</p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Понимает, как пройти ATS-системы</p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Помогает кастомизировать резюме под разные вакансии</p>
                </div>
                <div class="cv-experts-why-card">
                    <p>Знает тренды найма в РФ и 50+ странах. Помогает внедрить их в резюме</p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-feedback', {
        label: 'CV feedback (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-feedback main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Сила экспертного фидбека для резюме</h2>
            <div class="cv-feedback-cards careerum-flex-sbst">
                <div class="cv-feedback-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986005482-thtwx-Icon.svg"
                        alt="">
                    <p>Профессиональная оценка карьерных экспертов с международным опытом
                        покажет, как ваше резюме видит рекрyтер или нанимающий менеджер</p>
                </div>
                <div class="cv-feedback-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986005346-YP1jd-Vect.svg"
                        alt="">
                    <p>Каждый новый раунд обратной связи позволяет улучшить резюме и
                        формулировки достижений, опираясь на предыдущие рекомендации</p>
                </div>
                <div class="cv-feedback-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986005237-JFGH5-Star.svg"
                        alt="">
                    <p>За 2 раунда исправите все недочеты и доведете резюме до рабочего
                        результата</p>
                </div>
                <div class="cv-feedback-card">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986005125-6bv7a-Vect.svg"
                        alt="">
                    <p>Разбор ваших реальных кейсов </p>
                </div>
                <div class="cv-feedback-card blue position-relative">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742985964024-LL1Hr-Vect.svg"
                        alt="" class="position-absolute z-10">
                    <p class="cv-schedule-card-header position-relative z-20">Разбор резюме происходит онлайн</p>
                    <p class="cv-schedule-card-text position-relative z-20 hidden-tablet-mobile">Эксперт персонально
                        знакомится с вашим
                        резюме, разбирает ошибки и
                        дает рекомендации</p>
                    <p class="cv-schedule-card-text position-relative z-20 hidden-desc">Эксперт персонально знакомится с
                        вашим резюме и дает рекомендации</p>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-results', {
        label: 'CV results (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-results main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Результат, который вы получите </h2>
            <p>Каждая составляющая резюме будет качественно проработана благодаря персональной обратной связи от
                экспертов</p>
            <div class="cv-results-cards">
                <div class="cv-results-cards-wrapper careerum-flex-sbst">
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Резюме, которое увеличит количество откликов минимум в 2 раза</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Сильное резюме, соответствующее современным требованиям рынка</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Четкое описание ключевых компетенций и навыков для желаемой позиции</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Грамотно сформулированные достижения с измеримыми результатами</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Структурированная информация для быстрого сканирования рекрутером</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Ключевые слова, оптимизированные под ATS-системы </p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Убедительное описание мягких навыков с конкретными примерами их применения</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Правильно оформленный опыт работы с акцентом на ваши сильные стороны</p>
                    </div>
                    <div class="cv-results-card">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986507920-Huo7M-Chec.svg"
                            alt="" class="hidden-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743053795656-PgX4q-Chec.svg"
                            alt="" class="hidden-desc-tablet">
                        <p>Продающее саммари, которое позволит делать эффективную самопрезентацию на интервью</p>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-experts', {
        label: 'CV experts (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-experts main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Карьерные эксперты</h2>
            <div class="cv-experts-cards">
                <div class="cv-experts-card careerum-flex-sbfs">
                    <div class="cv-experts-card-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986783731-8g4ov-Image.webp"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742998299339-UuZVK-Image.webp"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743054863881-agfGl-Image.webp"
                            alt="" class="hidden-desc-tablet">
                        <p>Софи Бессон</p>
                    </div>
                    <div class="cv-experts-card-description careerum-flex-sbst">
                        <div class="cv-experts-card-description-about careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742987270237-1CYme-Work.svg"
                                    alt="">
                            </div>
                            <div>
                                <p>Карьерный консультант с международным опытом, специализирующийся на поиске работы</p>
                                <p>Консультирует на русском и английском</p>
                            </div>
                        </div>
                        <div class="cv-experts-card-description-number">
                            <div>
                                <p class="cv-experts-card-description-number-top">4,5</p>
                                <p class="cv-experts-card-description-number-label position-relative">года</p>
                            </div>
                            <p class="cv-experts-card-description-number-bottom">в карьерном консалтинге. С 2015 года —
                                в HR</p>
                        </div>
                        <div class="cv-experts-card-description-number">
                            <div>
                                <p class="cv-experts-card-description-number-top">9.7</p>
                                <p class="cv-experts-card-description-number-label position-relative">баллов</p>
                            </div>
                            <p class="cv-experts-card-description-number-bottom">из 10: средняя оценка качества работы
                                от клиентов</p>
                        </div>
                        <div class="cv-experts-card-description-number-full pink">
                            <div>
                                <p class="cv-experts-card-description-number-top">600+</p>
                                <p class="cv-experts-card-description-number-label position-relative">успешных клиентов
                                </p>
                            </div>
                            <p class="cv-experts-card-description-number-bottom">из локальных и международных компаний:
                                IBM, World Bank, Microsoft, Disney, Mastercard и др.</p>
                        </div>
                    </div>
                </div>
                <div class="cv-experts-card careerum-flex-sbfs">
                    <div class="cv-experts-card-img">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742986784267-VqvAQ-Image.webp"
                            alt="" class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742998299666-z3qUH-Image.webp"
                            alt="" class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743054863549-81r00-Image.webp"
                            alt="" class="hidden-desc-tablet">
                        <p>Мария Пудалова</p>
                    </div>
                    <div class="cv-experts-card-description careerum-flex-sbst">
                        <div class="cv-experts-card-description-about careerum-flex-fsfs">
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742987270237-1CYme-Work.svg"
                                    alt="">
                            </div>
                            <div>
                                <p>Карьерный эксперт с международной практикой, специализирующийся на развитии личного
                                    бренда</p>
                                <p>Консультирует на русском, английском, французском</p>
                            </div>
                        </div>
                        <div class="cv-experts-card-description-number">
                            <div>
                                <p class="cv-experts-card-description-number-top">7+</p>
                                <p class="cv-experts-card-description-number-label position-relative">лет</p>
                            </div>
                            <p class="cv-experts-card-description-number-bottom">международного опыта работы: Франция,
                                Израиль, Германия</p>
                        </div>
                        <div class="cv-experts-card-description-number">
                            <div>
                                <p class="cv-experts-card-description-number-top">х2</p>
                                <p class="cv-experts-card-description-number-label position-relative">чаще</p>
                            </div>
                            <p class="cv-experts-card-description-number-bottom">полyчают офферы клиенты Марии, чем при
                                самостоятельно поиске</p>
                        </div>
                        <div class="cv-experts-card-description-number-full blue">
                            <div>
                                <p class="cv-experts-card-description-number-top">350+</p>
                                <p class="cv-experts-card-description-number-label position-relative">счастливых
                                    клиентов
                                </p>
                            </div>
                            <p class="cv-experts-card-description-number-bottom">оптимизировали стратегию поиска
                                и работают в Meta, BBDO, Microsoft и других международных компаниях</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-header', {
        label: 'CV header (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-header main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2 class="position-relative z-20">Сделайте<span>резюме</span>, которое открывает двери в лучшие компании
                в вашей сфере</h2>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742988514104-ZcQ4G-Vect.svg" alt=""
                class="position-absolute cv-header-img-1 hidden-tablet-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742988513822-XcUTD-Vect.svg" alt=""
                class="position-absolute cv-header-img-2 hidden-tablet-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742999138926-wCgZl-Vect.svg" alt=""
                class="position-absolute cv-header-img-1 hidden-desc-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742999138658-9ivQi-Vect.svg" alt=""
                class="position-absolute cv-header-img-2 hidden-desc-mobile z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743055179464-bnVLG-Vect.svg" alt=""
                class="position-absolute cv-header-img-1 hidden-desc-tablet z-10">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743055179188-b9uRw-Vect.svg" alt=""
                class="position-absolute cv-header-img-2 hidden-desc-tablet z-10">
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-clients', {
        label: 'CV clients (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-clients main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Клиенты Carееrum получают офферы в ведущие компании России и мира</h2>
            <div class="cv-clients-logos position-relative z-10">
                <div class="cv-clients-logo">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742988884752-nBSBa-Ð»Ð¾Ð.webp"
                        alt="" class="hidden-tablet-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742999298225-1sAwU-Ð»Ð¾Ð.webp"
                        alt="" class="hidden-desc-mobile">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743055491170-BEgvm-Logos.webp"
                        alt="" class="hidden-desc-tablet">
                </div>
            </div>
            <div class="cv-clients-label position-absolute z-20">
                <p>5 000+ офферов</p>
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-reviews', {
        label: 'CV reviews (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
    <div class="careerum-cv-reviews main-wrapper">
        <div class="careerum-container-responsive position-relative">
            <h2>Отзывы о работе экспертов Careerum</h2>
            <div class="cv-reviews-img-container hidden-tablet-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742990536335-nnmgA-Conte.webp" alt=""
                    class="position-relative">
            </div>
            <div class="cv-reviews-img-container hidden-desc-mobile">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742999549183-fvvMI-Conte.webp" alt=""
                    class="position-relative">
            </div>
            <div class="cv-reviews-img-container hidden-desc-tablet">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743055542407-8QmbJ-Group.webp" alt=""
                    class="position-relative">
            </div>
        </div>
    </div>`
    });
    
    blockManager.add('careerum-cv-tariffs', {
        label: 'CV tariffs (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-club40-tariffs careerum-cv-tariffs main-wrapper">
                <div class="careerum-container-responsive">
                    <h2 class="careerum-club40-header">Выберите вариант участия </h2>
                    <div class="club40-tariffs-nav careerum-flex-fec">
                        <div class="club40-tariffs-period careerum-flex-fsst hidden">
                            <ul class="careerum-flex-fsfs">
                                <li data-period="1" class="active">1 месяц</li>
                                <li data-period="3">3 месяца</li>
                                <li data-period="6">6 месяцев</li>
                                <li data-period="12">12 месяцев</li>
                            </ul>
                            <div class="club40-tariffs-notif careerum-flex-cc">
                                <div class="club40-tariffs-notif-icon"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt=""></div>
                                <div class="club40-tariffs-notif-content">
                                    <p>1 месяц подписки предоставляет 30 дней доступа к платформе</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-tariffs-curr careerum-flex-fsst">
                            <ul class="careerum-flex-fsfs">
                                <li data-currency="eur" class="active">EUR</li>
                                <li data-currency="rub">RUB</li>
                            </ul>
                            <div class="club40-tariffs-notif careerum-flex-cc">
                                <div class="club40-tariffs-notif-icon"><img
                                        src="https://fra1.digitaloceanspaces.com/devabackenduploads/1723134336723-hWN6k-Warn.svg"
                                        alt=""></div>
                                <div class="club40-tariffs-notif-content">
                                    <p>Оплата в российских рублях возможна только картой российского банка. В&nbsp;евро — картой
                                        зарубежного банка</p>
                                </div>
                            </div>
                        </div>
                        <div class="club40-tariffs__swicher-block">
                            <div class="club40-tariffs__swicher-top">
                                <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                    <span>RUB</span>
                                </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" class="club40-tariffs__swicher-arrow">
                                    <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                                </svg>
                            </div>
                            <div class="club40-tariffs__swicher-bottom">
                                <ul>
                                    <li data-currency="rub">
                                        RUB
                                    </li>
                                    <li data-currency="eur" class="active">
                                        EUR
                                    </li>
                                </ul>
                                <p>
                                    Обратите внимание,<br> что оплата в российских рублях
                                    возможна только<br> с карты
                                    российского банка. Оплата в евро — с карты зарубежного банка
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="club40-tariffs-items careerum-flex-cst">
                        <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                            data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                            data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽" data-fullprice-12m-rub="77 880 ₽"
                            data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                            data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                            data-fullprice-12m-eur="960 €" data-offer-1m-rub="27" data-offer-3m-rub="94" data-offer-6m-rub="95"
                            data-offer-12m-rub="96" data-offer-1m-eur="48" data-offer-3m-eur="97" data-offer-6m-eur="98"
                            data-offer-12m-eur="99" class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «С поддержкой»</p>
                            <p class="club40-tariffs-item-header hidden-tablet-mobile">Резюме<br> с поддержкой<br><br><br></p>
                            <p class="club40-tariffs-item-header hidden-desc-mobile">Резюме<br> с поддержкой</p>
                            <p class="club40-tariffs-item-header hidden-desc-tablet">Резюме с поддержкой</p>
                            <p class="club40-tariffs-item-description">Всего: 50 мест</p>
                            <div class="club40-tariffs-item-divider"></div>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 эфир разбор summary резюме + промты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 эфир разбор достижения в резюме + промты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 Q&A-сессии с экспертами в формате вопрос-ответ</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>Чат на 1 неделю для получения фидбэка от эксперта на формулировки саммари и достижений
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>5 видеоуроков, шаблоны резюме, гайд по достижениям</p>
                                </li>
                                <li class="careerum-flex-fsfs disabled">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742992250466-jL6F4-Feat.svg"
                                        alt="">
                                    <p>1 личная консультация c карьерным экспертом для проработки резюме / LinkedIn
                                        в индивидуальном формате</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-discount careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742992296643-Uht7v-Lock.svg"
                                        alt="" class="hidden-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                        alt="" class="hidden-desc-tablet">
                                    <p>Доступ на 30 дней</p>
                                </div>
                                <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                    <div>
                                        <p class="club40-tariffs-item-price-pm">14 900 ₽</p>
                                    </div>
                                </div>
                                <a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Купить</a>
                            </div>
                        </div>
                        <div data-price="" data-price-1m-rub="12 900 ₽" data-price-3m-rub="9&nbsp;967 ₽"
                            data-fullprice-3m-rub="29&nbsp;900 ₽" data-price-6m-rub="7 900 ₽"
                            data-fullprice-6m-rub="47&nbsp;400 ₽" data-price-12m-rub="6 490 ₽" data-fullprice-12m-rub="77 880 ₽"
                            data-price-1m-eur="149 €" data-price-3m-eur="120 €" data-fullprice-3m-eur="360 €"
                            data-price-6m-eur="90 €" data-fullprice-6m-eur="540 €" data-price-12m-eur="80 €"
                            data-fullprice-12m-eur="960 €" data-offer-1m-rub="27" data-offer-3m-rub="94" data-offer-6m-rub="95"
                            data-offer-12m-rub="96" data-offer-1m-eur="48" data-offer-3m-eur="97" data-offer-6m-eur="98"
                            data-offer-12m-eur="99" class="club40-tariffs-item careerum-flex-fsfs">
                            <p class="club40-tariffs-item-subheader2">Тариф «Индивидуальный подход»</p>
                            <p class="club40-tariffs-item-header">Резюме с поддержкой + индивидуальная консультация с карьерным
                                экспертом</p>
                            <p class="club40-tariffs-item-description">Всего: 10 мест</p>
                            <div class="club40-tariffs-item-divider"></div>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 эфир разбор summary резюме + промты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 эфир разбор достижения в резюме + промты</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 Q&A-сессии с экспертами в формате вопрос-ответ</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>Чат на 1 неделю для получения фидбэка от эксперта на формулировки саммари и достижений
                                    </p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>5 видеоуроков, шаблоны резюме, гайд по достижениям</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742991894076-U2VdV-Feat.svg"
                                        alt="">
                                    <p>1 личная консультация c карьерным экспертом для проработки резюме / LinkedIn
                                        в индивидуальном формате</p>
                                </li>
                            </ul>
                            <div class="club40-tariffs-item-bottom">
                                <div class="club40-tariffs-item-discount careerum-flex-fsc">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742992296643-Uht7v-Lock.svg"
                                        alt="" class="hidden-mobile">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743056624755-0AZOL-Lock.svg"
                                        alt="" class="hidden-desc-tablet">
                                    <p>Доступ на 30 дней</p>
                                </div>
                                <div class="careerum-flex-fsfs club40-tariffs-item-wrapper-price with-discount">
                                    <div>
                                        <p class="club40-tariffs-item-price-pm">14 900 ₽</p>
                                    </div>
                                </div>
                                <a onclick="" href="#tariff-single" class="btn-color-main-dark-orange">Купить</a>
                            </div>
                        </div>
                    </div>
                    <div class="club40-tariffs-curr">
                        <div class="club40-tariffs__swicher-block">
                            <div class="club40-tariffs__swicher-top">
                                <p class="club40-tariffs__swicher-header">Посмотреть цены в
                                    <span>RUB</span>
                                </p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" class="club40-tariffs__swicher-arrow">
                                    <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="black"></path>
                                </svg>
                            </div>
                            <div class="club40-tariffs__swicher-bottom">
                                <ul>
                                    <li data-currency="rub">
                                        RUB
                                    </li>
                                    <li data-currency="eur" class="active">
                                        EUR
                                    </li>
                                </ul>
                                <p>
                                    Обратите внимание,<br> что оплата в российских рублях
                                    возможна только<br> с карты
                                    российского банка. Оплата в евро — с карты зарубежного банка
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-cv-pay', {
        label: 'CV pay (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-cv-pay main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2>Поможем оплатить подписку через работодателя</h2>
                    <div class="cv-pay-bottom position-relative">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1742992946020-8Dy9W-Vect.svg" alt=""
                            class="position-absolute p-10">
                        <p class="position-relative p-20">Если компания вас недавно сократила и готова оплатить вам поиск новой работы, свяжитесь с нами и
                            оплатите через нее</p>
                        <div class="position-relative p-20">
                            <a href="#" class="btn-color-main-white">Связаться</a>
                        </div>
                    </div>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-cv-start', {
        label: 'CV start (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-cv-start main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <h2 class="position-relative z-20">Начните получать много откликов в лучшие компании в вашей сфере.</h2>
                    <p class="position-relative z-20">За 2 дня под руководством экспертов создайте сильное резюме, которое поможет вам быстро найти желаемую работу.</p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743590517909-g2Zun-Vect.svg" alt="" class="hidden-tablet-mobile cv-start-img-hover position-absolute z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743590517657-vToab-t.sv.svg" alt="" class="hidden-desc-mobile cv-start-img-hover position-absolute z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743590517534-JUKRZ-m.sv.svg" alt="" class="hidden-desc-tablet cv-start-img-hover position-absolute z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743590597831-N7hvf-Vect.svg" alt="" class="cv-start-img-bg position-absolute z-10">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-affirm-main', {
        label: 'Affirmation main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-affirm-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="affirm-main-header careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743414526635-nEY0l-logo.svg" alt=""
                            class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743415839053-u7JZ8-logo.svg" alt=""
                            class="hidden-desc">
                        <p>— платформа карьерного развития</p>
                    </div>
                    <h1 class="position-relative z-20">Бот с карьерными аффирмациями</h1>
                    <div class="affirm-main-text-block position-relative z-20">
                        <p>365 дней вдохновляющей поддержки в коротких мотивирующих фразах для вас:</p>
                        <ul>
                            <li>Чтобы понедельники радовали</li>
                            <li>Чтобы не проваливаться в синдром самозванца</li>
                            <li>Чтобы замечать свои успехи</li>
                            <li>Чтобы расти в профессии</li>
                        </ul>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743414526279-K3it3-Grou.svg" alt=""
                        class="position-absolute affirm-main-bg hidden-tablet-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743414525920-XG0zx-Group.webp" alt=""
                        class="position-absolute affirm-main-phone hidden-tablet-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743415581817-TkobR-Grou.svg" alt=""
                        class="position-absolute affirm-main-bg hidden-desc-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743415622906-NGEZZ-Group.webp" alt=""
                        class="position-absolute affirm-main-phone hidden-desc-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743416230516-oBkQC-Grou.svg" alt=""
                        class="position-absolute affirm-main-bg hidden-desc-tablet z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743416197071-ijO6L-Group.webp" alt=""
                        class="affirm-main-phone hidden-desc-tablet">
                    <a href="#popup" class="btn-color-main-dark-orange">Забрать подарок</a>
                </div>
            </div>`
    });
    
    blockManager.add('careerum-diagnostics-main', {
        label: 'Diagnostics main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-diagnostics-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="diagnostics-main-header careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431141861-x9NS1-Grou.svg" alt=""
                            class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431152141-J2lCN-Head.svg" alt=""
                            class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431162612-Cw8O8-Grou.svg" alt=""
                            class="hidden-desc-tablet">
                    </div>
                    <h1 class="position-relative z-20">Бесплатная<br><span>экспресс-диагностика</span><br><span>резюме</span>
                    </h1>
                    <p class="position-absolute">НЕ ИМЕЕТ ПРОТИВОПОКАЗАНИЙ.
                        НЕ НУЖНА КОНСУЛЬТАЦИЯ ВРАЧА</p>
                    <p class="position-absolute">Результаты анализа за 10 минут</p>
                    <div class="diagnostics-main-cards position-relative z-20 careerum-flex-sbst">
                        <div class="diagnostics-main-card position-relative">
                            <p class="diagnostics-main-card-header">Показания</p>
                            <p class="diagnostics-main-card-text">Ваше резюме не просматривают и не приглашают на собеседования
                            </p>
                        </div>
                        <div class="diagnostics-main-card position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431962020-8GLCk-Icon.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743434598120-1MYca-Icon.svg"
                                alt="" class="hidden-desc">
                            <p class="diagnostics-main-card-header">Анализ состояния</p>
                            <p class="diagnostics-main-card-text">Выявим слабые места в резюме</p>
                        </div>
                        <div class="diagnostics-main-card position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431961751-egSVF-Icon.svg"
                                alt="" class="hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743434597856-OHjSd-Icon.svg"
                                alt="" class="hidden-desc">
                            <p class="diagnostics-main-card-header">Расшифровка результатов</p>
                            <p class="diagnostics-main-card-text">В чём причина недомогания</p>
                        </div>
                    </div>
                    <div class="diagnostics-main-form position-relative z-20">
                        <div class="careerum-registration-form-club40 no-checkbox">
                            <form class="deva-form getcourse-email-signup careerum-flex-sbfs" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-button-agree">
                                    <a href="#" class="submit-btn btn-color-main-bright-orange" disabled>Пройти диагностику</a>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree" checked="checked">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Нажимая на кнопку, я даю согласие на обработку своих персональных данных
                                            в соответствии с <a href="https://careerum.com/ru-ru/legal/privacy"
                                                target="_blank">Политикой конфиденциальности</a></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743432067704-tpMln-Grou.svg" alt=""
                        class="position-absolute diagnostics-main-bg hidden-tablet-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743434379452-2js3v-Grou.svg" alt=""
                        class="position-absolute diagnostics-main-bg hidden-desc-mobile z-10">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743435839820-AFBD0-Grou.svg" alt=""
                        class="position-absolute diagnostics-main-bg hidden-desc-tablet z-10">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-validator-main', {
        label: 'Validator main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `            
            <div class="careerum-validator-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="validator-main-header careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431141861-x9NS1-Grou.svg" alt=""
                            class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431152141-J2lCN-Head.svg" alt=""
                            class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431162612-Cw8O8-Grou.svg" alt=""
                            class="hidden-desc-tablet">
                    </div>
                    <h1 class="position-relative z-10">AI-валидатор</h1>
                    <p class="position-relative z-10">резюме</p>
                    <p class="position-relative z-10">Проверьте своё резюме и получите экспертные советы по улучшению</p>
                    <div class="validator-main-form position-relative z-20">
                        <div class="careerum-registration-form-club40 no-checkbox">
                            <form class="deva-form getcourse-email-signup careerum-flex-sbfs" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-button-agree">
                                    <a href="#" class="submit-btn btn-color-main-bright-orange" disabled>Проверить резюме</a>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree" checked="checked">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Нажимая на кнопку, я даю согласие на обработку своих персональных данных
                                            в соответствии с <a href="https://careerum.com/ru-ru/legal/privacy"
                                                target="_blank">Политикой конфиденциальности</a></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="validator-main-cards position-relative z-20 careerum-flex-sbst">
                        <div class="validator-main-card-left position-relative">
                            <p>Обучен на основе:</p>
                            <ul>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744099557354-drFph-Docu.svg" alt="">
                                    <p><span class="orange">5000+ резюме</span> которые привели к офферам</p>
                                </li>
                                <li class="careerum-flex-fsfs">
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744099556541-s4Tvs-Prof.svg" alt="">
                                    <p><span class="pink">Базы знаний</span> экспертов Careerum</p>
                                </li>
                            </ul>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744100236160-ZH6ib-ÑÐ¾.svg" alt="" class="position-absolute z-10 hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744101173292-GsXr2-ÑÐ¾.svg" alt="" class="position-absolute z-10 hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744103317799-wi4zP-ÑÐ¾.svg" alt="" class="position-absolute z-10 hidden-desc-tablet">
                        </div>
                        <div class="validator-main-card-right position-relative">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744100149498-rWY7E-Cont.png" alt="" class="position-absolute z-10 hidden-tablet-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744101172995-SEAhS-Grou.svg" alt="" class="position-absolute z-10 hidden-desc-mobile">
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744103381953-2gAoz-Imag.svg" alt="" class="position-absolute hidden-desc-tablet">
                        </div>
                    </div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744097566446-0Pd2Q-Star.svg" alt=""
                        class="position-absolute validator-img-label hidden-tablet-mobile z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744113262961-su8tk-Star.svg" alt=""
                        class="position-absolute validator-img-label hidden-desc-mobile z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744113280592-Ep3cl-Star.svg" alt=""
                        class="position-absolute validator-img-label hidden-desc-tablet z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744097566339-cktm9-Vect.svg" alt=""
                        class="position-absolute validator-img-arr hidden-tablet-mobile z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744100437169-P4Osp-Vect.png" alt=""
                        class="position-absolute validator-img-arr hidden-desc-mobile z-20">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744102862655-sPv1w-Vect.svg" alt=""
                        class="position-absolute validator-img-arr hidden-desc-tablet z-20">
                </div>
            </div>`
    });
    
    blockManager.add('careerum-career-main', {
        label: 'Career main (responsive)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: { class: '' }, // for toolbox icon
        content: `
            <div class="careerum-career-main main-wrapper">
                <div class="careerum-container-responsive position-relative">
                    <div class="validator-main-header careerum-flex-fsc">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431141861-x9NS1-Grou.svg" alt=""
                            class="hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431152141-J2lCN-Head.svg" alt=""
                            class="hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1743431162612-Cw8O8-Grou.svg" alt=""
                            class="hidden-desc-tablet">
                    </div>
                    <h1 class="position-relative z-10">Вы застряли в карьере<br> и <span class="left-before">не знаете,</span><span class="right-before">что дальше?</span></h1>
                    <p>Пройдите тест и узнайте:</p>
                    <div class="position-relative career-main-cards">
                        <div class="position-absolute z-20">Почему вы топчетесь на месте?</div>
                        <div class="position-absolute z-20">На какой стадии карьерного развития вы находитесь прямо сейчас?</div>
                        <div class="position-absolute z-20">Что делать, чтобы двигаться дальше без выгорания и хаоса?</div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744368150786-bPWPM-Vect.svg" alt="" class="position-relative z-10 hidden-tablet-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744368736468-kJSRX-Vect.svg" alt="" class="position-relative z-10 hidden-desc-mobile">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/1744369159876-8mUn1-Vect.svg" alt="" class="position-relative z-10 hidden-desc-tablet">
                    </div>
                    <div class="career-main-form position-relative z-30">
                        <div class="careerum-registration-form-club40 no-checkbox">
                            <form class="deva-form getcourse-email-signup careerum-flex-sbfs" name="devaRegistrationForm"
                                data-gjs-type="deva-registration-form">
                                <div class="careerum-club40-form-name">
                                    <input type="text" name="name" value="" required placeholder="Имя">
                                </div>
                                <div class="careerum-club40-form-email">
                                    <input type="text" name="email" value="" required placeholder="Почта">
                                </div>
                                <div class="careerum-club40-form-phone">
                                    <input type="tel" value="" name="tel" required class="itl-input">
                                </div>
                                <div class="careerum-club40-form-button-agree">
                                    <a href="#" class="submit-btn btn-color-main-bright-orange" disabled>Пройти тест</a>
                                    <div class="careerum-club40-form-agree">
                                        <label>
                                            <input type="checkbox" name="agree" checked="checked">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8"
                                                    fill="none">
                                                    <path
                                                        d="M1 2.84615L3.14168 6.70118C3.21595 6.83487 3.40669 6.83912 3.48685 6.70887L7 1"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                                </svg>
                                            </div>
                                        </label>
                                        <p>Нажимая на кнопку, я даю согласие на обработку своих персональных данных
                                            в соответствии с <a href="https://careerum.com/ru-ru/legal/privacy"
                                                target="_blank">Политикой конфиденциальности</a></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="career-main-bottom position-relative z-20">
                        <p class="career-main-bottom-header">Результат теста</p>
                        <p class="career-main-bottom-text hidden-tablet-mobile">Видеоразбор <span>Ольги Лермонтовой</span><br> с интерпретацией вашего результата</p>
                        <p class="career-main-bottom-text hidden-desc">Видеоразбор от <span>Ольги Лермонтовой</span><br> с интерпретацией вашего результата</p>
                        <p class="career-main-bottom-author">Карьерный стратег<br> и основательница Careerum</p>
                    </div>
                </div>
            </div>`
    });

}